import { ariaAttr, noop, canUseDOM, isObject, runIfFn, transitionEasing, transitionDuration, reflow, getEnterTransitionProps, getExitTransitionProps, createTransitionStyle, callEventHandlers, warnDeprecatedProps, callAll, dataAttr, isNullish, warnRemovedProps, getOwnerDocument, getAllFocusable, getComputedStyle, isHTMLElement, getLeftmostOffset, getTopmostOffset, isBlankString, isEmptyArray, isNullOrUndefined } from '@tonic-ui/utils';
import memoize from 'micro-memoize';
import React, { forwardRef, createContext, useReducer, useEffect, useCallback, useContext, useMemo, useRef, useState, Fragment as Fragment$1, cloneElement, useLayoutEffect, isValidElement } from 'react';
import _styled from '@emotion/styled/base';
import isPropValid from '@emotion/is-prop-valid';
import { system, pseudoClassSelector, pseudoElementSelector, sx } from '@tonic-ui/styled-system';
import { ensureArray, ensurePlainObject, ensureString, ensureFiniteNumber, ensureBoolean, ensureFunction, ensurePositiveNumber, ensureNumber, ensurePositiveInteger, ensurePositiveFiniteNumber } from 'ensure-type';
import { jsx, jsxs, Fragment } from '@emotion/react/jsx-runtime';
import { Global, ThemeProvider as ThemeProvider$1, useTheme, keyframes, css, withTheme as withTheme$1 } from '@emotion/react';
export { useTheme } from '@emotion/react';
import originalTheme from '@tonic-ui/theme';
import * as tmicon from '@trendmicro/tmicon';
import { useMergeRefs, useIsomorphicEffect, useOnceWhen, useConst, usePrevious, useEffectOnce, useHydrated, useEventListener, useOnce } from '@tonic-ui/react-hooks';
import { Transition, TransitionGroup } from 'react-transition-group';
import _get from 'lodash.get';
import FocusLock from 'react-focus-lock/dist/cjs';
import { createPortal } from 'react-dom';
import { createPopper } from '@popperjs/core';
import { isElement, isValidElementType } from 'react-is';

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var shouldForwardProp = function () {
  var stylePropMap = ensureArray(system.propNames).reduce(function (acc, val) {
    acc[val] = true;
    return acc;
  }, {});
  var omittedStylePropMap = _objectSpread2(_objectSpread2({}, stylePropMap), {}, {
    // The `as` prop is supported by Emotion
    'as': true
  });
  return function (prop) {
    return isPropValid(prop) && !omittedStylePropMap[prop];
  };
}();
var transformCSSPseudoSelectors = function transformCSSPseudoSelectors(props) {
  var entries = Object.entries(ensurePlainObject(props)).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0];
      _ref2[1];
    return Object.prototype.hasOwnProperty.call(pseudoClassSelector, name) || Object.prototype.hasOwnProperty.call(pseudoElementSelector, name);
  });
  return sx(Object.fromEntries(entries));
};
var transformCSSSuperset = function transformCSSSuperset(props) {
  // The `sx` prop is a shortcut for defining custom styles that has access to the theme
  return sx(props === null || props === void 0 ? void 0 : props.sx);
};
var Box = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  shouldForwardProp: shouldForwardProp,
  target: "ebasi3p0"
} : {
  shouldForwardProp: shouldForwardProp,
  target: "ebasi3p0",
  label: "Box"
})(system, transformCSSPseudoSelectors, transformCSSSuperset // Place `transformCSSSuperset` at the end to gain the highest specificity
, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
Box.displayName = 'Box';

var _excluded$1H = ["css", "type", "_hover", "_disabled", "_focus", "_checked", "_indeterminate", "_child", "_checkedAndChild", "_checkedAndDisabled", "_checkedAndActive", "_checkedAndFocus", "_checkedAndHover", "_indeterminateAndChild", "_indeterminateAndDisabled", "_indeterminateAndActive", "_indeterminateAndFocus", "_indeterminateAndHover"];
var ControlBox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _sx;
  var css = _ref.css,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'checkbox' : _ref$type,
    _hover = _ref._hover,
    _disabled = _ref._disabled,
    _focus = _ref._focus,
    _checked = _ref._checked,
    _indeterminate = _ref._indeterminate,
    _ref$_child = _ref._child,
    _child = _ref$_child === void 0 ? {
      opacity: 0
    } : _ref$_child,
    _ref$_checkedAndChild = _ref._checkedAndChild,
    _checkedAndChild = _ref$_checkedAndChild === void 0 ? {
      opacity: 1
    } : _ref$_checkedAndChild,
    _checkedAndDisabled = _ref._checkedAndDisabled,
    _checkedAndActive = _ref._checkedAndActive,
    _checkedAndFocus = _ref._checkedAndFocus,
    _checkedAndHover = _ref._checkedAndHover,
    _ref$_indeterminateAn = _ref._indeterminateAndChild,
    _indeterminateAndChild = _ref$_indeterminateAn === void 0 ? {
      opacity: 1
    } : _ref$_indeterminateAn,
    _indeterminateAndDisabled = _ref._indeterminateAndDisabled,
    _indeterminateAndActive = _ref._indeterminateAndActive,
    _indeterminateAndFocus = _ref._indeterminateAndFocus,
    _indeterminateAndHover = _ref._indeterminateAndHover,
    rest = _objectWithoutProperties(_ref, _excluded$1H);
  var checked = "input[type=".concat(type, "]:checked + &");
  var checkedAndDisabled = "input[type=".concat(type, "]:checked:disabled + &");
  var checkedAndActive = "input[type=".concat(type, "]:checked:active:not(:disabled):not(:focus) + &");
  var checkedAndHover = "input[type=".concat(type, "]:checked:hover:not(:disabled):not(:focus) + &");
  var checkedAndFocus = "input[type=".concat(type, "]:checked:focus + &");
  var disabled = "input[type=".concat(type, "]:disabled + &");
  var focus = "input[type=".concat(type, "]:focus + &");
  var hover = "input[type=".concat(type, "]:hover:not(:disabled):not(:checked):not(:focus) + &");
  var indeterminate = "input[type=".concat(type, "][data-indeterminate] + &");
  var indeterminateAndDisabled = "input[type=".concat(type, "][data-indeterminate]:disabled + &");
  var indeterminateAndActive = "input[type=".concat(type, "][data-indeterminate]:active:not(:disabled):not(:focus) + &");
  var indeterminateAndHover = "input[type=".concat(type, "][data-indeterminate]:hover:not(:disabled):not(:focus) + &");
  var indeterminateAndFocus = "input[type=".concat(type, "][data-indeterminate]:focus + &");
  css = [sx((_sx = {}, _defineProperty(_sx, focus, _focus), _defineProperty(_sx, hover, _hover), _defineProperty(_sx, disabled, _disabled), _defineProperty(_sx, checkedAndDisabled, _checkedAndDisabled), _defineProperty(_sx, checkedAndActive, _checkedAndActive), _defineProperty(_sx, checkedAndFocus, _checkedAndFocus), _defineProperty(_sx, checkedAndHover, _checkedAndHover), _defineProperty(_sx, '& > *', _child), _defineProperty(_sx, checked, _objectSpread2(_objectSpread2({}, _checked), {}, {
    '& > *': _checkedAndChild
  })), _defineProperty(_sx, indeterminateAndDisabled, _indeterminateAndDisabled), _defineProperty(_sx, indeterminateAndActive, _indeterminateAndActive), _defineProperty(_sx, indeterminateAndFocus, _indeterminateAndFocus), _defineProperty(_sx, indeterminateAndHover, _indeterminateAndHover), _defineProperty(_sx, indeterminate, _objectSpread2(_objectSpread2({}, _indeterminate), {}, {
    '& > *': _indeterminateAndChild
  })), _sx)), css];
  return jsx(Box, _objectSpread2({
    ref: ref,
    css: css,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 120ms",
    flexShrink: "0",
    "aria-hidden": ariaAttr(true),
    userSelect: "none"
  }, rest));
});
ControlBox.displayName = 'ControlBox';

var AccordionContext = /*#__PURE__*/createContext();
var AccordionItemContext = /*#__PURE__*/createContext();

var ColorModeContext = /*#__PURE__*/createContext();

var matchMediaQuery = function matchMediaQuery(query) {
  var _window, _window$matchMedia;
  var mediaQueryList = (_window = window) === null || _window === void 0 ? void 0 : (_window$matchMedia = _window.matchMedia) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.call(_window, query);
  if (!mediaQueryList) {
    return undefined;
  }
  return mediaQueryList.matches;
};
var colorSchemeQuery = {
  dark: '(prefers-color-scheme: dark)',
  light: '(prefers-color-scheme: light)'
};
var getColorScheme = function getColorScheme(fallbackColorMode) {
  var _matchMediaQuery;
  var isDarkColorScheme = (_matchMediaQuery = matchMediaQuery(colorSchemeQuery.dark)) !== null && _matchMediaQuery !== void 0 ? _matchMediaQuery : fallbackColorMode === 'dark';
  return isDarkColorScheme ? 'dark' : 'light';
};

var ensureColorMode = function ensureColorMode(colorMode) {
  return colorMode === 'dark' ? 'dark' : 'light';
};
var getMemoizedState$n = memoize(function (state) {
  return _objectSpread2({}, state);
});
var colorModeReducer = function colorModeReducer(state, nextValue) {
  if (nextValue === undefined) {
    var colorMode = state;
    return colorMode === 'dark' ? 'light' : 'dark';
  }
  return ensureColorMode(nextValue);
};
var ColorModeProvider = function ColorModeProvider(_ref) {
  var children = _ref.children,
    defaultValueProp = _ref.defaultValue,
    valueProp = _ref.value,
    onChangeProp = _ref.onChange,
    useSystemColorMode = _ref.useSystemColorMode;
  var defaultColorMode = defaultValueProp === 'dark' ? 'dark' : 'light';
  var _useReducer = useReducer(colorModeReducer, ensureColorMode(valueProp !== null && valueProp !== void 0 ? valueProp : defaultColorMode)),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    colorMode = _useReducer2[0],
    setColorMode = _useReducer2[1];
  useEffect(function () {
    if (valueProp !== undefined) {
      setColorMode(valueProp);
    }
  }, [valueProp]);
  var onChange = useCallback(function (nextValue) {
    if (valueProp !== undefined) {
      setColorMode(valueProp);
    } else {
      setColorMode(nextValue);
    }
    if (typeof onChangeProp === 'function') {
      onChangeProp(nextValue); // Pass original value to the onChange callback
    }
  }, [valueProp, onChangeProp]);
  useEffect(function () {
    var _window, _window$matchMedia;
    if (valueProp !== null && valueProp !== undefined) {
      // bypass the system color mode if `valueProp` is set
      return noop;
    }
    if (!useSystemColorMode) {
      return noop;
    }
    if (!canUseDOM()) {
      return noop;
    }
    var systemColorMode = getColorScheme(defaultColorMode);
    onChange(systemColorMode);
    var mediaQueryList = (_window = window) === null || _window === void 0 ? void 0 : (_window$matchMedia = _window.matchMedia) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.call(_window, colorSchemeQuery.dark);
    var listener = function listener() {
      onChange(mediaQueryList.matches ? 'dark' : 'light');
    };
    mediaQueryList.addEventListener('change', listener);
    return function () {
      mediaQueryList.removeEventListener('change', listener);
    };
  }, [defaultValueProp, valueProp, useSystemColorMode, defaultColorMode, onChange]);
  var colorModeState = getMemoizedState$n({
    colorMode: colorMode,
    onChange: onChange
  });
  return jsx(ColorModeContext.Provider, {
    value: colorModeState,
    children: children
  });
};
ColorModeProvider.displayName = 'ColorModeProvider';

var DarkMode = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(ColorModeProvider, {
    value: "dark",
    children: jsx(Box, _objectSpread2({
      ref: ref,
      colorScheme: "dark"
    }, props))
  });
});
DarkMode.displayName = 'DarkMode';

var useColorMode = function useColorMode() {
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(ColorModeContext);
  if (context === undefined) {
    throw new Error('The `useColorMode` hook must be called from a descendent of the `ColorModeProvider`.');
  }
  var _ensurePlainObject = ensurePlainObject(context),
    colorMode = _ensurePlainObject.colorMode,
    onChange = _ensurePlainObject.onChange;
  var getter = colorMode;
  var setter = useCallback(function (value) {
    if (typeof value === 'function') {
      value = value(colorMode);
    }
    var nextColorMode = value;
    onChange(nextColorMode);
  }, [colorMode, onChange]);
  return [getter, setter];
};

var InvertedMode = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var invertedColorMode = colorMode === 'light' ? 'dark' : 'light';
  return jsx(ColorModeProvider, {
    value: invertedColorMode,
    children: jsx(Box, _objectSpread2({
      ref: ref,
      colorScheme: invertedColorMode
    }, props))
  });
});
InvertedMode.displayName = 'InvertedMode';

var LightMode = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(ColorModeProvider, {
    value: "light",
    children: jsx(Box, _objectSpread2({
      ref: ref,
      colorScheme: "light"
    }, props))
  });
});
LightMode.displayName = 'LightMode';

var CSSVariables = function CSSVariables(_ref) {
  var _ref$root = _ref.root,
    root = _ref$root === void 0 ? [':root', ':host'] : _ref$root;
  var styles = useCallback(function (theme) {
    var selector = ensureArray(root).join(',');
    return _defineProperty({}, selector, _objectSpread2({}, theme === null || theme === void 0 ? void 0 : theme.__cssVariableMap));
  }, [root]);
  return jsx(Global, {
    styles: styles
  });
};

var icons = tmicon.icons.reduce(function (acc, _ref) {
  var name = _ref.name,
    paths = _ref.paths,
    viewBox = _ref.viewBox;
  return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, "tmicon-".concat(name), {
    path: jsx("g", {
      children: paths.map(function (path, idx) {
        return jsx("path", {
          d: path
        }, "".concat(name, "-").concat(idx));
      })
    }),
    viewBox: viewBox
  }));
}, {});

var theme = _objectSpread2(_objectSpread2({}, originalTheme), {}, {
  config: {
    prefix: 'tonic',
    useCSSVariables: false
  },
  icons: icons
});

var flatten = function flatten(target) {
  if (!isObject(target) && !Array.isArray(target)) {
    return target;
  }
  return Object.entries(target).reduce(function (result, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (isObject(value) || Array.isArray(value)) {
      Object.entries(flatten(value)).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          childKey = _ref4[0],
          childValue = _ref4[1];
        result["".concat(key, ".").concat(childKey)] = childValue;
      });
    } else {
      result[key] = value;
    }
    return result;
  }, {});
};

/**
 * Returns a CSS variable name formatted from the given name and options.
 *
 * @param {string} name - The name of the variable.
 * @param {object} [options] - The options object.
 * @param {string} [options.prefix=''] - The prefix to use for the variable name.
 * @param {string} [options.delimiter='-'] - The delimiter to use between the prefix and name.
 *
 * @return {string} The CSS variable name.
*/
var toCSSVariable = function toCSSVariable(name, options) {
  var _options = _objectSpread2({}, options),
    _options$prefix = _options.prefix,
    prefix = _options$prefix === void 0 ? '' : _options$prefix,
    _options$delimiter = _options.delimiter,
    delimiter = _options$delimiter === void 0 ? '-' : _options$delimiter;
  var variableName = [prefix, name].filter(Boolean).join(delimiter).replace(/\s+/g, delimiter) // replace whitespace characters
  .replace(/[^a-zA-Z0-9-_]/g, delimiter) // replace non-alphanumeric, non-hyphen, non-underscore characters
  .replace(/^-+|-+$/g, ''); // trim hyphens from beginning and end of string
  return "--".concat(variableName);
};

var originalThemeScales = Object.keys(originalTheme);

/**
 * Generate CSS variable map for a given theme object.
 *
 * @param {object} theme - The object containing the theme values.
 * @param {object} [options] - The options object.
 * @param {string} [options.prefix] - A prefix to prepend to each generated CSS variable.
 *
 * @example
 * ```js
 * const theme = {
 *   colors: {
 *     'blue:50': '#578aef',
 *   },
 * };
 * createCSSVariableMap(theme, { prefix: 'tonic' });
 * // => {
 * //   '--tonic-colors-blue-50': '#578aef'
 * // }
 * ```
 */
var createCSSVariableMap = function createCSSVariableMap(theme, options) {
  var prefix = ensureString(options === null || options === void 0 ? void 0 : options.prefix);
  var tokens = flatten(theme);
  var cssVariableMap = {};
  for (var _i = 0, _Object$entries = Object.entries(tokens); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      name = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    // name='colors.blue:50', prefix='tonic'
    // => '--tonic-colors-blue-50'
    var variable = toCSSVariable(name, {
      prefix: prefix
    });
    cssVariableMap[variable] = value;
  }
  return cssVariableMap;
};
var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
    themeProp = _ref.theme;
  var theme$1 = themeProp !== null && themeProp !== void 0 ? themeProp : theme;
  var computedTheme = useMemo(function () {
    var themeConfig = _objectSpread2(_objectSpread2({}, theme.config), theme$1 === null || theme$1 === void 0 ? void 0 : theme$1.config);

    // Filter only the theme scales that are supported by the original theme
    var normalizedTheme = Object.fromEntries(Object.entries(ensurePlainObject(theme$1)).filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
        key = _ref3[0];
      return originalThemeScales.includes(key);
    }));

    // Create CSS variable map for the theme
    var cssVariableMap = createCSSVariableMap(normalizedTheme, {
      prefix: themeConfig.prefix
    });
    return _objectSpread2(_objectSpread2({}, theme$1), {}, {
      config: themeConfig,
      __cssVariableMap: cssVariableMap
    });
  }, [theme$1]);
  return jsxs(ThemeProvider$1, {
    theme: computedTheme,
    children: [jsx(CSSVariables, {}), children]
  });
};
ThemeProvider.displayName = 'ThemeProvider';

var useAccordionStyle = function useAccordionStyle() {
  return {
    display: 'flex',
    flexDirection: 'column'
  };
};
var useAccordionHeaderStyle = function useAccordionHeaderStyle() {
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var _useTheme = useTheme(),
    sizes = _useTheme.sizes;
  var backgroundColor = {
    dark: 'gray:90',
    light: 'white'
  }[colorMode];
  var borderWidth = sizes['1q'];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  var disabledColor = {
    dark: 'white:disabled',
    light: 'black:disabled'
  }[colorMode];
  var px = sizes['4x'];
  var py = "calc(".concat(sizes['3x'], " - ").concat(borderWidth, ")");
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: '4x',
    backgroundColor: backgroundColor,
    borderColor: 'transparent',
    borderStyle: 'solid',
    borderWidth: borderWidth,
    color: color,
    _disabled: {
      color: disabledColor
    },
    px: px,
    py: py,
    width: '100%'
  };
};
var useAccordionBodyStyle = function useAccordionBodyStyle() {
  return {};
};
var useAccordionToggleStyle = function useAccordionToggleStyle() {
  return {
    width: '100%'
  };
};
var useAccordionToggleIconStyle = function useAccordionToggleIconStyle() {
  return {
    display: 'inline-flex',
    _disabled: {
      opacity: '.28'
    }
  };
};

var _excluded$1G = ["children"];
var getMemoizedState$m = memoize(function (state) {
  return _objectSpread2({}, state);
});
var Accordion = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$1G);
  var context = getMemoizedState$m({
    // TODO
  });
  var styleProps = useAccordionStyle();
  return jsx(AccordionContext.Provider, {
    value: context,
    children: jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
      ref: ref
    }, styleProps), rest), {}, {
      children: runIfFn(children, context)
    }))
  });
});
Accordion.displayName = 'Accordion';

var _excluded$1F = ["appear", "children", "collapsedHeight", "easing", "in", "style", "timeout"];
var mapStateToVariantStyle$9 = function mapStateToVariantStyle(state, props) {
  var variantStyle = {
    entering: {
      height: 'auto',
      opacity: 1,
      overflow: 'hidden'
    },
    entered: {
      height: 'auto',
      opacity: 1
    },
    exiting: {
      height: props.collapsedHeight || 0,
      opacity: 0,
      overflow: 'hidden'
    },
    exited: {
      height: props.collapsedHeight || 0,
      opacity: 0
    }
  }[state];
  return typeof variantStyle === 'function' ? variantStyle(props) : variantStyle;
};
var defaultEasing$9 = {
  enter: transitionEasing.easeInOut,
  exit: transitionEasing.easeInOut
};
var defaultTimeout$8 = {
  enter: transitionDuration.standard,
  exit: transitionDuration.standard
};
var Wrapper$1 = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(Box, _objectSpread2({
    ref: ref
  }, props));
});
var Collapse = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$appear = _ref.appear,
    appear = _ref$appear === void 0 ? false : _ref$appear,
    _children = _ref.children,
    _ref$collapsedHeight = _ref.collapsedHeight,
    collapsedHeight = _ref$collapsedHeight === void 0 ? 0 : _ref$collapsedHeight,
    _ref$easing = _ref.easing,
    easing = _ref$easing === void 0 ? defaultEasing$9 : _ref$easing,
    inProp = _ref["in"],
    style = _ref.style,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? defaultTimeout$8 : _ref$timeout,
    rest = _objectWithoutProperties(_ref, _excluded$1F);
  var nodeRef = useRef(null);
  var combinedRef = useMergeRefs(nodeRef, ref);
  var wrapperRef = useRef(null);
  useEffect(function () {
    var node = nodeRef.current;
    reflow(node); // force reflow to make the transition work when animating appearance
  }, [inProp]);
  return jsx(Transition, _objectSpread2(_objectSpread2({
    appear: appear,
    "in": inProp,
    nodeRef: nodeRef,
    timeout: timeout
  }, rest), {}, {
    children: function children(state, childProps) {
      var transitionProps = inProp ? getEnterTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      }) : getExitTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      });
      var transition = createTransitionStyle(['height', 'opacity'], transitionProps);
      var variantStyle = mapStateToVariantStyle$9(state, {
        collapsedHeight: collapsedHeight
      });
      var styleProps = _objectSpread2(_objectSpread2({}, variantStyle), {}, {
        transition: transition,
        visibility: state === 'exited' && !inProp && !collapsedHeight ? 'hidden' : undefined
      });
      if (typeof _children === 'function') {
        return _children(state, _objectSpread2(_objectSpread2({}, childProps), {}, {
          ref: combinedRef,
          style: _objectSpread2(_objectSpread2({}, styleProps), style)
        }));
      }
      var isAnimationStart = inProp && state === 'entering' || !inProp && (state === 'entering' || state === 'entered');
      //const isAnimationEnd = (inProp && (state === 'entered')) ||
      //  (!inProp && (state === 'exited'));

      if (isAnimationStart) {
        var wrapper = wrapperRef.current;
        var contentHeight = wrapper === null || wrapper === void 0 ? void 0 : wrapper.offsetHeight;
        styleProps.height = contentHeight;
      }
      return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
        ref: combinedRef
      }, childProps), styleProps), {}, {
        style: style,
        children: jsx(Wrapper$1, {
          ref: wrapperRef,
          children: _children
        })
      }));
    }
  }));
});
Collapse.displayName = 'Collapse';

var _excluded$1E = ["appear", "children", "easing", "in", "style", "timeout"];
var mapStateToVariantStyle$8 = function mapStateToVariantStyle(state, props) {
  var variantStyle = {
    entering: {
      opacity: 1
    },
    entered: {
      opacity: 1
    },
    exiting: {
      opacity: 0
    },
    exited: {
      opacity: 0
    }
  }[state];
  return typeof variantStyle === 'function' ? variantStyle(props) : variantStyle;
};
var defaultEasing$8 = {
  enter: transitionEasing.easeInOut,
  exit: transitionEasing.easeInOut
};
var defaultTimeout$7 = {
  enter: transitionDuration.enteringScreen,
  exit: transitionDuration.leavingScreen
};
var Fade = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$appear = _ref.appear,
    appear = _ref$appear === void 0 ? false : _ref$appear,
    _children = _ref.children,
    _ref$easing = _ref.easing,
    easing = _ref$easing === void 0 ? defaultEasing$8 : _ref$easing,
    inProp = _ref["in"],
    style = _ref.style,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? defaultTimeout$7 : _ref$timeout,
    rest = _objectWithoutProperties(_ref, _excluded$1E);
  var nodeRef = useRef(null);
  var combinedRef = useMergeRefs(nodeRef, ref);
  useEffect(function () {
    if (inProp) {
      var node = nodeRef.current;
      reflow(node); // force reflow to make the transition work when animating appearance
    }
  }, [inProp]);
  return jsx(Transition, _objectSpread2(_objectSpread2({
    appear: appear,
    "in": inProp,
    nodeRef: nodeRef,
    timeout: timeout
  }, rest), {}, {
    children: function children(state, childProps) {
      var transitionProps = inProp ? getEnterTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      }) : getExitTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      });
      var transition = createTransitionStyle('opacity', transitionProps);
      var variantStyle = mapStateToVariantStyle$8(state, {});
      var styleProps = _objectSpread2(_objectSpread2({}, variantStyle), {}, {
        transition: transition,
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      });
      if (typeof _children === 'function') {
        return _children(state, _objectSpread2(_objectSpread2({}, childProps), {}, {
          ref: combinedRef,
          style: _objectSpread2(_objectSpread2({}, styleProps), style)
        }));
      }
      return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
        ref: combinedRef
      }, childProps), styleProps), {}, {
        style: style,
        children: _children
      }));
    }
  }));
});
Fade.displayName = 'Fade';

var _excluded$1D = ["appear", "children", "easing", "in", "style", "timeout"];
var getScale$1 = function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
};
var mapStateToVariantStyle$7 = function mapStateToVariantStyle(state, props) {
  var variantStyle = {
    entering: {
      opacity: 1,
      transform: getScale$1(1)
    },
    entered: {
      opacity: 1,
      transform: 'none'
    },
    exiting: {
      opacity: 0,
      transform: getScale$1(0.75)
    },
    exited: {
      opacity: 0,
      transform: getScale$1(0.75)
    }
  }[state];
  return typeof variantStyle === 'function' ? variantStyle(props) : variantStyle;
};
var defaultEasing$7 = {
  enter: transitionEasing.easeInOut,
  exit: transitionEasing.easeInOut
};
var getAutoHeightDuration = function getAutoHeightDuration(height) {
  height = ensureFiniteNumber(height);
  if (!height) {
    return 0;
  }
  var value = height / 36;
  // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
  return Math.round((4 + 15 * Math.pow(value, 0.25) + value / 5) * 10);
};
var Grow = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$appear = _ref.appear,
    appear = _ref$appear === void 0 ? false : _ref$appear,
    _children = _ref.children,
    _ref$easing = _ref.easing,
    easing = _ref$easing === void 0 ? defaultEasing$7 : _ref$easing,
    inProp = _ref["in"],
    style = _ref.style,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? 'auto' : _ref$timeout,
    rest = _objectWithoutProperties(_ref, _excluded$1D);
  var timer = useRef(null);
  var autoTimeout = useRef(0);
  var nodeRef = useRef(null);
  var combinedRef = useMergeRefs(nodeRef, ref);
  useEffect(function () {
    if (inProp) {
      var node = nodeRef.current;
      reflow(node); // force reflow to make the transition work when animating appearance
    }
  }, [inProp]);
  useEffect(function () {
    return function () {
      if (timer.current) {
        clearTimeout(timer.current);
        timer.current = null;
      }
    };
  }, []);
  var addEndListener = useCallback(function (next) {
    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTimeout.current || 0);
    }
  }, [timeout]);
  return jsx(Transition, _objectSpread2(_objectSpread2({
    appear: appear,
    "in": inProp,
    nodeRef: nodeRef,
    timeout: timeout === 'auto' ? null : timeout,
    addEndListener: addEndListener
  }, rest), {}, {
    children: function children(state, childProps) {
      var node = nodeRef.current;
      var transitionProps = inProp ? getEnterTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      }) : getExitTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      });
      var duration = timeout === 'auto' ? getAutoHeightDuration(node === null || node === void 0 ? void 0 : node.clientHeight) : transitionProps.duration;
      var transition = [createTransitionStyle('opacity', {
        duration: duration,
        delay: transitionProps.delay
      }), createTransitionStyle('transform', {
        duration: duration * 0.666,
        easing: transitionProps.easing,
        delay: inProp ? transitionProps.delay : transitionProps.delay || duration * 0.333
      })].join(',');
      autoTimeout.current = timeout === 'auto' ? duration : 0;
      var variantStyle = mapStateToVariantStyle$7(state, {});
      var styleProps = _objectSpread2(_objectSpread2({}, variantStyle), {}, {
        transition: transition,
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      });
      if (typeof _children === 'function') {
        return _children(state, _objectSpread2(_objectSpread2({}, childProps), {}, {
          ref: combinedRef,
          style: _objectSpread2(_objectSpread2({}, styleProps), style)
        }));
      }
      return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
        ref: combinedRef
      }, childProps), styleProps), {}, {
        style: style,
        children: _children
      }));
    }
  }));
});
Grow.displayName = 'Grow';

var _excluded$1C = ["appear", "children", "easing", "in", "initialScale", "style", "timeout"];
var mapStateToVariantStyle$6 = function mapStateToVariantStyle(state, props) {
  var variantStyle = {
    entering: {
      transform: 'none'
    },
    entered: {
      transform: 'none'
    },
    exiting: function exiting(props) {
      var _ensureArray = ensureArray(props.initialScale),
        _ensureArray2 = _slicedToArray(_ensureArray, 2),
        scaleX = _ensureArray2[0],
        scaleY = _ensureArray2[1];
      return {
        transform: scaleY !== undefined ? "scale(".concat(scaleX, ", ").concat(scaleY, ")") : "scale(".concat(scaleX, ")")
      };
    },
    exited: function exited(props) {
      var _ensureArray3 = ensureArray(props.initialScale),
        _ensureArray4 = _slicedToArray(_ensureArray3, 2),
        scaleX = _ensureArray4[0],
        scaleY = _ensureArray4[1];
      return {
        transform: scaleY !== undefined ? "scale(".concat(scaleX, ", ").concat(scaleY, ")") : "scale(".concat(scaleX, ")")
      };
    }
  }[state];
  return typeof variantStyle === 'function' ? variantStyle(props) : variantStyle;
};
var defaultEasing$6 = {
  enter: transitionEasing.easeOut,
  exit: transitionEasing.easeIn
};
var defaultInitialScale = [0.95,
// sx
0.95 // sy
];

var defaultTimeout$6 = {
  enter: 150,
  exit: 150
};
var Scale = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$appear = _ref.appear,
    appear = _ref$appear === void 0 ? false : _ref$appear,
    _children = _ref.children,
    _ref$easing = _ref.easing,
    easing = _ref$easing === void 0 ? defaultEasing$6 : _ref$easing,
    inProp = _ref["in"],
    _ref$initialScale = _ref.initialScale,
    initialScale = _ref$initialScale === void 0 ? defaultInitialScale : _ref$initialScale,
    style = _ref.style,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? defaultTimeout$6 : _ref$timeout,
    rest = _objectWithoutProperties(_ref, _excluded$1C);
  var nodeRef = useRef(null);
  var combinedRef = useMergeRefs(nodeRef, ref);
  useEffect(function () {
    if (inProp) {
      var node = nodeRef.current;
      reflow(node); // force reflow to make the transition work when animating appearance
    }
  }, [inProp]);
  return jsx(Transition, _objectSpread2(_objectSpread2({
    appear: appear,
    "in": inProp,
    nodeRef: nodeRef,
    timeout: timeout
  }, rest), {}, {
    children: function children(state, childProps) {
      var transitionProps = inProp ? getEnterTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      }) : getExitTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      });
      var transition = createTransitionStyle('transform', transitionProps);
      var variantStyle = mapStateToVariantStyle$6(state, {
        initialScale: initialScale
      });
      var styleProps = _objectSpread2(_objectSpread2({}, variantStyle), {}, {
        transition: transition,
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      });
      if (typeof _children === 'function') {
        return _children(state, _objectSpread2(_objectSpread2({}, childProps), {}, {
          ref: combinedRef,
          style: _objectSpread2(_objectSpread2({}, styleProps), style)
        }));
      }
      return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
        ref: combinedRef
      }, childProps), styleProps), {}, {
        style: style,
        children: _children
      }));
    }
  }));
});
Scale.displayName = 'Scale';

var _excluded$1B = ["appear", "children", "direction", "easing", "in", "style", "timeout"];
var DIRECTION_LEFT = 'left';
var DIRECTION_RIGHT = 'right';
var DIRECTION_UP = 'up';
var DIRECTION_DOWN = 'down';
var mapStateToVariantStyle$5 = function mapStateToVariantStyle(state, props) {
  var variantStyle = {
    entering: {
      transform: 'none'
    },
    entered: {
      transform: 'none'
    },
    exiting: function exiting(props) {
      var _DIRECTION_LEFT$DIREC;
      return (_DIRECTION_LEFT$DIREC = {}, _defineProperty(_DIRECTION_LEFT$DIREC, DIRECTION_LEFT, {
        transform: 'translateX(100%)'
      }), _defineProperty(_DIRECTION_LEFT$DIREC, DIRECTION_RIGHT, {
        transform: 'translateX(-100%)'
      }), _defineProperty(_DIRECTION_LEFT$DIREC, DIRECTION_UP, {
        transform: 'translateY(100%)'
      }), _defineProperty(_DIRECTION_LEFT$DIREC, DIRECTION_DOWN, {
        transform: 'translateY(-100%)'
      }), _DIRECTION_LEFT$DIREC)[props.direction];
    },
    exited: function exited(props) {
      var _DIRECTION_LEFT$DIREC2;
      return (_DIRECTION_LEFT$DIREC2 = {}, _defineProperty(_DIRECTION_LEFT$DIREC2, DIRECTION_LEFT, {
        transform: 'translateX(100%)'
      }), _defineProperty(_DIRECTION_LEFT$DIREC2, DIRECTION_RIGHT, {
        transform: 'translateX(-100%)'
      }), _defineProperty(_DIRECTION_LEFT$DIREC2, DIRECTION_UP, {
        transform: 'translateY(100%)'
      }), _defineProperty(_DIRECTION_LEFT$DIREC2, DIRECTION_DOWN, {
        transform: 'translateY(-100%)'
      }), _DIRECTION_LEFT$DIREC2)[props.direction];
    }
  }[state];
  return typeof variantStyle === 'function' ? variantStyle(props) : variantStyle;
};
var defaultEasing$5 = {
  enter: transitionEasing.easeOut,
  exit: transitionEasing.sharp
};
var defaultTimeout$5 = {
  enter: transitionDuration.enteringScreen,
  exit: transitionDuration.leavingScreen
};
var Slide = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$appear = _ref.appear,
    appear = _ref$appear === void 0 ? false : _ref$appear,
    _children = _ref.children,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? DIRECTION_DOWN : _ref$direction,
    _ref$easing = _ref.easing,
    easing = _ref$easing === void 0 ? defaultEasing$5 : _ref$easing,
    inProp = _ref["in"],
    style = _ref.style,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? defaultTimeout$5 : _ref$timeout,
    rest = _objectWithoutProperties(_ref, _excluded$1B);
  var nodeRef = useRef(null);
  var combinedRef = useMergeRefs(nodeRef, ref);
  useEffect(function () {
    if (inProp) {
      var node = nodeRef.current;
      reflow(node); // force reflow to make the transition work when animating appearance
    }
  }, [inProp]);
  return jsx(Transition, _objectSpread2(_objectSpread2({
    appear: appear,
    "in": inProp,
    nodeRef: nodeRef,
    timeout: timeout
  }, rest), {}, {
    children: function children(state, childProps) {
      var transitionProps = inProp ? getEnterTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      }) : getExitTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      });
      var transition = createTransitionStyle('transform', transitionProps);
      var variantStyle = mapStateToVariantStyle$5(state, {
        direction: direction
      });
      var styleProps = _objectSpread2(_objectSpread2({}, variantStyle), {}, {
        transition: transition,
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      });
      if (typeof _children === 'function') {
        return _children(state, _objectSpread2(_objectSpread2({}, childProps), {}, {
          ref: combinedRef,
          style: _objectSpread2(_objectSpread2({}, styleProps), style)
        }));
      }
      return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
        ref: combinedRef
      }, childProps), styleProps), {}, {
        style: style,
        children: _children
      }));
    }
  }));
});
Slide.displayName = 'Slide';

var _excluded$1A = ["appear", "children", "easing", "in", "style", "timeout"];
var mapStateToVariantStyle$4 = function mapStateToVariantStyle(state, props) {
  var variantStyle = {
    entering: {
      transform: 'none'
    },
    entered: {
      transform: 'none'
    },
    exiting: {
      transform: 'scale(0)'
    },
    exited: {
      transform: 'scale(0)'
    }
  }[state];
  return typeof variantStyle === 'function' ? variantStyle(props) : variantStyle;
};
var defaultEasing$4 = {
  enter: transitionEasing.easeInOut,
  exit: transitionEasing.easeInOut
};
var defaultTimeout$4 = {
  enter: transitionDuration.enteringScreen,
  exit: transitionDuration.leavingScreen
};
var Zoom = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$appear = _ref.appear,
    appear = _ref$appear === void 0 ? false : _ref$appear,
    _children = _ref.children,
    _ref$easing = _ref.easing,
    easing = _ref$easing === void 0 ? defaultEasing$4 : _ref$easing,
    inProp = _ref["in"],
    style = _ref.style,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? defaultTimeout$4 : _ref$timeout,
    rest = _objectWithoutProperties(_ref, _excluded$1A);
  var nodeRef = useRef(null);
  var combinedRef = useMergeRefs(nodeRef, ref);
  useEffect(function () {
    if (inProp) {
      var node = nodeRef.current;
      reflow(node); // force reflow to make the transition work when animating appearance
    }
  }, [inProp]);
  return jsx(Transition, _objectSpread2(_objectSpread2({
    appear: appear,
    "in": inProp,
    nodeRef: nodeRef,
    timeout: timeout
  }, rest), {}, {
    children: function children(state, childProps) {
      var transitionProps = inProp ? getEnterTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      }) : getExitTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      });
      var transition = createTransitionStyle('transform', transitionProps);
      var variantStyle = mapStateToVariantStyle$4(state, {});
      var styleProps = _objectSpread2(_objectSpread2({}, variantStyle), {}, {
        transition: transition,
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      });
      if (typeof _children === 'function') {
        return _children(state, _objectSpread2(_objectSpread2({}, childProps), {}, {
          ref: combinedRef,
          style: _objectSpread2(_objectSpread2({}, styleProps), style)
        }));
      }
      return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
        ref: combinedRef
      }, childProps), styleProps), {}, {
        style: style,
        children: _children
      }));
    }
  }));
});
Zoom.displayName = 'Zoom';

var useAccordionItem = function useAccordionItem() {
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(AccordionItemContext);
  return context;
};

var _excluded$1z = ["TransitionComponent", "TransitionProps"];
var AccordionContent = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$TransitionCompon = _ref.TransitionComponent,
    TransitionComponent = _ref$TransitionCompon === void 0 ? Collapse : _ref$TransitionCompon,
    TransitionProps = _ref.TransitionProps,
    rest = _objectWithoutProperties(_ref, _excluded$1z);
  var context = useAccordionItem(); // context might be an undefined value

  if (!context) {
    return jsx(Box, _objectSpread2({
      ref: ref
    }, rest));
  }
  return jsx(TransitionComponent, _objectSpread2(_objectSpread2({
    appear: false // do not perform the enter transition when it first mounts
  }, TransitionProps), {}, {
    "aria-hidden": ariaAttr(!(context !== null && context !== void 0 && context.isExpanded)),
    "aria-labelledby": context === null || context === void 0 ? void 0 : context.accordionToggleId,
    id: context === null || context === void 0 ? void 0 : context.accordionContentId,
    "in": context === null || context === void 0 ? void 0 : context.isExpanded,
    ref: ref
  }, rest));
});
AccordionContent.displayName = 'AccordionContent';

var AccordionBody = /*#__PURE__*/forwardRef(function (props, ref) {
  var styleProps = useAccordionBodyStyle();
  return jsx(AccordionContent, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), props));
});
AccordionBody.displayName = 'AccordionBody';

//---------------- Default Button ----------------//
var defaultVariantStyle = function defaultVariantStyle(_ref) {
  var _theme$colors, _theme$colors2, _theme$sizes, _theme$colors3, _theme$colors4, _theme$sizes2;
  var colorMode = _ref.colorMode,
    theme = _ref.theme;
  // Normal
  var backgroundColor = {
    dark: 'gray:60',
    light: 'gray:20'
  }[colorMode];
  var color = {
    dark: 'white:emphasis',
    light: 'black:emphasis'
  }[colorMode];
  // Hover
  var hoverBackgroundColor = {
    dark: 'gray:50',
    light: 'gray:10'
  }[colorMode];
  // Active
  var activeBackgroundColor = {
    dark: 'gray:70',
    light: 'gray:30'
  }[colorMode];
  // Focus
  var focusBorderColor = {
    dark: 'blue:60',
    light: 'blue:60'
  }[colorMode];
  var focusBoxShadowOuterColor = {
    dark: theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors['blue:60'],
    light: theme === null || theme === void 0 ? void 0 : (_theme$colors2 = theme.colors) === null || _theme$colors2 === void 0 ? void 0 : _theme$colors2['blue:60']
  }[colorMode];
  var focusBoxShadowOuterSpreadRadius = theme === null || theme === void 0 ? void 0 : (_theme$sizes = theme.sizes) === null || _theme$sizes === void 0 ? void 0 : _theme$sizes['1q'];
  var focusBoxShadowInnerColor = {
    dark: theme === null || theme === void 0 ? void 0 : (_theme$colors3 = theme.colors) === null || _theme$colors3 === void 0 ? void 0 : _theme$colors3['black:emphasis'],
    light: theme === null || theme === void 0 ? void 0 : (_theme$colors4 = theme.colors) === null || _theme$colors4 === void 0 ? void 0 : _theme$colors4['white:emphasis']
  }[colorMode];
  var focusBoxShadowInnerSpreadRadius = theme === null || theme === void 0 ? void 0 : (_theme$sizes2 = theme.sizes) === null || _theme$sizes2 === void 0 ? void 0 : _theme$sizes2['2q'];
  // Disabled
  var disabledBackgroundColor = {
    dark: 'gray:60',
    light: 'gray:20'
  }[colorMode];
  var disabledColor = {
    dark: 'white:emphasis',
    light: 'black:emphasis'
  }[colorMode];
  var disabledOpacity = {
    dark: 0.28,
    light: 0.3
  }[colorMode];
  // Selected
  var selectedBackgroundColor = {
    dark: 'gray:70',
    light: 'gray:30'
  }[colorMode];
  var selectedColor = {
    dark: 'white:emphasis',
    light: 'black:emphasis'
  }[colorMode];
  return {
    backgroundColor: backgroundColor,
    borderColor: 'transparent',
    color: color,
    _focus: {
      ':not(:active)': {
        borderColor: focusBorderColor,
        boxShadow: "inset 0 0 0 ".concat(focusBoxShadowOuterSpreadRadius, " ").concat(focusBoxShadowOuterColor, ", inset 0 0 0 ").concat(focusBoxShadowInnerSpreadRadius, " ").concat(focusBoxShadowInnerColor)
      },
      // Bring overlapping border to front when focused
      zIndex: 1
    },
    _hover: {
      backgroundColor: hoverBackgroundColor,
      // Use a higher z-index value to bring overlapping border to front when hovered
      zIndex: 2
    },
    _active: {
      backgroundColor: activeBackgroundColor
    },
    _disabled: {
      backgroundColor: disabledBackgroundColor,
      color: disabledColor,
      cursor: 'not-allowed',
      opacity: disabledOpacity
    },
    _selected: {
      backgroundColor: selectedBackgroundColor,
      color: selectedColor,
      pointerEvents: 'none' // Do not react to mouse events when selected
    }
  };
};

//---------------- Secondary Button ----------------//
var secondaryVariantStyle = function secondaryVariantStyle(_ref2) {
  var _theme$colors5, _theme$colors6, _theme$sizes3;
  var colorMode = _ref2.colorMode,
    theme = _ref2.theme;
  // Normal
  var borderColor = {
    dark: 'gray:60',
    light: 'gray:30'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  // Hover
  var hoverBorderColor = {
    dark: 'blue:50',
    light: 'blue:50'
  }[colorMode];
  var hoverColor = {
    dark: 'blue:40',
    light: 'blue:60'
  }[colorMode];
  // Active
  var activeBackgroundColor = {
    dark: 'rgba(0, 0, 0, 0.12)',
    light: 'rgba(0, 0, 0, 0.08)'
  }[colorMode];
  var activeBorderColor = hoverBorderColor;
  var activeColor = hoverColor;
  // Focus
  var focusBorderColor = {
    dark: 'blue:60',
    light: 'blue:60'
  }[colorMode];
  var focusBoxShadowColor = {
    dark: theme === null || theme === void 0 ? void 0 : (_theme$colors5 = theme.colors) === null || _theme$colors5 === void 0 ? void 0 : _theme$colors5['blue:60'],
    light: theme === null || theme === void 0 ? void 0 : (_theme$colors6 = theme.colors) === null || _theme$colors6 === void 0 ? void 0 : _theme$colors6['blue:60']
  }[colorMode];
  var focusBoxShadowSpreadRadius = theme === null || theme === void 0 ? void 0 : (_theme$sizes3 = theme.sizes) === null || _theme$sizes3 === void 0 ? void 0 : _theme$sizes3['1q'];
  var focusColor = color;
  // Disabled
  var disabledBorderColor = borderColor;
  var disabledColor = {
    dark: 'white:emphasis',
    light: 'black:emphasis'
  }[colorMode];
  var disabledOpacity = {
    dark: 0.28,
    light: 0.3
  }[colorMode];
  // Selected
  var selectedBackgroundColor = {
    dark: 'gray:70',
    light: 'gray:30'
  }[colorMode];
  var selectedColor = {
    dark: 'white:emphasis',
    light: 'black:emphasis'
  }[colorMode];
  return {
    borderColor: borderColor,
    color: color,
    _focus: {
      borderColor: focusBorderColor,
      boxShadow: "inset 0 0 0 ".concat(focusBoxShadowSpreadRadius, " ").concat(focusBoxShadowColor),
      color: focusColor,
      // Bring overlapping border to front when focused
      zIndex: 1
    },
    _hover: {
      color: hoverColor,
      '&:not(:focus)': {
        borderColor: hoverBorderColor
      },
      // Use a higher z-index value to bring overlapping border to front when hovered
      zIndex: 2
    },
    _active: {
      borderColor: activeBorderColor,
      backgroundColor: activeBackgroundColor,
      color: activeColor
    },
    _disabled: {
      borderColor: disabledBorderColor,
      color: disabledColor,
      cursor: 'not-allowed',
      opacity: disabledOpacity
    },
    _selected: {
      backgroundColor: selectedBackgroundColor,
      color: selectedColor,
      pointerEvents: 'none' // Do not react to mouse events when selected
    }
  };
};

//---------------- Ghost Button ----------------//
var ghostVariantStyle = function ghostVariantStyle(_ref3) {
  var colorMode = _ref3.colorMode,
    theme = _ref3.theme;
  var style = secondaryVariantStyle({
    colorMode: colorMode,
    theme: theme
  });
  // Selected
  var selectedBackgroundColor = {
    dark: 'gray:70',
    light: 'gray:30'
  }[colorMode];
  var selectedBorderColor = {
    dark: 'gray:70',
    light: 'gray:30'
  }[colorMode];
  var selectedColor = {
    dark: 'white:emphasis',
    light: 'black:emphasis'
  }[colorMode];
  return _objectSpread2(_objectSpread2({}, style), {}, {
    borderColor: 'transparent',
    _disabled: _objectSpread2(_objectSpread2({}, style._disabled), {}, {
      borderColor: 'transparent',
      cursor: 'not-allowed'
    }),
    _selected: {
      backgroundColor: selectedBackgroundColor,
      borderColor: selectedBorderColor,
      color: selectedColor,
      pointerEvents: 'none' // Do not react to mouse events when selected
    }
  });
};

//---------------- Emphasis / Primary Button ----------------//
var fillColorVariantStyle = function fillColorVariantStyle(_ref4) {
  var _theme$colors7, _theme$colors8, _theme$sizes4, _theme$colors9, _theme$colors10, _theme$sizes5;
  var colorProp = _ref4.color,
    colorMode = _ref4.colorMode,
    theme = _ref4.theme;
  // Normal
  var backgroundColor = {
    dark: "".concat(colorProp, ":60"),
    light: "".concat(colorProp, ":60")
  }[colorMode];
  var color = {
    dark: 'white:emphasis',
    light: 'white:emphasis'
  }[colorMode];
  // Hover
  var hoverBackgroundColor = {
    dark: "".concat(colorProp, ":50"),
    light: "".concat(colorProp, ":50")
  }[colorMode];
  // Active
  var activeBackgroundColor = {
    dark: "".concat(colorProp, ":70"),
    light: "".concat(colorProp, ":70")
  }[colorMode];
  // Focus
  var focusBorderColor = {
    dark: theme === null || theme === void 0 ? void 0 : (_theme$colors7 = theme.colors) === null || _theme$colors7 === void 0 ? void 0 : _theme$colors7['blue:60'],
    light: theme === null || theme === void 0 ? void 0 : (_theme$colors8 = theme.colors) === null || _theme$colors8 === void 0 ? void 0 : _theme$colors8['blue:60']
  }[colorMode];
  var focusBoxShadowSpreadRadius = theme === null || theme === void 0 ? void 0 : (_theme$sizes4 = theme.sizes) === null || _theme$sizes4 === void 0 ? void 0 : _theme$sizes4['1q'];
  var boxShadowColor = {
    dark: theme === null || theme === void 0 ? void 0 : (_theme$colors9 = theme.colors) === null || _theme$colors9 === void 0 ? void 0 : _theme$colors9['black:emphasis'],
    light: theme === null || theme === void 0 ? void 0 : (_theme$colors10 = theme.colors) === null || _theme$colors10 === void 0 ? void 0 : _theme$colors10['white:emphasis']
  }[colorMode];
  var boxShadowSpreadRadius = theme === null || theme === void 0 ? void 0 : (_theme$sizes5 = theme.sizes) === null || _theme$sizes5 === void 0 ? void 0 : _theme$sizes5['2q'];
  // Disabled
  var disabledBackgroundColor = {
    dark: 'gray:60',
    light: 'gray:20'
  }[colorMode];
  var disabledColor = {
    dark: 'white:emphasis',
    light: 'black:emphasis'
  }[colorMode];
  var disabledOpacity = {
    dark: 0.28,
    light: 0.3
  }[colorMode];
  // Selected
  var selectedBackgroundColor = {
    dark: "".concat(colorProp, ":80"),
    light: "".concat(colorProp, ":80")
  }[colorMode];
  var selectedColor = {
    dark: 'white:emphasis',
    light: 'white:emphasis'
  }[colorMode];
  return {
    backgroundColor: backgroundColor,
    borderColor: 'transparent',
    color: color,
    _focus: {
      ':not(:active)': {
        borderColor: focusBorderColor,
        boxShadow: "inset 0 0 0 ".concat(focusBoxShadowSpreadRadius, " ").concat(focusBorderColor, ", inset 0 0 0 ").concat(boxShadowSpreadRadius, " ").concat(boxShadowColor)
      },
      // Bring overlapping border to front when focused
      zIndex: 1
    },
    _hover: {
      backgroundColor: hoverBackgroundColor,
      // Use a higher z-index value to bring overlapping border to front when hovered
      zIndex: 2
    },
    _active: {
      backgroundColor: activeBackgroundColor
    },
    _disabled: {
      backgroundColor: disabledBackgroundColor,
      color: disabledColor,
      cursor: 'not-allowed',
      opacity: disabledOpacity
    },
    _selected: {
      backgroundColor: selectedBackgroundColor,
      color: selectedColor,
      pointerEvents: 'none' // Do not react to mouse events when selected
    }
  };
};

var useButtonStyle = function useButtonStyle(_ref5) {
  var orientation = _ref5.orientation,
    size = _ref5.size,
    variant = _ref5.variant;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var theme = useTheme();
  var baseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    appearance: 'none',
    userSelect: 'none',
    whiteSpace: 'nowrap',
    border: 1,
    borderRadius: 'sm',
    px: '3x',
    transition: createTransitionStyle(['background-color', 'border-color', 'box-shadow', 'color'], {
      duration: 200
    })
  };
  var orientationStyle = {
    'horizontal': {
      _notFirstOfType: {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      },
      _notLastOfType: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      }
    },
    'vertical': {
      _notFirstOfType: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0
      },
      _notLastOfType: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
      }
    }
  }[orientation];
  var sizeStyle = {
    lg: {
      minHeight: '10x',
      fontSize: 'md',
      lineHeight: 'md'
    },
    md: {
      minHeight: '8x',
      fontSize: 'sm',
      lineHeight: 'sm'
    },
    sm: {
      minHeight: '6x',
      fontSize: 'sm',
      lineHeight: 'sm'
    }
  }[size];
  var variantStyle = {
    'secondary': secondaryVariantStyle({
      colorMode: colorMode,
      theme: theme
    }),
    'ghost': ghostVariantStyle({
      colorMode: colorMode,
      theme: theme
    }),
    'emphasis': fillColorVariantStyle({
      color: 'red',
      colorMode: colorMode,
      theme: theme
    }),
    'primary': fillColorVariantStyle({
      color: 'blue',
      colorMode: colorMode,
      theme: theme
    }),
    'default': defaultVariantStyle({
      colorMode: colorMode,
      theme: theme
    })
  }[variant];
  return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, baseStyle), orientationStyle), sizeStyle), variantStyle);
};
var useButtonBaseStyle = function useButtonBaseStyle(_ref6) {
  var disabled = _ref6.disabled;
  return {
    appearance: 'none',
    backgroundColor: 'inherit',
    border: 'none',
    color: 'inherit',
    // Use the `disabled` prop to conditionally set the cursor to 'not-allowed', allowing for easy style overrides without using the specific "_disabled" style prop.
    cursor: ensureBoolean(disabled) ? 'not-allowed' : 'pointer',
    outline: 0,
    padding: 0
  };
};
var useButtonGroupStyle = function useButtonGroupStyle(_ref7) {
  var orientation = _ref7.orientation;
  var orientationStyle = {
    vertical: {
      flexDirection: 'column'
    },
    horizontal: {
      flexDirection: 'row'
    }
  }[orientation];
  return _objectSpread2({
    display: 'inline-flex'
  }, orientationStyle);
};

var _excluded$1y = ["children", "disabled"];
var ButtonBase = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    rest = _objectWithoutProperties(_ref, _excluded$1y);
  var styleProps = useButtonBaseStyle({
    disabled: disabled
  });
  return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
    ref: ref,
    "aria-disabled": ariaAttr(disabled),
    as: "button",
    type: "button",
    disabled: disabled
  }, styleProps), rest), {}, {
    children: children
  }));
});
ButtonBase.displayName = 'ButtonBase';

var ButtonGroupContext = /*#__PURE__*/createContext();

var useButtonGroup = function useButtonGroup() {
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(ButtonGroupContext);
  return context;
};

var _excluded$1x = ["disabled", "selected", "size", "variant"];
var defaultSize$d = 'md';
var defaultVariant$a = 'default';
var defaultOrientation$2 = 'horizontal';
var Button = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var disabled = _ref.disabled,
    selected = _ref.selected,
    size = _ref.size,
    variant = _ref.variant,
    rest = _objectWithoutProperties(_ref, _excluded$1x);
  var orientation; // orientation for ButtonGroup

  var buttonGroupContext = useButtonGroup();
  if (buttonGroupContext) {
    var _ref2, _size, _ref3, _variant, _ref4, _orientation;
    var _buttonGroupContext = _objectSpread2({}, buttonGroupContext),
      buttonGroupSize = _buttonGroupContext.size,
      buttonGroupVariant = _buttonGroupContext.variant,
      buttonGroupOrientation = _buttonGroupContext.orientation;
    // Use fallback values if values are null or undefined
    size = (_ref2 = (_size = size) !== null && _size !== void 0 ? _size : buttonGroupSize) !== null && _ref2 !== void 0 ? _ref2 : defaultSize$d;
    variant = (_ref3 = (_variant = variant) !== null && _variant !== void 0 ? _variant : buttonGroupVariant) !== null && _ref3 !== void 0 ? _ref3 : defaultVariant$a;
    orientation = (_ref4 = (_orientation = orientation) !== null && _orientation !== void 0 ? _orientation : buttonGroupOrientation) !== null && _ref4 !== void 0 ? _ref4 : defaultOrientation$2;
  } else {
    var _size2, _variant2;
    // Use the default value if the value is null or undefined
    size = (_size2 = size) !== null && _size2 !== void 0 ? _size2 : defaultSize$d;
    variant = (_variant2 = variant) !== null && _variant2 !== void 0 ? _variant2 : defaultVariant$a;
  }
  var attributes = {
    'aria-disabled': ariaAttr(disabled),
    'aria-selected': ariaAttr(selected),
    type: 'button',
    // Disable the button if "disabled" is true
    disabled: disabled,
    /**
     * For button in the disabled state, just keep "pointer-events" and "tabIndex" as is.
     * For button in the selected state, set both "pointer-events: none" and "tabIndex: -1" to prevent the button receiving focus through sequential keyboard navigation.
     */
    tabIndex: selected ? -1 : undefined
  };
  var styleProps = useButtonStyle({
    orientation: orientation,
    // No default value if not specified
    size: size,
    variant: variant
  });
  return jsx(ButtonBase, _objectSpread2(_objectSpread2(_objectSpread2({
    ref: ref,
    as: "button"
  }, attributes), styleProps), rest));
});
Button.displayName = 'Button';

var _excluded$1w = ["children", "orientation", "size", "variant"];
var getMemoizedState$l = memoize(function (state) {
  return _objectSpread2({}, state);
});
var defaultOrientation$1 = 'horizontal';
var defaultSize$c = 'md';
var defaultVariant$9 = 'default';
var ButtonGroup = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? defaultOrientation$1 : _ref$orientation,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaultSize$c : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? defaultVariant$9 : _ref$variant,
    rest = _objectWithoutProperties(_ref, _excluded$1w);
  var styleProps = useButtonGroupStyle({
    orientation: orientation
  });
  var context = getMemoizedState$l({
    orientation: orientation,
    size: size,
    variant: variant
  });
  return jsx(ButtonGroupContext.Provider, {
    value: context,
    children: jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
      ref: ref
    }, styleProps), rest), {}, {
      children: runIfFn(children, context)
    }))
  });
});
ButtonGroup.displayName = 'ButtonGroup';

var ButtonLink = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(Button, _objectSpread2({
    as: "a",
    ref: ref
  }, props));
});
ButtonLink.displayName = 'ButtonLink';

var _excluded$1v = ["children", "disabled", "onClick"];
var AccordionToggle = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    disabledProp = _ref.disabled,
    onClickProp = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded$1v);
  var context = useAccordionItem(); // context might be an undefined value
  var disabled = ensureBoolean(disabledProp !== null && disabledProp !== void 0 ? disabledProp : context === null || context === void 0 ? void 0 : context.disabled);
  var styleProps = useAccordionToggleStyle();
  var getAccordionToggleProps = function getAccordionToggleProps() {
    return _objectSpread2(_objectSpread2({
      'aria-controls': context === null || context === void 0 ? void 0 : context.accordionContentId,
      'aria-disabled': ariaAttr(disabled),
      'aria-expanded': ariaAttr(context === null || context === void 0 ? void 0 : context.isExpanded),
      disabled: disabled,
      id: context === null || context === void 0 ? void 0 : context.accordionToggleId,
      onClick: callEventHandlers(onClickProp, context === null || context === void 0 ? void 0 : context.onToggle),
      ref: ref,
      role: 'button',
      tabIndex: 0
    }, styleProps), rest);
  };
  if (typeof children === 'function') {
    return children({
      getAccordionToggleProps: getAccordionToggleProps
    });
  }
  return jsx(ButtonBase, _objectSpread2(_objectSpread2({}, getAccordionToggleProps()), {}, {
    children: children
  }));
});

var _excluded$1u = ["children", "size", "color", "role", "focusable", "viewBox"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var SVGIconBase = /*#__PURE__*/_styled(Box, process.env.NODE_ENV === "production" ? {
  target: "ei4t6id0"
} : {
  target: "ei4t6id0",
  label: "SVGIconBase"
})(process.env.NODE_ENV === "production" ? {
  name: "q7l7x1",
  styles: "flex-shrink:0;&:not(:root){overflow:hidden;}"
} : {
  name: "q7l7x1",
  styles: "flex-shrink:0;&:not(:root){overflow:hidden;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNWR0ljb24uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSytCIiwiZmlsZSI6IlNWR0ljb24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBhcmlhQXR0ciB9IGZyb20gJ0B0b25pYy11aS91dGlscyc7XG5pbXBvcnQgUmVhY3QsIHsgZm9yd2FyZFJlZiB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IEJveCB9IGZyb20gJy4uL2JveCc7XG5cbmNvbnN0IFNWR0ljb25CYXNlID0gc3R5bGVkKEJveClgXG4gIGZsZXgtc2hyaW5rOiAwO1xuICAmOm5vdCg6cm9vdCkge1xuICAgIG92ZXJmbG93OiBoaWRkZW47XG4gIH1cbmA7XG5cbmNvbnN0IFNWR0ljb24gPSBmb3J3YXJkUmVmKChcbiAge1xuICAgIGNoaWxkcmVuLFxuICAgIHNpemUgPSAnNHgnLFxuICAgIGNvbG9yID0gJ2N1cnJlbnRDb2xvcicsXG4gICAgcm9sZSA9ICdwcmVzZW50YXRpb24nLFxuICAgIGZvY3VzYWJsZSA9IGZhbHNlLFxuICAgIHZpZXdCb3ggPSAnMCAwIDE2IDE2JyxcbiAgICAuLi5yZXN0XG4gIH0sXG4gIHJlZixcbikgPT4ge1xuICByZXR1cm4gKFxuICAgIDxTVkdJY29uQmFzZVxuICAgICAgYXJpYS1oaWRkZW49e2FyaWFBdHRyKHRydWUpfVxuICAgICAgcmVmPXtyZWZ9XG4gICAgICBhcz1cInN2Z1wiXG4gICAgICB3aWR0aD17c2l6ZX1cbiAgICAgIGhlaWdodD17c2l6ZX1cbiAgICAgIGZpbGw9e2NvbG9yfVxuICAgICAgZGlzcGxheT1cImlubGluZS1mbGV4XCJcbiAgICAgIHZlcnRpY2FsQWxpZ249XCJtaWRkbGVcIlxuICAgICAgdmlld0JveD17dmlld0JveH1cbiAgICAgIGZvY3VzYWJsZT17Zm9jdXNhYmxlfVxuICAgICAgcm9sZT17cm9sZX1cbiAgICAgIHsuLi5yZXN0fVxuICAgID5cbiAgICAgIHtjaGlsZHJlbn1cbiAgICA8L1NWR0ljb25CYXNlPlxuICApO1xufSk7XG5cblNWR0ljb24uZGlzcGxheU5hbWUgPSAnU1ZHSWNvbic7XG5cbmV4cG9ydCBkZWZhdWx0IFNWR0ljb247XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});
var SVGIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '4x' : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'presentation' : _ref$role,
    _ref$focusable = _ref.focusable,
    focusable = _ref$focusable === void 0 ? false : _ref$focusable,
    _ref$viewBox = _ref.viewBox,
    viewBox = _ref$viewBox === void 0 ? '0 0 16 16' : _ref$viewBox,
    rest = _objectWithoutProperties(_ref, _excluded$1u);
  return jsx(SVGIconBase, _objectSpread2(_objectSpread2({
    "aria-hidden": ariaAttr(true),
    ref: ref,
    as: "svg",
    width: size,
    height: size,
    fill: color,
    display: "inline-flex",
    verticalAlign: "middle",
    viewBox: viewBox,
    focusable: focusable,
    role: role
  }, rest), {}, {
    children: children
  }));
});
SVGIcon.displayName = 'SVGIcon';

var _excluded$1t = ["icon", "spin"],
  _excluded2 = ["path"];
var _templateObject$3, _templateObject2$2;
var cwSpin = keyframes(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  0% {\n      transform: rotate(0deg)\n  }\n  to {\n      transform: rotate(1turn)\n  }\n"])));
var ccwSpin = keyframes(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  0% {\n      transform: rotate(0deg)\n  }\n  to {\n      transform: rotate(-1turn)\n  }\n"])));
var Icon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
    _ref$spin = _ref.spin,
    spin = _ref$spin === void 0 ? false : _ref$spin,
    rest = _objectWithoutProperties(_ref, _excluded$1t);
  var _useTheme = useTheme(),
    _useTheme$icons = _useTheme.icons,
    icons = _useTheme$icons === void 0 ? {} : _useTheme$icons;
  var tmicon = _get(icons, ["tmicon-".concat(icon)]);
  var _ensurePlainObject = ensurePlainObject(_get(icons, icon, tmicon)),
    path = _ensurePlainObject.path,
    restIconProps = _objectWithoutProperties(_ensurePlainObject, _excluded2);
  var styleProps = {
    animation: function () {
      if (spin === 'ccw') {
        return "".concat(ccwSpin, " 2s linear infinite");
      }
      if (spin === 'cw' || spin === true) {
        return "".concat(cwSpin, " 2s linear infinite");
      }
      return undefined;
    }()
  };
  return jsx(SVGIcon, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), restIconProps), rest), {}, {
    children: path
  }));
});
Icon.displayName = 'Icon';

var _excluded$1s = ["appear", "children", "disabled", "easing", "style", "timeout"];
var mapStateToVariantStyle$3 = function mapStateToVariantStyle(state, props) {
  var variantStyle = {
    entering: function entering(props) {
      return {
        transform: 'rotate(-180deg)'
      };
    },
    entered: function entered(props) {
      return {
        transform: 'rotate(-180deg)'
      };
    },
    exiting: function exiting(props) {
      return {
        transform: 'rotate(0deg)'
      };
    },
    exited: function exited(props) {
      return {
        transform: 'rotate(0deg)'
      };
    }
  }[state];
  return typeof variantStyle === 'function' ? variantStyle(props) : variantStyle;
};
var defaultEasing$3 = {
  enter: transitionEasing.easeOut,
  exit: transitionEasing.easeOut
};
var defaultTimeout$3 = {
  enter: 133,
  exit: Math.floor(133 * 0.7)
};
var AccordionToggleIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$appear = _ref.appear,
    appear = _ref$appear === void 0 ? false : _ref$appear,
    _children = _ref.children,
    disabledProp = _ref.disabled,
    _ref$easing = _ref.easing,
    easing = _ref$easing === void 0 ? defaultEasing$3 : _ref$easing,
    style = _ref.style,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? defaultTimeout$3 : _ref$timeout,
    rest = _objectWithoutProperties(_ref, _excluded$1s);
  var context = useAccordionItem(); // context might be an undefined value
  var toggleIconStyleProps = useAccordionToggleIconStyle();
  var nodeRef = useRef(null);
  var combinedRef = useMergeRefs(nodeRef, ref);
  var disabled = ensureBoolean(disabledProp !== null && disabledProp !== void 0 ? disabledProp : context === null || context === void 0 ? void 0 : context.disabled);
  var isExpanded = ensureBoolean(context === null || context === void 0 ? void 0 : context.isExpanded);
  useEffect(function () {
    if (isExpanded) {
      var node = nodeRef.current;
      reflow(node); // force reflow to make the transition work when animating appearance
    }
  }, [isExpanded]);
  return jsx(Transition, _objectSpread2(_objectSpread2({
    appear: appear,
    "in": isExpanded,
    nodeRef: nodeRef,
    timeout: timeout
  }, rest), {}, {
    children: function children(state, childProps) {
      var transitionProps = isExpanded ? getEnterTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      }) : getExitTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      });
      var transition = createTransitionStyle('transform', transitionProps);
      var variantStyle = mapStateToVariantStyle$3(state, {});
      var styleProps = _objectSpread2(_objectSpread2(_objectSpread2({}, toggleIconStyleProps), variantStyle), {}, {
        'aria-disabled': ariaAttr(disabled),
        transition: transition
      });
      if (typeof _children === 'function') {
        return _children(state, _objectSpread2(_objectSpread2({}, childProps), {}, {
          ref: combinedRef,
          style: _objectSpread2(_objectSpread2({}, styleProps), style)
        }));
      }
      var iconName = 'chevron-down';
      return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
        ref: combinedRef
      }, styleProps), childProps), {}, {
        style: style,
        children: _children !== null && _children !== void 0 ? _children : jsx(Icon, {
          width: "4x",
          icon: iconName
        })
      }));
    }
  }));
});
AccordionToggleIcon.displayName = 'AccordionToggleIcon';

var _excluded$1r = ["children", "disabled"];
var AccordionHeader = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    disabledProp = _ref.disabled,
    rest = _objectWithoutProperties(_ref, _excluded$1r);
  var context = useAccordionItem(); // context might be an undefined value
  var disabled = ensureBoolean(disabledProp !== null && disabledProp !== void 0 ? disabledProp : context === null || context === void 0 ? void 0 : context.disabled);
  var styleProps = useAccordionHeaderStyle();
  return jsxs(AccordionToggle, _objectSpread2(_objectSpread2(_objectSpread2({
    ref: ref,
    disabled: disabled
  }, styleProps), rest), {}, {
    children: [jsx(Box, {
      children: children
    }), jsx(AccordionToggleIcon, {})]
  }));
});
AccordionHeader.displayName = 'AccordionHeader';

var config = {
  name: '@tonic-ui/react'
};

var serverHandoffComplete = false;
var id = 0;
var genId = function genId() {
  return ++id;
};

/**
 * useAutoId
 *
 * Autogenerate IDs to facilitate WAI-ARIA and server rendering.
 *
 * Note: The returned ID will initially be `null` and will update after a
 * component mounts. Users may need to supply their own ID if they need
 * consistent values for SSR.
 *
 */
var useAutoId = function useAutoId(idProp) {
  /*
   * If this instance isn't part of the initial render, we don't have to do the
   * double render/patch-up dance. We can just generate the ID and return it.
   */
  var initialId = idProp || (serverHandoffComplete ? genId() : null);
  var _useState = useState(initialId),
    _useState2 = _slicedToArray(_useState, 2),
    id = _useState2[0],
    setId = _useState2[1];
  useIsomorphicEffect(function () {
    if (id === null) {
      /*
       * Patch the ID after render. We do this in `useLayoutEffect` to avoid any
       * rendering flicker, though it'll make the first render slower (unlikely
       * to matter, but you're welcome to measure your app and let us know if
       * it's a problem).
       */
      setId(genId());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    if (serverHandoffComplete === false) {
      /*
       * Flag all future uses of `useAutoId` to skip the update dance. This is in
       * `useEffect` because it goes after `useLayoutEffect`, ensuring we don't
       * accidentally bail out of the patch-up dance prematurely.
       */
      serverHandoffComplete = true;
    }
  }, []);
  return id != null ? String(id) : undefined;
};

var useAccordion = function useAccordion() {
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(AccordionContext);
  return context;
};

var _excluded$1q = ["children", "disabled", "isExpanded", "defaultIsExpanded", "onToggle"];
var getMemoizedState$k = memoize(function (state) {
  return _objectSpread2({}, state);
});
var AccordionItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    isExpandedProp = _ref.isExpanded,
    defaultIsExpandedProp = _ref.defaultIsExpanded,
    onToggleProp = _ref.onToggle,
    rest = _objectWithoutProperties(_ref, _excluded$1q);
  var accordionContext = useAccordion();
  var defaultId = useAutoId();
  var accordionToggleId = "".concat(config.name, ":AccordionToggle-").concat(defaultId);
  var accordionContentId = "".concat(config.name, ":AccordionContent-").concat(defaultId);
  var _useState = useState(isExpandedProp !== null && isExpandedProp !== void 0 ? isExpandedProp : defaultIsExpandedProp),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  useEffect(function () {
    var isControlled = isExpandedProp !== undefined;
    if (isControlled) {
      setIsExpanded(isExpandedProp);
    }
  }, [isExpandedProp]);
  var onToggle = useCallback(function () {
    var isControlled = isExpandedProp !== undefined;
    if (!isControlled) {
      setIsExpanded(!isExpanded);
    }
    ensureFunction(onToggleProp)({
      isExpanded: !isExpanded
    });
  }, [isExpanded, isExpandedProp, onToggleProp]);
  var context = getMemoizedState$k({
    accordionToggleId: accordionToggleId,
    accordionContentId: accordionContentId,
    disabled: disabled,
    isExpanded: isExpanded,
    onToggle: onToggle,
    variant: accordionContext === null || accordionContext === void 0 ? void 0 : accordionContext.variant
  });
  return jsx(AccordionItemContext.Provider, {
    value: context,
    children: jsx(Box, _objectSpread2(_objectSpread2({
      ref: ref
    }, rest), {}, {
      children: runIfFn(children, context)
    }))
  });
});
AccordionItem.displayName = 'AccordionItem';

Accordion.Body = AccordionBody;
Accordion.Content = AccordionContent;
Accordion.Header = AccordionHeader;
Accordion.Item = AccordionItem;
Accordion.Toggle = AccordionToggle;
Accordion.Toggle.Icon = AccordionToggleIcon;
Accordion.Collapse = AccordionContent; //  alias of AccordionContent
var AccordionCollapse = AccordionContent; // alias of AccordionContent

var useIconButtonStyle = function useIconButtonStyle(_ref) {
  var _colors$colorProp, _colors$hoverColorPro, _colors$focusBorderCo, _colors$focusBoxShado;
  var colorProp = _ref.color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '8x' : _ref$size,
    focusBorderColorProp = _ref._focusBorderColor,
    focusBoxShadowBorderColorProp = _ref._focusBoxShadowBorderColor,
    hoverColorProp = _ref._hoverColor;
  var _useTheme = useTheme(),
    colors = _useTheme.colors;
  var color = (_colors$colorProp = colors === null || colors === void 0 ? void 0 : colors[colorProp]) !== null && _colors$colorProp !== void 0 ? _colors$colorProp : colorProp;
  var activeColor = color;
  var hoverColor = (_colors$hoverColorPro = colors === null || colors === void 0 ? void 0 : colors[hoverColorProp]) !== null && _colors$hoverColorPro !== void 0 ? _colors$hoverColorPro : hoverColorProp;
  var focusColor = color;
  var focusHoverColor = hoverColor;
  var focusActiveColor = activeColor;
  var focusBorderColor = (_colors$focusBorderCo = colors === null || colors === void 0 ? void 0 : colors[focusBorderColorProp]) !== null && _colors$focusBorderCo !== void 0 ? _colors$focusBorderCo : focusBorderColorProp;
  var focusBoxShadowBorderColor = (_colors$focusBoxShado = colors === null || colors === void 0 ? void 0 : colors[focusBoxShadowBorderColorProp]) !== null && _colors$focusBoxShado !== void 0 ? _colors$focusBoxShado : focusBoxShadowBorderColorProp;
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 1,
    borderColor: 'transparent',
    color: color,
    width: size,
    height: size,
    transition: createTransitionStyle(['border-color', 'box-shadow', 'color'], {
      duration: 200
    }),
    _hover: {
      color: hoverColor
    },
    _active: {
      color: activeColor
    },
    _focus: {
      borderColor: focusBorderColor,
      boxShadow: focusBoxShadowBorderColor ? "inset 0 0 0 1px ".concat(focusBoxShadowBorderColor) : undefined,
      color: focusColor
    },
    _focusHover: {
      color: focusHoverColor
    },
    _focusActive: {
      borderColor: focusBorderColor,
      boxShadow: focusBoxShadowBorderColor ? "inset 0 0 0 1px ".concat(focusBoxShadowBorderColor) : undefined,
      color: focusActiveColor
    }
  };
};

var getSolidSuccessStyle = function getSolidSuccessStyle(_ref) {
  var colorMode = _ref.colorMode;
  var backgroundColor = {
    dark: 'green:40',
    light: 'green:30'
  }[colorMode];
  var color = 'black:primary';
  return {
    backgroundColor: backgroundColor,
    color: color
  };
};
var getSolidInfoStyle = function getSolidInfoStyle(_ref2) {
  var colorMode = _ref2.colorMode;
  var backgroundColor = {
    dark: 'blue:40',
    light: 'blue:30'
  }[colorMode];
  var color = 'black:primary';
  return {
    backgroundColor: backgroundColor,
    color: color
  };
};
var getSolidWarningStyle = function getSolidWarningStyle(_ref3) {
  var colorMode = _ref3.colorMode;
  var backgroundColor = {
    dark: 'yellow:50',
    light: 'yellow:50'
  }[colorMode];
  var color = 'black:primary';
  return {
    backgroundColor: backgroundColor,
    color: color
  };
};
var getSolidErrorStyle = function getSolidErrorStyle(_ref4) {
  var colorMode = _ref4.colorMode;
  var backgroundColor = {
    dark: 'red:40',
    light: 'red:30'
  }[colorMode];
  var color = 'black:primary';
  return {
    backgroundColor: backgroundColor,
    color: color
  };
};
var getOutlineSuccessStyle = function getOutlineSuccessStyle(_ref5) {
  var colorMode = _ref5.colorMode;
  var borderColor = {
    dark: 'green:40',
    light: 'green:50'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  return {
    borderColor: borderColor,
    color: color
  };
};
var getOutlineInfoStyle = function getOutlineInfoStyle(_ref6) {
  var colorMode = _ref6.colorMode;
  var borderColor = {
    dark: 'blue:40',
    light: 'blue:50'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  return {
    borderColor: borderColor,
    color: color
  };
};
var getOutlineWarningStyle = function getOutlineWarningStyle(_ref7) {
  var colorMode = _ref7.colorMode;
  var borderColor = {
    dark: 'yellow:50',
    light: 'yellow:50'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  return {
    borderColor: borderColor,
    color: color
  };
};
var getOutlineErrorStyle = function getOutlineErrorStyle(_ref8) {
  var colorMode = _ref8.colorMode;
  var borderColor = {
    dark: 'red:40',
    light: 'red:40'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  return {
    borderColor: borderColor,
    color: color
  };
};
var getSolidSuccessIconStyle = function getSolidSuccessIconStyle(_ref9) {
  var colorMode = _ref9.colorMode;
  var color = {
    dark: 'black:primary',
    light: 'black:primary'
  }[colorMode];
  return {
    color: color
  };
};
var getSolidInfoIconStyle = function getSolidInfoIconStyle(_ref10) {
  var colorMode = _ref10.colorMode;
  var color = {
    dark: 'black:primary',
    light: 'black:primary'
  }[colorMode];
  return {
    color: color
  };
};
var getSolidWarningIconStyle = function getSolidWarningIconStyle(_ref11) {
  var colorMode = _ref11.colorMode;
  var color = {
    dark: 'black:primary',
    light: 'black:primary'
  }[colorMode];
  return {
    color: color
  };
};
var getSolidErrorIconStyle = function getSolidErrorIconStyle(_ref12) {
  var colorMode = _ref12.colorMode;
  var color = {
    dark: 'black:primary',
    light: 'black:primary'
  }[colorMode];
  return {
    color: color
  };
};
var getOutlineSuccessIconStyle = function getOutlineSuccessIconStyle(_ref13) {
  var colorMode = _ref13.colorMode;
  var color = {
    dark: 'green:50',
    light: 'green:60'
  }[colorMode];
  return {
    color: color
  };
};
var getOutlineInfoIconStyle = function getOutlineInfoIconStyle(_ref14) {
  var colorMode = _ref14.colorMode;
  var color = {
    dark: 'blue:50',
    light: 'blue:60'
  }[colorMode];
  return {
    color: color
  };
};
var getOutlineWarningIconStyle = function getOutlineWarningIconStyle(_ref15) {
  var colorMode = _ref15.colorMode;
  var color = {
    dark: 'yellow:50',
    light: 'yellow:50'
  }[colorMode];
  return {
    color: color
  };
};
var getOutlineErrorIconStyle = function getOutlineErrorIconStyle(_ref16) {
  var colorMode = _ref16.colorMode;
  var color = {
    dark: 'red:50',
    light: 'red:60'
  }[colorMode];
  return {
    color: color
  };
};
var getSolidStyle = function getSolidStyle(props) {
  var severity = props.severity,
    colorMode = props.colorMode;
  if (severity === 'success') {
    return getSolidSuccessStyle({
      colorMode: colorMode
    });
  }
  if (severity === 'info') {
    return getSolidInfoStyle({
      colorMode: colorMode
    });
  }
  if (severity === 'warning') {
    return getSolidWarningStyle({
      colorMode: colorMode
    });
  }
  if (severity === 'error') {
    return getSolidErrorStyle({
      colorMode: colorMode
    });
  }
  return {};
};
var getOutlineStyle = function getOutlineStyle(props) {
  var severity = props.severity,
    colorMode = props.colorMode;
  if (severity === 'success') {
    return getOutlineSuccessStyle({
      colorMode: colorMode
    });
  }
  if (severity === 'info') {
    return getOutlineInfoStyle({
      colorMode: colorMode
    });
  }
  if (severity === 'warning') {
    return getOutlineWarningStyle({
      colorMode: colorMode
    });
  }
  if (severity === 'error') {
    return getOutlineErrorStyle({
      colorMode: colorMode
    });
  }
  return {};
};
var useAlertStyle = function useAlertStyle(_ref17) {
  var variant = _ref17.variant,
    severity = _ref17.severity;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var _useTheme = useTheme(),
    sizes = _useTheme.sizes;
  var px = '4x';
  var py = '10q';
  var baseStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    position: 'relative',
    px: px,
    py: py
  };
  if (variant === 'solid') {
    var severityStyle = getSolidStyle({
      colorMode: colorMode,
      severity: severity
    });
    return _objectSpread2(_objectSpread2({}, baseStyle), severityStyle);
  }
  if (variant === 'outline') {
    var borderWidth = '1q';
    var _severityStyle = getOutlineStyle({
      colorMode: colorMode,
      severity: severity
    });
    return _objectSpread2(_objectSpread2({}, baseStyle), {}, {
      borderColor: 'transparent',
      borderStyle: 'solid',
      borderWidth: borderWidth,
      px: "calc(".concat(sizes[px], " - ").concat(sizes[borderWidth], ")"),
      py: "calc(".concat(sizes[py], " - ").concat(sizes[borderWidth], ")")
    }, _severityStyle);
  }
  return _objectSpread2({}, baseStyle);
};
var getSolidIconStyle = function getSolidIconStyle(props) {
  var severity = props.severity,
    colorMode = props.colorMode;
  if (severity === 'success') {
    return getSolidSuccessIconStyle({
      colorMode: colorMode
    });
  }
  if (severity === 'info') {
    return getSolidInfoIconStyle({
      colorMode: colorMode
    });
  }
  if (severity === 'warning') {
    return getSolidWarningIconStyle({
      colorMode: colorMode
    });
  }
  if (severity === 'error') {
    return getSolidErrorIconStyle({
      colorMode: colorMode
    });
  }
  return {};
};
var getOutlineIconStyle = function getOutlineIconStyle(props) {
  var severity = props.severity,
    colorMode = props.colorMode;
  if (severity === 'success') {
    return getOutlineSuccessIconStyle({
      colorMode: colorMode
    });
  }
  if (severity === 'info') {
    return getOutlineInfoIconStyle({
      colorMode: colorMode
    });
  }
  if (severity === 'warning') {
    return getOutlineWarningIconStyle({
      colorMode: colorMode
    });
  }
  if (severity === 'error') {
    return getOutlineErrorIconStyle({
      colorMode: colorMode
    });
  }
  return {};
};
var useAlertIconStyle = function useAlertIconStyle(_ref18) {
  var variant = _ref18.variant,
    severity = _ref18.severity;
  var _useColorMode3 = useColorMode(),
    _useColorMode4 = _slicedToArray(_useColorMode3, 1),
    colorMode = _useColorMode4[0];
  var iconStyle = {
    display: 'inline-flex',
    mr: '2x',
    mt: '1h'
  };
  if (variant === 'solid') {
    return _objectSpread2(_objectSpread2({}, iconStyle), getSolidIconStyle({
      colorMode: colorMode,
      severity: severity
    }));
  }
  if (variant === 'outline') {
    return _objectSpread2(_objectSpread2({}, iconStyle), getOutlineIconStyle({
      colorMode: colorMode,
      severity: severity
    }));
  }
  return _objectSpread2({}, iconStyle);
};
var useAlertMessageStyle = function useAlertMessageStyle(_ref19) {
  var isClosable = _ref19.isClosable;
  return {
    pr: isClosable ? '10x' : 0,
    width: '100%'
  };
};

/**
 * Returns a style object for the close button in an alert component.
 *
 * If `isClosable` is true, the button will be positioned absolutely in the top-right corner of the alert.
 *
 * You can also control the position of the close button declaratively by using the `AlertCloseButton` component within an `Alert` component:
 *
 * ```jsx
 * <Alert variant="solid" severity="success">
 *   <Text pr="10x">This is a success alert.</Text>
 *   <AlertCloseButton top={3} right={7} position="absolute" />
 * </Alert>
 * ```
 *
 * In this case, the `isClosable` prop is not needed and can be omitted.
 */
var useAlertCloseButtonStyle = function useAlertCloseButtonStyle(_ref20) {
  var isClosable = _ref20.isClosable,
    variant = _ref20.variant;
  var _useColorMode5 = useColorMode(),
    _useColorMode6 = _slicedToArray(_useColorMode5, 1),
    colorMode = _useColorMode6[0];
  var _useTheme2 = useTheme(),
    sizes = _useTheme2.sizes;
  var color = {
    dark: {
      solid: 'black:tertiary',
      outline: 'white:tertiary'
    }[variant],
    light: {
      solid: 'black:tertiary',
      outline: 'black:tertiary'
    }[variant]
  }[colorMode];
  var size = '8x';
  var _focusBorderColor = 'blue:60';
  var _focusBoxShadowBorderColor = 'blue:60';
  var _hoverColor = {
    dark: {
      solid: 'black:primary',
      outline: 'white:emphasis'
    }[variant],
    light: {
      solid: 'black:primary',
      outline: 'black:primary'
    }[variant]
  }[colorMode];
  var baseStyle = useIconButtonStyle({
    color: color,
    size: size,
    _focusBorderColor: _focusBorderColor,
    _focusBoxShadowBorderColor: _focusBoxShadowBorderColor,
    _hoverColor: _hoverColor
  });
  if (isClosable) {
    var parentBorderWidth = sizes['1q'];
    var top = "calc(".concat(sizes['1x'], " - ").concat(parentBorderWidth, ")");
    var right = "calc(".concat(sizes['2x'], " - ").concat(parentBorderWidth, ")");
    return _objectSpread2(_objectSpread2({}, baseStyle), {}, {
      position: 'absolute',
      top: top,
      right: right
    });
  }
  return baseStyle;
};

var AlertContext = /*#__PURE__*/createContext();

var useAlert = function useAlert() {
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(AlertContext);
  return context;
};

var _excluded$1p = ["children", "onClick"];
var AlertCloseButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    onClickProp = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded$1p);
  var alertContext = useAlert(); // context might be an undefined value
  var _alertContext = _objectSpread2({}, alertContext),
    isClosable = _alertContext.isClosable,
    onClose = _alertContext.onClose,
    variant = _alertContext.variant;
  var styleProps = useAlertCloseButtonStyle({
    isClosable: isClosable,
    variant: variant
  });
  return jsx(ButtonBase, _objectSpread2(_objectSpread2(_objectSpread2({
    "aria-label": "Close",
    ref: ref,
    onClick: callEventHandlers(onClickProp, onClose)
  }, styleProps), rest), {}, {
    children: children !== null && children !== void 0 ? children : jsx(Icon, {
      icon: "close-s"
    })
  }));
});
AlertCloseButton.displayName = 'AlertCloseButton';

var getIconBySeverity = function getIconBySeverity(severity) {
  var iconName = {
    success: 'success',
    info: 'info',
    warning: 'warning-minor',
    error: 'error'
  }[severity];
  if (!iconName) {
    return null;
  }
  return jsx(Icon, {
    icon: "".concat(iconName)
  });
};
var AlertIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var alertContext = useAlert(); // context might be an undefined value
  var _alertContext = _objectSpread2({}, alertContext),
    iconProp = _alertContext.icon,
    severity = _alertContext.severity,
    variant = _alertContext.variant;
  var styleProps = useAlertIconStyle({
    variant: variant,
    severity: severity
  });
  var icon = useMemo(function () {
    if (typeof iconProp === 'string') {
      return jsx(Icon, {
        icon: iconProp
      });
    }
    if (iconProp === undefined) {
      return getIconBySeverity(severity);
    }
    return iconProp;
  }, [iconProp, severity]);
  if (!icon) {
    return null;
  }
  return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), props), {}, {
    children: icon
  }));
});
AlertIcon.displayName = 'AlertIcon';

var AlertMessage = /*#__PURE__*/forwardRef(function (props, ref) {
  var alertContext = useAlert(); // context might be an undefined value
  var _alertContext = _objectSpread2({}, alertContext),
    isClosable = _alertContext.isClosable;
  var styleProps = useAlertMessageStyle({
    isClosable: isClosable
  });
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), props));
});
AlertMessage.displayName = 'AlertMessage';

var defaultSeverity = 'success';
var defaultVariant$8 = 'solid';

var _excluded$1o = ["isCloseButtonVisible", "isClosable", "onClose", "severity", "variant", "icon", "children"];
var getMemoizedState$j = memoize(function (state) {
  return _objectSpread2({}, state);
});
var Alert = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isCloseButtonVisible = _ref.isCloseButtonVisible,
    _ref$isClosable = _ref.isClosable,
    isClosable = _ref$isClosable === void 0 ? false : _ref$isClosable,
    onClose = _ref.onClose,
    _ref$severity = _ref.severity,
    severity = _ref$severity === void 0 ? defaultSeverity : _ref$severity,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? defaultVariant$8 : _ref$variant,
    icon = _ref.icon,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$1o);
  {
    // deprecation warning
    var prefix = "".concat(Alert.displayName, ":");
    useOnceWhen(function () {
      warnDeprecatedProps('isCloseButtonVisible', {
        prefix: prefix,
        alternative: 'isClosable',
        willRemove: true
      });
    }, isCloseButtonVisible !== undefined);
    isClosable = isClosable || isCloseButtonVisible; // TODO: remove this line after deprecation
  }

  var context = getMemoizedState$j({
    icon: icon,
    isClosable: isClosable,
    onClose: onClose,
    severity: severity,
    variant: variant
  });
  var styleProps = useAlertStyle({
    variant: variant,
    severity: severity
  });
  return jsx(AlertContext.Provider, {
    value: context,
    children: jsxs(Box, _objectSpread2(_objectSpread2(_objectSpread2({
      ref: ref
    }, styleProps), rest), {}, {
      children: [jsx(AlertIcon, {}), jsx(AlertMessage, {
        children: runIfFn(children, context)
      }), !!isClosable && jsx(AlertCloseButton, {})]
    }))
  });
});
Alert.displayName = 'Alert';

Alert.CloseButton = AlertCloseButton;
Alert.Icon = AlertIcon;
Alert.Message = AlertMessage;

var getSolidBadgeContentStyle = function getSolidBadgeContentStyle(_ref) {
  var _theme$sizes, _theme$sizes2, _theme$colors;
  var colorMode = _ref.colorMode,
    theme = _ref.theme;
  var backgroundColor = {
    dark: 'red:60',
    light: 'red:60'
  }[colorMode];
  var borderRadius = theme === null || theme === void 0 ? void 0 : (_theme$sizes = theme.sizes) === null || _theme$sizes === void 0 ? void 0 : _theme$sizes['4x'];
  var boxShadowSpreadRadius = theme === null || theme === void 0 ? void 0 : (_theme$sizes2 = theme.sizes) === null || _theme$sizes2 === void 0 ? void 0 : _theme$sizes2['1q'];
  var boxShadowColor = {
    dark: theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors['gray:100'],
    light: 'white'
  }[colorMode];
  var boxShadow = "0 0 0 ".concat(boxShadowSpreadRadius, " ").concat(boxShadowColor);
  var color = {
    dark: 'white:primary',
    light: 'white:primary'
  }[colorMode];
  return {
    backgroundColor: backgroundColor,
    borderRadius: borderRadius,
    boxShadow: boxShadow,
    color: color,
    fontSize: 'xs',
    height: borderRadius,
    lineHeight: '1',
    minWidth: borderRadius,
    px: '1x'
  };
};
var getDotBadgeContentStyle = function getDotBadgeContentStyle(_ref2) {
  var _theme$sizes3, _theme$colors2, _theme$sizes4, _theme$sizes5;
  var colorMode = _ref2.colorMode,
    theme = _ref2.theme;
  var backgroundColor = {
    dark: 'red:60',
    light: 'red:60'
  }[colorMode];
  var borderRadius = 'circle';
  var boxShadowSpreadRadius = theme === null || theme === void 0 ? void 0 : (_theme$sizes3 = theme.sizes) === null || _theme$sizes3 === void 0 ? void 0 : _theme$sizes3['1q'];
  var boxShadowColor = {
    dark: theme === null || theme === void 0 ? void 0 : (_theme$colors2 = theme.colors) === null || _theme$colors2 === void 0 ? void 0 : _theme$colors2['gray:100'],
    light: 'white'
  }[colorMode];
  var boxShadow = "0 0 0 ".concat(boxShadowSpreadRadius, " ").concat(boxShadowColor);
  var color = {
    dark: 'white:primary',
    light: 'white:primary'
  }[colorMode];
  var height = theme === null || theme === void 0 ? void 0 : (_theme$sizes4 = theme.sizes) === null || _theme$sizes4 === void 0 ? void 0 : _theme$sizes4['2x'];
  var width = theme === null || theme === void 0 ? void 0 : (_theme$sizes5 = theme.sizes) === null || _theme$sizes5 === void 0 ? void 0 : _theme$sizes5['2x'];
  return {
    backgroundColor: backgroundColor,
    borderRadius: borderRadius,
    boxShadow: boxShadow,
    color: color,
    height: height,
    width: width
  };
};
var useBadgeStyle = function useBadgeStyle() {
  return {
    display: 'inline-flex',
    position: 'relative',
    width: 'fit-content'
  };
};
var useBadgeContentStyle = function useBadgeContentStyle(_ref3) {
  var variant = _ref3.variant;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var theme = useTheme();
  var baseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center'
  };
  var variantStyle = {
    'solid': getSolidBadgeContentStyle({
      colorMode: colorMode,
      theme: theme
    }),
    'dot': getDotBadgeContentStyle({
      colorMode: colorMode,
      theme: theme
    })
  }[variant];
  return _objectSpread2(_objectSpread2({}, baseStyle), variantStyle);
};
var useBadgeContentPlacementStyle = function useBadgeContentPlacementStyle(_ref4) {
  var placement = _ref4.placement;
  var placementStyle = {
    'top-left': {
      top: 0,
      left: 0,
      transform: 'translate(-50%, -50%)'
    },
    'top-right': {
      top: 0,
      right: 0,
      transform: 'translate(50%, -50%)'
    },
    'bottom-left': {
      bottom: 0,
      left: 0,
      transform: 'translate(-50%, 50%)'
    },
    'bottom-right': {
      bottom: 0,
      right: 0,
      transform: 'translate(50%, 50%)'
    }
  }[placement];
  return _objectSpread2({
    position: 'absolute'
  }, placementStyle);
};

var _excluded$1n = ["dotSize", "isHidden", "offset", "variantColor", "badgeContent", "children", "isInvisible", "placement", "variant"];
var Badge = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _isInvisibleProp;
  var dotSizeProp = _ref.dotSize,
    isHiddenProp = _ref.isHidden,
    offsetProp = _ref.offset,
    variantColorProp = _ref.variantColor,
    badgeContentProp = _ref.badgeContent,
    children = _ref.children,
    isInvisibleProp = _ref.isInvisible,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top-right' : _ref$placement,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'solid' : _ref$variant,
    rest = _objectWithoutProperties(_ref, _excluded$1n);
  var theme = useTheme();
  {
    // deprecation warning
    var prefix = "".concat(Badge.displayName, ":");
    useOnceWhen(function () {
      warnDeprecatedProps('dotSize', {
        prefix: prefix,
        alternative: ['width', 'height'],
        willRemove: true
      });
    }, dotSizeProp !== undefined);
    useOnceWhen(function () {
      warnDeprecatedProps('isHidden', {
        prefix: prefix,
        alternative: 'isInvisible',
        willRemove: true
      });
    }, isHiddenProp !== undefined);
    useOnceWhen(function () {
      warnDeprecatedProps('offset', {
        prefix: prefix,
        alternative: ['right', 'top'],
        willRemove: true
      });
    }, offsetProp !== undefined);
    useOnceWhen(function () {
      warnDeprecatedProps('variant="badge"', {
        prefix: prefix,
        alternative: 'variant="solid"',
        willRemove: true
      });
    }, variant === 'badge');
    useOnceWhen(function () {
      warnDeprecatedProps('variantColor', {
        prefix: prefix,
        alternative: 'backgroundColor',
        willRemove: true
      });
    }, variantColorProp !== undefined);
    if (variant === 'dot' && dotSizeProp !== undefined) {
      var _rest$height, _rest$width;
      rest.height = (_rest$height = rest.height) !== null && _rest$height !== void 0 ? _rest$height : dotSizeProp;
      rest.width = (_rest$width = rest.width) !== null && _rest$width !== void 0 ? _rest$width : dotSizeProp;
    }
    if (isHiddenProp !== undefined) {
      isInvisibleProp = ensureBoolean(isHiddenProp);
    }
    if (offsetProp !== undefined) {
      var _ensureArray = ensureArray(offsetProp),
        _ensureArray2 = _slicedToArray(_ensureArray, 2),
        offsetX = _ensureArray2[0],
        offsetY = _ensureArray2[1];
      if (offsetX !== undefined) {
        var _rest$right;
        rest.right = (_rest$right = rest.right) !== null && _rest$right !== void 0 ? _rest$right : offsetX;
      }
      if (offsetY !== undefined) {
        var _rest$top;
        rest.top = (_rest$top = rest.top) !== null && _rest$top !== void 0 ? _rest$top : offsetY;
      }
    }
    if (variant === 'badge') {
      variant = 'solid';
    }
    if (variantColorProp !== undefined) {
      var _ref2, _theme$colors, _theme$colors2, _theme$colors3, _rest$backgroundColor;
      var variantColor = (_ref2 = (_theme$colors = theme === null || theme === void 0 ? void 0 : (_theme$colors2 = theme.colors) === null || _theme$colors2 === void 0 ? void 0 : _theme$colors2["".concat(variantColorProp, ":60")]) !== null && _theme$colors !== void 0 ? _theme$colors : theme === null || theme === void 0 ? void 0 : (_theme$colors3 = theme.colors) === null || _theme$colors3 === void 0 ? void 0 : _theme$colors3["".concat(variantColorProp, ":50")]) !== null && _ref2 !== void 0 ? _ref2 : variantColorProp;
      rest.backgroundColor = (_rest$backgroundColor = rest.backgroundColor) !== null && _rest$backgroundColor !== void 0 ? _rest$backgroundColor : variantColor;
    }
  }
  var badgeContent = variant === 'dot' ? null : badgeContentProp;
  var isInvisible = (_isInvisibleProp = isInvisibleProp) !== null && _isInvisibleProp !== void 0 ? _isInvisibleProp : function () {
    if ((badgeContent === null || badgeContent === undefined) && variant !== 'dot') {
      return true;
    }
    return false;
  }();
  var badgeStyle = useBadgeStyle();
  var badgeContentStyle = useBadgeContentStyle({
    variant: variant
  });
  var badgeContentPlacementStyle = useBadgeContentPlacementStyle({
    placement: placement
  });
  if (!children && !isInvisible) {
    return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
      ref: ref
    }, badgeContentStyle), rest), {}, {
      children: badgeContent
    }));
  }
  return jsxs(Box, _objectSpread2(_objectSpread2({}, badgeStyle), {}, {
    children: [children, !isInvisible && jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
      ref: ref
    }, badgeContentStyle), badgeContentPlacementStyle), rest), {}, {
      children: badgeContent
    }))]
  }));
});
Badge.displayName = 'Badge';

var VisuallyHidden = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(Box, _objectSpread2({
    ref: ref,
    position: "absolute",
    width: 1,
    height: 1,
    padding: 0,
    border: 0,
    overflow: "hidden",
    clipPath: "inset(50%)",
    whiteSpace: "nowrap"
  }, props));
});
VisuallyHidden.displayName = 'VisuallyHidden';

var defaultSize$b = 'md';
var defaultVariantColor$2 = 'blue';

var IconChecked = function IconChecked(props) {
  return jsx(SVGIcon, _objectSpread2(_objectSpread2({
    viewBox: "0 0 16 16"
  }, props), {}, {
    children: jsx("g", {
      fill: "currentColor",
      children: jsx("path", {
        d: "M6 11.060l-3-3-1 1 4 4 9-9-1-1z"
      })
    })
  }));
};
IconChecked.displayName = 'IconChecked';

var IconIndeterminate = function IconIndeterminate(props) {
  return jsx(SVGIcon, _objectSpread2(_objectSpread2({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: jsx("g", {
      fill: "currentColor",
      children: jsx("rect", {
        height: "18",
        width: "18",
        x: "3",
        y: "3"
      })
    })
  }));
};
IconIndeterminate.displayName = 'IconIndeterminate';

var useCheckboxStyle = function useCheckboxStyle(_ref) {
  var disabled = _ref.disabled;
  return {
    display: 'inline-flex',
    verticalAlign: 'top',
    alignItems: 'center',
    cursor: disabled ? 'not-allowed' : 'pointer'
  };
};
var useCheckboxControlBoxStyle = function useCheckboxControlBoxStyle(_ref2) {
  var color = _ref2.color,
    indeterminate = _ref2.indeterminate,
    height = _ref2.height,
    width = _ref2.width;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var baseStyle = {
    userSelect: 'none',
    border: 1,
    position: 'relative',
    transition: createTransitionStyle(['background-color'], {
      duration: 120
    }),
    width: width,
    height: height,
    zIndex: 0
  };
  var getIndeterminateStyle = function getIndeterminateStyle(_ref3) {
    var color = _ref3.color;
    // icon color
    var _color = {
      dark: "".concat(color, ":60"),
      light: "".concat(color, ":60")
    }[colorMode];
    var hoverColor = {
      dark: "".concat(color, ":50"),
      light: "".concat(color, ":50")
    }[colorMode];
    var disabledColor = {
      dark: 'gray:60',
      light: 'gray:40'
    }[colorMode];

    // border color
    var borderColor = {
      dark: 'gray:50',
      light: 'gray:40'
    }[colorMode];
    var hoverBorderColor = {
      dark: "".concat(color, ":50"),
      light: "".concat(color, ":50")
    }[colorMode];
    var disabledBorderColor = {
      dark: 'gray:60',
      light: 'gray:40'
    }[colorMode];

    // outline color
    var focusOutlineColor = {
      dark: "".concat(color, ":60"),
      light: "".concat(color, ":60")
    }[colorMode];
    return {
      _indeterminate: {
        borderColor: borderColor,
        color: _color // Icon color
      },

      _indeterminateAndHover: {
        borderColor: hoverBorderColor,
        color: hoverColor
      },
      _indeterminateAndFocus: {
        outlineStyle: 'solid',
        outlineColor: focusOutlineColor,
        outlineWidth: '1h'
      },
      _indeterminateAndDisabled: {
        borderColor: disabledBorderColor,
        color: disabledColor,
        // Icon color
        opacity: 0.28
      }
    };
  };
  var getInteractionStyle = function getInteractionStyle(_ref4) {
    var color = _ref4.color;
    // icon color
    var _color = {
      dark: 'white:emphasis',
      light: 'white:emphasis'
    }[colorMode];
    var hoverColor = _color;
    var disabledColor = _color;
    var checkedColor = _color;
    var checkedAndHoverColor = _color;
    var checkedAndFocusColor = _color;
    var checkedAndDisabledColor = {
      dark: 'white:emphasis',
      light: 'black:primary'
    }[colorMode];

    // background color
    var backgroundColor = 'transparent';
    var hoverBackgroundColor = backgroundColor;
    var disabledBackgroundColor = backgroundColor;
    var checkedBackgroundColor = {
      dark: "".concat(color, ":60"),
      light: "".concat(color, ":60")
    }[colorMode];
    var checkedAndHoverBackgroundColor = {
      dark: "".concat(color, ":50"),
      light: "".concat(color, ":50")
    }[colorMode];
    var checkedAndFocusBackgroundColor = checkedBackgroundColor;
    var checkedAndDisabledBackgroundColor = {
      dark: 'gray:60',
      light: 'gray:40'
    }[colorMode];

    // border color
    var borderColor = {
      dark: 'gray:50',
      light: 'gray:40'
    }[colorMode];
    var hoverBorderColor = {
      dark: "".concat(color, ":50"),
      light: "".concat(color, ":50")
    }[colorMode];
    var disabledBorderColor = {
      dark: 'gray:60',
      light: 'gray:40'
    }[colorMode];
    var checkedBorderColor = {
      dark: "".concat(color, ":60"),
      light: "".concat(color, ":60")
    }[colorMode];
    var checkedAndHoverBorderColor = hoverBorderColor;
    var checkedAndFocusBorderColor = 'transparent';
    var checkedAndDisabledBorderColor = disabledBorderColor;

    // outline color
    var focusOutlineColor = {
      dark: "".concat(color, ":60"),
      light: "".concat(color, ":60")
    }[colorMode];
    return {
      backgroundColor: backgroundColor,
      borderColor: borderColor,
      color: _color,
      // Icon color
      _hover: {
        backgroundColor: hoverBackgroundColor,
        borderColor: hoverBorderColor,
        color: hoverColor // Icon color
      },

      _disabled: {
        backgroundColor: disabledBackgroundColor,
        borderColor: disabledBorderColor,
        color: disabledColor,
        // Icon color
        opacity: 0.28
      },
      _focus: {
        outlineStyle: 'solid',
        outlineColor: focusOutlineColor,
        outlineWidth: '1h'
      },
      _checked: {
        backgroundColor: checkedBackgroundColor,
        borderColor: checkedBorderColor,
        color: checkedColor // Icon color
      },

      _checkedAndHover: {
        backgroundColor: checkedAndHoverBackgroundColor,
        borderColor: checkedAndHoverBorderColor,
        color: checkedAndHoverColor // Icon color
      },

      _checkedAndFocus: {
        backgroundColor: 'inherit',
        borderColor: checkedAndFocusBorderColor,
        color: checkedAndFocusColor,
        // Icon color
        '& > div:first-of-type': {
          backgroundColor: checkedAndFocusBackgroundColor
        }
      },
      _checkedAndDisabled: {
        backgroundColor: checkedAndDisabledBackgroundColor,
        borderColor: checkedAndDisabledBorderColor,
        color: checkedAndDisabledColor,
        // Icon color
        opacity: 0.28
      }
    };
  };
  if (indeterminate) {
    return _objectSpread2(_objectSpread2({}, baseStyle), getIndeterminateStyle({
      color: color
    }));
  }
  return _objectSpread2(_objectSpread2({}, baseStyle), getInteractionStyle({
    color: color
  }));
};

var _excluded$1m = ["indeterminate", "size", "variantColor"];
var CheckboxControlBox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var indeterminate = _ref.indeterminate,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaultSize$b : _ref$size,
    _ref$variantColor = _ref.variantColor,
    variantColor = _ref$variantColor === void 0 ? defaultVariantColor$2 : _ref$variantColor,
    rest = _objectWithoutProperties(_ref, _excluded$1m);
  var _useTheme = useTheme(),
    sizes = _useTheme.sizes;
  var iconSize = {
    lg: sizes['6x'],
    md: sizes['4x'],
    sm: sizes['3x']
  }[size];
  var width = {
    lg: '6x',
    md: '4x',
    sm: '3x'
  }[size];
  var height = {
    lg: '6x',
    md: '4x',
    sm: '3x'
  }[size];
  var styleProps = useCheckboxControlBoxStyle({
    color: variantColor,
    indeterminate: indeterminate,
    width: width,
    height: height
  });
  var icon = indeterminate ? jsx(IconIndeterminate, {
    size: iconSize
  }) : jsx(IconChecked, {
    size: iconSize
  });
  return jsxs(ControlBox, _objectSpread2(_objectSpread2(_objectSpread2({
    type: "checkbox"
  }, styleProps), rest), {}, {
    children: [jsx(Box, {
      zIndex: "-1",
      position: "absolute",
      top: "0",
      bottom: "0",
      left: "0",
      right: "0"
    }), icon]
  }));
});
CheckboxControlBox.displayName = 'CheckboxControlBox';

var CheckboxGroupContext = /*#__PURE__*/createContext();

var useCheckboxGroup = function useCheckboxGroup() {
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(CheckboxGroupContext);
  return context;
};

var _excluded$1l = ["checked", "children", "defaultChecked", "disabled", "id", "indeterminate", "inputProps", "inputRef", "name", "onBlur", "onChange", "onClick", "onFocus", "size", "value", "variantColor"];
var Checkbox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var checked = _ref.checked,
    children = _ref.children,
    defaultChecked = _ref.defaultChecked,
    disabled = _ref.disabled,
    id = _ref.id,
    indeterminate = _ref.indeterminate,
    inputProps = _ref.inputProps,
    inputRef = _ref.inputRef,
    name = _ref.name,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    size = _ref.size,
    value = _ref.value,
    variantColor = _ref.variantColor,
    rest = _objectWithoutProperties(_ref, _excluded$1l);
  var combinedInputRef = useMergeRefs(ref, inputRef); // TODO: Move the `ref` to the outermost element in the next major version
  var styleProps = useCheckboxStyle({
    disabled: disabled
  });
  var checkboxGroupContext = useCheckboxGroup();
  if (checkboxGroupContext) {
    var _ref2, _size, _ref3, _variantColor;
    var _checkboxGroupContext = _objectSpread2({}, checkboxGroupContext),
      checkboxGroupDisabled = _checkboxGroupContext.disabled,
      checkboxGroupName = _checkboxGroupContext.name,
      checkboxGroupSize = _checkboxGroupContext.size,
      checkboxGroupValue = _checkboxGroupContext.value,
      checkboxGroupVariantColor = _checkboxGroupContext.variantColor,
      checkboxGroupOnChange = _checkboxGroupContext.onChange;
    if (checkboxGroupValue !== undefined) {
      checked = ensureArray(checkboxGroupValue).includes(value);
    }
    disabled = checkboxGroupDisabled || disabled;
    name = checkboxGroupName !== null && checkboxGroupName !== void 0 ? checkboxGroupName : name;
    onChange = callAll(onChange, checkboxGroupOnChange);
    // Use the default value if the value is null or undefined
    size = (_ref2 = (_size = size) !== null && _size !== void 0 ? _size : checkboxGroupSize) !== null && _ref2 !== void 0 ? _ref2 : defaultSize$b;
    variantColor = (_ref3 = (_variantColor = variantColor) !== null && _variantColor !== void 0 ? _variantColor : checkboxGroupVariantColor) !== null && _ref3 !== void 0 ? _ref3 : defaultVariantColor$2;
  } else {
    var _size2, _variantColor2;
    // Use the default value if the value is null or undefined
    size = (_size2 = size) !== null && _size2 !== void 0 ? _size2 : defaultSize$b;
    variantColor = (_variantColor2 = variantColor) !== null && _variantColor2 !== void 0 ? _variantColor2 : defaultVariantColor$2;
  }
  return jsxs(Box, _objectSpread2(_objectSpread2(_objectSpread2({
    as: "label"
  }, styleProps), rest), {}, {
    children: [jsx(VisuallyHidden, _objectSpread2({
      as: "input",
      checked: checked,
      "data-indeterminate": dataAttr(indeterminate),
      defaultChecked: defaultChecked,
      disabled: disabled,
      id: id,
      name: name,
      onBlur: onBlur,
      onChange: onChange,
      onClick: onClick,
      onFocus: onFocus,
      ref: combinedInputRef,
      type: "checkbox",
      value: value
    }, inputProps)), jsx(CheckboxControlBox, {
      indeterminate: indeterminate,
      size: size,
      variantColor: variantColor
    }), !isNullish(children) && jsx(Box, {
      ml: "2x",
      userSelect: "none",
      opacity: disabled ? 0.28 : 1,
      children: children
    })]
  }));
});
Checkbox.displayName = 'Checkbox';

var attachProxyOnce = function () {
  var called = false;
  return function (target, fn) {
    if (called) {
      return target;
    }
    var handler = {
      get: function get() {
        if (!called) {
          fn === null || fn === void 0 ? void 0 : fn();
          called = true;
        }
        return Reflect.get.apply(Reflect, arguments);
      }
    };
    return new Proxy(target, handler);
  };
}();

var getMemoizedState$i = memoize(function (state) {
  return _objectSpread2({}, state);
});
var CheckboxGroup = function CheckboxGroup(_ref) {
  var _name;
  var children = _ref.children,
    defaultValue = _ref.defaultValue,
    disabled = _ref.disabled,
    name = _ref.name,
    size = _ref.size,
    valueProp = _ref.value,
    variantColor = _ref.variantColor,
    onChange = _ref.onChange;
  var defaultId = useAutoId();
  name = (_name = name) !== null && _name !== void 0 ? _name : "".concat(config.name, ":CheckboxGroup-").concat(defaultId);
  var _useState = useState({
      value: ensureArray(valueProp !== null && valueProp !== void 0 ? valueProp : defaultValue)
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    if (valueProp !== undefined) {
      setState({
        value: ensureArray(valueProp)
      });
    }
  }, [valueProp]);
  var handleChange = function handleChange(event) {
    var checkbox = {
      checked: event.target.checked,
      value: event.target.value
    };
    var nextValue = !!checkbox.checked ? state.value.concat(ensureArray(checkbox.value)) // expect value to be neither null nor undefined
    : state.value.filter(function (v) {
      return v !== checkbox.value;
    }); // filter out unchecked values

    if (valueProp !== undefined) {
      setState({
        value: ensureArray(valueProp)
      });
    } else {
      setState({
        value: nextValue
      });
    }
    if (typeof onChange === 'function') {
      // deprecation warning
      var prefix = "".concat(CheckboxGroup.displayName, ":");
      var proxiedEvent = attachProxyOnce(event, function () {
        console.error("".concat(prefix, " \"onChange(value, event)\" is deprecated and will be changed in the next major release. Please use \"onChange(value)\" instead."));
      });
      onChange(nextValue, proxiedEvent);
    }
  };
  var context = getMemoizedState$i({
    disabled: disabled,
    name: name,
    onChange: handleChange,
    size: size,
    value: state.value,
    variantColor: variantColor
  });
  return jsx(CheckboxGroupContext.Provider, {
    value: context,
    children: runIfFn(children, context)
  });
};
CheckboxGroup.displayName = 'CheckboxGroup';

var useCodeStyle = function useCodeStyle() {
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var backgroundColor = {
    dark: 'rgba(255, 255, 255, 0.08)',
    light: 'rgba(0, 0, 0, 0.08)'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  return {
    backgroundColor: backgroundColor,
    borderRadius: 'sm',
    color: color,
    fontFamily: 'mono',
    px: '1x'
  };
};

var Code = /*#__PURE__*/forwardRef(function (props, ref) {
  var styleProps = useCodeStyle();
  return jsx(Box, _objectSpread2(_objectSpread2({
    as: "code",
    ref: ref
  }, styleProps), props));
});
Code.displayName = 'Code';

var colorStyle = {
  dark: {
    background: {
      primary: 'gray:100',
      secondary: 'gray:90',
      tertiary: 'gray:80',
      inverted: 'gray:10',
      inverse: 'gray:10',
      // alias for inverted
      highlighted: 'rgba(255, 255, 255, 0.12)',
      selected: 'rgba(255, 255, 255, 0.08)'
    },
    color: {
      emphasis: 'white:emphasis',
      primary: 'white:primary',
      secondary: 'white:secondary',
      tertiary: 'white:tertiary',
      disabled: 'white:disabled',
      success: 'green:40',
      info: 'blue:40',
      warning: 'orange:50',
      error: 'red:50'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    text: {
      selection: 'blue:60',
      highlight: '#fce79e'
    },
    shadow: {
      // Tooltip, Popover
      thin: '0 2px 8px 0 rgba(0, 0, 0, 0.48), 0 1px 2px 0 rgba(0, 0, 0, 0.16)',
      // Menu
      medium: '0 4px 16px 0 rgba(0, 0, 0, 0.48), 0 2px 4px 0 rgba(0, 0, 0, 0.16)',
      // Drawer, Modal
      thick: '0 8px 32px 0 rgba(0, 0, 0, 0.48), 0 4px 8px 0 rgba(0, 0, 0, 0.16)'
    },
    severity: {
      critical: 'magenta:60',
      high: 'red:50',
      medium: 'orange:50',
      low: 'yellow:50',
      safe: 'green:40',
      info: 'gray:50',
      unknown: 'gray:50'
    },
    // https://docs.appian.com/suite/help/20.2/Chart_Color_Scheme.html
    chart: {
      classic: {
        colors: ['gray:50', 'blue:50', 'green:40', 'orange:50', 'cyan:40', 'red:50', 'purple:50', 'teal:40', 'magenta:40', 'green:30', 'yellow:50']
      }
    }
  },
  light: {
    background: {
      primary: 'white:emphasis',
      secondary: 'gray:10',
      tertiary: 'gray:20',
      inverted: 'gray:70',
      inverse: 'gray:70',
      // alias for inverted
      highlighted: 'rgba(0, 0, 0, 0.12)',
      selected: 'rgba(0, 0, 0, 0.08)'
    },
    color: {
      emphasis: 'black:emphasis',
      primary: 'black:primary',
      secondary: 'black:secondary',
      tertiary: 'black:tertiary',
      disabled: 'black:disabled',
      success: 'green:50',
      info: 'blue:60',
      warning: 'orange:50',
      error: 'red:60'
    },
    divider: 'rgba(0, 0, 0, 0.12)',
    text: {
      selection: 'blue:60',
      highlight: '#fce79e'
    },
    shadow: {
      // Tooltip, Popover
      thin: '0 2px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 0 rgba(0, 0, 0, 0.08)',
      // Menu
      medium: '0 4px 16px 0 rgba(0, 0, 0, 0.16), 0 2px 4px 0 rgba(0, 0, 0, 0.08)',
      // Drawer, Modal
      thick: '0 8px 32px 0 rgba(0, 0, 0, 0.16), 0 4px 8px 0 rgba(0, 0, 0, 0.08)'
    },
    severity: {
      critical: 'magenta:60',
      high: 'red:60',
      medium: 'orange:50',
      low: 'yellow:50',
      safe: 'green:50',
      info: 'gray:50',
      unknown: 'gray:50'
    },
    // https://docs.appian.com/suite/help/20.2/Chart_Color_Scheme.html
    chart: {
      classic: {
        colors: ['gray:50', 'blue:60', 'green:50', 'orange:50', 'cyan:40', 'red:60', 'purple:60', 'teal:40', 'magenta:50', 'green:30', 'yellow:50']
      }
    }
  }
};

var ColorStyleContext = /*#__PURE__*/createContext();

var ensureColorStyle = function ensureColorStyle(colorStyle) {
  return ensurePlainObject(colorStyle);
};
var getMemoizedState$h = memoize(function (state) {
  return _objectSpread2({}, state);
});
var ColorStyleProvider = function ColorStyleProvider(_ref) {
  var children = _ref.children,
    defaultValueProp = _ref.defaultValue,
    valueProp = _ref.value,
    onChangeProp = _ref.onChange;
  var _useState = useState(ensureColorStyle(valueProp !== null && valueProp !== void 0 ? valueProp : defaultValueProp !== null && defaultValueProp !== void 0 ? defaultValueProp : colorStyle)),
    _useState2 = _slicedToArray(_useState, 2),
    colorStyle$1 = _useState2[0],
    setColorStyle = _useState2[1];
  useEffect(function () {
    if (valueProp !== undefined) {
      setColorStyle(ensureColorStyle(valueProp));
    }
  }, [valueProp]);
  var onChange = useCallback(function (nextValue) {
    if (valueProp !== undefined) {
      setColorStyle(ensureColorStyle(valueProp));
    } else {
      setColorStyle(ensureColorStyle(nextValue));
    }
    if (typeof onChangeProp === 'function') {
      onChangeProp(nextValue); // Pass original value to the onChange callback
    }
  }, [valueProp, onChangeProp]);
  var colorStyleState = getMemoizedState$h({
    colorStyle: colorStyle$1,
    onChange: onChange
  });
  return jsx(ColorStyleContext.Provider, {
    value: colorStyleState,
    children: children
  });
};
ColorStyleProvider.displayName = 'ColorStyleProvider';

var useColorStyle = function useColorStyle(options) {
  var _ensurePlainObject = ensurePlainObject(options),
    specifiedColorMode = _ensurePlainObject.colorMode;
  var _ensurePlainObject2 = ensurePlainObject(useContext(ColorModeContext)),
    currentColorMode = _ensurePlainObject2.colorMode;
  var colorMode = specifiedColorMode !== null && specifiedColorMode !== void 0 ? specifiedColorMode : currentColorMode;
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(ColorStyleContext);
  if (context === undefined) {
    throw new Error('The `useColorStyle` hook must be called from a descendent of the `ColorStyleProvider`.');
  }
  var _ensurePlainObject3 = ensurePlainObject(context),
    colorStyle = _ensurePlainObject3.colorStyle,
    onChange = _ensurePlainObject3.onChange;
  if (!Object.prototype.hasOwnProperty.call(colorStyle, colorMode)) {
    throw new Error('The `colorMode` must be one of:', Object.keys(colorStyle));
  }
  var getter = ensurePlainObject(colorStyle[colorMode]);
  var setter = useCallback(function (value) {
    if (typeof value === 'function') {
      value = value(colorStyle);
    }
    var nextColorStyle = _objectSpread2(_objectSpread2({}, colorStyle), {}, _defineProperty({}, colorMode, ensurePlainObject(value)));
    onChange(nextColorStyle);
  }, [colorMode, colorStyle, onChange]);
  return [getter, setter];
};

var baseCSS = function baseCSS(theme) {
  return /*#__PURE__*/css("html{box-sizing:border-box;}*,*:before,*:after{box-sizing:inherit;}html{font-family:", _get(theme, 'fonts.base'), ";}pre,code,kbd,samp{font-family:", _get(theme, 'fonts.mono'), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:baseCSS;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImJhc2UtY3NzLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUlZIiwiZmlsZSI6ImJhc2UtY3NzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IF9nZXQgZnJvbSAnbG9kYXNoLmdldCc7XG5cbmNvbnN0IGJhc2VDU1MgPSB0aGVtZSA9PiB7XG4gIHJldHVybiBjc3NgXG4gICAgLyoqXG4gICAgICogQXBwbHkgYSBuYXR1cmFsIGJveCBsYXlvdXQgbW9kZWwgdG8gYWxsIGVsZW1lbnRzLCBidXQgYWxsb3dpbmcgY29tcG9uZW50cyB0byBjaGFuZ2UuXG4gICAgICovXG4gICAgaHRtbCB7XG4gICAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICAgIH1cbiAgICAqLCAqOmJlZm9yZSwgKjphZnRlciB7XG4gICAgICBib3gtc2l6aW5nOiBpbmhlcml0O1xuICAgIH1cblxuICAgIGh0bWwge1xuICAgICAgZm9udC1mYW1pbHk6ICR7X2dldCh0aGVtZSwgJ2ZvbnRzLmJhc2UnKX07XG4gICAgfVxuXG4gICAgcHJlLFxuICAgIGNvZGUsXG4gICAga2JkLFxuICAgIHNhbXAge1xuICAgICAgZm9udC1mYW1pbHk6ICR7X2dldCh0aGVtZSwgJ2ZvbnRzLm1vbm8nKX07XG4gICAgfVxuICBgO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgYmFzZUNTUztcbiJdfQ== */");
};

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1h74bwz",
  styles: "html{line-height:1.15;-webkit-text-size-adjust:100%;}body{margin:0;}main{display:block;}h1{font-size:2em;margin:0.67em 0;}hr{box-sizing:content-box;height:0;overflow:visible;}pre{font-family:monospace,monospace;font-size:1em;}a{background-color:transparent;}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted;}b,strong{font-weight:bolder;}code,kbd,samp{font-family:monospace,monospace;font-size:1em;}small{font-size:80%;}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline;}sub{bottom:-0.25em;}sup{top:-0.5em;}img{border-style:none;}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0;}button,input{overflow:visible;}button,select{text-transform:none;}button,[type=\"button\"],[type=\"reset\"],[type=\"submit\"]{-webkit-appearance:button;}button::-moz-focus-inner,[type=\"button\"]::-moz-focus-inner,[type=\"reset\"]::-moz-focus-inner,[type=\"submit\"]::-moz-focus-inner{border-style:none;padding:0;}button:-moz-focusring,[type=\"button\"]:-moz-focusring,[type=\"reset\"]:-moz-focusring,[type=\"submit\"]:-moz-focusring{outline:1px dotted ButtonText;}fieldset{padding:0.35em 0.75em 0.625em;}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal;}progress{vertical-align:baseline;}textarea{overflow:auto;}[type=\"checkbox\"],[type=\"radio\"]{box-sizing:border-box;padding:0;}[type=\"number\"]::-webkit-inner-spin-button,[type=\"number\"]::-webkit-outer-spin-button{height:auto;}[type=\"search\"]{-webkit-appearance:textfield;outline-offset:-2px;}[type=\"search\"]::-webkit-search-decoration{-webkit-appearance:none;}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit;}details{display:block;}summary{display:list-item;}template{display:none;}[hidden]{display:none;}"
} : {
  name: "1ejeae8-normalizeCSS",
  styles: "html{line-height:1.15;-webkit-text-size-adjust:100%;}body{margin:0;}main{display:block;}h1{font-size:2em;margin:0.67em 0;}hr{box-sizing:content-box;height:0;overflow:visible;}pre{font-family:monospace,monospace;font-size:1em;}a{background-color:transparent;}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted;}b,strong{font-weight:bolder;}code,kbd,samp{font-family:monospace,monospace;font-size:1em;}small{font-size:80%;}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline;}sub{bottom:-0.25em;}sup{top:-0.5em;}img{border-style:none;}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0;}button,input{overflow:visible;}button,select{text-transform:none;}button,[type=\"button\"],[type=\"reset\"],[type=\"submit\"]{-webkit-appearance:button;}button::-moz-focus-inner,[type=\"button\"]::-moz-focus-inner,[type=\"reset\"]::-moz-focus-inner,[type=\"submit\"]::-moz-focus-inner{border-style:none;padding:0;}button:-moz-focusring,[type=\"button\"]:-moz-focusring,[type=\"reset\"]:-moz-focusring,[type=\"submit\"]:-moz-focusring{outline:1px dotted ButtonText;}fieldset{padding:0.35em 0.75em 0.625em;}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal;}progress{vertical-align:baseline;}textarea{overflow:auto;}[type=\"checkbox\"],[type=\"radio\"]{box-sizing:border-box;padding:0;}[type=\"number\"]::-webkit-inner-spin-button,[type=\"number\"]::-webkit-outer-spin-button{height:auto;}[type=\"search\"]{-webkit-appearance:textfield;outline-offset:-2px;}[type=\"search\"]::-webkit-search-decoration{-webkit-appearance:none;}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit;}details{display:block;}summary{display:list-item;}template{display:none;}[hidden]{display:none;};label:normalizeCSS;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var normalizeCSS = function normalizeCSS(theme) {
  return _ref;
};

var globalStyles = function globalStyles(theme) {
  return /*#__PURE__*/css([normalizeCSS(), baseCSS(theme)], process.env.NODE_ENV === "production" ? "" : ";label:globalStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNTU0Jhc2VsaW5lLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUs4QiIsImZpbGUiOiJDU1NCYXNlbGluZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcywgR2xvYmFsIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBiYXNlQ1NTIGZyb20gJy4vYmFzZS1jc3MnO1xuaW1wb3J0IG5vcm1hbGl6ZUNTUyBmcm9tICcuL25vcm1hbGl6ZS1jc3MnO1xuXG5jb25zdCBnbG9iYWxTdHlsZXMgPSB0aGVtZSA9PiBjc3MoW1xuICBub3JtYWxpemVDU1ModGhlbWUpLFxuICBiYXNlQ1NTKHRoZW1lKSxcbl0pO1xuXG5jb25zdCBDU1NCYXNlbGluZSA9ICgpID0+IHtcbiAgcmV0dXJuIChcbiAgICA8R2xvYmFsIHN0eWxlcz17Z2xvYmFsU3R5bGVzfSAvPlxuICApO1xufTtcblxuQ1NTQmFzZWxpbmUuZGlzcGxheU5hbWUgPSAnQ1NTQmFzZWxpbmUnO1xuXG5leHBvcnQgZGVmYXVsdCBDU1NCYXNlbGluZTtcbiJdfQ== */");
};
var CSSBaseline = function CSSBaseline() {
  return jsx(Global, {
    styles: globalStyles
  });
};
CSSBaseline.displayName = 'CSSBaseline';

var useDividerStyle = function useDividerStyle(_ref) {
  var _ref2;
  var orientation = _ref.orientation,
    variant = _ref.variant;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var dividerColor = {
    dark: 'rgba(255, 255, 255, 0.12)',
    light: 'rgba(0, 0, 0, 0.12)'
  }[colorMode];
  var borderKey = {
    vertical: 'borderLeft',
    horizontal: 'borderTop'
  }[orientation];
  var borderColorKey = {
    vertical: 'borderLeftColor',
    horizontal: 'borderTopColor'
  }[orientation];
  var borderStyleKey = {
    vertical: 'borderLeftStyle',
    horizontal: 'borderTopStyle'
  }[orientation];
  return _ref2 = {}, _defineProperty(_ref2, borderKey, 1), _defineProperty(_ref2, borderColorKey, dividerColor), _defineProperty(_ref2, borderStyleKey, variant), _ref2;
};

var _excluded$1k = ["orientation", "variant"];
var Divider = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'horizontal' : _ref$orientation,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'solid' : _ref$variant,
    rest = _objectWithoutProperties(_ref, _excluded$1k);
  var styleProps = useDividerStyle({
    orientation: orientation,
    variant: variant
  });
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), rest));
});
Divider.displayName = 'Divider';

var useForceUpdate = function useForceUpdate() {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    setValue = _useState2[1]; // eslint-disable-line react/hook-use-state

  return useCallback(function () {
    setValue(function () {
      return {};
    });
  }, []);
};

var PortalContext = /*#__PURE__*/createContext();
var PortalManagerContext = /*#__PURE__*/createContext();

var PORTAL_CLASSNAME = 'tonic-ui-portal';
var PORTAL_SELECTOR = ".".concat(PORTAL_CLASSNAME);
var Portal = function Portal(_ref) {
  var DEPRECATED_container = _ref.container,
    DEPRECATED_isDisabled = _ref.isDisabled,
    DEPRECATED_onRender = _ref.onRender,
    _ref$appendToParentPo = _ref.appendToParentPortal,
    appendToParentPortal = _ref$appendToParentPo === void 0 ? false : _ref$appendToParentPo,
    children = _ref.children,
    containerRef = _ref.containerRef;
  {
    // deprecation warning
    var prefix = "".concat(Portal.displayName, ":");
    useOnceWhen(function () {
      warnDeprecatedProps('container', {
        prefix: prefix,
        alternative: 'containerRef',
        willRemove: true
      });
    }, DEPRECATED_container !== undefined);
    useOnceWhen(function () {
      warnRemovedProps('isDisabled', {
        prefix: prefix
      });
    }, DEPRECATED_isDisabled !== undefined);
    useOnceWhen(function () {
      warnRemovedProps('onRender', {
        prefix: prefix
      });
    }, DEPRECATED_onRender !== undefined);
  }
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    doc = _useState2[0],
    setDoc = _useState2[1];
  var portalRef = useRef(null);
  var parentPortal = useContext(PortalContext);
  var forceUpdate = useForceUpdate();
  useIsomorphicEffect(function () {
    forceUpdate();
  }, []);
  useIsomorphicEffect(function () {
    var _containerRef$current;
    if (!doc) {
      return noop;
    }
    var containerEl = (_containerRef$current = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) !== null && _containerRef$current !== void 0 ? _containerRef$current : DEPRECATED_container; // TODO: remove DEPRECATED_container
    var host = function () {
      if (containerEl) {
        return containerEl;
      }
      if (appendToParentPortal) {
        return parentPortal !== null && parentPortal !== void 0 ? parentPortal : doc.body;
      }
      return doc.body;
    }();
    if (!host) {
      return noop;
    }
    portalRef.current = doc.createElement('div');
    portalRef.current.className = PORTAL_CLASSNAME;
    host.appendChild(portalRef.current);
    forceUpdate();
    var portalNode = portalRef.current;
    return function () {
      if (host.contains(portalNode)) {
        host.removeChild(portalNode);
      }
    };
  }, [doc]);
  if (!portalRef.current) {
    return jsx(Box, {
      ref: function ref(node) {
        if (node) {
          var ownerDocument = getOwnerDocument(node);
          setDoc(ownerDocument);
        }
      }
    });
  }
  return /*#__PURE__*/createPortal(jsx(PortalContext.Provider, {
    value: portalRef.current,
    children: children
  }), portalRef.current);
};
Portal.className = PORTAL_CLASSNAME;
Portal.selector = PORTAL_SELECTOR;
Portal.displayName = 'Portal';

var uniqueId$1 = function () {
  var id = 0;
  return function () {
    id += 1;
    return String(id);
  };
}();
var getMemoizedState$g = memoize(function (state) {
  return _objectSpread2({}, state);
});
var PortalManager = function PortalManager(_ref) {
  var children = _ref.children,
    containerRefProp = _ref.containerRef;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    portals = _useState2[0],
    setPortals = _useState2[1];
  var add = useCallback(function (render, options) {
    var _options$id, _options$containerRef;
    var id = (_options$id = options === null || options === void 0 ? void 0 : options.id) !== null && _options$id !== void 0 ? _options$id : uniqueId$1();
    var appendToParentPortal = options === null || options === void 0 ? void 0 : options.appendToParentPortal;
    var containerRef = (_options$containerRef = options === null || options === void 0 ? void 0 : options.containerRef) !== null && _options$containerRef !== void 0 ? _options$containerRef : containerRefProp;
    setPortals(function (portals) {
      return [].concat(_toConsumableArray(portals), [{
        id: id,
        appendToParentPortal: appendToParentPortal,
        containerRef: containerRef,
        render: render
      }]);
    });
    return id;
  }, [containerRefProp]);
  var remove = useCallback(function (id) {
    setPortals(function (portals) {
      return portals.filter(function (portal) {
        return portal.id !== id;
      });
    });
  }, []);
  var context = getMemoizedState$g({
    add: add,
    remove: remove
  });
  return jsxs(PortalManagerContext.Provider, {
    value: context,
    children: [portals.map(function (portal) {
      return jsx(Portal, {
        appendToParentPortal: portal.appendToParentPortal,
        containerRef: portal.containerRef,
        children: portal.render(function () {
          return remove(portal.id);
        })
      }, portal.id);
    }), children]
  });
};
PortalManager.displayName = 'PortalManager';

var usePortalManager = function usePortalManager() {
  var createPortalRef = useRef(null);
  var portalManagerRef = useRef(null);
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(PortalManagerContext);
  if (!context) {
    throw new Error('The `usePortalManager` hook must be called from a descendent of the `PortalManager`.');
  }
  createPortalRef.current = context.add;
  if (!portalManagerRef.current) {
    portalManagerRef.current = function () {
      var _createPortalRef$curr;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return (_createPortalRef$curr = createPortalRef.current) === null || _createPortalRef$curr === void 0 ? void 0 : _createPortalRef$curr.call.apply(_createPortalRef$curr, [createPortalRef].concat(args));
    };
  }
  Object.assign(portalManagerRef.current, context);
  return portalManagerRef.current;
};

var AnimatePresenceContext = /*#__PURE__*/createContext();

var AnimatePresence = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    inProp = _ref["in"],
    _onExitComplete = _ref.onExitComplete;
  var childCompleteMap = useConst(function () {
    return new Map();
  });
  var context = useMemo(function () {
    return {
      "in": inProp,
      onExitComplete: function onExitComplete(childId) {
        childCompleteMap.set(childId, true /* isComplete */);

        var allComplete = true;
        var _iterator = _createForOfIteratorHelper(childCompleteMap),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
              isComplete = _step$value[1];
            if (!isComplete) {
              allComplete = false;
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (allComplete) {
          ensureFunction(_onExitComplete)();
        }
      },
      register: function register(childId) {
        childCompleteMap.set(childId, false /* isComplete */);
        return function () {
          childCompleteMap["delete"](childId);
        };
      }
    };
  }, [inProp, _onExitComplete, childCompleteMap]);

  // Remove the component immediately if there's no components to fire exit transitions.
  useEffect(function () {
    if (!inProp && childCompleteMap.size === 0) {
      _onExitComplete();
    }
  }, [inProp, _onExitComplete, childCompleteMap]);
  return jsx(AnimatePresenceContext.Provider, {
    value: context,
    children: children
  });
});

var useAnimatePresence = function useAnimatePresence() {
  var id = useAutoId();
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(AnimatePresenceContext);
  var _context = _objectSpread2({}, context),
    inProp = _context["in"],
    onExitComplete = _context.onExitComplete,
    register = _context.register;
  var safeToRemove = function safeToRemove() {
    return ensureFunction(onExitComplete)(id);
  };
  useEffect(function () {
    return ensureFunction(register)(id);
  }, [id, register]);
  if (context === undefined) {
    return [null, null];
  }
  return !inProp && onExitComplete ? [false, safeToRemove] : [true, null];
};

var defaultPlacement$5 = 'right';
var defaultSize$a = 'auto';
var useDrawerContainerStyle = function useDrawerContainerStyle(_ref) {
  var backdrop = _ref.backdrop,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? defaultPlacement$5 : _ref$placement;
  var placementStyle = {
    top: {
      top: 0,
      right: 0,
      bottom: backdrop ? 0 : undefined,
      left: 0
    },
    right: {
      top: 0,
      right: 0,
      bottom: 0,
      left: backdrop ? 0 : undefined
    },
    bottom: {
      top: backdrop ? 0 : undefined,
      right: 0,
      bottom: 0,
      left: 0
    },
    left: {
      top: 0,
      right: backdrop ? 0 : undefined,
      bottom: 0,
      left: 0
    }
  }[placement];
  return _objectSpread2({
    position: 'fixed',
    display: 'flex',
    zIndex: 'drawer'
  }, placementStyle);
};
var useDrawerOverlayStyle = function useDrawerOverlayStyle() {
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var backgroundColor = {
    dark: 'rgba(0, 0, 0, .7)',
    light: 'rgba(0, 0, 0, .7)'
  }[colorMode];
  return {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    backgroundColor: backgroundColor
  };
};
var useDrawerContentStyle = function useDrawerContentStyle(_ref2) {
  var _colorStyle$shadow, _colorStyle$shadow2;
  var _ref2$placement = _ref2.placement,
    placement = _ref2$placement === void 0 ? defaultPlacement$5 : _ref2$placement,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? defaultSize$a : _ref2$size,
    tabIndex = _ref2.tabIndex;
  var isLeftOrRight = placement === 'left' || placement === 'right';
  var _useColorMode3 = useColorMode(),
    _useColorMode4 = _slicedToArray(_useColorMode3, 1),
    colorMode = _useColorMode4[0];
  var _useColorStyle = useColorStyle({
      colorMode: colorMode
    }),
    _useColorStyle2 = _slicedToArray(_useColorStyle, 1),
    colorStyle = _useColorStyle2[0];
  var baseStyle = {
    display: 'flex',
    flexDirection: 'column',
    outline: tabIndex < 0 ? 0 : undefined,
    // Remove the default outline for tabindex="-1"
    overflow: 'clip',
    // Set overflow to clip to forbid all scrolling for drawer content
    position: 'relative'
  };
  var colorModeStyle = {
    light: {
      color: 'black:primary',
      bg: 'white',
      borderWidth: '1q',
      borderStyle: 'solid',
      borderColor: 'gray:30',
      boxShadow: colorStyle === null || colorStyle === void 0 ? void 0 : (_colorStyle$shadow = colorStyle.shadow) === null || _colorStyle$shadow === void 0 ? void 0 : _colorStyle$shadow.thick
    },
    dark: {
      color: 'white:primary',
      bg: 'gray:90',
      borderWidth: '1q',
      borderStyle: 'solid',
      borderColor: 'gray:80',
      boxShadow: colorStyle === null || colorStyle === void 0 ? void 0 : (_colorStyle$shadow2 = colorStyle.shadow) === null || _colorStyle$shadow2 === void 0 ? void 0 : _colorStyle$shadow2.thick
    }
  }[colorMode];
  var placementStyle = {
    // https://stackoverflow.com/questions/33454533/cant-scroll-to-top-of-flex-item-that-is-overflowing-container
    top: {
      margin: 'auto',
      marginTop: 0
    },
    right: {
      margin: 'auto',
      marginRight: 0
    },
    bottom: {
      margin: 'auto',
      marginBottom: 0
    },
    left: {
      margin: 'auto',
      marginLeft: 0
    }
  }[placement];
  var sizeStyle = {
    sm: {
      width: isLeftOrRight ? 336 : '100%',
      height: isLeftOrRight ? '100%' : undefined,
      minHeight: isLeftOrRight ? undefined : 320,
      maxHeight: isLeftOrRight ? undefined : '80vh'
    },
    md: {
      width: isLeftOrRight ? 504 : '100%',
      height: isLeftOrRight ? '100%' : undefined,
      minHeight: isLeftOrRight ? undefined : 320,
      maxHeight: isLeftOrRight ? undefined : '80vh'
    },
    lg: {
      width: isLeftOrRight ? 672 : '100%',
      height: isLeftOrRight ? '100%' : undefined,
      minHeight: isLeftOrRight ? undefined : 320,
      maxHeight: isLeftOrRight ? undefined : '80vh'
    },
    full: {
      width: '100%',
      height: '100%',
      maxWidth: '100vw',
      maxHeight: '100vh'
    },
    auto: {
      width: isLeftOrRight ? 'auto' : '100%',
      height: isLeftOrRight ? '100%' : 'auto',
      maxWidth: '100vw',
      maxHeight: '100vh'
    }
  }[size];
  return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, baseStyle), colorModeStyle), placementStyle), sizeStyle);
};
var useDrawerCloseButtonStyle = function useDrawerCloseButtonStyle() {
  var _useColorMode5 = useColorMode(),
    _useColorMode6 = _slicedToArray(_useColorMode5, 1),
    colorMode = _useColorMode6[0];
  var _useTheme = useTheme(),
    sizes = _useTheme.sizes;
  var color = {
    dark: 'white:tertiary',
    light: 'black:tertiary'
  }[colorMode];
  var size = '8x';
  var _focusBorderColor = 'blue:60';
  var _focusBoxShadowBorderColor = 'blue:60';
  var _hoverColor = {
    dark: 'white:emphasis',
    light: 'black:primary'
  }[colorMode];
  var baseStyle = useIconButtonStyle({
    color: color,
    size: size,
    _focusBorderColor: _focusBorderColor,
    _focusBoxShadowBorderColor: _focusBoxShadowBorderColor,
    _hoverColor: _hoverColor
  });
  var parentBorderWidth = sizes['1q'];
  var top = "calc(".concat(sizes['2x'], " - ").concat(parentBorderWidth, ")");
  var right = "calc(".concat(sizes['2x'], " - ").concat(parentBorderWidth, ")");
  return _objectSpread2(_objectSpread2({}, baseStyle), {}, {
    position: 'absolute',
    top: top,
    right: right
  });
};
var useDrawerHeaderStyle = function useDrawerHeaderStyle(_ref3) {
  var isClosable = _ref3.isClosable;
  return {
    pt: '4x',
    pb: '6x',
    pl: '4x',
    pr: isClosable ? '12x' : '4x',
    position: 'relative',
    fontSize: 'xl',
    lineHeight: 'xl'
  };
};
var useDrawerBodyStyle = function useDrawerBodyStyle(_ref4) {
  var scrollBehavior = _ref4.scrollBehavior;
  var _useTheme2 = useTheme(),
    sizes = _useTheme2.sizes,
    lineHeights = _useTheme2.lineHeights;
  return {
    px: '4x',
    pb: '6x',
    flex: 1,
    height: 'auto',
    overflowY: scrollBehavior === 'inside' ? 'auto' : undefined,
    _firstOfType: {
      // Sets the margin area on the top if it is the first child
      // 4x (padding-top) + xl (line-height) + 3x (padding-bottom)
      marginTop: "calc(".concat(_get(sizes, '4x'), " + ").concat(_get(lineHeights, 'xl'), " + ").concat(_get(sizes, '3x'), ")")
    }
  };
};
var useDrawerFooterStyle = function useDrawerFooterStyle(_ref5) {
  var _ref5$placement = _ref5.placement,
    placement = _ref5$placement === void 0 ? defaultPlacement$5 : _ref5$placement;
  var _useTheme3 = useTheme(),
    sizes = _useTheme3.sizes,
    lineHeights = _useTheme3.lineHeights;
  return {
    display: 'flex',
    justifyContent: {
      'right': 'flex-start',
      'left': 'flex-end'
    }[placement],
    px: '4x',
    py: '4x',
    _firstOfType: {
      // Sets the margin area on the top if it is the first child
      // 4x (padding-top) + xl (line-height) + 3x (padding-bottom)
      marginTop: "calc(".concat(_get(sizes, '4x'), " + ").concat(_get(lineHeights, 'xl'), " + ").concat(_get(sizes, '3x'), ")")
    }
  };
};

var DrawerContext = /*#__PURE__*/createContext();

var useDrawer = function useDrawer() {
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(DrawerContext);
  return context;
};

var DrawerContainer = /*#__PURE__*/forwardRef(function (props, ref) {
  var drawerContext = useDrawer(); // context might be an undefined value
  var _drawerContext = _objectSpread2({}, drawerContext),
    backdrop = _drawerContext.backdrop,
    closeOnOutsideClick = _drawerContext.closeOnOutsideClick,
    onClose = _drawerContext.onClose,
    placement = _drawerContext.placement,
    containerRef = _drawerContext.containerRef;
  var combinedRef = useMergeRefs(containerRef, ref);
  var styleProps = useDrawerContainerStyle({
    backdrop: backdrop,
    placement: placement
  });
  var containerProps = _objectSpread2(_objectSpread2({
    ref: combinedRef,
    onClick: function onClick(event) {
      event.stopPropagation();
      if (closeOnOutsideClick) {
        typeof onClose === 'function' && onClose(event);
      }
    }
  }, styleProps), props);
  return jsx(Box, _objectSpread2({}, containerProps));
});
DrawerContainer.displayName = 'DrawerContainer';

var _excluded$1j = ["isCloseButtonVisible", "autoFocus", "backdrop", "children", "closeOnEsc", "closeOnOutsideClick", "ensureFocus", "finalFocusRef", "initialFocusRef", "isClosable", "isOpen", "onClose", "placement", "portalProps", "returnFocusOnClose", "size"];
var getMemoizedState$f = memoize(function (state) {
  return _objectSpread2({}, state);
});
var defaultPlacement$4 = 'right';
var defaultSize$9 = 'auto';
var Drawer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isCloseButtonVisible = _ref.isCloseButtonVisible,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    _ref$backdrop = _ref.backdrop,
    backdrop = _ref$backdrop === void 0 ? false : _ref$backdrop,
    children = _ref.children,
    _ref$closeOnEsc = _ref.closeOnEsc,
    closeOnEsc = _ref$closeOnEsc === void 0 ? false : _ref$closeOnEsc,
    _ref$closeOnOutsideCl = _ref.closeOnOutsideClick,
    closeOnOutsideClick = _ref$closeOnOutsideCl === void 0 ? false : _ref$closeOnOutsideCl,
    _ref$ensureFocus = _ref.ensureFocus,
    ensureFocus = _ref$ensureFocus === void 0 ? false : _ref$ensureFocus,
    finalFocusRef = _ref.finalFocusRef,
    initialFocusRef = _ref.initialFocusRef,
    _ref$isClosable = _ref.isClosable,
    isClosable = _ref$isClosable === void 0 ? false : _ref$isClosable,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    onClose = _ref.onClose,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? defaultPlacement$4 : _ref$placement,
    portalProps = _ref.portalProps,
    _ref$returnFocusOnClo = _ref.returnFocusOnClose,
    returnFocusOnClose = _ref$returnFocusOnClo === void 0 ? true : _ref$returnFocusOnClo,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaultSize$9 : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded$1j);
  {
    // deprecation warning
    var prefix = "".concat(Drawer.displayName, ":");
    useOnceWhen(function () {
      warnDeprecatedProps('isCloseButtonVisible', {
        prefix: prefix,
        alternative: 'isClosable',
        willRemove: true
      });
    }, isCloseButtonVisible !== undefined);
    isClosable = isClosable || isCloseButtonVisible; // TODO: remove this line after deprecation
  }

  var _useState = useState(isOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isMounted = _useState2[0],
    setIsMounted = _useState2[1];
  var containerRef = useRef();
  var contentRef = useRef(null);
  var context = getMemoizedState$f({
    autoFocus: autoFocus,
    backdrop: backdrop,
    closeOnEsc: closeOnEsc,
    closeOnOutsideClick: closeOnOutsideClick,
    ensureFocus: ensureFocus,
    finalFocusRef: finalFocusRef,
    initialFocusRef: initialFocusRef,
    isClosable: isClosable,
    isOpen: isOpen,
    onClose: onClose,
    placement: placement,
    size: size,
    containerRef: containerRef,
    // internal use only
    contentRef: contentRef,
    // internal use only
    scrollBehavior: 'inside' // internal use only (only 'inside' is supported by Drawer)
  });

  var returnFocus = returnFocusOnClose && !finalFocusRef;
  var onFocusLockActivation = useCallback(function () {
    if (initialFocusRef && initialFocusRef.current) {
      var el = initialFocusRef.current;
      if (typeof el.focus === 'function') {
        el.focus();
      }
      return;
    }
    if (contentRef.current) {
      var _el = contentRef.current;
      var focusableElements = getAllFocusable(_el);
      if (focusableElements.length > 0) {
        return;
      }
      if (typeof _el.focus === 'function') {
        _el.focus();
      }
    }
  }, [initialFocusRef]);
  var onFocusLockDeactivation = useCallback(function () {
    if (finalFocusRef && finalFocusRef.current) {
      var el = finalFocusRef.current;
      if (typeof el.focus === 'function') {
        el.focus();
      }
    }
  }, [finalFocusRef]);
  var onExitComplete = useCallback(function () {
    setIsMounted(false);
  }, []);
  useEffect(function () {
    if (isOpen && !isMounted) {
      setIsMounted(true);
      return;
    }
  }, [isOpen, isMounted]);
  return jsx(DrawerContext.Provider, {
    value: context,
    children: jsx(AnimatePresence, {
      "in": isOpen,
      onExitComplete: onExitComplete,
      children: !!isMounted && jsx(Portal, _objectSpread2(_objectSpread2({}, portalProps), {}, {
        children: jsx(FocusLock, {
          disabled: !ensureFocus,
          autoFocus: autoFocus,
          returnFocus: returnFocus,
          onActivation: onFocusLockActivation,
          onDeactivation: onFocusLockDeactivation,
          children: jsx(DrawerContainer, _objectSpread2(_objectSpread2({
            ref: ref
          }, rest), {}, {
            children: runIfFn(children, context)
          }))
        })
      }))
    })
  });
});
Drawer.displayName = 'Drawer';

var DrawerBody = /*#__PURE__*/forwardRef(function (props, ref) {
  var drawerContext = useDrawer(); // context might be an undefined value
  var _drawerContext = _objectSpread2({}, drawerContext),
    scrollBehavior = _drawerContext.scrollBehavior;
  var styleProps = useDrawerBodyStyle({
    scrollBehavior: scrollBehavior
  });
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), props));
});
DrawerBody.displayName = 'DrawerBody';

var _excluded$1i = ["children", "onClick"];
var DrawerCloseButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    onClickProp = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded$1i);
  var drawerContext = useDrawer(); // context might be an undefined value
  var _drawerContext = _objectSpread2({}, drawerContext),
    onClose = _drawerContext.onClose;
  var styleProps = useDrawerCloseButtonStyle();
  return jsx(ButtonBase, _objectSpread2(_objectSpread2(_objectSpread2({
    "aria-label": "Close",
    ref: ref,
    onClick: callEventHandlers(onClickProp, onClose)
  }, styleProps), rest), {}, {
    children: children !== null && children !== void 0 ? children : jsx(Icon, {
      icon: "close"
    })
  }));
});
DrawerCloseButton.displayName = 'DrawerCloseButton';

var _excluded$1h = ["TransitionComponent", "TransitionProps", "children"];
var DrawerContent = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$TransitionCompon = _ref.TransitionComponent,
    TransitionComponent = _ref$TransitionCompon === void 0 ? Slide : _ref$TransitionCompon,
    TransitionProps = _ref.TransitionProps,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$1h);
  var _useAnimatePresence = useAnimatePresence(),
    _useAnimatePresence2 = _slicedToArray(_useAnimatePresence, 2),
    safeToRemove = _useAnimatePresence2[1];
  var drawerContext = useDrawer(); // context might be an undefined value
  var _drawerContext = _objectSpread2({}, drawerContext),
    closeOnEsc = _drawerContext.closeOnEsc,
    isClosable = _drawerContext.isClosable,
    isOpen = _drawerContext.isOpen,
    onClose = _drawerContext.onClose,
    placement = _drawerContext.placement,
    size = _drawerContext.size,
    contentRef = _drawerContext.contentRef;
  var combinedRef = useMergeRefs(contentRef, ref);
  var tabIndex = -1;
  var styleProps = useDrawerContentStyle({
    placement: placement,
    size: size,
    tabIndex: tabIndex
  });
  var contentProps = _objectSpread2(_objectSpread2({
    'aria-modal': ariaAttr(true),
    ref: combinedRef,
    role: 'dialog',
    tabIndex: tabIndex,
    onClick: function onClick(event) {
      return event.stopPropagation();
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Escape') {
        event.stopPropagation();
        if (closeOnEsc) {
          typeof onClose === 'function' && onClose(event);
        }
      }
    }
  }, styleProps), rest);
  var transitionDirection = {
    'left': 'right',
    'right': 'left',
    'top': 'down',
    'bottom': 'up'
  }[placement];
  return jsxs(TransitionComponent, _objectSpread2(_objectSpread2(_objectSpread2({
    appear: !!drawerContext
  }, TransitionProps), contentProps), {}, {
    "in": drawerContext ? isOpen : true,
    direction: transitionDirection,
    onExited: callAll(safeToRemove, TransitionProps === null || TransitionProps === void 0 ? void 0 : TransitionProps.onExited),
    children: [children, !!isClosable && jsx(DrawerCloseButton, {})]
  }));
});
DrawerContent.displayName = 'DrawerContent';

var DrawerFooter = /*#__PURE__*/forwardRef(function (props, ref) {
  var context = useDrawer(); // context might be an undefined value
  var _context = _objectSpread2({}, context),
    placement = _context.placement;
  var styleProps = useDrawerFooterStyle({
    placement: placement
  });
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), props));
});
DrawerFooter.displayName = 'DrawerFooter';

var DrawerHeader = /*#__PURE__*/forwardRef(function (props, ref) {
  var drawerContext = useDrawer(); // context might be an undefined value
  var _drawerContext = _objectSpread2({}, drawerContext),
    isClosable = _drawerContext.isClosable;
  var styleProps = useDrawerHeaderStyle({
    isClosable: isClosable
  });
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), props));
});
DrawerHeader.displayName = 'DrawerHeader';

var _excluded$1g = ["TransitionComponent", "TransitionProps"];
var DrawerOverlay = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$TransitionCompon = _ref.TransitionComponent,
    TransitionComponent = _ref$TransitionCompon === void 0 ? Fade : _ref$TransitionCompon,
    TransitionProps = _ref.TransitionProps,
    rest = _objectWithoutProperties(_ref, _excluded$1g);
  var drawerContext = useDrawer(); // context might be an undefined value
  var _drawerContext = _objectSpread2({}, drawerContext),
    isOpen = _drawerContext.isOpen;
  var _useAnimatePresence = useAnimatePresence(),
    _useAnimatePresence2 = _slicedToArray(_useAnimatePresence, 2),
    safeToRemove = _useAnimatePresence2[1];
  var overlayRef = useRef();
  var combinedRef = useMergeRefs(overlayRef, ref);
  var styleProps = useDrawerOverlayStyle();
  var overlayProps = _objectSpread2(_objectSpread2({
    ref: combinedRef
  }, styleProps), rest);
  return jsx(TransitionComponent, _objectSpread2(_objectSpread2(_objectSpread2({
    appear: !!drawerContext
  }, TransitionProps), overlayProps), {}, {
    "in": drawerContext ? isOpen : true,
    onExited: callAll(safeToRemove, TransitionProps === null || TransitionProps === void 0 ? void 0 : TransitionProps.onExited)
  }));
});
DrawerOverlay.displayName = 'DrawerOverlay';

Drawer.Body = DrawerBody;
Drawer.Content = DrawerContent;
Drawer.Footer = DrawerFooter;
Drawer.Header = DrawerHeader;
Drawer.Overlay = DrawerOverlay;

var _excluded$1f = ["direction", "wrap", "align", "justify"];
var Flex = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var direction = _ref.direction,
    wrap = _ref.wrap,
    align = _ref.align,
    justify = _ref.justify,
    rest = _objectWithoutProperties(_ref, _excluded$1f);
  return jsx(Box, _objectSpread2({
    ref: ref,
    display: "flex",
    flexDirection: direction,
    flexWrap: wrap,
    alignItems: align,
    justifyContent: justify
  }, rest));
});
Flex.displayName = 'Flex';

var _excluded$1e = ["gap", "rowGap", "columnGap", "column", "row", "area", "autoFlow", "autoRows", "autoColumns", "templateRows", "templateColumns", "templateAreas"];
var Grid = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var gap = _ref.gap,
    rowGap = _ref.rowGap,
    columnGap = _ref.columnGap,
    column = _ref.column,
    row = _ref.row,
    area = _ref.area,
    autoFlow = _ref.autoFlow,
    autoRows = _ref.autoRows,
    autoColumns = _ref.autoColumns,
    templateRows = _ref.templateRows,
    templateColumns = _ref.templateColumns,
    templateAreas = _ref.templateAreas,
    rest = _objectWithoutProperties(_ref, _excluded$1e);
  return jsx(Box, _objectSpread2({
    ref: ref,
    display: "grid",
    gridGap: gap,
    gridRowGap: rowGap,
    gridColumnGap: columnGap,
    gridColumn: column,
    gridRow: row,
    gridArea: area,
    gridAutoFlow: autoFlow,
    gridAutoRows: autoRows,
    gridAutoColumns: autoColumns,
    gridTemplateRows: templateRows,
    gridTemplateColumns: templateColumns,
    gridTemplateAreas: templateAreas
  }, rest));
});
Grid.displayName = 'Grid';

var Image = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(Box, _objectSpread2({
    ref: ref,
    as: "img",
    alt: ""
  }, props));
});
Image.displayName = 'Image';

var VARIANT_OUTLINE = 'outline';
var VARIANT_FILLED = 'filled';
var VARIANT_FLUSH = 'flush';
var VARIANT_UNSTYLED = 'unstyled';
var defaultSize$8 = 'md';
var defaultVariant$7 = 'outline';

/**
 * Input
 */

var getInputOutlineStyle = function getInputOutlineStyle(_ref) {
  var colorMode = _ref.colorMode;
  var backgroundColor = {
    dark: 'transparent',
    light: 'white'
  }[colorMode];
  var borderColor = {
    dark: 'gray:60',
    light: 'gray:30'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  var hoverBorderColor = {
    dark: 'blue:50',
    light: 'blue:50'
  }[colorMode];
  var focusBorderColor = {
    dark: 'blue:60',
    light: 'blue:60'
  }[colorMode];
  var disabledBorderColor = {
    dark: 'gray:60',
    light: 'gray:30'
  }[colorMode];
  var invalidBorderColor = {
    dark: 'red:50',
    light: 'red:60'
  }[colorMode];
  var placeholderColor = {
    dark: 'white:tertiary',
    light: 'black:tertiary'
  }[colorMode];
  var _disabledStyle = {
    borderColor: disabledBorderColor,
    cursor: 'not-allowed',
    opacity: '.28'
  };
  var _focusStyle = {
    borderColor: focusBorderColor,
    // Bring overlapping border to front when focused
    zIndex: 1
  };
  var _hoverStyle = {
    borderColor: hoverBorderColor,
    // Use a higher z-index value to bring overlapping border to front when hovered
    zIndex: 2
  };
  var _invalidStyle = {
    borderColor: invalidBorderColor,
    '&:focus:hover': {
      borderColor: focusBorderColor
    },
    '&:hover': {
      borderColor: invalidBorderColor
    }
  };
  var _validStyle = {
    // XXX - border color for valid input is not defined
  };
  var __placeholderStyle = {
    color: placeholderColor,
    // Override Firefox's unusual default opacity
    opacity: 1
  };
  return {
    backgroundColor: backgroundColor,
    border: 1,
    borderColor: borderColor,
    borderRadius: 'sm',
    color: color,
    _disabled: _disabledStyle,
    _focus: _focusStyle,
    _hover: _hoverStyle,
    _invalid: _invalidStyle,
    _valid: _validStyle,
    __placeholder: __placeholderStyle
  };
};
var getInputFilledStyle = function getInputFilledStyle(_ref2) {
  var colorMode = _ref2.colorMode;
  var backgroundColor = {
    dark: 'gray:80',
    light: 'gray:10'
  }[colorMode];
  return _objectSpread2(_objectSpread2({}, getInputOutlineStyle({
    colorMode: colorMode
  })), {}, {
    backgroundColor: backgroundColor
  });
};
var getInputFlushStyle = function getInputFlushStyle(_ref3) {
  var colorMode = _ref3.colorMode;
  var backgroundColor = {
    dark: 'transparent',
    light: 'white'
  }[colorMode];
  var borderColor = {
    dark: 'gray:60',
    light: 'gray:30'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  var hoverBorderColor = {
    dark: 'blue:50',
    light: 'blue:50'
  }[colorMode];
  var focusBorderColor = {
    dark: 'blue:60',
    light: 'blue:60'
  }[colorMode];
  var disabledBorderColor = {
    dark: 'gray:60',
    light: 'gray:30'
  }[colorMode];
  var invalidBorderColor = {
    dark: 'red:50',
    light: 'red:60'
  }[colorMode];
  var placeholderColor = {
    dark: 'white:tertiary',
    light: 'black:tertiary'
  }[colorMode];
  var _disabledStyle = {
    borderBottomColor: disabledBorderColor,
    cursor: 'not-allowed',
    opacity: '.28'
  };
  var _focusStyle = {
    borderBottomColor: focusBorderColor,
    // Bring overlapping border to front when focused
    zIndex: 1
  };
  var _hoverStyle = {
    borderBottomColor: hoverBorderColor,
    // Use a higher z-index value to bring overlapping border to front when hovered
    zIndex: 2
  };
  var _invalidStyle = {
    borderBottomColor: invalidBorderColor,
    '&:focus:hover': {
      borderBottomColor: focusBorderColor
    },
    '&:hover': {
      borderBottomColor: invalidBorderColor
    }
  };
  var _validStyle = {
    // XXX - border color for valid input is not defined
  };
  var __placeholderStyle = {
    color: placeholderColor,
    // Override Firefox's unusual default opacity
    opacity: 1
  };
  return {
    backgroundColor: backgroundColor,
    borderBottom: 1,
    borderBottomColor: borderColor,
    color: color,
    _disabled: _disabledStyle,
    _focus: _focusStyle,
    _hover: _hoverStyle,
    _invalid: _invalidStyle,
    _valid: _validStyle,
    __placeholder: __placeholderStyle
  };
};
var getInputUnstyledStyle = function getInputUnstyledStyle(_ref4) {
  var colorMode = _ref4.colorMode;
  var backgroundColor = {
    dark: 'transparent',
    light: 'white'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  return {
    backgroundColor: backgroundColor,
    border: 0,
    color: color
  };
};
var getInputVariantStyle = function getInputVariantStyle(_ref5) {
  var colorMode = _ref5.colorMode,
    variant = _ref5.variant;
  if (variant === VARIANT_OUTLINE) {
    return getInputOutlineStyle({
      colorMode: colorMode
    });
  }
  if (variant === VARIANT_FILLED) {
    return getInputFilledStyle({
      colorMode: colorMode
    });
  }
  if (variant === VARIANT_FLUSH) {
    return getInputFlushStyle({
      colorMode: colorMode
    });
  }
  if (variant === VARIANT_UNSTYLED) {
    return getInputUnstyledStyle({
      colorMode: colorMode
    });
  }
  return {};
};

/**
 * InputControl
 */

var getInputControlOutlineStyle = function getInputControlOutlineStyle(_ref6) {
  var colorMode = _ref6.colorMode,
    inputState = _ref6.inputState;
  var backgroundColor = {
    dark: 'transparent',
    light: 'white'
  }[colorMode];
  var borderColor = {
    dark: 'gray:60',
    light: 'gray:30'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  var hoverBorderColor = {
    dark: 'blue:50',
    light: 'blue:50'
  }[colorMode];
  var focusBorderColor = {
    dark: 'blue:60',
    light: 'blue:60'
  }[colorMode];
  var disabledBorderColor = {
    dark: 'gray:60',
    light: 'gray:30'
  }[colorMode];
  var invalidBorderColor = {
    dark: 'red:50',
    light: 'red:60'
  }[colorMode];
  var placeholderColor = {
    dark: 'white:tertiary',
    light: 'black:tertiary'
  }[colorMode];
  var _disabledStyle = {
    borderColor: disabledBorderColor,
    cursor: 'not-allowed',
    opacity: '.28'
  };
  var _focusStyle = {
    borderColor: focusBorderColor,
    // Bring overlapping border to front when focused
    zIndex: 1
  };
  var _hoverStyle = {
    borderColor: hoverBorderColor,
    // Use a higher z-index value to bring overlapping border to front when hovered
    zIndex: 2
  };
  var _invalidStyle = {
    borderColor: invalidBorderColor
  };
  var _validStyle = {
    // XXX - border color for valid input is not defined
  };
  var __placeholderStyle = {
    color: placeholderColor,
    // Override Firefox's unusual default opacity
    opacity: 1
  };
  var inputStateStyle = function () {
    var _inputState = _objectSpread2({}, inputState),
      disabled = _inputState.disabled,
      focused = _inputState.focused,
      valid = _inputState.valid;
    if (disabled !== undefined && !!disabled) {
      return _objectSpread2({
        _disabled: undefined,
        _focus: undefined,
        _hover: undefined,
        _invalid: undefined,
        _valid: undefined
      }, _disabledStyle);
    }
    return _objectSpread2(_objectSpread2({}, focused !== undefined && !!focused && _focusStyle), valid !== undefined && (!!valid ? _validStyle : _invalidStyle));
  }();
  return _objectSpread2({
    backgroundColor: backgroundColor,
    border: 1,
    borderColor: borderColor,
    borderRadius: 'sm',
    color: color,
    _disabled: _disabledStyle,
    _focus: _focusStyle,
    _hover: _hoverStyle,
    _invalid: _invalidStyle,
    _valid: _validStyle,
    __placeholder: __placeholderStyle
  }, inputStateStyle);
};
var getInputControlFilledStyle = function getInputControlFilledStyle(_ref7) {
  var colorMode = _ref7.colorMode,
    inputState = _ref7.inputState;
  var backgroundColor = {
    dark: 'gray:80',
    light: 'gray:10'
  }[colorMode];
  return _objectSpread2(_objectSpread2({}, getInputControlOutlineStyle({
    colorMode: colorMode,
    inputState: inputState
  })), {}, {
    backgroundColor: backgroundColor
  });
};
var getInputControlFlushStyle = function getInputControlFlushStyle(_ref8) {
  var colorMode = _ref8.colorMode,
    inputState = _ref8.inputState;
  var backgroundColor = {
    dark: 'transparent',
    light: 'white'
  }[colorMode];
  var borderColor = {
    dark: 'gray:60',
    light: 'gray:30'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  var hoverBorderColor = {
    dark: 'blue:50',
    light: 'blue:50'
  }[colorMode];
  var focusBorderColor = {
    dark: 'blue:60',
    light: 'blue:60'
  }[colorMode];
  var disabledBorderColor = {
    dark: 'gray:60',
    light: 'gray:30'
  }[colorMode];
  var invalidBorderColor = {
    dark: 'red:50',
    light: 'red:60'
  }[colorMode];
  var placeholderColor = {
    dark: 'white:tertiary',
    light: 'black:tertiary'
  }[colorMode];
  var _disabledStyle = {
    borderBottomColor: disabledBorderColor,
    cursor: 'not-allowed',
    opacity: '.28'
  };
  var _focusStyle = {
    borderBottomColor: focusBorderColor,
    // Bring overlapping border to front when focused
    zIndex: 1
  };
  var _hoverStyle = {
    borderBottomColor: hoverBorderColor,
    // Use a higher z-index value to bring overlapping border to front when hovered
    zIndex: 2
  };
  var _invalidStyle = {
    borderBottomColor: invalidBorderColor
  };
  var _validStyle = {
    // XXX - border color for valid input is not defined
  };
  var __placeholderStyle = {
    color: placeholderColor,
    // Override Firefox's unusual default opacity
    opacity: 1
  };
  var inputStateStyle = function () {
    var _inputState2 = _objectSpread2({}, inputState),
      disabled = _inputState2.disabled,
      focused = _inputState2.focused,
      valid = _inputState2.valid;
    if (disabled !== undefined && !!disabled) {
      return _objectSpread2({
        _disabled: undefined,
        _focus: undefined,
        _hover: undefined,
        _invalid: undefined,
        _valid: undefined
      }, _disabledStyle);
    }
    return _objectSpread2(_objectSpread2({}, focused !== undefined && !!focused && _focusStyle), valid !== undefined && (!!valid ? _validStyle : _invalidStyle));
  }();
  return _objectSpread2({
    backgroundColor: backgroundColor,
    borderBottom: 1,
    borderBottomColor: borderColor,
    color: color,
    _disabled: _disabledStyle,
    _focus: _focusStyle,
    _hover: _hoverStyle,
    _invalid: _invalidStyle,
    _valid: _validStyle,
    __placeholder: __placeholderStyle
  }, inputStateStyle);
};
var getInputControlUnstyledStyle = function getInputControlUnstyledStyle(_ref9) {
  var colorMode = _ref9.colorMode;
    _ref9.inputState;
  var backgroundColor = {
    dark: 'transparent',
    light: 'white'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  return {
    backgroundColor: backgroundColor,
    border: 0,
    color: color
  };
};
var getInputControlVariantStyle = function getInputControlVariantStyle(_ref10) {
  var colorMode = _ref10.colorMode,
    inputState = _ref10.inputState,
    variant = _ref10.variant;
  if (variant === VARIANT_OUTLINE) {
    return getInputControlOutlineStyle({
      colorMode: colorMode,
      inputState: inputState
    });
  }
  if (variant === VARIANT_FILLED) {
    return getInputControlFilledStyle({
      colorMode: colorMode,
      inputState: inputState
    });
  }
  if (variant === VARIANT_FLUSH) {
    return getInputControlFlushStyle({
      colorMode: colorMode,
      inputState: inputState
    });
  }
  if (variant === VARIANT_UNSTYLED) {
    return getInputControlUnstyledStyle({
      colorMode: colorMode,
      inputState: inputState
    });
  }
  return {};
};

/**
 * InputGroup
 */

var getInputGroupAddonOutlineStyle = function getInputGroupAddonOutlineStyle(_ref11) {
  var colorMode = _ref11.colorMode;
  var borderColor = {
    dark: 'gray:60',
    light: 'gray:30'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  return {
    border: 1,
    borderColor: borderColor,
    borderRadius: 'sm',
    color: color
  };
};
var getInputGroupAddonFilledStyle = function getInputGroupAddonFilledStyle(_ref12) {
  var colorMode = _ref12.colorMode;
  var backgroundColor = {
    dark: 'gray:80',
    light: 'gray:10'
  }[colorMode];
  return _objectSpread2(_objectSpread2({}, getInputGroupAddonOutlineStyle({
    colorMode: colorMode
  })), {}, {
    backgroundColor: backgroundColor
  });
};
var getInputGroupAddonFlushStyle = function getInputGroupAddonFlushStyle(_ref13) {
  var colorMode = _ref13.colorMode;
  var borderColor = 'transparent';
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  return {
    borderBottom: 1,
    borderBottomColor: borderColor,
    color: color
  };
};
var getInputGroupAddonUnstyledStyle = function getInputGroupAddonUnstyledStyle(_ref14) {
  var colorMode = _ref14.colorMode;
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  return {
    border: 0,
    borderRadius: 0,
    color: color
  };
};
var getInputGroupAddonVariantStyle = function getInputGroupAddonVariantStyle(_ref15) {
  var colorMode = _ref15.colorMode,
    variant = _ref15.variant;
  if (variant === VARIANT_OUTLINE) {
    return getInputGroupAddonOutlineStyle({
      colorMode: colorMode
    });
  }
  if (variant === VARIANT_FILLED) {
    return getInputGroupAddonFilledStyle({
      colorMode: colorMode
    });
  }
  if (variant === VARIANT_FLUSH) {
    return getInputGroupAddonFlushStyle({
      colorMode: colorMode
    });
  }
  if (variant === VARIANT_UNSTYLED) {
    return getInputGroupAddonUnstyledStyle({
      colorMode: colorMode
    });
  }
  return {};
};
var useInputStyle = function useInputStyle(_ref16) {
  var size = _ref16.size,
    variant = _ref16.variant;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var _useTheme = useTheme(),
    sizes = _useTheme.sizes;
  var baseStyle = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    transition: 'all .2s',
    width: '100%'
  };
  var sizeStyle = function () {
    var _style = {
      'sm': {
        fontSize: 'sm',
        lineHeight: 'sm',
        height: '6x'
      },
      'md': {
        fontSize: 'sm',
        lineHeight: 'sm',
        height: '8x'
      },
      'lg': {
        fontSize: 'md',
        lineHeight: 'md',
        height: '10x'
      }
    }[size];

    // Do not override the height if the input variant is `unstyled`
    if (variant === VARIANT_UNSTYLED) {
      _style.height = undefined;
    }

    // Adjust the padding based on the input variant
    if (variant === VARIANT_OUTLINE || variant === VARIANT_FILLED) {
      _style.px = "calc(".concat(sizes['3x'], " - ").concat(sizes['1q'], ")");
    }
    return _style;
  }();
  var variantStyle = getInputVariantStyle({
    colorMode: colorMode,
    variant: variant
  });
  return _objectSpread2(_objectSpread2(_objectSpread2({}, baseStyle), sizeStyle), variantStyle);
};
var useInputAdornmentStyle = function useInputAdornmentStyle() {
  return {
    flex: 'none',
    px: '3x'
  };
};
var useInputBaseStyle = function useInputBaseStyle() {
  return {
    appearance: 'none',
    backgroundColor: 'inherit',
    border: 'none',
    color: 'inherit',
    outline: 0,
    padding: 0
  };
};
var getInputGroupCSS = function getInputGroupCSS(_ref17) {
  var variant = _ref17.variant;
  var useNegativeMargin = variant === VARIANT_OUTLINE || variant === VARIANT_FILLED;
  return sx({
    '&:not(:first-child)': {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    },
    '&:not(:last-child)': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    },
    // adjacent sibling
    '&+&': {
      marginLeft: useNegativeMargin ? -1 : 0
    }
  });
};
var useInputGroupStyle = function useInputGroupStyle() {
  return {
    position: 'relative',
    display: 'flex',
    alignItems: 'stretch',
    width: '100%'
  };
};
var useInputGroupAddonStyle = function useInputGroupAddonStyle(_ref18) {
  var size = _ref18.size,
    variant = _ref18.variant;
  var _useColorMode3 = useColorMode(),
    _useColorMode4 = _slicedToArray(_useColorMode3, 1),
    colorMode = _useColorMode4[0];
  var _useTheme2 = useTheme(),
    sizes = _useTheme2.sizes;
  var baseStyle = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    outline: 0
  };
  var sizeStyle = function () {
    var _style = {
      'sm': {
        fontSize: 'sm',
        lineHeight: 'sm',
        height: '6x'
      },
      'md': {
        fontSize: 'sm',
        lineHeight: 'sm',
        height: '8x'
      },
      'lg': {
        fontSize: 'md',
        lineHeight: 'md',
        height: '10x'
      }
    }[size];

    // Do not override the height if the input variant is `unstyled`
    if (variant === VARIANT_UNSTYLED) {
      _style.height = undefined;
    }

    // Adjust the padding based on the input variant
    if (variant === VARIANT_OUTLINE || variant === VARIANT_FILLED) {
      _style.px = "calc(".concat(sizes['3x'], " - ").concat(sizes['1q'], ")");
    } else if (variant === VARIANT_FLUSH) {
      _style.px = '3x';
    }
    return _style;
  }();
  var variantStyle = getInputGroupAddonVariantStyle({
    colorMode: colorMode,
    variant: variant
  });
  return _objectSpread2(_objectSpread2(_objectSpread2({}, baseStyle), sizeStyle), variantStyle);
};
var getInputGroupAppendCSS = function getInputGroupAppendCSS() {
  var notFirstChildStyle = {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  };
  var notLastChildStyle = {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  };
  return sx({
    '& > *:first-of-type': notFirstChildStyle,
    '&:not(:last-child) > *:first-of-type': notLastChildStyle
  });
};
var useInputGroupAppendStyle = function useInputGroupAppendStyle() {
  return {
    display: 'flex',
    ml: -1
  };
};
var getInputGroupPrependCSS = function getInputGroupPrependCSS() {
  var notFirstChildStyle = {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  };
  var notLastChildStyle = {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  };
  return sx({
    '& > *:first-of-type': notLastChildStyle,
    '&:not(:first-of-type) > *:first-of-type': notFirstChildStyle
  });
};
var useInputGroupPrependStyle = function useInputGroupPrependStyle() {
  return {
    display: 'flex',
    mr: -1
  };
};
var useInputControlBaseCSS = function useInputControlBaseCSS(_ref19) {
  var _VARIANT_OUTLINE$VARI;
  var variant = _ref19.variant;
  var _useColorMode5 = useColorMode(),
    _useColorMode6 = _slicedToArray(_useColorMode5, 1),
    colorMode = _useColorMode6[0];
  var focusBorderColor = {
    dark: 'blue:60',
    light: 'blue:60'
  }[colorMode];
  var invalidBorderColor = {
    dark: 'red:50',
    light: 'red:60'
  }[colorMode];
  var borderKey = (_VARIANT_OUTLINE$VARI = {}, _defineProperty(_VARIANT_OUTLINE$VARI, VARIANT_OUTLINE, 'border'), _defineProperty(_VARIANT_OUTLINE$VARI, VARIANT_FILLED, 'border'), _defineProperty(_VARIANT_OUTLINE$VARI, VARIANT_FLUSH, 'borderBottom'), _VARIANT_OUTLINE$VARI)[variant];

  // No need to set the border color if the input variant is not `outline`, `filled`, or `flush`
  if (!borderKey) {
    return {};
  }
  var borderColorKey = "".concat(borderKey, "Color"); // e.g. "borderColor" or "borderBottomColor"

  return sx({
    '&:has(> input:focus:invalid), &:has(> input:focus[aria-invalid=true])': _defineProperty({}, borderColorKey, focusBorderColor),
    '&:hover:has(> input:invalid), &:hover:has(> input[aria-invalid=true])': _defineProperty({}, borderColorKey, invalidBorderColor),
    '&:hover:has(> input:focus:invalid), &:hover:has(> input:focus[aria-invalid=true])': _defineProperty({}, borderColorKey, focusBorderColor)
  });
};
var useInputControlBaseStyle = function useInputControlBaseStyle(_ref20) {
  var inputState = _ref20.inputState,
    size = _ref20.size,
    variant = _ref20.variant;
  var _useColorMode7 = useColorMode(),
    _useColorMode8 = _slicedToArray(_useColorMode7, 1),
    colorMode = _useColorMode8[0];
  var baseStyle = {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    transition: 'all .2s'
  };
  var sizeStyle = function () {
    var _style = {
      'sm': {
        fontSize: 'sm',
        lineHeight: 'sm',
        height: '6x'
      },
      'md': {
        fontSize: 'sm',
        lineHeight: 'sm',
        height: '8x'
      },
      'lg': {
        fontSize: 'md',
        lineHeight: 'md',
        height: '10x'
      }
    }[size];

    // Do not override the height if the input variant is `unstyled`
    if (variant === VARIANT_UNSTYLED) {
      _style.height = undefined;
    }
    return _style;
  }();
  var variantStyle = getInputControlVariantStyle({
    colorMode: colorMode,
    inputState: inputState,
    variant: variant
  });
  return _objectSpread2(_objectSpread2(_objectSpread2({}, baseStyle), sizeStyle), variantStyle);
};
var useInputControlInputStyle = function useInputControlInputStyle(_ref21) {
  var inputState = _ref21.inputState,
    size = _ref21.size,
    variant = _ref21.variant,
    startAdornment = _ref21.startAdornment,
    endAdornment = _ref21.endAdornment;
  var _useTheme3 = useTheme(),
    sizes = _useTheme3.sizes;
  var baseStyle = {
    cursor: inputState !== null && inputState !== void 0 && inputState.disabled ? 'not-allowed' : undefined,
    width: '100%'
  };
  var sizeStyle = function () {
    var _style = {
      'sm': {
        fontSize: 'sm',
        lineHeight: 'sm'
      },
      'md': {
        fontSize: 'sm',
        lineHeight: 'sm'
      },
      'lg': {
        fontSize: 'md',
        lineHeight: 'md'
      }
    }[size];

    // Adjust the padding based on the input variant
    if (variant === VARIANT_OUTLINE || variant === VARIANT_FILLED) {
      _style.px = "calc(".concat(sizes['3x'], " - ").concat(sizes['1q'], ")");
    }

    // Adjust padding based on the input adornments
    if (startAdornment && endAdornment) {
      _style.px = undefined;
    }
    if (startAdornment && !endAdornment) {
      _style.pr = _style.px;
      _style.px = undefined;
    }
    if (!startAdornment && endAdornment) {
      _style.pl = _style.px;
      _style.px = undefined;
    }
    return _style;
  }();
  return _objectSpread2(_objectSpread2({}, baseStyle), sizeStyle);
};

var _excluded$1d = ["isInvalid", "children", "error"];
var InputBase = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isInvalid = _ref.isInvalid,
    children = _ref.children,
    error = _ref.error,
    rest = _objectWithoutProperties(_ref, _excluded$1d);
  {
    // deprecation warning
    var prefix = "".concat(InputBase.displayName, ":");
    useOnceWhen(function () {
      warnDeprecatedProps('isInvalid', {
        prefix: prefix,
        alternative: 'error',
        willRemove: true
      });
    }, isInvalid !== undefined);
    error = error || isInvalid; // TODO: remove this line after deprecation
  }

  var ariaProps = {
    'aria-disabled': ariaAttr(rest.disabled),
    'aria-invalid': ariaAttr(error),
    'aria-readonly': ariaAttr(rest.readOnly),
    'aria-required': ariaAttr(rest.required)
  };
  var styleProps = useInputBaseStyle();
  return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
    as: "input",
    ref: ref
  }, ariaProps), styleProps), rest), {}, {
    children: children
  }));
});
InputBase.displayName = 'InputBase';

var InputGroupContext = /*#__PURE__*/createContext();

var useInputGroup = function useInputGroup() {
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(InputGroupContext);
  return context;
};

var _excluded$1c = ["size", "variant", "css"];
var Input = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref2, _ref3;
  var sizeProp = _ref.size,
    variantProp = _ref.variant,
    cssProp = _ref.css,
    rest = _objectWithoutProperties(_ref, _excluded$1c);
  var inputGroupContext = useInputGroup();
  var _inputGroupContext = _objectSpread2({}, inputGroupContext),
    inputGroupSize = _inputGroupContext.size,
    inputGroupVariant = _inputGroupContext.variant;
  var size = (_ref2 = sizeProp !== null && sizeProp !== void 0 ? sizeProp : inputGroupSize) !== null && _ref2 !== void 0 ? _ref2 : defaultSize$8;
  var variant = (_ref3 = variantProp !== null && variantProp !== void 0 ? variantProp : inputGroupVariant) !== null && _ref3 !== void 0 ? _ref3 : defaultVariant$7;
  var css = inputGroupContext ? [getInputGroupCSS({
    variant: variant
  }), cssProp] : cssProp;
  var styleProps = useInputStyle({
    size: size,
    variant: variant
  });
  return jsx(InputBase, _objectSpread2(_objectSpread2({
    ref: ref,
    as: "input",
    css: css
  }, styleProps), rest));
});
Input.displayName = 'Input';

var _excluded$1b = ["size", "variant"];
var InputAdornment = /*#__PURE__*/forwardRef(function (_ref, ref) {
  _ref.size;
    _ref.variant;
    var rest = _objectWithoutProperties(_ref, _excluded$1b);
  var inputGroupContext = useInputGroup();
  var _inputGroupContext = _objectSpread2({}, inputGroupContext);
    _inputGroupContext.size;
    _inputGroupContext.variant;
  var styleProps = useInputAdornmentStyle();
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), rest));
});
InputAdornment.displayName = 'InputAdornment';

var _excluded$1a = ["autoComplete", "autoFocus", "checked", "defaultValue", "disabled", "error", "id", "list", "max", "maxlength", "min", "minlength", "multiple", "name", "onBlur", "onChange", "onClick", "onFocus", "pattern", "placeholder", "readOnly", "required", "spellcheck", "step", "type", "value", "children", "css", "endAdornment", "inputComponent", "inputProps", "inputRef", "size", "startAdornment", "variant"];
var InputControl = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref2, _ref3;
  var autoCompleteProp = _ref.autoComplete,
    autoFocusProp = _ref.autoFocus,
    checkedProp = _ref.checked,
    defaultValueProp = _ref.defaultValue,
    disabledProp = _ref.disabled,
    errorProp = _ref.error,
    idProp = _ref.id,
    listProp = _ref.list,
    maxProp = _ref.max,
    maxLengthProp = _ref.maxlength,
    minProp = _ref.min,
    minLengthProp = _ref.minlength,
    multipleProp = _ref.multiple,
    nameProp = _ref.name,
    onBlurProp = _ref.onBlur,
    onChangeProp = _ref.onChange,
    onClickProp = _ref.onClick,
    onFocusProp = _ref.onFocus,
    patternProp = _ref.pattern,
    placeholderProp = _ref.placeholder,
    readOnlyProp = _ref.readOnly,
    requiredProp = _ref.required,
    spellcheckProp = _ref.spellcheck,
    stepProp = _ref.step,
    typeProp = _ref.type,
    valueProp = _ref.value,
    children = _ref.children,
    cssProp = _ref.css,
    endAdornment = _ref.endAdornment,
    _ref$inputComponent = _ref.inputComponent,
    InputComponent = _ref$inputComponent === void 0 ? InputBase : _ref$inputComponent,
    inputProps = _ref.inputProps,
    inputRefProp = _ref.inputRef,
    sizeProp = _ref.size,
    startAdornment = _ref.startAdornment,
    variantProp = _ref.variant,
    rest = _objectWithoutProperties(_ref, _excluded$1a);
  var nodeRef = useRef();
  var combinedInputRef = useMergeRefs(nodeRef, inputRefProp);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focused = _useState2[0],
    setFocused = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    valid = _useState4[0],
    setValid = _useState4[1];
  var inputGroupContext = useInputGroup();
  var _inputGroupContext = _objectSpread2({}, inputGroupContext),
    inputGroupSize = _inputGroupContext.size,
    inputGroupVariant = _inputGroupContext.variant;
  var size = (_ref2 = sizeProp !== null && sizeProp !== void 0 ? sizeProp : inputGroupSize) !== null && _ref2 !== void 0 ? _ref2 : defaultSize$8;
  var variant = (_ref3 = variantProp !== null && variantProp !== void 0 ? variantProp : inputGroupVariant) !== null && _ref3 !== void 0 ? _ref3 : defaultVariant$7;
  var inputState = {
    disabled: disabledProp,
    focused: focused,
    valid: !!valid && !errorProp
  };
  var baseCSS = useInputControlBaseCSS({
    variant: variant
  });
  var baseStyleProps = useInputControlBaseStyle({
    inputState: inputState,
    size: size,
    variant: variant
  });
  var inputStyleProps = useInputControlInputStyle({
    inputState: inputState,
    size: size,
    variant: variant,
    startAdornment: startAdornment,
    endAdornment: endAdornment
  });
  var css = inputGroupContext ? [baseCSS, getInputGroupCSS({
    variant: variant
  }), cssProp] : [baseCSS, cssProp];
  var handleClick = useCallback(function (event) {
    if (nodeRef.current && event.currentTarget === event.target) {
      nodeRef.current.focus();
    }
    if (typeof onClickProp === 'function') {
      onClickProp(event);
    }
    if (typeof (inputProps === null || inputProps === void 0 ? void 0 : inputProps.onClick) === 'function') {
      inputProps === null || inputProps === void 0 ? void 0 : inputProps.onClick(event);
    }
  }, [onClickProp, inputProps]);
  var handleBlur = useCallback(function (event) {
    if (typeof onBlurProp === 'function') {
      onBlurProp(event);
    }
    if (typeof (inputProps === null || inputProps === void 0 ? void 0 : inputProps.onBlur) === 'function') {
      inputProps === null || inputProps === void 0 ? void 0 : inputProps.onBlur(event);
    }
    setFocused(false);
  }, [onBlurProp, inputProps]);
  var handleChange = useCallback(function (event) {
    if (typeof onChangeProp === 'function') {
      onChangeProp(event);
    }
    if (typeof (inputProps === null || inputProps === void 0 ? void 0 : inputProps.onChange) === 'function') {
      inputProps === null || inputProps === void 0 ? void 0 : inputProps.onChange(event);
    }
  }, [onChangeProp, inputProps]);
  var handleFocus = useCallback(function (event) {
    if (typeof onFocusProp === 'function') {
      onFocusProp(event);
    }
    if (typeof (inputProps === null || inputProps === void 0 ? void 0 : inputProps.onFocus) === 'function') {
      inputProps === null || inputProps === void 0 ? void 0 : inputProps.onFocus(event);
    }
    setFocused(true);
  }, [onFocusProp, inputProps]);

  // The blur won't fire when the disabled state is set on a focused input.
  // We need to set the focused state to false and call the onBlur callback manually.
  useEffect(function () {
    if (disabledProp && focused) {
      setFocused(false);
      handleBlur();
    }
  }, [disabledProp, focused, handleBlur]);

  // Observe the validity of the input
  var el = nodeRef.current;
  useEffect(function () {
    var _globalThis$MutationO;
    if (!el) {
      // No element to observe
      return;
    }
    var update = function update() {
      var _el$validity;
      var nextValid = (_el$validity = el.validity) === null || _el$validity === void 0 ? void 0 : _el$validity.valid;
      if (nextValid !== valid) {
        setValid(nextValid);
      }
    };
    update();
    var MutationObserver = (_globalThis$MutationO = globalThis.MutationObserver) !== null && _globalThis$MutationO !== void 0 ? _globalThis$MutationO : globalThis.WebKitMutationObserver;
    if (typeof MutationObserver !== 'undefined') {
      var _mutationObserver = new MutationObserver(function (mutations) {
        update();
      });
      _mutationObserver.observe(el, {
        attributes: true,
        attributeFilter: ['value']
      });
    }
    return function () {
    };
  }, [el, valid]);
  var getInputProps = function getInputProps() {
    return _objectSpread2(_objectSpread2(_objectSpread2({
      autoComplete: autoCompleteProp,
      autoFocus: autoFocusProp,
      checked: checkedProp,
      defaultValue: defaultValueProp,
      disabled: disabledProp,
      error: errorProp,
      id: idProp,
      list: listProp,
      max: maxProp,
      maxlength: maxLengthProp,
      min: minProp,
      minlength: minLengthProp,
      multiple: multipleProp,
      name: nameProp,
      pattern: patternProp,
      placeholder: placeholderProp,
      readOnly: readOnlyProp,
      required: requiredProp,
      spellcheck: spellcheckProp,
      step: stepProp,
      type: typeProp,
      value: valueProp
    }, inputStyleProps), inputProps), {}, {
      ref: combinedInputRef,
      onBlur: handleBlur,
      onChange: handleChange,
      onFocus: handleFocus
    });
  };
  return jsxs(Box, _objectSpread2(_objectSpread2(_objectSpread2({
    ref: ref,
    css: css,
    onClick: handleClick
  }, baseStyleProps), rest), {}, {
    children: [startAdornment, typeof children === 'function' ? children({
      getInputProps: getInputProps
    }) : jsx(InputComponent, _objectSpread2({}, getInputProps())), endAdornment]
  }));
});
InputControl.displayName = 'InputControl';

var _excluded$19 = ["children", "size", "variant"];
var getMemoizedState$e = memoize(function (state) {
  return _objectSpread2({}, state);
});
var InputGroup = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'outline' : _ref$variant,
    rest = _objectWithoutProperties(_ref, _excluded$19);
  var context = getMemoizedState$e({
    size: size,
    variant: variant
  });
  var styleProps = useInputGroupStyle();
  return jsx(InputGroupContext.Provider, {
    value: context,
    children: jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
      ref: ref
    }, styleProps), rest), {}, {
      children: runIfFn(children, context)
    }))
  });
});
InputGroup.displayName = 'InputGroup';

var _excluded$18 = ["size", "variant"];
var InputGroupAddon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref2, _ref3;
  var sizeProp = _ref.size,
    variantProp = _ref.variant,
    rest = _objectWithoutProperties(_ref, _excluded$18);
  var inputGroupContext = useInputGroup();
  var _inputGroupContext = _objectSpread2({}, inputGroupContext),
    inputGroupSize = _inputGroupContext.size,
    inputGroupVariant = _inputGroupContext.variant;
  var size = (_ref2 = sizeProp !== null && sizeProp !== void 0 ? sizeProp : inputGroupSize) !== null && _ref2 !== void 0 ? _ref2 : defaultSize$8;
  var variant = (_ref3 = variantProp !== null && variantProp !== void 0 ? variantProp : inputGroupVariant) !== null && _ref3 !== void 0 ? _ref3 : defaultVariant$7;
  var styleProps = useInputGroupAddonStyle({
    size: size,
    variant: variant
  });
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), rest));
});
InputGroupAddon.displayName = 'InputGroupAddon';

var _excluded$17 = ["css"];
var InputGroupAppend = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var cssProp = _ref.css,
    rest = _objectWithoutProperties(_ref, _excluded$17);
  var css = [getInputGroupAppendCSS(), cssProp];
  var styleProps = useInputGroupAppendStyle();
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref,
    css: css
  }, styleProps), rest));
});
InputGroupAppend.displayName = 'InputGroupAppend';

var _excluded$16 = ["css"];
var InputGroupPrepend = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var cssProp = _ref.css,
    rest = _objectWithoutProperties(_ref, _excluded$16);
  var css = [getInputGroupPrependCSS(), cssProp];
  var styleProps = useInputGroupPrependStyle();
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref,
    css: css
  }, styleProps), rest));
});
InputGroupPrepend.displayName = 'InputGroupPrepend';

var useLinkStyle = function useLinkStyle(_ref) {
  var disabled = _ref.disabled,
    textDecoration = _ref.textDecoration;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var color = {
    light: 'blue:60',
    dark: 'blue:40'
  }[colorMode];
  var hoverColor = {
    light: 'blue:50',
    dark: 'blue:40'
  }[colorMode];
  var visitedColor = {
    light: 'purple:60',
    dark: 'purple:50'
  }[colorMode];
  var disabledColor = {
    light: 'black:disabled',
    dark: 'white:disabled'
  }[colorMode];
  var hoverTextDecoration = textDecoration ? 'none' : 'underline';
  var activeTextDecoration = !!disabled ? 'none' : 'underline';
  return {
    color: color,
    cursor: 'pointer',
    textDecoration: textDecoration !== null && textDecoration !== void 0 ? textDecoration : 'none',
    display: 'inline-flex',
    alignItems: 'center',
    _disabled: {
      color: disabledColor,
      cursor: 'not-allowed'
    },
    _visited: {
      color: visitedColor
    },
    _hover: {
      color: hoverColor,
      textDecoration: !!disabled ? textDecoration : hoverTextDecoration
    },
    _active: {
      color: 'blue:60',
      textDecoration: textDecoration !== null && textDecoration !== void 0 ? textDecoration : activeTextDecoration
    }
  };
};
var useLinkButtonStyle = function useLinkButtonStyle() {
  return {};
};

var _excluded$15 = ["disabled", "onClick", "textDecoration"];
var Link = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var disabled = _ref.disabled,
    onClick = _ref.onClick,
    textDecoration = _ref.textDecoration,
    rest = _objectWithoutProperties(_ref, _excluded$15);
  var styleProps = useLinkStyle({
    disabled: disabled,
    textDecoration: textDecoration
  });
  var preventDefaultCallback = useCallback(function (event) {
    return event.preventDefault();
  }, []);
  return jsx(Box, _objectSpread2(_objectSpread2({
    as: "a",
    ref: ref,
    "aria-disabled": ariaAttr(disabled),
    onClick: disabled ? preventDefaultCallback : onClick
  }, styleProps), rest));
});
Link.displayName = 'Link';

var LinkButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var styleProps = useLinkButtonStyle();
  return jsx(Link, _objectSpread2(_objectSpread2({
    as: ButtonBase,
    ref: ref
  }, styleProps), props));
});
LinkButton.displayName = 'LinkButton';

var MenuContext = /*#__PURE__*/createContext();
var SubmenuContext = /*#__PURE__*/createContext();

var useMenuStyle = function useMenuStyle() {
  return {
    position: 'relative',
    display: 'inline-flex'
  };
};
var useMenuButtonCSS = function useMenuButtonCSS(_ref) {
  var variant = _ref.variant;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var primaryColor = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  // Override the color in hover and active states
  var variantCSS = {
    'ghost': {
      '&:hover': {
        color: primaryColor
      },
      '&:active': {
        color: primaryColor
      }
    },
    'secondary': {
      '&:hover': {
        color: primaryColor
      },
      '&:active': {
        color: primaryColor
      }
    }
  }[variant];
  return sx(_objectSpread2({}, variantCSS));
};
var useMenuButtonStyle = function useMenuButtonStyle() {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: '1x'
  };
};
var useMenuContentStyle = function useMenuContentStyle(_ref2) {
  var tabIndex = _ref2.tabIndex;
  return {
    outline: tabIndex < 0 ? 0 : undefined // Remove the default outline for tabindex="-1"
  };
};

var useMenuListStyle = function useMenuListStyle() {
  var _colorStyle$shadow, _colorStyle$shadow2;
  var _useColorMode3 = useColorMode(),
    _useColorMode4 = _slicedToArray(_useColorMode3, 1),
    colorMode = _useColorMode4[0];
  var _useColorStyle = useColorStyle({
      colorMode: colorMode
    }),
    _useColorStyle2 = _slicedToArray(_useColorStyle, 1),
    colorStyle = _useColorStyle2[0];
  var colorModeStyle = {
    light: {
      backgroundColor: 'white',
      boxShadow: colorStyle === null || colorStyle === void 0 ? void 0 : (_colorStyle$shadow = colorStyle.shadow) === null || _colorStyle$shadow === void 0 ? void 0 : _colorStyle$shadow.medium
    },
    dark: {
      backgroundColor: 'gray:80',
      boxShadow: colorStyle === null || colorStyle === void 0 ? void 0 : (_colorStyle$shadow2 = colorStyle.shadow) === null || _colorStyle$shadow2 === void 0 ? void 0 : _colorStyle$shadow2.medium
    }
  }[colorMode];
  return _objectSpread2(_objectSpread2({}, colorModeStyle), {}, {
    color: 'inherit',
    m: '0',
    p: '0',
    py: '2x'
  });
};
var useMenuGroupStyle = function useMenuGroupStyle() {
  var _useColorMode5 = useColorMode(),
    _useColorMode6 = _slicedToArray(_useColorMode5, 1),
    colorMode = _useColorMode6[0];
  var color = {
    dark: 'white:secondary',
    light: 'black:secondary'
  }[colorMode];
  return {
    px: '3x',
    py: '2x',
    color: color
  };
};
var useMenuItemStyle = function useMenuItemStyle(_ref3) {
  var tabIndex = _ref3.tabIndex;
  var theme = useTheme();
  var sizes = theme.sizes;
  var _useColorMode7 = useColorMode(),
    _useColorMode8 = _slicedToArray(_useColorMode7, 1),
    colorMode = _useColorMode8[0];
  var color = {
    light: 'black:primary',
    dark: 'white:primary'
  }[colorMode];
  var hoverBackgroundColor = {
    light: 'rgba(0, 0, 0, 0.12)',
    dark: 'rgba(255, 255, 255, 0.12)'
  }[colorMode];
  var focusBorderColor = {
    light: 'blue:60',
    dark: 'blue:60'
  }[colorMode];
  var disabledColor = {
    light: 'black:disabled',
    dark: 'white:disabled'
  }[colorMode];
  var selectedBackgroundColor = {
    light: 'rgba(0, 0, 0, 0.08)',
    dark: 'rgba(255, 255, 255, 0.08)'
  }[colorMode];
  return {
    fontSize: 'sm',
    lineHeight: 'sm',
    color: color,
    cursor: 'pointer',
    display: 'flex',
    textDecoration: 'none',
    alignItems: 'center',
    textAlign: 'left',
    outline: tabIndex < 0 ? 0 : undefined,
    // Remove the default outline for tabindex="-1"
    px: '3x',
    py: '2x',
    userSelect: 'none',
    width: '100%',
    _focus: {
      borderColor: focusBorderColor,
      borderStyle: 'solid',
      borderWidth: '1h',
      px: "calc(".concat(sizes['3x'], " - ").concat(sizes['1h'], ")"),
      py: "calc(".concat(sizes['2x'], " - ").concat(sizes['1h'], ")")
    },
    _hover: {
      backgroundColor: hoverBackgroundColor
    },
    _selected: {
      backgroundColor: selectedBackgroundColor
    },
    _disabled: {
      backgroundColor: 'inherit',
      color: disabledColor,
      cursor: 'not-allowed'
    }
  };
};
var useMenuItemDividerStyle = function useMenuItemDividerStyle() {
  return {
    my: '2x'
  };
};
var useMenuToggleStyle = function useMenuToggleStyle() {
  return {
    display: 'inline-flex'
  };
};
var useMenuToggleIconStyle = function useMenuToggleIconStyle() {
  return {
    display: 'inline-flex',
    _disabled: {
      opacity: '.28'
    }
  };
};
var useSubmenuStyle = function useSubmenuStyle() {
  return {
    position: 'relative'
  };
};
var useSubmenuContentStyle = function useSubmenuContentStyle(_ref4) {
  var tabIndex = _ref4.tabIndex;
  return {
    outline: tabIndex < 0 ? 0 : undefined // Remove the default outline for tabindex="-1"
  };
};

var useSubmenuListStyle = function useSubmenuListStyle(_ref5) {
  var _colorStyle$shadow3, _colorStyle$shadow4, _mapPlacementToStyle;
  var isOpen = _ref5.isOpen,
    placement = _ref5.placement;
  var _useColorMode9 = useColorMode(),
    _useColorMode10 = _slicedToArray(_useColorMode9, 1),
    colorMode = _useColorMode10[0];
  var _useColorStyle3 = useColorStyle({
      colorMode: colorMode
    }),
    _useColorStyle4 = _slicedToArray(_useColorStyle3, 1),
    colorStyle = _useColorStyle4[0];
  var colorModeStyle = {
    light: {
      backgroundColor: 'white',
      boxShadow: colorStyle === null || colorStyle === void 0 ? void 0 : (_colorStyle$shadow3 = colorStyle.shadow) === null || _colorStyle$shadow3 === void 0 ? void 0 : _colorStyle$shadow3.medium
    },
    dark: {
      backgroundColor: 'gray:80',
      boxShadow: colorStyle === null || colorStyle === void 0 ? void 0 : (_colorStyle$shadow4 = colorStyle.shadow) === null || _colorStyle$shadow4 === void 0 ? void 0 : _colorStyle$shadow4.medium
    }
  }[colorMode];
  var mapPlacementToStyle = function mapPlacementToStyle(placement) {
    return {
      'right-start': {
        position: 'absolute',
        top: 0,
        left: '100%'
      },
      'right-end': {
        position: 'absolute',
        bottom: 0,
        left: '100%'
      },
      'left-start': {
        position: 'absolute',
        top: 0,
        right: '100%'
      },
      'left-end': {
        position: 'absolute',
        bottom: 0,
        right: '100%'
      }
    }[placement];
  };
  var placementStyle = (_mapPlacementToStyle = mapPlacementToStyle(placement)) !== null && _mapPlacementToStyle !== void 0 ? _mapPlacementToStyle : mapPlacementToStyle('right-start');
  return _objectSpread2(_objectSpread2(_objectSpread2({}, colorModeStyle), placementStyle), {}, {
    color: 'inherit',
    display: isOpen ? 'block' : 'none',
    m: '0',
    p: '0',
    py: '2x'
  });
};
var useSubmenuToggleStyle = function useSubmenuToggleStyle() {
  return {
    cursor: 'pointer',
    display: 'inline-flex'
  };
};

var _excluded$14 = ["anchorEl", "autoSelect", "children", "closeOnBlur", "closeOnSelect", "defaultActiveIndex", "defaultIsOpen", "isOpen", "offset", "onClose", "onOpen", "placement", "returnFocusOnClose"];
var getMemoizedState$d = memoize(function (state) {
  return _objectSpread2({}, state);
});
var mapPlacementToDirection = function mapPlacementToDirection(placement) {
  var p0 = ensureString(placement).split('-')[0];
  var direction = {
    top: 'up',
    bottom: 'down'
  }[p0];
  return direction;
};
var Menu = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var anchorEl = _ref.anchorEl,
    _ref$autoSelect = _ref.autoSelect,
    autoSelect = _ref$autoSelect === void 0 ? false : _ref$autoSelect,
    children = _ref.children,
    _ref$closeOnBlur = _ref.closeOnBlur,
    closeOnBlur = _ref$closeOnBlur === void 0 ? true : _ref$closeOnBlur,
    _ref$closeOnSelect = _ref.closeOnSelect,
    closeOnSelect = _ref$closeOnSelect === void 0 ? true : _ref$closeOnSelect,
    _ref$defaultActiveInd = _ref.defaultActiveIndex,
    defaultActiveIndex = _ref$defaultActiveInd === void 0 ? -1 : _ref$defaultActiveInd,
    _ref$defaultIsOpen = _ref.defaultIsOpen,
    defaultIsOpen = _ref$defaultIsOpen === void 0 ? false : _ref$defaultIsOpen,
    isOpenProp = _ref.isOpen,
    offset = _ref.offset,
    onCloseProp = _ref.onClose,
    onOpenProp = _ref.onOpen,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement,
    _ref$returnFocusOnClo = _ref.returnFocusOnClose,
    returnFocusOnClose = _ref$returnFocusOnClo === void 0 ? true : _ref$returnFocusOnClo,
    rest = _objectWithoutProperties(_ref, _excluded$14);
  var menuContentRef = useRef(null);
  var menuToggleRef = useRef(null);
  var _useState = useState(defaultActiveIndex),
    _useState2 = _slicedToArray(_useState, 2),
    activeIndex = _useState2[0],
    setActiveIndex = _useState2[1];
  var _useState3 = useState(isOpenProp !== null && isOpenProp !== void 0 ? isOpenProp : defaultIsOpen),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  var prevIsOpen = usePrevious(isOpen);
  var getFocusableElements = useCallback(function () {
    if (!menuContentRef.current) {
      return [];
    }
    var focusableElements = getAllFocusable(menuContentRef.current).filter(function (node) {
      return node.getAttribute('role') === 'menuitem';
    });
    return focusableElements;
  }, []);
  useEffect(function () {
    var isControlled = isOpenProp !== undefined;
    if (isControlled) {
      setIsOpen(isOpenProp);
    }
  }, [isOpenProp]);
  useEffect(function () {
    if (isOpen) {
      // Use requestAnimationFrame to ensure that the menu is rendered before we try to focus on it.
      requestAnimationFrame(function () {
        var focusableElements = getFocusableElements();
        focusableElements.forEach(function (node, index) {
          return index === 0 && node.setAttribute('tabindex', 0);
        });
      });
    }
  }, [isOpen, getFocusableElements]);
  useEffect(function () {
    if (activeIndex !== -1) {
      // Use requestAnimationFrame to ensure that the focus is set at the end of the current frame
      requestAnimationFrame(function () {
        var focusableElements = getFocusableElements();
        var el = focusableElements[activeIndex];
        el && el.focus();
        focusableElements.forEach(function (node, index) {
          if (index === activeIndex) {
            node.setAttribute('tabindex', 0);
          } else {
            node.setAttribute('tabindex', -1);
          }
        });
      });
    }
    if (activeIndex === -1 && !isOpen && prevIsOpen && returnFocusOnClose) {
      // Use requestAnimationFrame to ensure that the focus is set at the end of the current frame
      requestAnimationFrame(function () {
        var el = menuToggleRef.current;
        el && el.focus();
      });
    }
    if (activeIndex === -1 && isOpen && !prevIsOpen) {
      // Use requestAnimationFrame to ensure that the focus is set at the end of the current frame
      requestAnimationFrame(function () {
        var el = menuContentRef.current;
        el && el.focus();
      });
    }
  }, [isOpen, activeIndex, getFocusableElements, menuContentRef, menuToggleRef, prevIsOpen, returnFocusOnClose]);
  var onOpen = useCallback(function () {
    var isControlled = isOpenProp !== undefined;
    if (!isControlled) {
      setIsOpen(true);
    }
    if (typeof onOpenProp === 'function') {
      onOpenProp();
    }
  }, [isOpenProp, onOpenProp]);
  var focusOnFirstItem = useCallback(function () {
    var focusableElements = getFocusableElements();
    if (focusableElements.length > 0) {
      setActiveIndex(0);
    }
  }, [getFocusableElements]);
  var focusOnLastItem = useCallback(function () {
    var focusableElements = getFocusableElements();
    if (focusableElements.length > 0) {
      setActiveIndex(focusableElements.length - 1);
    }
  }, [getFocusableElements]);
  var focusOnNextItem = useCallback(function () {
    var focusableElements = getFocusableElements();
    if (focusableElements.length > 0) {
      var nextIndex = (activeIndex + 1) % focusableElements.length;
      setActiveIndex(nextIndex);
    }
  }, [activeIndex, getFocusableElements]);
  var focusOnPreviousItem = useCallback(function () {
    var focusableElements = getFocusableElements();
    if (focusableElements.length > 0) {
      var prevIndex = (activeIndex - 1 + focusableElements.length) % focusableElements.length;
      setActiveIndex(prevIndex);
    }
  }, [activeIndex, getFocusableElements]);
  var onClose = useCallback(function () {
    var isControlled = isOpenProp !== undefined;
    if (!isControlled) {
      setIsOpen(false);
    }
    if (typeof onCloseProp === 'function') {
      onCloseProp();
    }
    setActiveIndex(defaultActiveIndex);

    // Reset tab index
    var focusableElements = getFocusableElements();
    focusableElements.forEach(function (node) {
      return node.setAttribute('tabindex', -1);
    });
  }, [getFocusableElements, isOpenProp, onCloseProp, defaultActiveIndex]);
  if (anchorEl) {
    menuToggleRef.current = anchorEl;
  }
  var defaultId = useAutoId();
  var menuId = "".concat(config.name, ":Menu-").concat(defaultId);
  var menuToggleId = "".concat(config.name, ":MenuToggle-").concat(defaultId);
  var direction = mapPlacementToDirection(placement);
  var context = getMemoizedState$d({
    closeMenu: onClose,
    // FIXME: `closeMenu` is deprecated and will be removed in a future release
    openMenu: onOpen,
    // FIXME: `openMenu` is deprecated and will be removed in a future release
    autoSelect: autoSelect,
    closeOnBlur: closeOnBlur,
    closeOnSelect: closeOnSelect,
    direction: direction,
    focusOnFirstItem: focusOnFirstItem,
    focusOnLastItem: focusOnLastItem,
    focusOnNextItem: focusOnNextItem,
    focusOnPreviousItem: focusOnPreviousItem,
    isOpen: isOpen,
    offset: offset,
    onClose: onClose,
    onOpen: onOpen,
    placement: placement,
    menuId: menuId,
    menuContentRef: menuContentRef,
    menuToggleId: menuToggleId,
    menuToggleRef: menuToggleRef
  });
  var styleProps = useMenuStyle();
  return jsx(MenuContext.Provider, {
    value: context,
    children: jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
      ref: ref
    }, styleProps), rest), {}, {
      children: runIfFn(children, context)
    }))
  });
});
Menu.displayName = 'Menu';

var useMenu = function useMenu() {
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(MenuContext);
  return context;
};

var _excluded$13 = ["children", "disabled", "onClick", "onKeyDown"];
var MenuToggle = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    onClickProp = _ref.onClick,
    onKeyDownProp = _ref.onKeyDown,
    rest = _objectWithoutProperties(_ref, _excluded$13);
  var menuContext = useMenu(); // context might be an undefined value
  var _menuContext = _objectSpread2({}, menuContext),
    autoSelect = _menuContext.autoSelect,
    focusOnLastItem = _menuContext.focusOnLastItem,
    focusOnFirstItem = _menuContext.focusOnFirstItem,
    isOpen = _menuContext.isOpen,
    menuId = _menuContext.menuId,
    menuToggleId = _menuContext.menuToggleId,
    menuToggleRef = _menuContext.menuToggleRef,
    closeMenu = _menuContext.onClose,
    openMenu = _menuContext.onOpen;
  var combinedRef = useMergeRefs(menuToggleRef, ref);
  var styleProps = useMenuToggleStyle();
  var handleClick = callEventHandlers(onClickProp, function (event) {
    // Don't handle `onClick` event when the `MenuToggle` is disabled
    if (disabled) {
      event.preventDefault();
      return;
    }
    if (isOpen) {
      ensureFunction(closeMenu)();
      return;
    }
    ensureFunction(openMenu)();

    // If `autoSelect` is true, focus on the first item when the menu opens with a mouse click
    autoSelect && focusOnFirstItem();
  });
  var handleKeyDown = callEventHandlers(onKeyDownProp, function (event) {
    // Don't handle `onKeyDown` event when the `MenuToggle` is disabled
    if (disabled) {
      event.preventDefault();
      return;
    }
    if (event.key === 'ArrowDown') {
      ensureFunction(openMenu)();

      // Focus on the first item when the menu opens with the down arrow
      ensureFunction(focusOnFirstItem)();
      return;
    }
    if (event.key === 'ArrowUp') {
      ensureFunction(openMenu)();

      // Focus on the last item when the menu opens with the up arrow
      ensureFunction(focusOnLastItem)();
      return;
    }
  });
  var getMenuToggleProps = function getMenuToggleProps() {
    return _objectSpread2(_objectSpread2({
      'aria-controls': menuId,
      'aria-disabled': ariaAttr(disabled),
      'aria-expanded': ariaAttr(isOpen),
      'aria-haspopup': 'menu',
      disabled: disabled,
      id: menuToggleId,
      onClick: handleClick,
      onKeyDown: handleKeyDown,
      ref: combinedRef,
      role: 'button',
      tabIndex: 0
    }, styleProps), rest);
  };
  if (typeof children === 'function') {
    return children({
      getMenuToggleProps: getMenuToggleProps
    });
  }
  return jsx(ButtonBase, _objectSpread2(_objectSpread2({}, getMenuToggleProps()), {}, {
    children: children
  }));
});
MenuToggle.displayName = 'MenuToggle';

var _excluded$12 = ["appear", "children", "disabled", "easing", "style", "timeout"];
var mapDirectionToIconName = function mapDirectionToIconName(direction) {
  var iconName = {
    up: 'angle-up',
    down: 'angle-down',
    left: 'angle-left',
    right: 'angle-right'
  }[direction];
  return iconName;
};
var mapStateToVariantStyle$2 = function mapStateToVariantStyle(state, props) {
  var variantStyle = {
    entering: function entering(props) {
      return {
        transform: {
          up: 'rotate(180deg)',
          down: 'rotate(-180deg)'
        }[props.direction]
      };
    },
    entered: function entered(props) {
      return {
        transform: {
          up: 'rotate(180deg)',
          down: 'rotate(-180deg)'
        }[props.direction]
      };
    },
    exiting: function exiting(props) {
      return {
        transform: {
          up: 'rotate(0deg)',
          down: 'rotate(0deg)'
        }[props.direction]
      };
    },
    exited: function exited(props) {
      return {
        transform: {
          up: 'rotate(0deg)',
          down: 'rotate(0deg)'
        }[props.direction]
      };
    }
  }[state];
  return typeof variantStyle === 'function' ? variantStyle(props) : variantStyle;
};
var defaultEasing$2 = {
  enter: transitionEasing.easeOut,
  exit: transitionEasing.easeOut
};
var defaultTimeout$2 = {
  enter: 133,
  exit: Math.floor(133 * 0.7)
};
var MenuToggleIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$appear = _ref.appear,
    appear = _ref$appear === void 0 ? false : _ref$appear,
    _children = _ref.children,
    disabled = _ref.disabled,
    _ref$easing = _ref.easing,
    easing = _ref$easing === void 0 ? defaultEasing$2 : _ref$easing,
    style = _ref.style,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? defaultTimeout$2 : _ref$timeout,
    rest = _objectWithoutProperties(_ref, _excluded$12);
  var menuContext = useMenu(); // context might be an undefined value
  var _menuContext = _objectSpread2({}, menuContext),
    isOpen = _menuContext.isOpen,
    direction = _menuContext.direction;
  var toggleIconStyleProps = useMenuToggleIconStyle();
  var nodeRef = useRef(null);
  var combinedRef = useMergeRefs(nodeRef, ref);
  useEffect(function () {
    if (isOpen) {
      var node = nodeRef.current;
      reflow(node); // force reflow to make the transition work when animating appearance
    }
  }, [isOpen]);
  return jsx(Transition, _objectSpread2(_objectSpread2({
    appear: appear,
    "in": isOpen,
    nodeRef: nodeRef,
    timeout: timeout
  }, rest), {}, {
    children: function children(state, childProps) {
      var transitionProps = isOpen ? getEnterTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      }) : getExitTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      });
      var transition = createTransitionStyle('transform', transitionProps);
      var variantStyle = mapStateToVariantStyle$2(state, {
        direction: direction
      });
      var styleProps = _objectSpread2(_objectSpread2(_objectSpread2({}, toggleIconStyleProps), variantStyle), {}, {
        'aria-disabled': ariaAttr(disabled),
        transition: transition
      });
      if (typeof _children === 'function') {
        return _children(state, _objectSpread2(_objectSpread2({}, childProps), {}, {
          ref: combinedRef,
          style: _objectSpread2(_objectSpread2({}, styleProps), style)
        }));
      }
      var iconName = mapDirectionToIconName(direction);
      return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
        ref: combinedRef
      }, styleProps), childProps), {}, {
        style: style,
        children: _children !== null && _children !== void 0 ? _children : jsx(Icon, {
          width: "4x",
          icon: iconName
        })
      }));
    }
  }));
});
MenuToggleIcon.displayName = 'MenuToggleIcon';

var _excluded$11 = ["children", "css", "disabled", "onClick", "onKeyDown", "variant"];
var MenuButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _children = _ref.children,
    css = _ref.css,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown,
    variant = _ref.variant,
    rest = _objectWithoutProperties(_ref, _excluded$11);
  css = [useMenuButtonCSS({
    variant: variant
  }), css];
  var styleProps = useMenuButtonStyle();
  return jsx(MenuToggle, {
    disabled: disabled,
    onClick: onClick,
    onKeyDown: onKeyDown,
    children: function children(_ref2) {
      var getMenuToggleProps = _ref2.getMenuToggleProps;
      return jsxs(Button, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
        ref: ref,
        css: css,
        variant: variant
      }, getMenuToggleProps()), styleProps), rest), {}, {
        children: [jsx(Box, {
          children: _children
        }), jsx(MenuToggleIcon, {})]
      }));
    }
  });
});
MenuButton.displayName = 'MenuButton';

/**
 * Assign a value to a ref function or object.
 *
 * @param ref the ref to assign to
 * @param value the value
 */
var assignRef = function assignRef(ref, value) {
  if (ref === null || ref === undefined) {
    return;
  }
  if (typeof ref === 'function') {
    ref(value);
    return;
  }
  try {
    ref.current = value;
  } catch (error) {
    throw new Error("Cannot assign value '".concat(value, "' to ref '").concat(ref, "'"));
  }
};

/**
 * Combine multiple React refs into a single ref function.
 * This is used mostly when you need to allow consumers forward refs to internal components.
 *
 * @param refs refs to assign to value to
 */
var mergeRefs = function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return function (node) {
    refs.forEach(function (ref) {
      return assignRef(ref, node);
    });
  };
};

var _excluded$10 = ["container", "anchorEl", "children", "isOpen", "modifiers", "placement", "popperRef", "portalProps", "unmountOnExit", "usePortal", "willUseTransition"];
function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
var defaultPlacement$3 = 'bottom-start';
var Popper = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var container = _ref.container,
    anchorEl = _ref.anchorEl,
    children = _ref.children,
    isOpen = _ref.isOpen,
    modifiers = _ref.modifiers,
    placementProp = _ref.placement,
    popperRefProp = _ref.popperRef,
    portalProps = _ref.portalProps,
    _ref$unmountOnExit = _ref.unmountOnExit,
    unmountOnExit = _ref$unmountOnExit === void 0 ? false : _ref$unmountOnExit,
    _ref$usePortal = _ref.usePortal,
    usePortal = _ref$usePortal === void 0 ? false : _ref$usePortal,
    _ref$willUseTransitio = _ref.willUseTransition,
    willUseTransition = _ref$willUseTransitio === void 0 ? false : _ref$willUseTransitio,
    rest = _objectWithoutProperties(_ref, _excluded$10);
  {
    // deprecation warning
    var prefix = "".concat(Popper.displayName, ":");
    useOnceWhen(function () {
      warnRemovedProps('container', {
        prefix: prefix,
        alternative: 'portalProps'
      });
    }, container !== undefined);
  }
  var nodeRef = useRef();
  var popperRef = useRef(null); // popper instance
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    exited = _useState2[0],
    setExited = _useState2[1];
  var _useState3 = useState(placementProp !== null && placementProp !== void 0 ? placementProp : defaultPlacement$3),
    _useState4 = _slicedToArray(_useState3, 2),
    placement = _useState4[0],
    setPlacement = _useState4[1];
  useEffect(function () {
    var isControlled = placementProp !== undefined;
    if (isControlled) {
      setPlacement(placementProp);
    }
  }, [placementProp]);
  var setupPopper = useCallback(function () {
    var _popperRef$current, _popperRef$current$de;
    if (!anchorEl || !nodeRef.current) {
      return;
    }

    // Destroy existing popper instance and create a new one
    (_popperRef$current = popperRef.current) === null || _popperRef$current === void 0 ? void 0 : (_popperRef$current$de = _popperRef$current.destroy) === null || _popperRef$current$de === void 0 ? void 0 : _popperRef$current$de.call(_popperRef$current);
    var popperInstance = createPopper(getAnchorEl(anchorEl), nodeRef.current, {
      placement: placement,
      modifiers: [{
        // https://popper.js.org/docs/v2/modifiers/arrow/
        name: 'arrow',
        options: {
          element: '[data-popper-arrow]',
          padding: 12 // 12px from the edges of the popper
        }
      }, {
        name: 'handlePopperUpdate',
        enabled: true,
        phase: 'afterWrite',
        fn: function fn(_ref2) {
          var _state$elements;
          var state = _ref2.state;
          var arrowEl = state === null || state === void 0 ? void 0 : (_state$elements = state.elements) === null || _state$elements === void 0 ? void 0 : _state$elements.arrow;
          var nextPlacement = state === null || state === void 0 ? void 0 : state.placement;

          // Update the arrow element's `data-popper-placement` attribute based on the desired placement
          // @see https://popper.js.org/docs/v2/tutorial/
          if (arrowEl && arrowEl.getAttribute('data-popper-placement') !== nextPlacement) {
            arrowEl.setAttribute('data-popper-placement', nextPlacement);
          }
          var isControlled = placementProp !== undefined;
          if (isControlled) {
            return;
          }
          if (nextPlacement && nextPlacement !== placement) {
            setPlacement(nextPlacement);
          }
        }
      }].concat(_toConsumableArray(modifiers)),
      strategy: 'absolute'
    });

    // Force update one-time to fix any positioning issues
    popperInstance.forceUpdate();
    assignRef(popperRef, popperInstance);
    assignRef(popperRefProp, popperInstance);
    if (popperRef.current !== popperInstance) {
      var _prefix = "".concat(Popper.displayName, ":");
      console.error("".concat(_prefix, " An unexpected error occurred. The popper instance is not assigned to the \"popperRef\" as expected."));
    }
  }, [anchorEl, modifiers, placement, placementProp, popperRefProp]);
  var cleanupPopper = useCallback(function () {
    var _popperRef$current2, _popperRef$current2$d;
    // Destroy popper instance
    (_popperRef$current2 = popperRef.current) === null || _popperRef$current2 === void 0 ? void 0 : (_popperRef$current2$d = _popperRef$current2.destroy) === null || _popperRef$current2$d === void 0 ? void 0 : _popperRef$current2$d.call(_popperRef$current2);
    assignRef(popperRef, null);
    assignRef(popperRefProp, null);
    if (popperRef.current !== null) {
      var _prefix2 = "".concat(Popper.displayName, ":");
      console.error("".concat(_prefix2, " An unexpected error occurred. The \"popperRef\" is not set to null as expected."));
    }
  }, [popperRefProp]);
  useEffectOnce(function () {
    return function () {
      cleanupPopper();
    };
  });
  var refUpdater = useCallback(function (node) {
    assignRef(nodeRef, node);
    assignRef(ref, node);
    setupPopper();
  }, [setupPopper, ref]);
  if (unmountOnExit && !isOpen && (!willUseTransition || exited)) {
    return null;
  }
  var childProps = {
    placement: placement
  };
  if (willUseTransition) {
    childProps.transition = {
      "in": isOpen,
      onEnter: function onEnter() {
        setExited(false);
      },
      onExited: function onExited() {
        setExited(true);
        cleanupPopper();
      }
    };
  }
  var _children = jsx(Box, _objectSpread2(_objectSpread2({
    ref: refUpdater,
    position: "absolute"
  }, rest), {}, {
    children: typeof children === 'function' ? children(childProps) : children
  }));
  if (usePortal) {
    return jsx(Portal, _objectSpread2(_objectSpread2({}, portalProps), {}, {
      children: _children
    }));
  }
  return _children;
});
Popper.displayName = 'Popper';

var _excluded$$ = ["PopperComponent", "PopperProps", "TransitionComponent", "TransitionProps", "children", "onBlur", "onKeyDown"];
var MenuContent = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$PopperComponent = _ref.PopperComponent,
    PopperComponent = _ref$PopperComponent === void 0 ? Popper : _ref$PopperComponent,
    PopperProps = _ref.PopperProps,
    _ref$TransitionCompon = _ref.TransitionComponent,
    TransitionComponent = _ref$TransitionCompon === void 0 ? Collapse : _ref$TransitionCompon,
    TransitionProps = _ref.TransitionProps,
    _children = _ref.children,
    onBlurProp = _ref.onBlur,
    onKeyDownProp = _ref.onKeyDown,
    rest = _objectWithoutProperties(_ref, _excluded$$);
  var nodeRef = useRef(null);
  var combinedRef = useMergeRefs(nodeRef, ref);
  var menuContext = useMenu(); // context might be an undefined value
  var _menuContext = _objectSpread2({}, menuContext),
    closeOnBlur = _menuContext.closeOnBlur,
    isOpen = _menuContext.isOpen,
    focusOnFirstItem = _menuContext.focusOnFirstItem,
    focusOnLastItem = _menuContext.focusOnLastItem,
    focusOnNextItem = _menuContext.focusOnNextItem,
    focusOnPreviousItem = _menuContext.focusOnPreviousItem,
    menuId = _menuContext.menuId,
    menuToggleId = _menuContext.menuToggleId,
    menuToggleRef = _menuContext.menuToggleRef,
    menuContentRef = _menuContext.menuContentRef,
    offset = _menuContext.offset,
    closeMenu = _menuContext.onClose,
    placement = _menuContext.placement;
  var eventHandler = {};

  // Close the menu on blur
  eventHandler.onBlur = function (event) {
    var _menuToggleRef$curren, _menuToggleRef$curren2, _menuContentRef$curre, _menuContentRef$curre2;
    // https://developer.mozilla.org/en-US/docs/Web/API/FocusEvent/relatedTarget
    // The relatedTarget property represents the `EventTarget` receiving focus or losing focus during a `blur` or `focus` event, respectively.
    var focusTarget = event.relatedTarget || document.activeElement; // `relatedTarget` is the `EventTarget` receiving focus (if any)
    var isOutsideMenuToggle = !((_menuToggleRef$curren = menuToggleRef.current) !== null && _menuToggleRef$curren !== void 0 && (_menuToggleRef$curren2 = _menuToggleRef$curren.contains) !== null && _menuToggleRef$curren2 !== void 0 && _menuToggleRef$curren2.call(_menuToggleRef$curren, focusTarget));
    var isOutsideMenuContent = !((_menuContentRef$curre = menuContentRef.current) !== null && _menuContentRef$curre !== void 0 && (_menuContentRef$curre2 = _menuContentRef$curre.contains) !== null && _menuContentRef$curre2 !== void 0 && _menuContentRef$curre2.call(_menuContentRef$curre, focusTarget));
    var shouldClose = isOpen && closeOnBlur && !!focusTarget && isOutsideMenuToggle && isOutsideMenuContent;
    if (shouldClose) {
      ensureFunction(closeMenu)();
    }
  };

  // Navigate the menu items using keyboard.
  eventHandler.onKeyDown = function (event) {
    var key = event === null || event === void 0 ? void 0 : event.key;
    var shiftKey = event === null || event === void 0 ? void 0 : event.shiftKey;

    // Prevents default page scrolling for ArrowDown, ArrowUp, End, Home, and Tab keys.
    if (key === 'ArrowDown') {
      event.preventDefault();
      ensureFunction(focusOnNextItem)();
    }
    if (key === 'ArrowUp') {
      event.preventDefault();
      ensureFunction(focusOnPreviousItem)();
    }
    if (key === 'End') {
      event.preventDefault();
      ensureFunction(focusOnLastItem)();
    }
    if (key === 'Home') {
      event.preventDefault();
      ensureFunction(focusOnFirstItem)();
    }
    if (key === 'Tab') {
      event.preventDefault();
      ensureFunction(shiftKey ? focusOnPreviousItem : focusOnNextItem)();
    }

    // Closes menu on pressing the Escape key.
    if (key === 'Escape') {
      ensureFunction(closeMenu)();
    }
  };
  var tabIndex = -1;
  var styleProps = useMenuContentStyle({
    tabIndex: tabIndex
  });
  var _ensureArray = ensureArray(offset),
    _ensureArray2 = _slicedToArray(_ensureArray, 2),
    _ensureArray2$ = _ensureArray2[0],
    skidding = _ensureArray2$ === void 0 ? 0 : _ensureArray2$,
    _ensureArray2$2 = _ensureArray2[1],
    distance = _ensureArray2$2 === void 0 ? 0 : _ensureArray2$2;
  var popperModifiers = useMemo(function () {
    var modifiers = [{
      // https://popper.js.org/docs/v2/modifiers/flip/
      name: 'flip',
      enabled: false // Disable flip functionality
    }, {
      // https://popper.js.org/docs/v2/modifiers/offset/
      name: 'offset',
      options: {
        offset: [skidding, distance]
      }
    }];
    return modifiers;
  }, [skidding, distance]);
  return jsx(PopperComponent, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
    "aria-labelledby": menuToggleId,
    anchorEl: menuToggleRef === null || menuToggleRef === void 0 ? void 0 : menuToggleRef.current // TODO: rename to `referenceRef` in a future release
    ,
    "data-menu-id": menuId,
    id: menuId,
    isOpen: isOpen,
    placement: placement,
    ref: menuContentRef,
    role: "menu",
    tabIndex: tabIndex,
    unmountOnExit: true,
    usePortal: false // Pass `true` in `PopperProps` to render menu in a portal
    ,
    willUseTransition: true,
    zIndex: "dropdown",
    onBlur: callEventHandlers(onBlurProp, eventHandler.onBlur),
    onKeyDown: callEventHandlers(onKeyDownProp, eventHandler.onKeyDown)
  }, PopperProps), {}, {
    modifiers: [].concat(_toConsumableArray(popperModifiers), _toConsumableArray(ensureArray(PopperProps === null || PopperProps === void 0 ? void 0 : PopperProps.modifiers)))
  }, styleProps), rest), {}, {
    children: function children(_ref2) {
      _ref2.placement;
        var transition = _ref2.transition;
      var _transition = _objectSpread2({}, transition),
        inProp = _transition["in"],
        onEnter = _transition.onEnter,
        onExited = _transition.onExited;
      return jsx(TransitionComponent, _objectSpread2(_objectSpread2({
        appear: true,
        easing: "linear",
        timeout: {
          enter: 133,
          exit: Math.floor(133 * 0.7)
        }
      }, TransitionProps), {}, {
        ref: combinedRef,
        "in": inProp,
        onEnter: callAll(onEnter, TransitionProps === null || TransitionProps === void 0 ? void 0 : TransitionProps.onEnter),
        onExited: callAll(onExited, TransitionProps === null || TransitionProps === void 0 ? void 0 : TransitionProps.onExited),
        children: _children
      }));
    }
  }));
});
MenuContent.displayName = 'MenuContent';

var MenuDivider = /*#__PURE__*/forwardRef(function (props, ref) {
  var styleProps = useMenuItemDividerStyle();
  return jsx(Divider, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), props));
});
MenuDivider.displayName = 'MenuDivider';

var _excluded$_ = ["children", "title"];
var MenuGroup = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    title = _ref.title,
    rest = _objectWithoutProperties(_ref, _excluded$_);
  var styleProps = useMenuGroupStyle();
  return jsxs(Fragment, {
    children: [jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
      ref: ref,
      role: "group"
    }, styleProps), rest), {}, {
      children: title
    })), children]
  });
});
MenuGroup.displayName = 'MenuGroup';

var _excluded$Z = ["disabled", "onClick", "onKeyDown", "role"];
var MenuItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var disabled = _ref.disabled,
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'menuitem' : _ref$role,
    rest = _objectWithoutProperties(_ref, _excluded$Z);
  var menuContext = useMenu(); // context might be an undefined value
  var _menuContext = _objectSpread2({}, menuContext),
    closeOnSelect = _menuContext.closeOnSelect,
    closeMenu = _menuContext.onClose;
  var tabIndex = -1;
  var styleProps = useMenuItemStyle({
    tabIndex: tabIndex
  });
  return jsx(ButtonBase, _objectSpread2(_objectSpread2({
    ref: ref,
    role: role,
    tabIndex: tabIndex,
    disabled: disabled,
    "aria-disabled": ariaAttr(disabled),
    onClick: callEventHandlers(onClick, function (event) {
      if (disabled) {
        event.stopPropagation();
        event.preventDefault();
        return;
      }
      if (closeOnSelect) {
        ensureFunction(closeMenu)();
      }
    }),
    onKeyDown: callEventHandlers(onKeyDown, function (event) {
      if (disabled) {
        return;
      }
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        if (onClick) {
          ensureFunction(onClick)();
        }
        if (closeOnSelect) {
          ensureFunction(closeMenu)();
        }
      }
    })
  }, styleProps), rest));
});
MenuItem.displayName = 'MenuItem';

var MenuList = /*#__PURE__*/forwardRef(function (props, ref) {
  var styleProps = useMenuListStyle();
  return jsx(MenuContent, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), props));
});
MenuList.displayName = 'MenuList';

var _excluded$Y = ["children", "defaultIsOpen", "isOpen", "offset", "onClose", "onOpen", "placement"];
var getMemoizedState$c = memoize(function (state) {
  return _objectSpread2({}, state);
});
var Submenu = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$defaultIsOpen = _ref.defaultIsOpen,
    defaultIsOpen = _ref$defaultIsOpen === void 0 ? false : _ref$defaultIsOpen,
    isOpenProp = _ref.isOpen,
    offset = _ref.offset,
    onCloseProp = _ref.onClose,
    onOpenProp = _ref.onOpen,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'right-start' : _ref$placement,
    rest = _objectWithoutProperties(_ref, _excluded$Y);
  var submenuContentRef = useRef(null);
  var submenuToggleRef = useRef(null);
  var isHoveringSubmenuContentRef = useRef();
  var isHoveringSubmenuToggleRef = useRef();
  var _useState = useState(isOpenProp !== null && isOpenProp !== void 0 ? isOpenProp : defaultIsOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  useEffect(function () {
    var isControlled = isOpenProp !== undefined;
    if (isControlled) {
      setIsOpen(isOpenProp);
    }
  }, [isOpenProp]);
  var onClose = useCallback(function () {
    var isControlled = isOpenProp !== undefined;
    if (!isControlled) {
      setIsOpen(false);
    }
    if (typeof onCloseProp === 'function') {
      onCloseProp();
    }
  }, [isOpenProp, onCloseProp]);
  var onOpen = useCallback(function () {
    var isControlled = isOpenProp !== undefined;
    if (!isControlled) {
      setIsOpen(true);
    }
    if (typeof onOpenProp === 'function') {
      onOpenProp();
    }
  }, [isOpenProp, onOpenProp]);
  var defaultId = useAutoId();
  var submenuId = "".concat(config.name, ":Submenu-").concat(defaultId);
  var submenuToggleId = "".concat(config.name, ":SubmenuToggle-").concat(defaultId);
  var styleProps = useSubmenuStyle();
  var context = getMemoizedState$c({
    isHoveringSubmenuContentRef: isHoveringSubmenuContentRef,
    isHoveringSubmenuToggleRef: isHoveringSubmenuToggleRef,
    isOpen: isOpen,
    offset: offset,
    onClose: onClose,
    onOpen: onOpen,
    placement: placement,
    submenuId: submenuId,
    submenuToggleId: submenuToggleId,
    submenuContentRef: submenuContentRef,
    submenuToggleRef: submenuToggleRef
  });
  return jsx(SubmenuContext.Provider, {
    value: context,
    children: jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
      ref: ref
    }, styleProps), rest), {}, {
      children: runIfFn(children, context)
    }))
  });
});
Submenu.displayName = 'Submenu';

var useSubmenu = function useSubmenu() {
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(SubmenuContext);
  return context;
};

var _excluded$X = ["PopperComponent", "PopperProps", "TransitionComponent", "TransitionProps", "children", "onMouseEnter", "onMouseLeave"];
var SubmenuContent = /*#__PURE__*/forwardRef(function (_ref, ref) {
  _ref.PopperComponent;
    var PopperProps = _ref.PopperProps,
    _ref$TransitionCompon = _ref.TransitionComponent,
    TransitionComponent = _ref$TransitionCompon === void 0 ? Collapse : _ref$TransitionCompon,
    TransitionProps = _ref.TransitionProps,
    _children = _ref.children,
    onMouseEnterProp = _ref.onMouseEnter,
    onMouseLeaveProp = _ref.onMouseLeave,
    rest = _objectWithoutProperties(_ref, _excluded$X);
  var nodeRef = useRef(null);
  var combinedRef = useMergeRefs(nodeRef, ref);
  var mouseLeaveTimeoutRef = useRef();
  var submenuContext = useSubmenu(); // context might be an undefined value
  var _submenuContext = _objectSpread2({}, submenuContext),
    isHoveringSubmenuContentRef = _submenuContext.isHoveringSubmenuContentRef,
    isHoveringSubmenuToggleRef = _submenuContext.isHoveringSubmenuToggleRef,
    isOpen = _submenuContext.isOpen,
    offset = _submenuContext.offset,
    closeSubmenu = _submenuContext.onClose,
    placement = _submenuContext.placement,
    submenuId = _submenuContext.submenuId,
    submenuToggleId = _submenuContext.submenuToggleId,
    submenuToggleRef = _submenuContext.submenuToggleRef,
    submenuContentRef = _submenuContext.submenuContentRef;
  var eventHandler = {};
  eventHandler.onMouseEnter = function (event) {
    isHoveringSubmenuContentRef.current = true;
    if (mouseLeaveTimeoutRef.current) {
      clearTimeout(mouseLeaveTimeoutRef.current);
      mouseLeaveTimeoutRef.current = undefined;
    }
  };
  eventHandler.onMouseLeave = function (event) {
    isHoveringSubmenuContentRef.current = false;
    if (mouseLeaveTimeoutRef.current) {
      clearTimeout(mouseLeaveTimeoutRef.current);
      mouseLeaveTimeoutRef.current = undefined;
    }
    mouseLeaveTimeoutRef.current = setTimeout(function () {
      mouseLeaveTimeoutRef.current = undefined;
      if (!isHoveringSubmenuToggleRef.current && !isHoveringSubmenuContentRef.current) {
        ensureFunction(closeSubmenu)();
      }
    }, 100); // XXX: keep opening submenu when cursor quickly move between SubmenuToggle and SubmenuContent
  };

  var tabIndex = -1;
  var styleProps = useSubmenuContentStyle({
    tabIndex: tabIndex
  });
  var _ensureArray = ensureArray(offset),
    _ensureArray2 = _slicedToArray(_ensureArray, 2),
    _ensureArray2$ = _ensureArray2[0],
    skidding = _ensureArray2$ === void 0 ? 0 : _ensureArray2$,
    _ensureArray2$2 = _ensureArray2[1],
    distance = _ensureArray2$2 === void 0 ? 0 : _ensureArray2$2;
  var popperModifiers = useMemo(function () {
    var modifiers = [{
      // https://popper.js.org/docs/v2/modifiers/flip/
      name: 'flip',
      enabled: false // Disable flip functionality
    }, {
      // https://popper.js.org/docs/v2/modifiers/offset/
      name: 'offset',
      options: {
        offset: [skidding, distance]
      }
    }, {
      // https://popper.js.org/docs/v2/modifiers/event-listeners/
      name: 'eventListeners',
      options: {
        scroll: false,
        // Disable scroll event listener to prevent scrolling the popper element with the reference element
        resize: true // Keep resize event listener enabled (default behavior)
      }
    }];

    return modifiers;
  }, [skidding, distance]);
  return jsx(Popper, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
    "aria-labelledby": submenuToggleId,
    anchorEl: submenuToggleRef === null || submenuToggleRef === void 0 ? void 0 : submenuToggleRef.current // TODO: rename to `referenceRef` in a future release
    ,
    "data-submenu-id": submenuId,
    id: submenuId,
    isOpen: isOpen,
    placement: placement,
    ref: submenuContentRef,
    role: "menu",
    tabIndex: tabIndex,
    unmountOnExit: true,
    usePortal: false // Pass `true` in `PopperProps` to render menu in a portal
    ,
    willUseTransition: true,
    zIndex: "dropdown",
    onMouseEnter: callEventHandlers(onMouseEnterProp, eventHandler.onMouseEnter),
    onMouseLeave: callEventHandlers(onMouseLeaveProp, eventHandler.onMouseLeave)
  }, PopperProps), {}, {
    modifiers: [].concat(_toConsumableArray(popperModifiers), _toConsumableArray(ensureArray(PopperProps === null || PopperProps === void 0 ? void 0 : PopperProps.modifiers)))
  }, styleProps), rest), {}, {
    children: function children(_ref2) {
      _ref2.placement;
        var transition = _ref2.transition;
      var _transition = _objectSpread2({}, transition),
        inProp = _transition["in"],
        onEnter = _transition.onEnter,
        onExited = _transition.onExited;
      return jsx(TransitionComponent, _objectSpread2(_objectSpread2({
        appear: true,
        easing: "linear",
        timeout: {
          enter: 133,
          exit: Math.floor(133 * 0.7)
        }
      }, TransitionProps), {}, {
        ref: combinedRef,
        "in": inProp,
        onEnter: callAll(onEnter, TransitionProps === null || TransitionProps === void 0 ? void 0 : TransitionProps.onEnter),
        onExited: callAll(onExited, TransitionProps === null || TransitionProps === void 0 ? void 0 : TransitionProps.onExited),
        children: _children
      }));
    }
  }));
});
SubmenuContent.displayName = 'SubmenuContent';

var SubmenuList = /*#__PURE__*/forwardRef(function (props, ref) {
  var submenuContext = useSubmenu(); // context might be an undefined value
  var _submenuContext = _objectSpread2({}, submenuContext),
    isOpen = _submenuContext.isOpen,
    placement = _submenuContext.placement;
  var styleProps = useSubmenuListStyle({
    isOpen: isOpen,
    placement: placement
  });
  return jsx(SubmenuContent, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), props));
});
SubmenuList.displayName = 'SubmenuList';

var _excluded$W = ["children", "disabled", "onMouseEnter", "onMouseLeave"];
var SubmenuToggle = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    onMouseEnterProp = _ref.onMouseEnter,
    onMouseLeaveProp = _ref.onMouseLeave,
    rest = _objectWithoutProperties(_ref, _excluded$W);
  var mouseLeaveTimeoutRef = useRef();
  var submenuContext = useSubmenu(); // context might be an undefined value
  var _submenuContext = _objectSpread2({}, submenuContext),
    isHoveringSubmenuContentRef = _submenuContext.isHoveringSubmenuContentRef,
    isHoveringSubmenuToggleRef = _submenuContext.isHoveringSubmenuToggleRef,
    isOpen = _submenuContext.isOpen,
    closeSubmenu = _submenuContext.onClose,
    openSubmenu = _submenuContext.onOpen,
    submenuId = _submenuContext.submenuId,
    submenuToggleId = _submenuContext.submenuToggleId,
    submenuToggleRef = _submenuContext.submenuToggleRef;
  var combinedRef = useMergeRefs(submenuToggleRef, ref);
  var styleProps = useSubmenuToggleStyle();
  var eventHandler = {};
  eventHandler.onMouseEnter = function (event) {
    if (disabled) {
      event.preventDefault();
      return;
    }
    isHoveringSubmenuToggleRef.current = true;
    if (mouseLeaveTimeoutRef.current) {
      clearTimeout(mouseLeaveTimeoutRef.current);
      mouseLeaveTimeoutRef.current = undefined;
    }
    ensureFunction(openSubmenu)();
  };
  eventHandler.onMouseLeave = function (event) {
    if (disabled) {
      event.preventDefault();
      return;
    }
    isHoveringSubmenuToggleRef.current = false;
    if (mouseLeaveTimeoutRef.current) {
      clearTimeout(mouseLeaveTimeoutRef.current);
      mouseLeaveTimeoutRef.current = undefined;
    }
    mouseLeaveTimeoutRef.current = setTimeout(function () {
      mouseLeaveTimeoutRef.current = undefined;
      if (!isHoveringSubmenuToggleRef.current && !isHoveringSubmenuContentRef.current) {
        ensureFunction(closeSubmenu)();
      }
    }, 100); // XXX: keep opening popover when cursor quickly move between trigger and content
  };

  var getSubmenuToggleProps = function getSubmenuToggleProps() {
    return _objectSpread2(_objectSpread2({
      'aria-controls': submenuId,
      'aria-disabled': ariaAttr(disabled),
      'aria-expanded': ariaAttr(isOpen),
      'aria-haspopup': 'menu',
      disabled: disabled,
      id: submenuToggleId,
      onMouseEnter: callEventHandlers(onMouseEnterProp, eventHandler.onMouseEnter),
      onMouseLeave: callEventHandlers(onMouseLeaveProp, eventHandler.onMouseLeave),
      ref: combinedRef,
      role: 'presentation'
    }, styleProps), rest);
  };
  if (typeof children === 'function') {
    return children({
      getSubmenuToggleProps: getSubmenuToggleProps
    });
  }
  return jsx(Box, _objectSpread2(_objectSpread2({}, getSubmenuToggleProps()), {}, {
    children: children
  }));
});
SubmenuToggle.displayName = 'SubmenuToggle';

Menu.Button = MenuButton;
Menu.Content = MenuContent;
Menu.Divider = MenuDivider;
Menu.Group = MenuGroup;
Menu.Item = MenuItem;
Menu.List = MenuList;
Menu.Toggle = MenuToggle;
Menu.Toggle.Icon = MenuToggleIcon;
Submenu.Content = SubmenuContent;
Submenu.List = SubmenuList;
Submenu.Toggle = SubmenuToggle;

var defaultSize$7 = 'auto';
var useModalContainerStyle = function useModalContainerStyle() {
  return {
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    overflow: 'auto',
    zIndex: 'modal'
  };
};
var useModalOverlayStyle = function useModalOverlayStyle() {
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var backgroundColor = {
    dark: 'rgba(0, 0, 0, .7)',
    light: 'rgba(0, 0, 0, .7)'
  }[colorMode];
  return {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    backgroundColor: backgroundColor
  };
};
var useModalContentStyle = function useModalContentStyle(_ref) {
  var _colorStyle$shadow, _colorStyle$shadow2;
  var placement = _ref.placement,
    scrollBehavior = _ref.scrollBehavior,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaultSize$7 : _ref$size,
    tabIndex = _ref.tabIndex;
  var _useColorMode3 = useColorMode(),
    _useColorMode4 = _slicedToArray(_useColorMode3, 1),
    colorMode = _useColorMode4[0];
  var _useColorStyle = useColorStyle({
      colorMode: colorMode
    }),
    _useColorStyle2 = _slicedToArray(_useColorStyle, 1),
    colorStyle = _useColorStyle2[0];
  var baseStyle = {
    display: 'flex',
    flexDirection: 'column',
    outline: tabIndex < 0 ? 0 : undefined,
    // Remove the default outline for tabindex="-1"
    overflow: 'clip',
    // Set overflow to clip to prevent any scrolling in the modal content
    position: 'relative'
  };
  var colorModeStyle = {
    light: {
      color: 'black:primary',
      bg: 'white',
      borderWidth: '1q',
      borderStyle: 'solid',
      borderColor: 'gray:30',
      boxShadow: colorStyle === null || colorStyle === void 0 ? void 0 : (_colorStyle$shadow = colorStyle.shadow) === null || _colorStyle$shadow === void 0 ? void 0 : _colorStyle$shadow.thick
    },
    dark: {
      color: 'white:primary',
      bg: 'gray:90',
      borderWidth: '1q',
      borderStyle: 'solid',
      borderColor: 'gray:80',
      boxShadow: colorStyle === null || colorStyle === void 0 ? void 0 : (_colorStyle$shadow2 = colorStyle.shadow) === null || _colorStyle$shadow2 === void 0 ? void 0 : _colorStyle$shadow2.thick
    }
  }[colorMode];
  var placementStyle = {
    'center': {
      // https://stackoverflow.com/questions/33454533/cant-scroll-to-top-of-flex-item-that-is-overflowing-container
      margin: 'auto' // Use the `margin: auto` technique to center the content
    }
  }[placement];
  var sizeStyle = {
    xs: {
      width: 352,
      minHeight: 240,
      maxHeight: scrollBehavior === 'inside' ? '80vh' : undefined
    },
    sm: {
      width: 512,
      minHeight: 320,
      maxHeight: scrollBehavior === 'inside' ? '80vh' : undefined
    },
    md: {
      width: 672,
      minHeight: 320,
      maxHeight: scrollBehavior === 'inside' ? '80vh' : undefined
    },
    lg: {
      width: 832,
      minHeight: 320,
      maxHeight: scrollBehavior === 'inside' ? '80vh' : undefined
    },
    xl: {
      width: 992,
      minHeight: 320,
      maxHeight: scrollBehavior === 'inside' ? '80vh' : undefined
    },
    full: {
      maxWidth: scrollBehavior === 'inside' ? '100vw' : undefined,
      maxHeight: scrollBehavior === 'inside' ? '100vh' : undefined,
      /**
       * Autoprefixer will compile it to:
       *
       * ```css
       * min-height: -webkit-fill-available;
       * min-height: -moz-available;
       * min-height: fill-available;
       * min-height: stretch;
       * ```
       */
      minHeight: 'stretch',
      width: '100%'
    },
    auto: {
      width: 'auto',
      height: 'auto',
      maxWidth: scrollBehavior === 'inside' ? '100vw' : undefined,
      maxHeight: scrollBehavior === 'inside' ? '100vh' : undefined
    }
  }[size];
  return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, baseStyle), colorModeStyle), placementStyle), sizeStyle);
};
var useModalCloseButtonStyle = function useModalCloseButtonStyle() {
  var _useColorMode5 = useColorMode(),
    _useColorMode6 = _slicedToArray(_useColorMode5, 1),
    colorMode = _useColorMode6[0];
  var _useTheme = useTheme(),
    sizes = _useTheme.sizes;
  var color = {
    dark: 'white:tertiary',
    light: 'black:tertiary'
  }[colorMode];
  var size = '8x';
  var _focusBorderColor = 'blue:60';
  var _focusBoxShadowBorderColor = 'blue:60';
  var _hoverColor = {
    dark: 'white:emphasis',
    light: 'black:primary'
  }[colorMode];
  var baseStyle = useIconButtonStyle({
    color: color,
    size: size,
    _focusBorderColor: _focusBorderColor,
    _focusBoxShadowBorderColor: _focusBoxShadowBorderColor,
    _hoverColor: _hoverColor
  });
  var parentBorderWidth = sizes['1q'];
  var top = "calc(".concat(sizes['2x'], " - ").concat(parentBorderWidth, ")");
  var right = "calc(".concat(sizes['2x'], " - ").concat(parentBorderWidth, ")");
  return _objectSpread2(_objectSpread2({}, baseStyle), {}, {
    position: 'absolute',
    top: top,
    right: right
  });
};
var useModalHeaderStyle = function useModalHeaderStyle(_ref2) {
  var isClosable = _ref2.isClosable;
  return {
    pt: '4x',
    pb: '6x',
    pl: '6x',
    pr: isClosable ? '12x' : '6x',
    position: 'relative',
    fontSize: 'xl',
    lineHeight: 'xl'
  };
};
var useModalBodyStyle = function useModalBodyStyle(_ref3) {
  var scrollBehavior = _ref3.scrollBehavior;
  var _useTheme2 = useTheme(),
    sizes = _useTheme2.sizes,
    lineHeights = _useTheme2.lineHeights;
  return {
    px: '6x',
    pb: '6x',
    flex: 1,
    height: 'auto',
    overflowY: scrollBehavior === 'inside' ? 'auto' : undefined,
    _firstOfType: {
      // Sets the margin area on the top if it is the first child
      // 4x (padding-top) + xl (line-height) + 3x (padding-bottom)
      marginTop: "calc(".concat(_get(sizes, '4x'), " + ").concat(_get(lineHeights, 'xl'), " + ").concat(_get(sizes, '3x'), ")")
    }
  };
};
var useModalFooterStyle = function useModalFooterStyle() {
  var _useColorMode7 = useColorMode(),
    _useColorMode8 = _slicedToArray(_useColorMode7, 1),
    colorMode = _useColorMode8[0];
  var _useTheme3 = useTheme(),
    sizes = _useTheme3.sizes,
    lineHeights = _useTheme3.lineHeights;
  var borderColor = {
    dark: 'rgba(255, 255, 255, 0.12)',
    light: 'rgba(0, 0, 0, 0.12)'
  }[colorMode];
  return {
    display: 'flex',
    justifyContent: 'flex-end',
    px: '6x',
    py: '4x',
    borderTop: 1,
    borderTopColor: borderColor,
    _firstOfType: {
      // Sets the margin area on the top if it is the first child
      // 4x (padding-top) + xl (line-height) + 3x (padding-bottom)
      marginTop: "calc(".concat(_get(sizes, '4x'), " + ").concat(_get(lineHeights, 'xl'), " + ").concat(_get(sizes, '3x'), ")")
    }
  };
};

var ModalContext = /*#__PURE__*/createContext();

var useModal = function useModal() {
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(ModalContext);
  return context;
};

var ModalContainer = /*#__PURE__*/forwardRef(function (props, ref) {
  var modalContext = useModal(); // context might be an undefined value
  var _modalContext = _objectSpread2({}, modalContext),
    closeOnOutsideClick = _modalContext.closeOnOutsideClick,
    onClose = _modalContext.onClose,
    containerRef = _modalContext.containerRef;
  var combinedRef = useMergeRefs(containerRef, ref);
  var styleProps = useModalContainerStyle();
  var containerProps = _objectSpread2(_objectSpread2({
    ref: combinedRef,
    onClick: function onClick(event) {
      event.stopPropagation();
      if (closeOnOutsideClick) {
        typeof onClose === 'function' && onClose(event);
      }
    }
  }, styleProps), props);
  return jsx(Box, _objectSpread2({}, containerProps));
});
ModalContainer.displayName = 'ModalContainer';

var _excluded$V = ["isCloseButtonVisible", "autoFocus", "children", "closeOnEsc", "closeOnOutsideClick", "ensureFocus", "finalFocusRef", "initialFocusRef", "isClosable", "isOpen", "onClose", "portalProps", "returnFocusOnClose", "scrollBehavior", "size"];
var getMemoizedState$b = memoize(function (state) {
  return _objectSpread2({}, state);
});
var defaultScrollBehavior = 'inside';
var defaultSize$6 = 'auto';
var Modal = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isCloseButtonVisible = _ref.isCloseButtonVisible,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    children = _ref.children,
    _ref$closeOnEsc = _ref.closeOnEsc,
    closeOnEsc = _ref$closeOnEsc === void 0 ? false : _ref$closeOnEsc,
    _ref$closeOnOutsideCl = _ref.closeOnOutsideClick,
    closeOnOutsideClick = _ref$closeOnOutsideCl === void 0 ? false : _ref$closeOnOutsideCl,
    _ref$ensureFocus = _ref.ensureFocus,
    ensureFocus = _ref$ensureFocus === void 0 ? false : _ref$ensureFocus,
    finalFocusRef = _ref.finalFocusRef,
    initialFocusRef = _ref.initialFocusRef,
    _ref$isClosable = _ref.isClosable,
    isClosable = _ref$isClosable === void 0 ? false : _ref$isClosable,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    onClose = _ref.onClose,
    portalProps = _ref.portalProps,
    _ref$returnFocusOnClo = _ref.returnFocusOnClose,
    returnFocusOnClose = _ref$returnFocusOnClo === void 0 ? true : _ref$returnFocusOnClo,
    _ref$scrollBehavior = _ref.scrollBehavior,
    scrollBehavior = _ref$scrollBehavior === void 0 ? defaultScrollBehavior : _ref$scrollBehavior,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaultSize$6 : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded$V);
  {
    // deprecation warning
    var prefix = "".concat(Modal.displayName, ":");
    useOnceWhen(function () {
      warnDeprecatedProps('isCloseButtonVisible', {
        prefix: prefix,
        alternative: 'isClosable',
        willRemove: true
      });
    }, isCloseButtonVisible !== undefined);
    isClosable = isClosable || isCloseButtonVisible; // TODO: remove this line after deprecation
  }

  var _useState = useState(isOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isMounted = _useState2[0],
    setIsMounted = _useState2[1];
  var containerRef = useRef();
  var contentRef = useRef();
  var context = getMemoizedState$b({
    autoFocus: autoFocus,
    closeOnEsc: closeOnEsc,
    closeOnOutsideClick: closeOnOutsideClick,
    ensureFocus: ensureFocus,
    finalFocusRef: finalFocusRef,
    initialFocusRef: initialFocusRef,
    isClosable: isClosable,
    isOpen: isOpen,
    onClose: onClose,
    scrollBehavior: scrollBehavior,
    size: size,
    containerRef: containerRef,
    // internal use only
    contentRef: contentRef,
    // internal use only
    placement: 'center' // internal use only (only 'center' is supported by Modal)
  });

  var returnFocus = returnFocusOnClose && !finalFocusRef;
  var onFocusLockActivation = useCallback(function () {
    if (initialFocusRef && initialFocusRef.current) {
      var el = initialFocusRef.current;
      if (typeof el.focus === 'function') {
        el.focus();
      }
      return;
    }
    if (contentRef.current) {
      var _el = contentRef.current;
      var focusableElements = getAllFocusable(_el);
      if (focusableElements.length > 0) {
        return;
      }
      if (typeof _el.focus === 'function') {
        _el.focus();
      }
    }
  }, [initialFocusRef]);
  var onFocusLockDeactivation = useCallback(function () {
    if (finalFocusRef && finalFocusRef.current) {
      var el = finalFocusRef.current;
      if (typeof el.focus === 'function') {
        el.focus();
      }
    }
  }, [finalFocusRef]);
  var onExitComplete = useCallback(function () {
    setIsMounted(false);
  }, []);
  useEffect(function () {
    if (isOpen && !isMounted) {
      setIsMounted(true);
      return;
    }
  }, [isOpen, isMounted]);
  return jsx(ModalContext.Provider, {
    value: context,
    children: jsx(AnimatePresence, {
      "in": isOpen,
      onExitComplete: onExitComplete,
      children: !!isMounted && jsx(Portal, _objectSpread2(_objectSpread2({}, portalProps), {}, {
        children: jsx(FocusLock, {
          disabled: !ensureFocus,
          autoFocus: autoFocus,
          returnFocus: returnFocus,
          onActivation: onFocusLockActivation,
          onDeactivation: onFocusLockDeactivation,
          children: jsx(ModalContainer, _objectSpread2(_objectSpread2({
            ref: ref
          }, rest), {}, {
            children: runIfFn(children, context)
          }))
        })
      }))
    })
  });
});
Modal.displayName = 'Modal';

var ModalBody = /*#__PURE__*/forwardRef(function (props, ref) {
  var modalContext = useModal(); // context might be an undefined value
  var _modalContext = _objectSpread2({}, modalContext),
    scrollBehavior = _modalContext.scrollBehavior;
  var styleProps = useModalBodyStyle({
    scrollBehavior: scrollBehavior
  });
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), props));
});
ModalBody.displayName = 'ModalBody';

var _excluded$U = ["children", "onClick"];
var ModalCloseButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    onClickProp = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded$U);
  var modalContext = useModal(); // context might be an undefined value
  var _modalContext = _objectSpread2({}, modalContext),
    onClose = _modalContext.onClose;
  var styleProps = useModalCloseButtonStyle();
  return jsx(ButtonBase, _objectSpread2(_objectSpread2(_objectSpread2({
    "aria-label": "Close",
    ref: ref,
    onClick: callEventHandlers(onClickProp, onClose)
  }, styleProps), rest), {}, {
    children: children !== null && children !== void 0 ? children : jsx(Icon, {
      icon: "close"
    })
  }));
});
ModalCloseButton.displayName = 'ModalCloseButton';

var _excluded$T = ["TransitionComponent", "TransitionProps", "children"];
var ModalContent = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$TransitionCompon = _ref.TransitionComponent,
    TransitionComponent = _ref$TransitionCompon === void 0 ? Fade : _ref$TransitionCompon,
    TransitionProps = _ref.TransitionProps,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$T);
  var _useAnimatePresence = useAnimatePresence(),
    _useAnimatePresence2 = _slicedToArray(_useAnimatePresence, 2),
    safeToRemove = _useAnimatePresence2[1];
  var modalContext = useModal(); // context might be an undefined value
  var _modalContext = _objectSpread2({}, modalContext),
    closeOnEsc = _modalContext.closeOnEsc,
    isClosable = _modalContext.isClosable,
    isOpen = _modalContext.isOpen,
    onClose = _modalContext.onClose,
    scrollBehavior = _modalContext.scrollBehavior,
    size = _modalContext.size,
    contentRef = _modalContext.contentRef,
    placement = _modalContext.placement;
  var combinedRef = useMergeRefs(contentRef, ref);
  var tabIndex = -1;
  var styleProps = useModalContentStyle({
    placement: placement,
    scrollBehavior: scrollBehavior,
    size: size,
    tabIndex: tabIndex
  });
  var contentProps = _objectSpread2(_objectSpread2({
    'aria-modal': ariaAttr(true),
    ref: combinedRef,
    role: 'dialog',
    tabIndex: tabIndex,
    onClick: function onClick(event) {
      return event.stopPropagation();
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Escape') {
        event.stopPropagation();
        if (closeOnEsc) {
          typeof onClose === 'function' && onClose(event);
        }
      }
    }
  }, styleProps), rest);
  return jsxs(TransitionComponent, _objectSpread2(_objectSpread2(_objectSpread2({
    appear: !!modalContext
  }, TransitionProps), contentProps), {}, {
    "in": modalContext ? isOpen : true,
    onExited: callAll(safeToRemove, TransitionProps === null || TransitionProps === void 0 ? void 0 : TransitionProps.onExited),
    children: [children, !!isClosable && jsx(ModalCloseButton, {})]
  }));
});
ModalContent.displayName = 'ModalContent';

var ModalFooter = /*#__PURE__*/forwardRef(function (props, ref) {
  var styleProps = useModalFooterStyle();
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), props));
});
ModalFooter.displayName = 'ModalFooter';

var ModalHeader = /*#__PURE__*/forwardRef(function (props, ref) {
  var modalContext = useModal(); // context might be an undefined value
  var _modalContext = _objectSpread2({}, modalContext),
    isClosable = _modalContext.isClosable;
  var styleProps = useModalHeaderStyle({
    isClosable: isClosable
  });
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), props));
});
ModalHeader.displayName = 'ModalHeader';

var _excluded$S = ["TransitionComponent", "TransitionProps"];
var ModalOverlay = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$TransitionCompon = _ref.TransitionComponent,
    TransitionComponent = _ref$TransitionCompon === void 0 ? Fade : _ref$TransitionCompon,
    TransitionProps = _ref.TransitionProps,
    rest = _objectWithoutProperties(_ref, _excluded$S);
  var _useAnimatePresence = useAnimatePresence(),
    _useAnimatePresence2 = _slicedToArray(_useAnimatePresence, 2),
    safeToRemove = _useAnimatePresence2[1];
  var modalContext = useModal(); // context might be an undefined value
  var _modalContext = _objectSpread2({}, modalContext),
    isOpen = _modalContext.isOpen,
    scrollBehavior = _modalContext.scrollBehavior,
    containerRef = _modalContext.containerRef,
    contentRef = _modalContext.contentRef;
  var overlayRef = useRef();
  var combinedRef = useMergeRefs(overlayRef, ref);
  var styleProps = useModalOverlayStyle();
  var overlayProps = _objectSpread2(_objectSpread2({
    ref: combinedRef
  }, styleProps), rest);
  useEffect(function () {
    var update = function update() {
      var _contentRef$current, _contentRef$current2, _containerRef$current, _containerRef$current2;
      var el = overlayRef === null || overlayRef === void 0 ? void 0 : overlayRef.current;
      if (!el) {
        return;
      }
      var computedContainerStyle = (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) && getComputedStyle(containerRef === null || containerRef === void 0 ? void 0 : containerRef.current);
      var paddingX = ensurePositiveNumber(parseFloat(computedContainerStyle === null || computedContainerStyle === void 0 ? void 0 : computedContainerStyle.paddingLeft) + parseFloat(computedContainerStyle === null || computedContainerStyle === void 0 ? void 0 : computedContainerStyle.paddingRight));
      var paddingY = ensurePositiveNumber(parseFloat(computedContainerStyle === null || computedContainerStyle === void 0 ? void 0 : computedContainerStyle.paddingTop) + parseFloat(computedContainerStyle === null || computedContainerStyle === void 0 ? void 0 : computedContainerStyle.paddingBottom));
      var computedScrollWidth = ensurePositiveNumber(contentRef === null || contentRef === void 0 ? void 0 : (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.offsetWidth) + paddingX;
      var computedScrollHeight = ensurePositiveNumber(contentRef === null || contentRef === void 0 ? void 0 : (_contentRef$current2 = contentRef.current) === null || _contentRef$current2 === void 0 ? void 0 : _contentRef$current2.offsetHeight) + paddingY;
      if (computedScrollWidth > (containerRef === null || containerRef === void 0 ? void 0 : (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetWidth)) {
        el.style.width = "".concat(computedScrollWidth, "px");
      } else {
        el.style.width = '';
      }
      if (computedScrollHeight > (containerRef === null || containerRef === void 0 ? void 0 : (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.offsetHeight)) {
        el.style.height = "".concat(computedScrollHeight, "px");
      } else {
        el.style.height = '';
      }
    };
    update();
    var resizeObserver = null;
    var ResizeObserver = globalThis.ResizeObserver;
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(function (entries) {
        update();
      });
      if (containerRef.current) {
        resizeObserver.observe(containerRef.current);
      }
      if (contentRef.current) {
        resizeObserver.observe(contentRef.current);
      }
    }
    return function () {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [scrollBehavior, containerRef, contentRef]);
  return jsx(TransitionComponent, _objectSpread2(_objectSpread2(_objectSpread2({
    appear: !!modalContext
  }, TransitionProps), overlayProps), {}, {
    "in": modalContext ? isOpen : true,
    onExited: callAll(safeToRemove, TransitionProps === null || TransitionProps === void 0 ? void 0 : TransitionProps.onExited)
  }));
});
ModalOverlay.displayName = 'ModalOverlay';

Modal.Body = ModalBody;
Modal.Content = ModalContent;
Modal.Footer = ModalFooter;
Modal.Header = ModalHeader;
Modal.Overlay = ModalOverlay;

var usePaginationStyle = function usePaginationStyle() {
  return {
    display: 'flex',
    alignItems: 'center'
  };
};
var usePaginationItemStyle = function usePaginationItemStyle(_ref) {
  var type = _ref.type;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var selectedBorderColor = {
    dark: 'blue:50',
    light: 'blue:50'
  }[colorMode];
  var sizeStyle = function (_ref2) {
    var type = _ref2.type;
    // page button
    if (type === 'page') {
      return {
        px: '2x',
        minWidth: '8x'
      };
    }

    // first, last, previous, next, start-ellipsis, end-ellipsis buttons
    return {
      px: '2x',
      width: '8x'
    };
  }({
    type: type
  });
  return _objectSpread2(_objectSpread2({}, sizeStyle), {}, {
    transition: 'none',
    // avoid unwanted transition effects on buttons
    _selected: {
      borderColor: selectedBorderColor
    }
  });
};

var _excluded$R = ["aria-label", "disabled", "type", "page", "selected", "slot", "variant"];
var defaultSlot$1 = {
  'start-ellipsis': jsx(Icon, {
    icon: "more-horiz"
  }),
  'end-ellipsis': jsx(Icon, {
    icon: "more-horiz"
  }),
  first: jsx(Icon, {
    icon: "collapse-left"
  }),
  previous: jsx(Icon, {
    icon: "angle-left"
  }),
  next: jsx(Icon, {
    icon: "angle-right"
  }),
  last: jsx(Icon, {
    icon: "collapse-right"
  })
};
var getAriaLabel = function getAriaLabel(_ref) {
  var type = _ref.type,
    page = _ref.page,
    selected = _ref.selected;
  if (type === 'start-ellipsis' || type === 'end-ellipsis') {
    return "Go to page ".concat(page);
  }
  if (type === 'page' && !selected) {
    return "Go to page ".concat(page);
  }
  if (type === 'page' && selected) {
    return "Page ".concat(page);
  }
  return "Go to ".concat(type, " page");
};
var PaginationItem = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var ariaLabel = _ref2['aria-label'],
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? 'page' : _ref2$type,
    page = _ref2.page,
    _ref2$selected = _ref2.selected,
    selected = _ref2$selected === void 0 ? false : _ref2$selected,
    slotProp = _ref2.slot,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'ghost' : _ref2$variant,
    rest = _objectWithoutProperties(_ref2, _excluded$R);
  var slot = _objectSpread2(_objectSpread2({}, defaultSlot$1), slotProp);
  var styleProps = usePaginationItemStyle({
    type: type
  });
  return jsx(Button, _objectSpread2(_objectSpread2(_objectSpread2({
    ref: ref,
    "aria-current": ariaAttr(selected),
    "aria-disabled": ariaAttr(disabled),
    "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : getAriaLabel({
      type: type,
      page: page,
      selected: selected
    }),
    "data-selected": dataAttr(selected),
    disabled: disabled,
    variant: variant
  }, styleProps), rest), {}, {
    children: type === 'page' ? page : slot === null || slot === void 0 ? void 0 : slot[type]
  }));
});
PaginationItem.displayName = 'PaginationItem';

var defaultSlot = {
  first: false,
  previous: true,
  next: true,
  last: false
};
var usePagination = function usePagination(props) {
  var _props = _objectSpread2({}, props),
    _props$boundaryCount = _props.boundaryCount,
    boundaryCount = _props$boundaryCount === void 0 ? 1 : _props$boundaryCount,
    _props$componentName = _props.componentName,
    componentName = _props$componentName === void 0 ? 'usePagination' : _props$componentName,
    _props$count = _props.count,
    count = _props$count === void 0 ? 1 : _props$count,
    _props$defaultPage = _props.defaultPage,
    defaultPageProp = _props$defaultPage === void 0 ? 1 : _props$defaultPage,
    _props$disabled = _props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    onChange = _props.onChange,
    pageProp = _props.page,
    _props$siblingCount = _props.siblingCount,
    siblingCount = _props$siblingCount === void 0 ? 1 : _props$siblingCount,
    slotProp = _props.slot;
  var _useState = useState(pageProp !== null && pageProp !== void 0 ? pageProp : defaultPageProp),
    _useState2 = _slicedToArray(_useState, 2),
    page = _useState2[0],
    setPage = _useState2[1];
  var slot = _objectSpread2(_objectSpread2({}, defaultSlot), slotProp);
  useEffect(function () {
    var isControlled = pageProp !== undefined;
    if (isControlled) {
      setPage(pageProp);
    }
  }, [pageProp]);
  var handleClickByPageNumber = function handleClickByPageNumber(value) {
    return function (event) {
      var isControlled = pageProp !== undefined;
      if (!isControlled) {
        setPage(value);
      }
      if (typeof onChange === 'function') {
        // deprecation warning
        var proxiedEvent = attachProxyOnce(event, function () {
          console.warn("".concat(componentName, " \"onChange(event, page)\" is deprecated and will be changed to \"onChange(page)\" in the next major release."));
        });
        onChange(proxiedEvent, value);
      }
    };
  };

  // https://dev.to/namirsab/comment/2050
  var range = function range(start, end) {
    var length = end - start + 1;
    return Array.from({
      length: length
    }, function (_, i) {
      return start + i;
    });
  };
  var startPages = range(1, Math.min(boundaryCount, count));
  var endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
  var siblingStart = Math.max(Math.min(
  // Natural start
  page - siblingCount,
  // Lower boundary when page is high
  count - boundaryCount - siblingCount * 2 - 1),
  // Greater than startPages
  boundaryCount + 2);
  var siblingEnd = Math.min(Math.max(
  // Natural end
  page + siblingCount,
  // Upper boundary when page is low
  boundaryCount + siblingCount * 2 + 2),
  // Less than endPages
  endPages.length > 0 ? endPages[0] - 2 : count - 1);

  // Basic list of items to render
  // e.g. itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
  var paginationItems = [].concat(_toConsumableArray(slot.first ? [{
    type: 'first'
  }] : []), _toConsumableArray(slot.previous ? [{
    type: 'previous'
  }] : []), _toConsumableArray(startPages.map(function (page) {
    return {
      type: 'page',
      value: page
    };
  })), _toConsumableArray(siblingStart > boundaryCount + 2 ? [{
    type: 'start-ellipsis'
  }] : boundaryCount + 1 < count - boundaryCount ? [{
    type: 'page',
    value: boundaryCount + 1
  }] : []), _toConsumableArray(range(siblingStart, siblingEnd).map(function (page) {
    return {
      type: 'page',
      value: page
    };
  })), _toConsumableArray(siblingEnd < count - boundaryCount - 1 ? [{
    type: 'end-ellipsis'
  }] : count - boundaryCount > boundaryCount ? [{
    type: 'page',
    value: count - boundaryCount
  }] : []), _toConsumableArray(endPages.map(function (page) {
    return {
      type: 'page',
      value: page
    };
  })), _toConsumableArray(slot.next ? [{
    type: 'next'
  }] : []), _toConsumableArray(slot.last ? [{
    type: 'last'
  }] : []));
  var mapPageTypeToPageNumber = function mapPageTypeToPageNumber(pageType) {
    if (pageType === 'first') {
      return 1;
    }
    if (pageType === 'previous') {
      return Math.max(page - 1, 1);
    }
    if (pageType === 'start-ellipsis') {
      return Math.max(siblingStart - (siblingCount + 1), 1);
    }
    if (pageType === 'end-ellipsis') {
      return Math.min(siblingEnd + (siblingCount + 1), count);
    }
    if (pageType === 'next') {
      return Math.min(page + 1, count);
    }
    if (pageType === 'last') {
      return count;
    }
    return null;
  };
  var items = paginationItems.map(function (paginationItem) {
    if (paginationItem.type === 'page') {
      var _isDisabled = !!disabled;
      var _pageNumber = paginationItem.value;
      return {
        type: 'page',
        page: _pageNumber,
        disabled: _isDisabled,
        selected: paginationItem.value === page,
        onClick: handleClickByPageNumber(_pageNumber)
      };
    }
    var isDisabled = !!disabled || ['first', 'previous'].includes(paginationItem.type) && page <= 1 || ['next', 'last'].includes(paginationItem.type) && page >= count;
    var pageNumber = mapPageTypeToPageNumber(paginationItem.type);
    return {
      type: paginationItem.type,
      page: pageNumber,
      disabled: isDisabled,
      selected: false,
      onClick: handleClickByPageNumber(pageNumber)
    };
  });
  return {
    items: items
  };
};

var _excluded$Q = ["firstButton", "lastButton", "prevButton", "nextButton", "ellipsisLabel", "boundaryCount", "count", "defaultPage", "disabled", "onChange", "page", "renderItem", "siblingCount", "slot"];
var Pagination = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var firstButtonProp = _ref.firstButton,
    lastButtonProp = _ref.lastButton,
    prevButtonProp = _ref.prevButton,
    nextButtonProp = _ref.nextButton,
    ellipsisLabelProp = _ref.ellipsisLabel,
    _ref$boundaryCount = _ref.boundaryCount,
    boundaryCount = _ref$boundaryCount === void 0 ? 1 : _ref$boundaryCount,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? 1 : _ref$count,
    _ref$defaultPage = _ref.defaultPage,
    defaultPage = _ref$defaultPage === void 0 ? 1 : _ref$defaultPage,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    page = _ref.page,
    _ref$renderItem = _ref.renderItem,
    renderItem = _ref$renderItem === void 0 ? function (item) {
      return jsx(PaginationItem, _objectSpread2({}, item));
    } : _ref$renderItem,
    _ref$siblingCount = _ref.siblingCount,
    siblingCount = _ref$siblingCount === void 0 ? 1 : _ref$siblingCount,
    slot = _ref.slot,
    rest = _objectWithoutProperties(_ref, _excluded$Q);
  {
    // deprecation warning
    var prefix = "".concat(Pagination.displayName, ":");
    useOnceWhen(function () {
      warnRemovedProps('firstButton', {
        prefix: prefix,
        alternative: ["slot={{ first: ".concat(!!firstButtonProp, " }}"), 'renderItem']
      });
    }, firstButtonProp !== undefined);
    useOnceWhen(function () {
      warnRemovedProps('lastButton', {
        prefix: prefix,
        alternative: ["slot={{ last: ".concat(!!lastButtonProp, " }}"), 'renderItem']
      });
    }, lastButtonProp !== undefined);
    useOnceWhen(function () {
      warnRemovedProps('prevButton', {
        prefix: prefix,
        alternative: ["slot={{ previous: ".concat(!!prevButtonProp, " }}"), 'renderItem']
      });
    }, prevButtonProp !== undefined);
    useOnceWhen(function () {
      warnRemovedProps('nextButton', {
        prefix: prefix,
        alternative: ["slot={{ next: ".concat(!!nextButtonProp, " }}"), 'renderItem']
      });
    }, nextButtonProp !== undefined);
    useOnceWhen(function () {
      warnRemovedProps('ellipsisLabel', {
        prefix: prefix,
        alternative: ['renderItem']
      });
    }, ellipsisLabelProp !== undefined);
    if (firstButtonProp !== undefined) {
      slot = _objectSpread2(_objectSpread2({}, slot), {}, {
        first: !!firstButtonProp
      });
    }
    if (lastButtonProp !== undefined) {
      slot = _objectSpread2(_objectSpread2({}, slot), {}, {
        last: !!lastButtonProp
      });
    }
    if (prevButtonProp !== undefined) {
      slot = _objectSpread2(_objectSpread2({}, slot), {}, {
        previous: !!prevButtonProp
      });
    }
    if (nextButtonProp !== undefined) {
      slot = _objectSpread2(_objectSpread2({}, slot), {}, {
        next: !!nextButtonProp
      });
    }
  }
  var _usePagination = usePagination({
      boundaryCount: boundaryCount,
      componentName: Pagination.displayName,
      count: count,
      defaultPage: defaultPage,
      disabled: disabled,
      onChange: onChange,
      page: page,
      siblingCount: siblingCount,
      slot: slot
    }),
    items = _usePagination.items;
  var styleProps = usePaginationStyle();
  return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), rest), {}, {
    children: items.map(function (item, index) {
      return jsx(Fragment$1, {
        children: renderItem(_objectSpread2({}, item))
      }, "".concat(item.type, "-").concat(item.page));
    })
  }));
});
Pagination.displayName = 'Pagination';

var PopoverContext = /*#__PURE__*/createContext();

var getMemoizedState$a = memoize(function (state) {
  return _objectSpread2({}, state);
});
var defaultPlacement$2 = 'bottom';
var Popover = function Popover(_ref) {
  var arrowAt = _ref.arrowAt,
    distance = _ref.distance,
    hideArrow = _ref.hideArrow,
    skidding = _ref.skidding,
    _ref$arrow = _ref.arrow,
    arrow = _ref$arrow === void 0 ? true : _ref$arrow,
    children = _ref.children,
    _ref$closeOnBlur = _ref.closeOnBlur,
    closeOnBlur = _ref$closeOnBlur === void 0 ? true : _ref$closeOnBlur,
    _ref$closeOnEsc = _ref.closeOnEsc,
    closeOnEsc = _ref$closeOnEsc === void 0 ? true : _ref$closeOnEsc,
    _ref$defaultIsOpen = _ref.defaultIsOpen,
    defaultIsOpen = _ref$defaultIsOpen === void 0 ? false : _ref$defaultIsOpen,
    disabled = _ref.disabled,
    _ref$enterDelay = _ref.enterDelay,
    enterDelay = _ref$enterDelay === void 0 ? 100 : _ref$enterDelay,
    followCursor = _ref.followCursor,
    initialFocusRef = _ref.initialFocusRef,
    isOpenProp = _ref.isOpen,
    _ref$leaveDelay = _ref.leaveDelay,
    leaveDelay = _ref$leaveDelay === void 0 ? 0 : _ref$leaveDelay,
    nextToCursor = _ref.nextToCursor,
    offset = _ref.offset,
    onCloseProp = _ref.onClose,
    onOpenProp = _ref.onOpen,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? defaultPlacement$2 : _ref$placement,
    _ref$returnFocusOnClo = _ref.returnFocusOnClose,
    returnFocusOnClose = _ref$returnFocusOnClo === void 0 ? true : _ref$returnFocusOnClo,
    _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? 'click' : _ref$trigger;
  {
    var _offset;
    // deprecation warning
    var prefix = "".concat(Popover.displayName, ":");
    useOnceWhen(function () {
      warnRemovedProps('arrowAt', {
        prefix: prefix,
        message: 'Use the \'PopoverArrowProps\' prop on the \'PopoverContent\' component instead.'
      });
    }, arrowAt !== undefined);
    useOnceWhen(function () {
      warnDeprecatedProps('distance', {
        prefix: prefix,
        alternative: 'offset={[skidding, distance]}',
        willRemove: true
      });
    }, distance !== undefined);
    useOnceWhen(function () {
      warnDeprecatedProps('hideArrow', {
        prefix: prefix,
        alternative: 'arrow',
        willRemove: true
      });
    }, process.env.NODE_ENV !== 'production' && hideArrow !== undefined);
    useOnceWhen(function () {
      warnDeprecatedProps('skidding', {
        prefix: prefix,
        alternative: 'offset={[skidding, distance]}',
        willRemove: true
      });
    }, skidding !== undefined);
    if (hideArrow !== undefined) {
      arrow = !hideArrow;
    }
    offset = (_offset = offset) !== null && _offset !== void 0 ? _offset : [skidding, distance];
  }
  var popoverContentRef = useRef();
  var popoverTriggerRef = useRef();
  var isHoveringContentRef = useRef();
  var isHoveringTriggerRef = useRef();
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    mousePageX = _useState2[0],
    setMousePageX = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    mousePageY = _useState4[0],
    setMousePageY = _useState4[1];
  var _useState5 = useState(isOpenProp !== null && isOpenProp !== void 0 ? isOpenProp : defaultIsOpen),
    _useState6 = _slicedToArray(_useState5, 2),
    isOpen = _useState6[0],
    setIsOpen = _useState6[1];
  var prevIsOpen = usePrevious(isOpen);
  useEffect(function () {
    var isControlled = isOpenProp !== undefined;
    if (isControlled) {
      setIsOpen(isOpenProp);
    }
  }, [isOpenProp]);
  var enterTimeoutRef = useRef();
  var leaveTimeoutRef = useRef();
  var openWithDelay = useCallback(function (callback, delay) {
    if (leaveTimeoutRef.current) {
      clearTimeout(leaveTimeoutRef.current);
      leaveTimeoutRef.current = undefined;
    }
    if (delay > 0) {
      enterTimeoutRef.current = setTimeout(function () {
        enterTimeoutRef.current = undefined;
        setIsOpen(true);
        typeof callback === 'function' && callback();
      }, delay);
    } else {
      setIsOpen(true);
      typeof callback === 'function' && callback();
    }
  }, []);
  var closeWithDelay = useCallback(function (callback, delay) {
    if (enterTimeoutRef.current) {
      clearTimeout(enterTimeoutRef.current);
      enterTimeoutRef.current = undefined;
    }
    if (delay > 0) {
      leaveTimeoutRef.current = setTimeout(function () {
        leaveTimeoutRef.current = undefined;
        setIsOpen(false);
        typeof callback === 'function' && callback();
      }, delay);
    } else {
      setIsOpen(false);
      typeof callback === 'function' && callback();
    }
  }, []);
  var onOpen = useCallback(function (callback) {
    var isControlled = isOpenProp !== undefined;
    if (!isControlled) {
      var delay = trigger === 'hover' ? enterDelay : 0;
      openWithDelay(callback, delay);
    }
    if (typeof onOpenProp === 'function') {
      onOpenProp();
    }
  }, [isOpenProp, onOpenProp, trigger, enterDelay, openWithDelay]);
  var onClose = useCallback(function (callback) {
    var isControlled = isOpenProp !== undefined;
    if (!isControlled) {
      var delay = trigger === 'hover' ? leaveDelay : 0;
      closeWithDelay(callback, delay);
    }
    if (typeof onCloseProp === 'function') {
      onCloseProp();
    }
  }, [isOpenProp, onCloseProp, trigger, leaveDelay, closeWithDelay]);
  useEffect(function () {
    if (isOpen && trigger === 'click') {
      requestAnimationFrame(function () {
        if (initialFocusRef && initialFocusRef.current) {
          initialFocusRef.current.focus();
        } else if (popoverContentRef.current) {
          popoverContentRef.current.focus();
        }
      });
    }
    if (!isOpen && prevIsOpen && trigger === 'click' && returnFocusOnClose) {
      if (popoverTriggerRef.current) {
        popoverTriggerRef.current.focus();
      }
    }
  }, [isOpen, popoverContentRef, initialFocusRef, trigger, popoverTriggerRef, prevIsOpen, returnFocusOnClose]);
  useEffect(function () {
    return function () {
      if (enterTimeoutRef.current) {
        clearTimeout(enterTimeoutRef.current);
        enterTimeoutRef.current = undefined;
      }
      if (leaveTimeoutRef.current) {
        clearTimeout(leaveTimeoutRef.current);
        leaveTimeoutRef.current = undefined;
      }
    };
  }, []);
  var defaultId = useAutoId();
  var popoverId = "".concat(config.name, ":Popover-").concat(defaultId);
  var popoverTriggerId = "".concat(config.name, ":PopoverTrigger-").concat(defaultId);
  var context = getMemoizedState$a({
    closeOnBlur: closeOnBlur,
    closeOnEsc: closeOnEsc,
    disabled: disabled,
    followCursor: followCursor,
    arrow: followCursor || nextToCursor ? false : arrow,
    initialFocusRef: initialFocusRef,
    isHoveringContentRef: isHoveringContentRef,
    isHoveringTriggerRef: isHoveringTriggerRef,
    isOpen: isOpen,
    mousePageX: mousePageX,
    mousePageY: mousePageY,
    nextToCursor: nextToCursor,
    offset: offset,
    onClose: onClose,
    onOpen: onOpen,
    placement: followCursor || nextToCursor ? 'bottom-start' : placement,
    popoverId: popoverId,
    popoverContentRef: popoverContentRef,
    popoverTriggerId: popoverTriggerId,
    popoverTriggerRef: popoverTriggerRef,
    setMousePageX: setMousePageX,
    setMousePageY: setMousePageY,
    skidding: skidding,
    trigger: trigger
  });
  return jsx(PopoverContext.Provider, {
    value: context,
    children: runIfFn(children, context)
  });
};
Popover.displayName = 'Popover';

var pixelize$1 = function pixelize(value) {
  if (typeof value === 'string') {
    return value;
  }
  value = ensureNumber(value);
  return "".concat(value, "px");
};
var usePopoverArrowStyle = function usePopoverArrowStyle(_ref) {
  var _sizes$arrowHeightPro, _sizes$arrowWidthProp;
  var arrowHeightProp = _ref.arrowHeight,
    arrowWidthProp = _ref.arrowWidth;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var _useTheme = useTheme(),
    sizes = _useTheme.sizes;
  var arrowHeight = (_sizes$arrowHeightPro = sizes[arrowHeightProp]) !== null && _sizes$arrowHeightPro !== void 0 ? _sizes$arrowHeightPro : pixelize$1(arrowHeightProp);
  var arrowWidth = (_sizes$arrowWidthProp = sizes[arrowWidthProp]) !== null && _sizes$arrowWidthProp !== void 0 ? _sizes$arrowWidthProp : pixelize$1(arrowWidthProp);
  var dropShadowColor = {
    dark: 'rgba(0, 0, 0, 0.16)',
    light: 'rgba(0, 0, 0, 0.08)'
  }[colorMode];
  return {
    // https://popper.js.org/docs/v2/tutorial/#arrow
    '&[data-popper-placement^="top"]': {
      position: 'absolute',
      bottom: 0,
      '::before': {
        content: '""',
        borderTop: "".concat(arrowHeight, " solid"),
        borderLeft: "calc(".concat(arrowWidth, "/2) solid transparent"),
        borderRight: "calc(".concat(arrowWidth, "/2) solid transparent"),
        filter: "drop-shadow(0 1px 1px ".concat(dropShadowColor, ")"),
        position: 'absolute',
        bottom: "-".concat(arrowHeight),
        transform: 'translateX(-50%)'
      }
    },
    '&[data-popper-placement^="bottom"]': {
      position: 'absolute',
      top: 0,
      '::before': {
        content: '""',
        borderBottom: "".concat(arrowHeight, " solid"),
        borderLeft: "calc(".concat(arrowWidth, "/2) solid transparent"),
        borderRight: "calc(".concat(arrowWidth, "/2) solid transparent"),
        filter: "drop-shadow(0 -1px 1px ".concat(dropShadowColor, ")"),
        position: 'absolute',
        top: "-".concat(arrowHeight),
        transform: 'translateX(-50%)'
      }
    },
    '&[data-popper-placement^="left"]': {
      position: 'absolute',
      right: 0,
      '::before': {
        content: '""',
        borderLeft: "".concat(arrowHeight, " solid"),
        borderTop: "calc(".concat(arrowWidth, "/2) solid transparent"),
        borderBottom: "calc(".concat(arrowWidth, "/2) solid transparent"),
        filter: "drop-shadow(1px 0px 1px ".concat(dropShadowColor, ")"),
        position: 'absolute',
        right: "-".concat(arrowHeight),
        transform: 'translateY(-50%)'
      }
    },
    '&[data-popper-placement^="right"]': {
      position: 'absolute',
      left: 0,
      '::before': {
        content: '""',
        borderRight: "".concat(arrowHeight, " solid"),
        borderTop: "calc(".concat(arrowWidth, "/2) solid transparent"),
        borderBottom: "calc(".concat(arrowWidth, "/2) solid transparent"),
        filter: "drop-shadow(-1px 0px 1px ".concat(dropShadowColor, ")"),
        position: 'absolute',
        left: "-".concat(arrowHeight),
        transform: 'translateY(-50%)'
      }
    }
  };
};
var usePopoverTriggerStyle = function usePopoverTriggerStyle() {
  return {
    // The popover trigger style will be passed to the wrapper element when the "shouldWrapChildren" prop is set to true
  };
};
var usePopoverContentStyle = function usePopoverContentStyle(_ref2) {
  var _colorStyle$shadow;
  var tabIndex = _ref2.tabIndex;
  var _useColorMode3 = useColorMode(),
    _useColorMode4 = _slicedToArray(_useColorMode3, 1),
    colorMode = _useColorMode4[0];
  var _useColorStyle = useColorStyle({
      colorMode: colorMode
    }),
    _useColorStyle2 = _slicedToArray(_useColorStyle, 1),
    colorStyle = _useColorStyle2[0];
  var backgroundColor = {
    dark: 'gray:80',
    light: 'white'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  return {
    backgroundColor: backgroundColor,
    color: color,
    boxShadow: colorStyle === null || colorStyle === void 0 ? void 0 : (_colorStyle$shadow = colorStyle.shadow) === null || _colorStyle$shadow === void 0 ? void 0 : _colorStyle$shadow.thin,
    borderWidth: 1,
    fontSize: 'sm',
    lineHeight: 'sm',
    p: '3x',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 'sm',
    maxWidth: '288px',
    outline: tabIndex < 0 ? 0 : undefined // Remove the default outline for tabindex="-1"
  };
};

var usePopoverHeaderStyle = function usePopoverHeaderStyle() {
  var _useColorMode5 = useColorMode(),
    _useColorMode6 = _slicedToArray(_useColorMode5, 1),
    colorMode = _useColorMode6[0];
  var borderColor = {
    dark: 'rgba(255, 255, 255, 0.12)',
    light: 'rgba(0, 0, 0, 0.12)'
  }[colorMode];
  return {
    fontWeight: 'semibold',
    __after: {
      content: '""',
      display: 'block',
      borderTop: 1,
      borderColor: borderColor,
      my: '2x'
    }
  };
};
var usePopoverBodyStyle = function usePopoverBodyStyle() {
  return {};
};
var usePopoverFooterStyle = function usePopoverFooterStyle() {
  return {
    pt: '4x'
  };
};

var usePopover = function usePopover() {
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(PopoverContext);
  return context;
};

var _excluded$P = ["arrowHeight", "arrowWidth", "sx"];
var PopoverArrow = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$arrowHeight = _ref.arrowHeight,
    arrowHeight = _ref$arrowHeight === void 0 ? 8 : _ref$arrowHeight,
    _ref$arrowWidth = _ref.arrowWidth,
    arrowWidth = _ref$arrowWidth === void 0 ? 12 : _ref$arrowWidth,
    sx = _ref.sx,
    rest = _objectWithoutProperties(_ref, _excluded$P);
  var _usePopover = usePopover(),
    placement = _usePopover.placement,
    popoverContentRef = _usePopover.popoverContentRef;
  var popoverContentEl = popoverContentRef === null || popoverContentRef === void 0 ? void 0 : popoverContentRef.current;
  var styleProps = usePopoverArrowStyle({
    arrowHeight: arrowHeight,
    arrowWidth: arrowWidth
  });
  if (isHTMLElement(popoverContentEl)) {
    // Compute the background color of the first direct child of the popover content and apply it to the popover arrow
    var computedStyle = getComputedStyle(popoverContentEl.firstChild);
    styleProps.color = computedStyle === null || computedStyle === void 0 ? void 0 : computedStyle.backgroundColor;
  }
  return jsx(Box, _objectSpread2({
    ref: ref,
    role: "presentation"
    // The `data-popper-arrow` attribute is utilized by `popper/Popper.js` to designate the element used as the arrow
    ,
    "data-popper-arrow": true
    // The `data-popper-placement` attribute is automatically updated by `popper/Popper.js` to reflect the popper's actual placement
    ,
    "data-popper-placement": placement,
    sx: [styleProps].concat(_toConsumableArray(Array.isArray(sx) ? sx : [sx]))
  }, rest));
});
PopoverArrow.displayName = 'PopoverArrow';

var PopoverBody = /*#__PURE__*/forwardRef(function (props, ref) {
  var styleProps = usePopoverBodyStyle();
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), props));
});
PopoverBody.displayName = 'PopoverBody';

var _excluded$O = ["PopperArrowComponent", "PopperArrowProps", "PopperComponent", "PopperProps", "PopoverArrowComponent", "PopoverArrowProps", "TransitionComponent", "TransitionProps", "children", "onBlur", "onKeyDown", "onMouseEnter", "onMouseLeave"];
var mapPlacementToTransformOrigin$1 = function mapPlacementToTransformOrigin(placement) {
  return {
    'top': 'bottom center',
    'top-start': 'bottom left',
    'top-end': 'bottom right',
    'bottom': 'top center',
    'bottom-start': 'top left',
    'bottom-end': 'top right',
    'left': 'right center',
    'left-start': 'right top',
    'left-end': 'right bottom',
    'right': 'left center',
    'right-start': 'left top',
    'right-end': 'left bottom'
  }[placement];
};
var PopoverContent = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var PopperArrowComponent = _ref.PopperArrowComponent,
    PopperArrowProps = _ref.PopperArrowProps,
    _ref$PopperComponent = _ref.PopperComponent,
    PopperComponent = _ref$PopperComponent === void 0 ? Popper : _ref$PopperComponent,
    PopperProps = _ref.PopperProps,
    _ref$PopoverArrowComp = _ref.PopoverArrowComponent,
    PopoverArrowComponent = _ref$PopoverArrowComp === void 0 ? PopoverArrow : _ref$PopoverArrowComp,
    PopoverArrowProps = _ref.PopoverArrowProps,
    _ref$TransitionCompon = _ref.TransitionComponent,
    TransitionComponent = _ref$TransitionCompon === void 0 ? Grow : _ref$TransitionCompon,
    TransitionProps = _ref.TransitionProps,
    _children = _ref.children,
    onBlurProp = _ref.onBlur,
    onKeyDownProp = _ref.onKeyDown,
    onMouseEnterProp = _ref.onMouseEnter,
    onMouseLeaveProp = _ref.onMouseLeave,
    rest = _objectWithoutProperties(_ref, _excluded$O);
  {
    // deprecation warning
    var prefix = "".concat(PopoverContent.displayName, ":");
    useOnceWhen(function () {
      warnRemovedProps('PopperArrowComponent', {
        prefix: prefix,
        alternative: 'PopoverArrowComponent'
      });
    }, PopperArrowComponent !== undefined);
    useOnceWhen(function () {
      warnDeprecatedProps('PopperArrowProps', {
        prefix: prefix,
        alternative: 'PopoverArrowProps',
        willRemove: true
      });
    }, PopperArrowProps !== undefined);
    PopoverArrowProps = _objectSpread2(_objectSpread2({}, PopperArrowProps), PopoverArrowProps);
  }
  var isHydrated = useHydrated();
  var nodeRef = useRef(null);
  var combinedRef = useMergeRefs(nodeRef, ref);
  var _usePopover = usePopover(),
    arrow = _usePopover.arrow,
    closeOnBlur = _usePopover.closeOnBlur,
    closeOnEsc = _usePopover.closeOnEsc,
    disabled = _usePopover.disabled,
    followCursor = _usePopover.followCursor,
    isHoveringContentRef = _usePopover.isHoveringContentRef,
    isHoveringTriggerRef = _usePopover.isHoveringTriggerRef,
    isOpen = _usePopover.isOpen,
    mousePageX = _usePopover.mousePageX,
    mousePageY = _usePopover.mousePageY,
    nextToCursor = _usePopover.nextToCursor,
    offset = _usePopover.offset,
    closePopover = _usePopover.onClose,
    placement = _usePopover.placement,
    popoverId = _usePopover.popoverId,
    popoverContentRef = _usePopover.popoverContentRef,
    popoverTriggerId = _usePopover.popoverTriggerId,
    popoverTriggerRef = _usePopover.popoverTriggerRef,
    trigger = _usePopover.trigger;
  var role = {
    'click': 'dialog',
    'hover': 'tooltip'
  }[trigger];
  var tabIndex = -1;
  var styleProps = usePopoverContentStyle({
    tabIndex: tabIndex
  });
  var mouseLeaveTimeoutRef = useRef();
  var eventHandler = {};
  eventHandler.onKeyDown = function (event) {
    if (event.key === 'Escape' && closeOnEsc) {
      ensureFunction(closePopover)();
    }
  };
  if (trigger === 'click') {
    eventHandler.onBlur = function (event) {
      var _popoverTriggerRef$cu, _popoverTriggerRef$cu2, _popoverContentRef$cu, _popoverContentRef$cu2;
      // https://developer.mozilla.org/en-US/docs/Web/API/FocusEvent/relatedTarget
      // The relatedTarget property represents the `EventTarget` receiving focus or losing focus during a `blur` or `focus` event, respectively.
      var focusTarget = event.relatedTarget || document.activeElement; // `relatedTarget` is the `EventTarget` receiving focus (if any)
      var isOutsidePopoverTrigger = !((_popoverTriggerRef$cu = popoverTriggerRef.current) !== null && _popoverTriggerRef$cu !== void 0 && (_popoverTriggerRef$cu2 = _popoverTriggerRef$cu.contains) !== null && _popoverTriggerRef$cu2 !== void 0 && _popoverTriggerRef$cu2.call(_popoverTriggerRef$cu, focusTarget));
      var isOutsidePopoverContent = !((_popoverContentRef$cu = popoverContentRef.current) !== null && _popoverContentRef$cu !== void 0 && (_popoverContentRef$cu2 = _popoverContentRef$cu.contains) !== null && _popoverContentRef$cu2 !== void 0 && _popoverContentRef$cu2.call(_popoverContentRef$cu, focusTarget));
      var shouldClose = isOpen && closeOnBlur && !!focusTarget && isOutsidePopoverTrigger && isOutsidePopoverContent;
      if (shouldClose) {
        ensureFunction(closePopover)();
      }
    };
  }
  if (trigger === 'hover') {
    eventHandler.onMouseEnter = function (event) {
      isHoveringContentRef.current = true;
      if (mouseLeaveTimeoutRef.current) {
        clearTimeout(mouseLeaveTimeoutRef.current);
        mouseLeaveTimeoutRef.current = undefined;
      }
    };
    eventHandler.onMouseLeave = function (event) {
      isHoveringContentRef.current = false;
      if (mouseLeaveTimeoutRef.current) {
        clearTimeout(mouseLeaveTimeoutRef.current);
        mouseLeaveTimeoutRef.current = undefined;
      }
      mouseLeaveTimeoutRef.current = setTimeout(function () {
        mouseLeaveTimeoutRef.current = undefined;
        if (!isHoveringContentRef.current && !isHoveringTriggerRef.current) {
          ensureFunction(closePopover)();
        }
      }, 100); // XXX: keep opening popover when cursor quickly move between trigger and content
    };
  }

  var popoverTriggerElement = popoverTriggerRef.current;
  var _ensureArray = ensureArray(offset),
    _ensureArray2 = _slicedToArray(_ensureArray, 2),
    _ensureArray2$ = _ensureArray2[0],
    skidding = _ensureArray2$ === void 0 ? 0 : _ensureArray2$,
    _ensureArray2$2 = _ensureArray2[1],
    distance = _ensureArray2$2 === void 0 ? 12 : _ensureArray2$2;
  var _useMemo = useMemo(function () {
      var _skidding = skidding;
      var _distance = distance;
      if (isHTMLElement(popoverTriggerElement) && (followCursor || nextToCursor)) {
        var offsetHeight = popoverTriggerElement.offsetHeight;
        var leftmostOffset = getLeftmostOffset(popoverTriggerElement);
        var topmostOffset = getTopmostOffset(popoverTriggerElement);
        _skidding = mousePageX - leftmostOffset + 10;
        _distance = mousePageY - topmostOffset - offsetHeight + 15;
      }
      return [_skidding, _distance];
    }, [skidding, distance, popoverTriggerElement, followCursor, nextToCursor, mousePageX, mousePageY]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    computedSkidding = _useMemo2[0],
    computedDistance = _useMemo2[1];
  var popperModifiers = useMemo(function () {
    var modifiers = [{
      // https://popper.js.org/docs/v2/modifiers/offset/
      name: 'offset',
      options: {
        offset: [computedSkidding, computedDistance]
      }
    }];
    return modifiers;
  }, [computedSkidding, computedDistance]);
  if (!isHydrated) {
    return null;
  }
  if (disabled) {
    return null;
  }
  if (!_children || isBlankString(_children) || isEmptyArray(_children)) {
    // TOOD: Objects are not valid as a React child
    return null;
  }
  return jsx(PopperComponent, _objectSpread2(_objectSpread2({
    "aria-hidden": ariaAttr(!isOpen),
    "aria-labelledby": popoverTriggerId,
    anchorEl: popoverTriggerRef.current // TODO: rename to `referenceRef` in a future release
    ,
    id: popoverId,
    isOpen: isOpen,
    placement: placement,
    ref: popoverContentRef,
    role: role,
    unmountOnExit: true,
    usePortal: false // Pass `true` in `PopperProps` to render popover in a portal
    ,
    willUseTransition: true,
    zIndex: "popover"
  }, PopperProps), {}, {
    modifiers: [].concat(_toConsumableArray(popperModifiers), _toConsumableArray(ensureArray(PopperProps === null || PopperProps === void 0 ? void 0 : PopperProps.modifiers))),
    children: function children(_ref2) {
      var placement = _ref2.placement,
        transition = _ref2.transition;
      var _transition = _objectSpread2({}, transition),
        inProp = _transition["in"],
        onEnter = _transition.onEnter,
        onExited = _transition.onExited;
      return jsx(TransitionComponent, _objectSpread2(_objectSpread2({
        appear: true
      }, TransitionProps), {}, {
        ref: combinedRef,
        "in": inProp,
        onEnter: callAll(onEnter, TransitionProps === null || TransitionProps === void 0 ? void 0 : TransitionProps.onEnter, function (event) {
          // set focus on the popover content
          if (inProp && trigger === 'click') {
            requestAnimationFrame(function () {
              nodeRef.current && nodeRef.current.focus();
            });
          }
        }),
        onExited: callAll(onExited, TransitionProps === null || TransitionProps === void 0 ? void 0 : TransitionProps.onExited),
        children: function children(state, _ref3) {
          var ref = _ref3.ref,
            transitionStyle = _ref3.style;
          return jsxs(Box, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
            onBlur: callEventHandlers(onBlurProp, eventHandler.onBlur),
            onKeyDown: callEventHandlers(onKeyDownProp, eventHandler.onKeyDown),
            onMouseEnter: callEventHandlers(onMouseEnterProp, eventHandler.onMouseEnter),
            onMouseLeave: callEventHandlers(onMouseLeaveProp, eventHandler.onMouseLeave),
            ref: ref,
            tabIndex: tabIndex
          }, styleProps), transitionStyle), {}, {
            transformOrigin: mapPlacementToTransformOrigin$1(placement)
          }, rest), {}, {
            children: [!!arrow && jsx(PopoverArrowComponent, _objectSpread2({}, PopoverArrowProps)), _children]
          }));
        }
      }));
    }
  }));
});
PopoverContent.displayName = 'PopoverContent';

var PopoverFooter = /*#__PURE__*/forwardRef(function (props, ref) {
  var styleProps = usePopoverFooterStyle();
  return jsx(Box, _objectSpread2(_objectSpread2({
    as: "footer",
    ref: ref
  }, styleProps), props));
});
PopoverFooter.displayName = 'PopoverFooter';

var PopoverHeader = /*#__PURE__*/forwardRef(function (props, ref) {
  var styleProps = usePopoverHeaderStyle();
  return jsx(Box, _objectSpread2(_objectSpread2({
    as: "header",
    ref: ref
  }, styleProps), props));
});
PopoverHeader.displayName = 'PopoverHeader';

var _excluded$N = ["children", "shouldWrapChildren", "onBlur", "onClick", "onFocus", "onKeyDown", "onMouseEnter", "onMouseLeave", "onMouseMove"];
var PopoverTrigger = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$shouldWrapChildr = _ref.shouldWrapChildren,
    shouldWrapChildren = _ref$shouldWrapChildr === void 0 ? false : _ref$shouldWrapChildr,
    onBlurProp = _ref.onBlur,
    onClickProp = _ref.onClick,
    onFocusProp = _ref.onFocus,
    onKeyDownProp = _ref.onKeyDown,
    onMouseEnterProp = _ref.onMouseEnter,
    onMouseLeaveProp = _ref.onMouseLeave,
    onMouseMoveProp = _ref.onMouseMove,
    rest = _objectWithoutProperties(_ref, _excluded$N);
  var _usePopover = usePopover(),
    followCursor = _usePopover.followCursor,
    isHoveringContentRef = _usePopover.isHoveringContentRef,
    isHoveringTriggerRef = _usePopover.isHoveringTriggerRef,
    isOpen = _usePopover.isOpen,
    onClose = _usePopover.onClose,
    onOpen = _usePopover.onOpen,
    popoverId = _usePopover.popoverId,
    popoverTriggerId = _usePopover.popoverTriggerId,
    popoverTriggerRef = _usePopover.popoverTriggerRef,
    setMousePageX = _usePopover.setMousePageX,
    setMousePageY = _usePopover.setMousePageY,
    trigger = _usePopover.trigger;
  var combinedRef = useMergeRefs(popoverTriggerRef, ref);
  var styleProps = usePopoverTriggerStyle();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    enableMouseMove = _useState2[0],
    setEnableMouseMove = _useState2[1];
  var mouseLeaveTimeoutRef = useRef();
  var eventHandler = {};
  if (trigger === 'click') {
    eventHandler.onClick = function (event) {
      if (isOpen) {
        onClose();
      } else {
        onOpen();
      }
    };
    eventHandler.onKeyDown = function (event) {
      if (event.key === 'Enter') {
        onOpen();
      }
    };
  }
  if (trigger === 'hover') {
    eventHandler.onBlur = function (event) {
      onClose();
    };
    eventHandler.onFocus = function (event) {
      onOpen();
    };
    eventHandler.onKeyDown = function (event) {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    eventHandler.onMouseEnter = function (event) {
      isHoveringTriggerRef.current = true;
      if (mouseLeaveTimeoutRef.current) {
        clearTimeout(mouseLeaveTimeoutRef.current);
        mouseLeaveTimeoutRef.current = undefined;
      }
      setEnableMouseMove(true); // track mouse movement
      onOpen(function () {
        // callback
        setEnableMouseMove(followCursor); // after the enter delay, track mouse movement only if "followCursor" is true
      });
    };

    eventHandler.onMouseLeave = function (event) {
      isHoveringTriggerRef.current = false;
      if (mouseLeaveTimeoutRef.current) {
        clearTimeout(mouseLeaveTimeoutRef.current);
        mouseLeaveTimeoutRef.current = undefined;
      }
      mouseLeaveTimeoutRef.current = setTimeout(function () {
        mouseLeaveTimeoutRef.current = undefined;
        if (!isHoveringContentRef.current && !isHoveringTriggerRef.current) {
          onClose(function () {
            // callback
            setEnableMouseMove(true);
          });
        }
      }, 100); // XXX: keep opening popover when cursor quickly move between trigger and content
    };

    eventHandler.onMouseMove = function (event) {
      if (enableMouseMove || followCursor) {
        setMousePageX(event.pageX);
        setMousePageY(event.pageY);
      }
    };
  }

  /**
   * This allows for catching the "mouseleave" event when the popover trigger is disabled.
   * There is currently a known issue in React regarding the onMouseLeave polyfill.
   * @see https://github.com/facebook/react/issues/11972
   */
  useEventListener(function () {
    return popoverTriggerRef.current;
  }, 'mouseleave', eventHandler.onMouseLeave);
  var getPopoverTriggerProps = function getPopoverTriggerProps() {
    var ownProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ownRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2(_objectSpread2(_objectSpread2({}, ownProps), {}, {
      'aria-haspopup': 'dialog',
      'aria-controls': popoverId,
      'aria-describedby': isOpen ? popoverId : undefined,
      'aria-expanded': ariaAttr(isOpen),
      id: popoverTriggerId,
      onBlur: callEventHandlers(ownProps === null || ownProps === void 0 ? void 0 : ownProps.onBlur, onBlurProp, eventHandler.onBlur),
      onClick: callEventHandlers(ownProps === null || ownProps === void 0 ? void 0 : ownProps.onClick, onClickProp, eventHandler.onClick),
      onFocus: callEventHandlers(ownProps === null || ownProps === void 0 ? void 0 : ownProps.onFocus, onFocusProp, eventHandler.onFocus),
      onKeyDown: callEventHandlers(ownProps === null || ownProps === void 0 ? void 0 : ownProps.onKeyDown, onKeyDownProp, eventHandler.onKeyDown),
      onMouseEnter: callEventHandlers(ownProps === null || ownProps === void 0 ? void 0 : ownProps.onMouseEnter, onMouseEnterProp, eventHandler.onMouseEnter),
      onMouseLeave: callEventHandlers(ownProps === null || ownProps === void 0 ? void 0 : ownProps.onMouseLeave, onMouseLeaveProp, eventHandler.onMouseLeave),
      onMouseMove: callEventHandlers(ownProps === null || ownProps === void 0 ? void 0 : ownProps.onMouseMove, onMouseMoveProp, eventHandler.onMouseMove),
      ref: mergeRefs(combinedRef, ownRef)
    }, styleProps), rest);
  };
  if (typeof children === 'function') {
    return children({
      getPopoverTriggerProps: getPopoverTriggerProps
    });
  }
  if (shouldWrapChildren) {
    return jsx(Box, _objectSpread2(_objectSpread2({}, getPopoverTriggerProps()), {}, {
      children: children
    }));
  }

  // Ensure popover has only one child node
  var child = React.Children.only(children);
  var popoverTriggerProps = getPopoverTriggerProps(child === null || child === void 0 ? void 0 : child.props, child === null || child === void 0 ? void 0 : child.ref);
  return /*#__PURE__*/cloneElement(child, popoverTriggerProps);
});
PopoverTrigger.displayName = 'PopoverTrigger';

Popover.Arrow = PopoverArrow;
Popover.Header = PopoverHeader;
Popover.Body = PopoverBody;
Popover.Content = PopoverContent;
Popover.Footer = PopoverFooter;
Popover.Header = PopoverHeader;
Popover.Trigger = PopoverTrigger;

var _templateObject$2;
var indeterminateProgressAnimation = keyframes(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  0% {\n    left: -40%;\n    right: 100%;\n  }\n  60% {\n    left: 100%;\n    right: -40%;\n  }\n  100% {\n    left: 100%;\n    right: -40%;\n  }\n"])));
var useLinearProgressStyle = function useLinearProgressStyle(_ref) {
  var size = _ref.size;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var backgroundColor = {
    dark: 'rgba(255, 255, 255, 0.12)',
    light: 'rgba(0, 0, 0, 0.12)'
  }[colorMode];
  var height = {
    'xs': '1h',
    'sm': '1x',
    'md': '2x',
    'lg': '3x'
  }[size];
  return {
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: backgroundColor,
    height: height
  };
};
var useLinearProgressBarStyle = function useLinearProgressBarStyle(_ref2) {
  var variant = _ref2.variant,
    color = _ref2.color;
  var theme = useTheme();
  var colors = ensureArray(color).map(function (c) {
    var _theme$colors$c, _theme$colors;
    // "blue"          => "blue"
    // "blue:60"       => "#1e5ede"
    // "black"         => "black"
    // "black:primary" => "rgba(0, 0, 0, .92)"
    return (_theme$colors$c = theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors[c]) !== null && _theme$colors$c !== void 0 ? _theme$colors$c : c;
  });
  if (variant === 'determinate') {
    return {
      position: 'absolute',
      inset: 0,
      background: colors.length > 1 ? "linear-gradient(90deg,".concat(colors.join(','), ")") : colors[0],
      transition: createTransitionStyle('all', {
        duration: 200,
        easing: 'linear'
      })
    };
  }
  if (variant === 'indeterminate') {
    return {
      position: 'absolute',
      inset: 0,
      animation: "".concat(indeterminateProgressAnimation, " 1.6s linear .5s infinite"),
      background: colors.length > 1 ? "linear-gradient(90deg,".concat(colors.join(','), ")") : colors[0],
      transition: createTransitionStyle('all', {
        duration: 200,
        easing: 'linear'
      })
    };
  }
  return {};
};

var _excluded$M = ["aria-label", "aria-labelledby", "color", "min", "max", "size", "value", "variant"];
var defaultSize$5 = 'sm';
var defaultVariant$6 = 'indeterminate';
var LinearProgress = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var ariaLabel = _ref['aria-label'],
    ariaLabelledBy = _ref['aria-labelledby'],
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'blue:60' : _ref$color,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaultSize$5 : _ref$size,
    value = _ref.value,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? defaultVariant$6 : _ref$variant,
    rest = _objectWithoutProperties(_ref, _excluded$M);
  var progressStyleProps = useLinearProgressStyle({
    size: size
  });
  var progressbarStyleProps = useLinearProgressBarStyle({
    color: color,
    variant: variant
  });
  var progressbarProps = {
    'aria-valuemin': min,
    'aria-valuemax': max,
    'aria-valuenow': variant === 'determinate' ? value : undefined,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy,
    role: 'progressbar'
  };
  if (variant === 'determinate') {
    if (process.env.NODE_ENV !== 'production' && value === undefined) {
      console.error('You need to provide a value prop when using the determinate variant of LinearProgress.');
    }
    var scale = (ensureFiniteNumber(value) - min) / (max - min);
    progressbarProps.style = _objectSpread2(_objectSpread2({}, progressbarProps.style), {}, {
      clipPath: "inset(0 ".concat((1 - scale) * 100, "% 0 0)")
    });
  }
  return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
    ref: ref
  }, progressStyleProps), rest), {}, {
    children: jsx(Box, _objectSpread2(_objectSpread2({}, progressbarStyleProps), progressbarProps))
  }));
});

var TonicProvider = function TonicProvider(_ref) {
  var _colorModeProps, _colorStyleProps;
  var children = _ref.children,
    colorModeProps = _ref.colorMode,
    colorStyleProps = _ref.colorStyle,
    theme = _ref.theme,
    _ref$useCSSBaseline = _ref.useCSSBaseline,
    useCSSBaseline = _ref$useCSSBaseline === void 0 ? false : _ref$useCSSBaseline;
  colorModeProps = (_colorModeProps = colorModeProps) !== null && _colorModeProps !== void 0 ? _colorModeProps : {};
  colorStyleProps = (_colorStyleProps = colorStyleProps) !== null && _colorStyleProps !== void 0 ? _colorStyleProps : {};
  if (_typeof(colorModeProps) !== 'object') {
    console.error('TonicProvider: "colorMode" prop must be an object if provided.\n' + 'See https://trendmicro-frontend.github.io/tonic-ui for more information.');
  }
  if (_typeof(colorStyleProps) !== 'object') {
    console.error('TonicProvider: "colorStyle" prop must be an object if provided.\n' + 'See https://trendmicro-frontend.github.io/tonic-ui for more information.');
  }
  return jsx(ThemeProvider, {
    theme: theme,
    children: jsx(ColorModeProvider, _objectSpread2(_objectSpread2({}, colorModeProps), {}, {
      children: jsxs(ColorStyleProvider, _objectSpread2(_objectSpread2({}, colorStyleProps), {}, {
        children: [!!useCSSBaseline && jsx(CSSBaseline, {}), children]
      }))
    }))
  });
};

var defaultSize$4 = 'md';
var defaultVariantColor$1 = 'blue';

var useRadioStyle = function useRadioStyle(_ref) {
  var disabled = _ref.disabled;
  return {
    display: 'inline-flex',
    verticalAlign: 'top',
    alignItems: 'center',
    cursor: disabled ? 'not-allowed' : 'pointer'
  };
};
var useRadioControlBoxStyle = function useRadioControlBoxStyle(_ref2) {
  var color = _ref2.color,
    width = _ref2.width,
    height = _ref2.height;
  var theme = useTheme();
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var baseStyle = {
    userSelect: 'none',
    border: 1,
    borderRadius: 'circle',
    transition: 'background-color 120ms, box-shadow 250ms',
    width: width,
    height: height
  };
  var getInteractionStyle = function getInteractionStyle(_ref3) {
    var _theme$colors;
    var color = _ref3.color;
    // icon color
    var _color = {
      dark: "".concat(color, ":60"),
      light: "".concat(color, ":60")
    }[colorMode];
    var hoverColor = {
      dark: "".concat(color, ":50"),
      light: "".concat(color, ":50")
    }[colorMode];
    var disabledColor = {
      dark: 'gray:60',
      light: 'gray:40'
    }[colorMode];

    // border color
    var borderColor = {
      dark: 'gray:50',
      light: 'gray:40'
    }[colorMode];
    var hoverBorderColor = {
      dark: "".concat(color, ":50"),
      light: "".concat(color, ":50")
    }[colorMode];
    var disabledBorderColor = {
      dark: 'gray:60',
      light: 'gray:40'
    }[colorMode];
    var checkedBorderColor = {
      dark: "".concat(color, ":60"),
      light: "".concat(color, ":60")
    }[colorMode];
    var checkedAndHoverBorderColor = hoverBorderColor;
    var checkedAndDisabledBorderColor = disabledBorderColor;

    // focus color
    var focusOutlineColor = {
      dark: "".concat(color, ":60"),
      light: "".concat(color, ":60")
    }[colorMode];
    return {
      borderColor: borderColor,
      _hover: {
        borderColor: hoverBorderColor
      },
      _focus: {
        boxShadow: "0 0 0 2px ".concat(theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors[focusOutlineColor])
      },
      _disabled: {
        borderColor: disabledBorderColor,
        opacity: 0.28
      },
      _checked: {
        borderColor: checkedBorderColor,
        color: _color
      },
      _checkedAndHover: {
        borderColor: checkedAndHoverBorderColor,
        color: hoverColor
      },
      _checkedAndDisabled: {
        borderColor: checkedAndDisabledBorderColor,
        color: disabledColor,
        opacity: 0.28
      }
    };
  };
  return _objectSpread2(_objectSpread2({}, baseStyle), getInteractionStyle({
    color: color
  }));
};

var _excluded$L = ["size", "variantColor"];
var RadioControlBox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaultSize$4 : _ref$size,
    _ref$variantColor = _ref.variantColor,
    variantColor = _ref$variantColor === void 0 ? defaultVariantColor$1 : _ref$variantColor;
    _objectWithoutProperties(_ref, _excluded$L);
  var _useTheme = useTheme(),
    sizes = _useTheme.sizes;
  var width = {
    lg: '6x',
    md: '4x',
    sm: '3x'
  }[size];
  var height = {
    lg: '6x',
    md: '4x',
    sm: '3x'
  }[size];
  var iconWidth = "calc(".concat(sizes[width], " / 2)");
  var iconHeight = "calc(".concat(sizes[height], " / 2)");
  var styleProps = useRadioControlBoxStyle({
    color: variantColor,
    width: width,
    height: height
  });
  return jsx(ControlBox, _objectSpread2(_objectSpread2({
    type: "radio"
  }, styleProps), {}, {
    children: jsx(Box, {
      backgroundColor: "currentColor",
      borderRadius: "circle",
      display: "inline-flex",
      width: iconWidth,
      height: iconHeight
    })
  }));
});
RadioControlBox.displayName = 'RadioControlBox';

var RadioGroupContext = /*#__PURE__*/createContext();

var useRadioGroup = function useRadioGroup() {
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(RadioGroupContext);
  return context;
};

var _excluded$K = ["checked", "children", "defaultChecked", "disabled", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onClick", "onFocus", "size", "value", "variantColor"];
var Radio = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var checked = _ref.checked,
    children = _ref.children,
    defaultChecked = _ref.defaultChecked,
    disabled = _ref.disabled,
    id = _ref.id,
    inputProps = _ref.inputProps,
    inputRef = _ref.inputRef,
    name = _ref.name,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    size = _ref.size,
    value = _ref.value,
    variantColor = _ref.variantColor,
    rest = _objectWithoutProperties(_ref, _excluded$K);
  var combinedInputRef = useMergeRefs(ref, inputRef); // TODO: Move the `ref` to the outermost element in the next major version
  var styleProps = useRadioStyle({
    disabled: disabled
  });
  var radioGroupContext = useRadioGroup();
  if (radioGroupContext) {
    var _ref2, _size, _ref3, _variantColor;
    var _radioGroupContext = _objectSpread2({}, radioGroupContext),
      radioGroupDisabled = _radioGroupContext.disabled,
      radioGroupName = _radioGroupContext.name,
      radioGroupSize = _radioGroupContext.size,
      radioGroupValue = _radioGroupContext.value,
      radioGroupVariantColor = _radioGroupContext.variantColor,
      radioGroupOnChange = _radioGroupContext.onChange;
    if (radioGroupValue !== undefined) {
      checked = radioGroupValue === value;
    }
    disabled = radioGroupDisabled || disabled;
    name = radioGroupName !== null && radioGroupName !== void 0 ? radioGroupName : name;
    onChange = callAll(onChange, radioGroupOnChange);
    // Use the default value if the value is null or undefined
    size = (_ref2 = (_size = size) !== null && _size !== void 0 ? _size : radioGroupSize) !== null && _ref2 !== void 0 ? _ref2 : defaultSize$4;
    variantColor = (_ref3 = (_variantColor = variantColor) !== null && _variantColor !== void 0 ? _variantColor : radioGroupVariantColor) !== null && _ref3 !== void 0 ? _ref3 : defaultVariantColor$1;
  } else {
    var _size2, _variantColor2;
    // Use the default value if the value is null or undefined
    size = (_size2 = size) !== null && _size2 !== void 0 ? _size2 : defaultSize$4;
    variantColor = (_variantColor2 = variantColor) !== null && _variantColor2 !== void 0 ? _variantColor2 : defaultVariantColor$1;
  }
  return jsxs(Box, _objectSpread2(_objectSpread2(_objectSpread2({
    as: "label"
  }, styleProps), rest), {}, {
    children: [jsx(VisuallyHidden, _objectSpread2({
      as: "input",
      checked: checked,
      defaultChecked: defaultChecked,
      disabled: disabled,
      id: id,
      name: name,
      onBlur: onBlur,
      onChange: onChange,
      onClick: onClick,
      onFocus: onFocus,
      ref: combinedInputRef,
      type: "radio",
      value: value
    }, inputProps)), jsx(RadioControlBox, {
      size: size,
      variantColor: variantColor
    }), !isNullish(children) && jsx(Box, {
      ml: "2x",
      userSelect: "none",
      opacity: disabled ? 0.28 : 1,
      children: children
    })]
  }));
});
Radio.displayName = 'Radio';

var getMemoizedState$9 = memoize(function (state) {
  return _objectSpread2({}, state);
});
var RadioGroup = function RadioGroup(_ref) {
  var _name;
  var children = _ref.children,
    defaultValue = _ref.defaultValue,
    disabled = _ref.disabled,
    name = _ref.name,
    size = _ref.size,
    valueProp = _ref.value,
    variantColor = _ref.variantColor,
    onChange = _ref.onChange;
  var defaultId = useAutoId();
  name = (_name = name) !== null && _name !== void 0 ? _name : "".concat(config.name, ":RadioGroup-").concat(defaultId);
  var _useState = useState({
      value: valueProp !== null && valueProp !== void 0 ? valueProp : defaultValue
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    if (valueProp !== undefined) {
      setState({
        value: valueProp
      });
    }
  }, [valueProp]);
  var handleChange = function handleChange(event) {
    var nextValue = event.target.value;
    if (valueProp !== undefined) {
      setState({
        value: valueProp
      });
    } else {
      setState({
        value: nextValue
      });
    }
    if (typeof onChange === 'function') {
      onChange(nextValue);
    }
  };
  var context = getMemoizedState$9({
    disabled: disabled,
    name: name,
    onChange: handleChange,
    size: size,
    value: state.value,
    variantColor: variantColor
  });
  return jsx(RadioGroupContext.Provider, {
    value: context,
    children: runIfFn(children, context)
  });
};
RadioGroup.displayName = 'RadioGroup';

var useResizeHandleStyle = function useResizeHandleStyle(_ref) {
  var isResizing = _ref.isResizing;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var translucentBackgroundColor = {
    dark: 'rgba(255, 255, 255, 0.12)',
    light: 'rgba(0, 0, 0, 0.12)'
  }[colorMode];
  var hoverableWidth = '2x';
  var translucentWidth = '1x';
  return {
    backgroundColor: isResizing ? translucentBackgroundColor : 'transparent',
    boxSizing: isResizing ? 'content-box' : 'border-box',
    cursor: 'col-resize',
    touchAction: 'none',
    userSelect: 'none',
    width: isResizing ? translucentWidth : hoverableWidth
  };
};

var getIsPassiveListenerSupported = function getIsPassiveListenerSupported() {
  var isPassiveListenerSupported = null;
  return function () {
    if (typeof isPassiveListenerSupported === 'boolean') {
      return isPassiveListenerSupported;
    }
    try {
      var options = {
        get passive() {
          isPassiveListenerSupported = true;
          return false;
        }
      };
      var noop = function noop() {};
      window.addEventListener('test', noop, options);
      window.removeEventListener('test', noop);
    } catch (error) {
      isPassiveListenerSupported = false;
    }
    return isPassiveListenerSupported;
  };
};

var _excluded$J = ["onMouseDown", "onResize", "onResizeEnd", "onResizeStart", "onTouchStart"];
var ResizeHandle = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var onMouseDownProp = _ref.onMouseDown,
    onResizeProp = _ref.onResize,
    onResizeEndProp = _ref.onResizeEnd,
    onResizeStartProp = _ref.onResizeStart,
    onTouchStartProp = _ref.onTouchStart,
    rest = _objectWithoutProperties(_ref, _excluded$J);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isResizing = _useState2[0],
    setIsResizing = _useState2[1];
  var styleProps = useResizeHandleStyle({
    isResizing: isResizing
  });
  var onMouseDown = useCallback(function (event) {
    var _eventHandler;
    var clientX = event.clientX;
    var clientY = event.clientY;
    onResizeStartProp === null || onResizeStartProp === void 0 ? void 0 : onResizeStartProp({
      clientX: clientX,
      clientY: clientY
    });
    setIsResizing(true);
    var moveEvent = 'mousemove';
    var endEvent = 'mouseup';
    var eventHandler = (_eventHandler = {}, _defineProperty(_eventHandler, moveEvent, function (event) {
      var clientX = event.clientX;
      var clientY = event.clientY;
      onResizeProp === null || onResizeProp === void 0 ? void 0 : onResizeProp({
        clientX: clientX,
        clientY: clientY
      });
    }), _defineProperty(_eventHandler, endEvent, function (event) {
      document.removeEventListener('mousemove', eventHandler[moveEvent]);
      document.removeEventListener('mouseup', eventHandler[endEvent]);
      setIsResizing(false);
      var clientX = event.clientX;
      var clientY = event.clientY;
      onResizeEndProp === null || onResizeEndProp === void 0 ? void 0 : onResizeEndProp({
        clientX: clientX,
        clientY: clientY
      });
    }), _eventHandler);
    var addEventListenerOptions = getIsPassiveListenerSupported() ? {
      passive: false
    } : false;
    document.addEventListener('mousemove', eventHandler[moveEvent], addEventListenerOptions);
    document.addEventListener('mouseup', eventHandler[endEvent], addEventListenerOptions);
  }, [onResizeProp, onResizeEndProp, onResizeStartProp]);
  var onTouchStart = useCallback(function (event) {
    var _event$touches$, _event$touches$2, _eventHandler2;
    var isTouchStartEvent = event.type === 'touchstart';
    if (isTouchStartEvent) {
      // Do not respond to multi-touch events (e.g. 2 or more fingers)
      if (Array.isArray(event.touches) && event.touches.length > 1) {
        return;
      }
    }
    var clientX = Array.isArray(event.touches) ? (_event$touches$ = event.touches[0]) === null || _event$touches$ === void 0 ? void 0 : _event$touches$.clientX : undefined;
    var clientY = Array.isArray(event.touches) ? (_event$touches$2 = event.touches[0]) === null || _event$touches$2 === void 0 ? void 0 : _event$touches$2.clientY : undefined;
    onResizeStartProp === null || onResizeStartProp === void 0 ? void 0 : onResizeStartProp({
      clientX: clientX,
      clientY: clientY
    });
    setIsResizing(true);
    var moveEvent = 'touchmove';
    var endEvent = 'touchend';
    var eventHandler = (_eventHandler2 = {}, _defineProperty(_eventHandler2, moveEvent, function (event) {
      var _event$touches$3, _event$touches$4;
      if (event.cancelable) {
        event.preventDefault();
        event.stopPropagation();
      }
      var clientX = Array.isArray(event.touches) ? (_event$touches$3 = event.touches[0]) === null || _event$touches$3 === void 0 ? void 0 : _event$touches$3.clientX : undefined;
      var clientY = Array.isArray(event.touches) ? (_event$touches$4 = event.touches[0]) === null || _event$touches$4 === void 0 ? void 0 : _event$touches$4.clientY : undefined;
      onResizeProp === null || onResizeProp === void 0 ? void 0 : onResizeProp({
        clientX: clientX,
        clientY: clientY
      });
      return false;
    }), _defineProperty(_eventHandler2, endEvent, function (event) {
      var _event$touches$5, _event$touches$6;
      document.removeEventListener('touchmove', eventHandler[moveEvent]);
      document.removeEventListener('touchend', eventHandler[endEvent]);
      if (event.cancelable) {
        event.preventDefault();
        event.stopPropagation();
      }
      setIsResizing(false);
      var clientX = Array.isArray(event.touches) ? (_event$touches$5 = event.touches[0]) === null || _event$touches$5 === void 0 ? void 0 : _event$touches$5.clientX : undefined;
      var clientY = Array.isArray(event.touches) ? (_event$touches$6 = event.touches[0]) === null || _event$touches$6 === void 0 ? void 0 : _event$touches$6.clientY : undefined;
      onResizeEndProp === null || onResizeEndProp === void 0 ? void 0 : onResizeEndProp({
        clientX: clientX,
        clientY: clientY
      });
    }), _eventHandler2);
    var addEventListenerOptions = getIsPassiveListenerSupported() ? {
      passive: false
    } : false;
    document.addEventListener('touchmove', eventHandler[moveEvent], addEventListenerOptions);
    document.addEventListener('touchend', eventHandler[endEvent], addEventListenerOptions);
  }, [onResizeProp, onResizeEndProp, onResizeStartProp]);
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref,
    onMouseDown: callEventHandlers(onMouseDownProp, onMouseDown),
    onTouchStart: callEventHandlers(onTouchStartProp, onTouchStart)
  }, styleProps), rest));
});
ResizeHandle.displayName = 'ResizeHandle';

var useRunAfterUpdate = function useRunAfterUpdate() {
  var afterPaintRef = useRef(null);
  useLayoutEffect(function () {
    if (afterPaintRef.current) {
      var _afterPaintRef$curren;
      (_afterPaintRef$curren = afterPaintRef.current) === null || _afterPaintRef$curren === void 0 ? void 0 : _afterPaintRef$curren.call(afterPaintRef);
      afterPaintRef.current = null;
    }
  });
  return function (callback) {
    afterPaintRef.current = callback;
  };
};

var useSearchInputAdornmentStyle = function useSearchInputAdornmentStyle() {
  return {
    flex: 'none'
  };
};
var useSearchInputClearButtonStyle = function useSearchInputClearButtonStyle(_ref) {
  var variant = _ref.variant,
    size = _ref.size;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var _useTheme = useTheme(),
    colors = _useTheme.colors;
  var color = {
    dark: 'white:tertiary',
    light: 'black:tertiary'
  }[colorMode];
  var activeColor = color;
  var borderColor = 'transparent';
  var borderStyle = 'solid';
  var borderWidth = '1q';
  var hoverColor = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  var focusColor = color;
  var focusHoverColor = hoverColor;
  var focusActiveColor = activeColor;
  var focusBorderColor = colors['blue:60'];
  var focusBoxShadowBorderColor = colors['blue:60'];
  var sizeStyle = function (_sm$md$lg$size, _sm$md$lg$size2) {
    var width = (_sm$md$lg$size = {
      sm: '6x',
      md: '8x',
      // default width
      lg: '8x'
    }[size]) !== null && _sm$md$lg$size !== void 0 ? _sm$md$lg$size : '8x';
    var height = (_sm$md$lg$size2 = {
      sm: '6x',
      md: '8x',
      // default height
      lg: '8x'
    }[size]) !== null && _sm$md$lg$size2 !== void 0 ? _sm$md$lg$size2 : '8x';
    var _style = {
      width: width,
      height: height
    };
    if (variant === VARIANT_OUTLINE || variant === VARIANT_FILLED) {
      _style.ml = size === 'sm' ? '1x' : undefined;
      _style.mr = size === 'sm' ? '3q' : '-1q'; // right border
      _style.my = size === 'sm' || size === 'md' ? '-1q' : undefined; // top and bottom borders
    } else if (variant === VARIANT_FLUSH) {
      _style.mx = size === 'sm' ? '1x' : undefined;
      _style.mb = size === 'sm' || size === 'md' ? '-1q' : undefined; // bottom border
    } else if (variant === VARIANT_UNSTYLED) {
      _style.mx = size === 'sm' ? '1x' : undefined;
    }
    return _style;
  }();
  var baseStyle = _objectSpread2(_objectSpread2({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderColor: borderColor,
    borderStyle: borderStyle,
    borderWidth: borderWidth,
    color: color
  }, sizeStyle), {}, {
    transition: createTransitionStyle(['border-color', 'box-shadow', 'color'], {
      duration: 200
    }),
    _hover: {
      color: hoverColor
    },
    _active: {
      color: activeColor
    },
    _focus: {
      borderColor: focusBorderColor,
      boxShadow: focusBoxShadowBorderColor ? "inset 0 0 0 1px ".concat(focusBoxShadowBorderColor) : undefined,
      color: focusColor
    },
    _focusHover: {
      color: focusHoverColor
    },
    _focusActive: {
      borderColor: focusBorderColor,
      boxShadow: focusBoxShadowBorderColor ? "inset 0 0 0 1px ".concat(focusBoxShadowBorderColor) : undefined,
      color: focusActiveColor
    }
  });
  return _objectSpread2({}, baseStyle);
};
var useSearchInputLoadingIconStyle = function useSearchInputLoadingIconStyle(_ref2) {
  var variant = _ref2.variant;
  var _useTheme2 = useTheme(),
    sizes = _useTheme2.sizes;
  var pl = '2x';
  var pr = variant === VARIANT_OUTLINE || variant === VARIANT_FILLED ? "calc(".concat(sizes['2x'], " - ").concat(sizes['1q'], ")") : '2x';
  return {
    pl: pl,
    pr: pr
  };
};
var useSearchInputSearchIconStyle = function useSearchInputSearchIconStyle(_ref3) {
  var variant = _ref3.variant;
  var _useTheme3 = useTheme(),
    sizes = _useTheme3.sizes;
  var pl = variant === VARIANT_OUTLINE || variant === VARIANT_FILLED ? "calc(".concat(sizes['3x'], " - ").concat(sizes['1q'], ")") : '3x';
  var pr = '2x';
  return {
    pl: pl,
    pr: pr
  };
};

var SearchInputAdornment = /*#__PURE__*/forwardRef(function (props, ref) {
  var styleProps = useSearchInputAdornmentStyle();
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), props));
});
SearchInputAdornment.displayName = 'SearchInputAdornment';

var _excluded$I = ["children", "size", "variant"];
var SearchInputClearButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    size = _ref.size,
    variant = _ref.variant,
    rest = _objectWithoutProperties(_ref, _excluded$I);
  var styleProps = useSearchInputClearButtonStyle({
    size: size,
    variant: variant
  });
  return jsx(ButtonBase, _objectSpread2(_objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), rest), {}, {
    children: children !== null && children !== void 0 ? children : jsx(Icon, {
      icon: "close-s"
    })
  }));
});
SearchInputClearButton.displayName = 'SearchInputClearButton';

var _templateObject$1, _templateObject2$1;
var defaultRadius = 24;
var defaultStrokeWidth = 4;
var baseAnimationDuration = 2; // in seconds
var baseAnimation = keyframes(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
var lineAnimationDuration = Math.floor(baseAnimationDuration * 0.75 * 100) / 100; // in seconds
var getLineAnimation = function getLineAnimation(_ref) {
  var circumference = _ref.circumference,
    strokeWidth = _ref.strokeWidth;
  return keyframes(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n    0% {\n      stroke-dasharray: 0, ", ";\n      stroke-dashoffset: 0;\n    }\n    50% {\n      stroke-dasharray: ", ", ", ";\n      stroke-dashoffset: -", ";\n    }\n    100% {\n      stroke-dasharray: ", ", ", ";\n      stroke-dashoffset: -", ";\n    }\n  "])), circumference, circumference * 0.6, circumference, circumference * (1 - 0.6) - strokeWidth * 4, circumference * 0.6, circumference, circumference * 1 - strokeWidth * 4);
};
var mapSizeToRadius = function mapSizeToRadius(size) {
  var _xs$sm$md$lg$xl$size;
  return (_xs$sm$md$lg$xl$size = {
    xs: 8,
    sm: 16,
    md: 24,
    lg: 32,
    xl: 40
  }[size]) !== null && _xs$sm$md$lg$xl$size !== void 0 ? _xs$sm$md$lg$xl$size : defaultRadius;
};
var mapSizeToStrokeWidth = function mapSizeToStrokeWidth(size) {
  var _xs$sm$md$lg$xl$size2;
  return (_xs$sm$md$lg$xl$size2 = {
    xs: 2,
    sm: 2,
    md: 4,
    lg: 4,
    xl: 4
  }[size]) !== null && _xs$sm$md$lg$xl$size2 !== void 0 ? _xs$sm$md$lg$xl$size2 : defaultStrokeWidth;
};
var useSpinnerStyle = function useSpinnerStyle(_ref2) {
  var size = _ref2.size;
  var outerRadius = mapSizeToRadius(size);
  var width = outerRadius * 2;
  var height = outerRadius * 2;
  return {
    width: width,
    height: height
  };
};
var useSpinnerSVGBaseStyle = function useSpinnerSVGBaseStyle(_ref3) {
  var size = _ref3.size;
  var outerRadius = mapSizeToRadius(size);
  return {
    viewBox: "0 0 ".concat(outerRadius * 2, " ").concat(outerRadius * 2),
    animation: "".concat(baseAnimation, " ").concat(baseAnimationDuration, "s linear infinite")
  };
};
var useSpinnerSVGTrackStyle = function useSpinnerSVGTrackStyle(_ref4) {
  var size = _ref4.size,
    trackColor = _ref4.trackColor,
    trackWidth = _ref4.trackWidth;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var stroke = trackColor !== null && trackColor !== void 0 ? trackColor : {
    dark: 'rgba(255, 255, 255, 0.12)',
    light: 'rgba(0, 0, 0, 0.12)'
  }[colorMode];
  var strokeWidth = ensurePositiveInteger(trackWidth !== null && trackWidth !== void 0 ? trackWidth : mapSizeToStrokeWidth(size));
  var outerRadius = mapSizeToRadius(size);
  var centerRadius = outerRadius - strokeWidth / 2;
  return {
    fill: 'none',
    stroke: stroke,
    strokeWidth: strokeWidth,
    cx: outerRadius,
    cy: outerRadius,
    r: centerRadius,
    strokeLinecap: 'round'
  };
};
var useSpinnerSVGLineStyle = function useSpinnerSVGLineStyle(_ref5) {
  var size = _ref5.size,
    lineColor = _ref5.lineColor,
    lineWidth = _ref5.lineWidth;
  var stroke = lineColor !== null && lineColor !== void 0 ? lineColor : 'blue:60';
  var strokeWidth = ensurePositiveInteger(lineWidth !== null && lineWidth !== void 0 ? lineWidth : mapSizeToStrokeWidth(size));
  var outerRadius = mapSizeToRadius(size);
  var centerRadius = outerRadius - strokeWidth / 2;
  var circumference = Math.floor(outerRadius * Math.PI * 2);
  var lineAnimation = getLineAnimation({
    circumference: circumference,
    strokeWidth: strokeWidth
  });
  return {
    animation: "".concat(lineAnimation, " ").concat(lineAnimationDuration, "s ease-in-out infinite"),
    fill: 'none',
    stroke: stroke,
    strokeWidth: strokeWidth,
    cx: outerRadius,
    cy: outerRadius,
    r: centerRadius,
    strokeLinecap: 'round'
  };
};

var _excluded$H = ["color", "strokeWidth", "speed", "size", "lineColor", "lineWidth", "trackColor", "trackWidth"];
var defaultSize$3 = 'md';
var Spinner = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var color = _ref.color,
    strokeWidth = _ref.strokeWidth,
    speed = _ref.speed,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaultSize$3 : _ref$size,
    lineColor = _ref.lineColor,
    lineWidth = _ref.lineWidth,
    trackColor = _ref.trackColor,
    trackWidth = _ref.trackWidth,
    rest = _objectWithoutProperties(_ref, _excluded$H);
  {
    var _lineColor, _lineWidth, _trackWidth;
    // deprecation warning
    var prefix = "".concat(Spinner.displayName, ":");
    useOnceWhen(function () {
      warnDeprecatedProps('color', {
        prefix: prefix,
        alternative: 'lineColor',
        willRemove: true
      });
    }, color !== undefined);
    useOnceWhen(function () {
      warnDeprecatedProps('strokeWidth', {
        prefix: prefix,
        alternative: ['lineWidth', 'trackWidth'],
        willRemove: true
      });
    }, strokeWidth !== undefined);
    useOnceWhen(function () {
      warnRemovedProps('speed', {
        prefix: prefix
      });
    }, speed !== undefined);
    lineColor = (_lineColor = lineColor) !== null && _lineColor !== void 0 ? _lineColor : color; // TODO: color is deprecated
    lineWidth = (_lineWidth = lineWidth) !== null && _lineWidth !== void 0 ? _lineWidth : strokeWidth; // TODO: strokeWidth is deprecated
    trackWidth = (_trackWidth = trackWidth) !== null && _trackWidth !== void 0 ? _trackWidth : strokeWidth; // TODO: strokeWidth is deprecated
  }

  var styleProps = useSpinnerStyle({
    size: size
  });
  var svgBaseStyleProps = useSpinnerSVGBaseStyle({
    size: size
  });
  var svgTrackStyleProps = useSpinnerSVGTrackStyle({
    size: size,
    trackColor: trackColor,
    trackWidth: trackWidth
  });
  var svgLineStyleProps = useSpinnerSVGLineStyle({
    size: size,
    lineColor: lineColor,
    lineWidth: lineWidth
  });
  return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), rest), {}, {
    children: jsxs(Box, _objectSpread2(_objectSpread2({
      as: "svg"
    }, svgBaseStyleProps), {}, {
      children: [jsx(Box, _objectSpread2({
        as: "circle"
      }, svgTrackStyleProps)), jsx(Box, _objectSpread2({
        as: "circle"
      }, svgLineStyleProps))]
    }))
  }));
});
Spinner.displayName = 'Spinner';

var _excluded$G = ["children", "variant"];
var SearchInputLoadingIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    variant = _ref.variant,
    rest = _objectWithoutProperties(_ref, _excluded$G);
  var styleProps = useSearchInputLoadingIconStyle({
    variant: variant
  });
  return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), rest), {}, {
    children: children !== null && children !== void 0 ? children : jsx(Spinner, {
      size: "xs"
    })
  }));
});
SearchInputLoadingIcon.displayName = 'SearchInputLoadingIcon';

var _excluded$F = ["children", "variant"];
var SearchInputSearchIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    variant = _ref.variant,
    rest = _objectWithoutProperties(_ref, _excluded$F);
  var styleProps = useSearchInputSearchIconStyle({
    variant: variant
  });
  return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), rest), {}, {
    children: children !== null && children !== void 0 ? children : jsx(Icon, {
      icon: "search-o"
    })
  }));
});
SearchInputSearchIcon.displayName = 'SearchInputSearchIcon';

var _excluded$E = ["defaultValue", "disabled", "endAdornment", "isLoading", "onChange", "onClearInput", "readOnly", "size", "startAdornment", "value", "variant"];
var defaultSize$2 = 'md';
var defaultVariant$5 = 'outline';
var SearchInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$defaultValue = _ref.defaultValue,
    defaultValueProp = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
    disabled = _ref.disabled,
    endAdornmentProp = _ref.endAdornment,
    isLoading = _ref.isLoading,
    onChangeProp = _ref.onChange,
    onClearInputProp = _ref.onClearInput,
    readOnly = _ref.readOnly,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaultSize$2 : _ref$size,
    startAdornmentProp = _ref.startAdornment,
    valueProp = _ref.value,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? defaultVariant$5 : _ref$variant,
    rest = _objectWithoutProperties(_ref, _excluded$E);
  var nodeRef = useRef();
  var combinedRef = useMergeRefs(nodeRef, ref);
  var _useState = useState(ensureString(valueProp !== null && valueProp !== void 0 ? valueProp : defaultValueProp)),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var isClearable = !disabled && !readOnly && !!value;
  var inputSelectionRef = useRef();
  var runAfterUpdate = useRunAfterUpdate();
  useEffect(function () {
    var isControlled = valueProp !== undefined;
    if (isControlled) {
      setValue(valueProp);
    }
    runAfterUpdate(function () {
      if (inputSelectionRef.current && nodeRef.current) {
        nodeRef.current.selectionStart = inputSelectionRef.current.start;
        nodeRef.current.selectionEnd = inputSelectionRef.current.end;
      }
    });
  }, [valueProp, runAfterUpdate]);
  var iconState = function () {
    if (isLoading) {
      return 'loading';
    }
    if (isClearable) {
      return 'clearable';
    }
    return null;
  }();
  var onClearInput = useCallback(function (e) {
    if (iconState !== 'clearable') {
      return;
    }
    var nextValue = '';
    var isControlled = valueProp !== undefined;
    if (!isControlled) {
      setValue(nextValue);
    }
    if (typeof onClearInputProp === 'function') {
      onClearInputProp(e);
    }
    requestAnimationFrame(function () {
      var el = nodeRef.current;
      el && el.focus(); // Retain focus on the input after clearing
    });
  }, [iconState, valueProp, onClearInputProp]);
  var onChange = useCallback(function (e) {
    var _e$target$value;
    var nextValue = ensureString((_e$target$value = e.target.value) !== null && _e$target$value !== void 0 ? _e$target$value : '');
    var isControlled = valueProp !== undefined;
    if (!isControlled) {
      setValue(nextValue);
    }
    inputSelectionRef.current = {
      start: e.target.selectionStart,
      end: e.target.selectionEnd
    };
    if (typeof onChangeProp === 'function') {
      onChangeProp(e);
    }
  }, [valueProp, onChangeProp]);
  var startAdornment = jsx(SearchInputAdornment, {
    children: jsx(SearchInputSearchIcon, {
      variant: variant
    })
  });
  var endAdornment = function () {
    if (iconState === 'clearable') {
      return jsx(SearchInputAdornment, {
        children: jsx(SearchInputClearButton, {
          disabled: disabled,
          onClick: onClearInput,
          size: size,
          variant: variant
        })
      });
    }
    if (iconState === 'loading') {
      return jsx(SearchInputAdornment, {
        children: jsx(SearchInputLoadingIcon, {
          variant: variant
        })
      });
    }
    return null;
  }();
  return jsx(InputControl, _objectSpread2({
    inputRef: combinedRef,
    disabled: disabled,
    endAdornment: endAdornmentProp !== undefined ? endAdornmentProp : endAdornment,
    onChange: onChange,
    readOnly: readOnly,
    size: size,
    startAdornment: startAdornmentProp !== undefined ? startAdornmentProp : startAdornment,
    value: value,
    variant: variant
  }, rest));
});
SearchInput.displayName = 'SearchInput';

var useContainerStyle = function useContainerStyle(_ref) {
  var width = _ref.width,
    height = _ref.height,
    minWidth = _ref.minWidth,
    maxWidth = _ref.maxWidth,
    minHeight = _ref.minHeight,
    maxHeight = _ref.maxHeight;
  return {
    position: 'relative',
    overflow: 'hidden',
    width: width,
    height: height,
    minWidth: minWidth,
    maxWidth: maxWidth,
    minHeight: minHeight,
    maxHeight: maxHeight
  };
};
var useScrollViewStyle = function useScrollViewStyle(_ref2) {
  _ref2.width;
    var height = _ref2.height,
    minWidth = _ref2.minWidth,
    maxWidth = _ref2.maxWidth,
    minHeight = _ref2.minHeight,
    maxHeight = _ref2.maxHeight,
    overflowX = _ref2.overflowX,
    overflowY = _ref2.overflowY;
  var style = {
    overflowX: overflowX === 'hidden' ? 'hidden' : 'scroll',
    overflowY: overflowY === 'hidden' ? 'hidden' : 'scroll',
    minWidth: minWidth,
    maxWidth: maxWidth,
    minHeight: minHeight,
    maxHeight: maxHeight,
    WebkitOverflowScrolling: 'touch'
  };
  if (height === 'auto') {
    return _objectSpread2(_objectSpread2({}, style), {}, {
      position: 'relative'
    });
  }
  return _objectSpread2(_objectSpread2({}, style), {}, {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  });
};
var useHorizontalTrackStyle = function useHorizontalTrackStyle(_ref3) {
  var overflowX = _ref3.overflowX;
  return _objectSpread2(_objectSpread2({
    position: 'absolute',
    height: '2x',
    right: 0,
    bottom: 0,
    left: 0,
    visibility: 'hidden'
  }, overflowX === 'auto' && {
    transition: 'opacity 200ms',
    opacity: 0
  }), overflowX === 'hidden' && {
    display: 'none'
  });
};
var useVerticalTrackStyle = function useVerticalTrackStyle(_ref4) {
  var overflowY = _ref4.overflowY;
  return _objectSpread2(_objectSpread2({
    position: 'absolute',
    width: '2x',
    right: 0,
    bottom: 0,
    top: 0,
    visibility: 'hidden'
  }, overflowY === 'auto' && {
    transition: 'opacity 200ms',
    opacity: 0
  }), overflowY === 'hidden' && {
    display: 'none'
  });
};
var useHorizontalThumbStyle = function useHorizontalThumbStyle(props) {
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var backgroundColor = {
    dark: 'white:disabled',
    light: 'black:disabled'
  }[colorMode];
  var hoverBackgroundColor = {
    dark: 'white:tertiary',
    light: 'black:tertiary'
  }[colorMode];
  var hoverBorderColor = {
    dark: 'white:secondary',
    light: 'black:secondary'
  }[colorMode];
  return {
    position: 'relative',
    height: '100%',
    cursor: 'pointer',
    backgroundColor: backgroundColor,
    borderRadius: 'inherit',
    border: 1,
    borderColor: 'transparent',
    _hover: {
      backgroundColor: hoverBackgroundColor,
      borderColor: hoverBorderColor
    }
  };
};
var useVerticalThumbStyle = function useVerticalThumbStyle(props) {
  var _useColorMode3 = useColorMode(),
    _useColorMode4 = _slicedToArray(_useColorMode3, 1),
    colorMode = _useColorMode4[0];
  var backgroundColor = {
    dark: 'white:disabled',
    light: 'black:disabled'
  }[colorMode];
  var hoverBackgroundColor = {
    dark: 'white:tertiary',
    light: 'black:tertiary'
  }[colorMode];
  var hoverBorderColor = {
    dark: 'white:secondary',
    light: 'black:secondary'
  }[colorMode];
  return {
    position: 'relative',
    display: 'block',
    width: '100%',
    cursor: 'pointer',
    backgroundColor: backgroundColor,
    borderRadius: 'inherit',
    border: 1,
    borderColor: 'transparent',
    _hover: {
      backgroundColor: hoverBackgroundColor,
      borderColor: hoverBorderColor
    }
  };
};

var getInnerHeight = function getInnerHeight(el) {
  var clientHeight = parseFloat(el === null || el === void 0 ? void 0 : el.clientHeight) || 0;
  var innerHeight = clientHeight;
  try {
    var computedStyle = getComputedStyle(el);
    var paddingTop = parseFloat(computedStyle === null || computedStyle === void 0 ? void 0 : computedStyle.paddingTop);
    var paddingBottom = parseFloat(computedStyle === null || computedStyle === void 0 ? void 0 : computedStyle.paddingBottom);
    innerHeight = ensureFiniteNumber(clientHeight - paddingTop - paddingBottom);
  } catch (e) {
    // do nothing
  }
  return innerHeight;
};

var getInnerWidth = function getInnerWidth(el) {
  var clientWidth = parseFloat(el === null || el === void 0 ? void 0 : el.clientWidth) || 0;
  var innerWidth = clientWidth;
  try {
    var computedStyle = getComputedStyle(el);
    var paddingLeft = parseFloat(computedStyle === null || computedStyle === void 0 ? void 0 : computedStyle.paddingLeft);
    var paddingRight = parseFloat(computedStyle === null || computedStyle === void 0 ? void 0 : computedStyle.paddingRight);
    innerWidth = ensureFiniteNumber(clientWidth - paddingLeft - paddingRight);
  } catch (e) {
    // do nothing
  }
  return innerWidth;
};

var _excluded$D = ["css"];
var ScrollView = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var css = _ref.css,
    rest = _objectWithoutProperties(_ref, _excluded$D);
  css = [sx({
    // Hide the browser scrollbar
    // Chrome, Safari and Opera
    '::-webkit-scrollbar': {
      display: 'none'
    },
    // IE and Edge
    msOverflowStyle: 'none',
    // Firefox
    scrollbarWidth: 'none'
  }), css];
  return jsx(Box, _objectSpread2({
    ref: ref,
    css: css
  }, rest));
});
ScrollView.displayName = 'ScrollView';

var HorizontalTrack = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(Box, _objectSpread2({
    "data-scrollbar-track": "horizontal",
    ref: ref
  }, props));
});
HorizontalTrack.displayName = 'HorizontalTrack';

var VerticalTrack = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(Box, _objectSpread2({
    "data-scrollbar-track": "vertical",
    ref: ref
  }, props));
});
VerticalTrack.displayName = 'VerticalTrack';

var HorizontalThumb = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(Box, _objectSpread2({
    "data-scrollbar-thumb": "horizontal",
    ref: ref
  }, props));
});
HorizontalThumb.displayName = 'HorizontalThumb';

var VerticalThumb = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(Box, _objectSpread2({
    "data-scrollbar-thumb": "vertical",
    ref: ref
  }, props));
});
VerticalThumb.displayName = 'VerticalThumb';

var _excluded$C = ["disabled", "minThumbSize", "visibility", "renderView", "renderHorizontalTrack", "renderHorizontalThumb", "renderVerticalTrack", "renderVerticalThumb", "thumbSize", "children", "width", "height", "minWidth", "maxWidth", "minHeight", "maxHeight", "minThumbWidth", "minThumbHeight", "onScroll", "onUpdate", "overflow", "overflowX", "overflowY"];
var Scrollbar = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var disabled = _ref.disabled,
    minThumbSize = _ref.minThumbSize,
    visibility = _ref.visibility,
    renderView = _ref.renderView,
    renderHorizontalTrack = _ref.renderHorizontalTrack,
    renderHorizontalThumb = _ref.renderHorizontalThumb,
    renderVerticalTrack = _ref.renderVerticalTrack,
    renderVerticalThumb = _ref.renderVerticalThumb,
    thumbSize = _ref.thumbSize,
    children = _ref.children,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'auto' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 'auto' : _ref$height,
    minWidth = _ref.minWidth,
    maxWidth = _ref.maxWidth,
    minHeight = _ref.minHeight,
    maxHeight = _ref.maxHeight,
    _ref$minThumbWidth = _ref.minThumbWidth,
    minThumbWidth = _ref$minThumbWidth === void 0 ? 32 : _ref$minThumbWidth,
    _ref$minThumbHeight = _ref.minThumbHeight,
    minThumbHeight = _ref$minThumbHeight === void 0 ? 32 : _ref$minThumbHeight,
    onScroll = _ref.onScroll,
    onUpdate = _ref.onUpdate,
    _ref$overflow = _ref.overflow,
    overflow = _ref$overflow === void 0 ? 'auto' : _ref$overflow,
    overflowX = _ref.overflowX,
    overflowY = _ref.overflowY,
    rest = _objectWithoutProperties(_ref, _excluded$C);
  {
    var _overflowX, _overflowY, _overflowX2, _overflowY2;
    // deprecation warning
    var prefix = "".concat(Scrollbar.displayName, ":");
    useOnceWhen(function () {
      warnDeprecatedProps('disabled', {
        prefix: prefix,
        alternative: 'overflow="hidden"',
        willRemove: true
      });
    }, disabled !== undefined);
    useOnceWhen(function () {
      warnDeprecatedProps('minThumbSize', {
        prefix: prefix,
        alternative: ['minThumbWidth', 'minThumbHeight'],
        willRemove: true
      });
    }, minThumbSize !== undefined);
    useOnceWhen(function () {
      var deprecatedProps = visibility === 'visible' ? 'visibility="visible"' : 'visibility';
      var alternative = visibility === 'visible' ? 'overflow="scroll"' : 'overflow';
      warnDeprecatedProps(deprecatedProps, {
        prefix: prefix,
        alternative: alternative,
        willRemove: true
      });
    }, visibility !== undefined);
    useOnceWhen(function () {
      warnRemovedProps('renderView', {
        prefix: prefix,
        message: 'Use Function as Child Component (FaCC) to render the scroll view instead.'
      });
    }, renderView !== undefined);
    useOnceWhen(function () {
      warnRemovedProps('renderHorizontalTrack', {
        prefix: prefix,
        message: 'Use Function as Child Component (FaCC) to render the horizontal track instead.'
      });
    }, renderHorizontalTrack !== undefined);
    useOnceWhen(function () {
      warnRemovedProps('renderHorizontalThumb', {
        prefix: prefix,
        message: 'Use Function as Child Component (FaCC) to render the horizontal thumb instead.'
      });
    }, renderHorizontalThumb !== undefined);
    useOnceWhen(function () {
      warnRemovedProps('renderVerticalTrack', {
        prefix: prefix,
        message: 'Use Function as Child Component (FaCC) to render the vertical track instead.'
      });
    }, renderVerticalTrack !== undefined);
    useOnceWhen(function () {
      warnRemovedProps('renderVerticalThumb', {
        prefix: prefix,
        message: 'Use Function as Child Component (FaCC) to render the vertical thumb instead.'
      });
    }, renderVerticalThumb !== undefined);
    useOnceWhen(function () {
      warnRemovedProps('thumbSize', {
        prefix: prefix,
        alternative: ['minThumbWidth', 'minThumbHeight']
      });
    }, thumbSize !== undefined);

    // TODO: remove `disabled` and `visibility` props in next major version
    if (disabled === true) {
      overflowX = 'hidden';
      overflowY = 'hidden';
    }

    // TODO: remove `minThumbSize` prop in next major version
    if (Number.isFinite(minThumbSize) && minThumbSize > 0) {
      minThumbWidth = ensurePositiveFiniteNumber(minThumbSize);
      minThumbHeight = ensurePositiveFiniteNumber(minThumbSize);
    }
    overflowX = (_overflowX = overflowX) !== null && _overflowX !== void 0 ? _overflowX : visibility !== null && visibility !== void 0 ? visibility : overflow; // TODO: visibility is deprecated
    overflowY = (_overflowY = overflowY) !== null && _overflowY !== void 0 ? _overflowY : visibility !== null && visibility !== void 0 ? visibility : overflow; // TODO: visibility is deprecated
    if (overflowX === 'visible') {
      overflowX = 'scroll';
    }
    if (overflowY === 'visible') {
      overflowY = 'scroll';
    }
    overflowX = (_overflowX2 = overflowX) !== null && _overflowX2 !== void 0 ? _overflowX2 : 'auto';
    overflowY = (_overflowY2 = overflowY) !== null && _overflowY2 !== void 0 ? _overflowY2 : 'auto';
  }
  var isHydrated = useHydrated();
  var nodeRef = useRef(null);
  var combinedRef = useMergeRefs(nodeRef, ref);
  var viewScrollLeftRef = useRef(0);
  var viewScrollTopRef = useRef(0);
  var lastViewScrollLeftRef = useRef(0);
  var lastViewScrollTopRef = useRef(0);

  // For binding the `mousemove` and `mouseup` events to document, we use `useState` to store `startDragging` variable to trigger `useEffect`.
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    startDragging = _useState2[0],
    setStartDragging = _useState2[1];

  // These variables are used to be the checked point to change DOM element style directly (Do NOT need to re-render UI)
  var isDraggingRef = useRef(false);
  var isScrollingRef = useRef(false);
  var isTrackMouseOverRef = useRef(false);
  var isViewMouseOverRef = useRef(false);
  var prevPageXRef = useRef(0);
  var prevPageYRef = useRef(0);
  var scrollViewRef = useRef(null);
  var horizontalTrackRef = useRef(null);
  var verticalTrackRef = useRef(null);
  var horizontalThumbRef = useRef(null);
  var verticalThumbRef = useRef(null);
  var getValues = function getValues() {
    var _ref2 = scrollViewRef.current || {},
      _ref2$scrollLeft = _ref2.scrollLeft,
      scrollLeft = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft,
      _ref2$scrollTop = _ref2.scrollTop,
      scrollTop = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop,
      _ref2$scrollWidth = _ref2.scrollWidth,
      scrollWidth = _ref2$scrollWidth === void 0 ? 0 : _ref2$scrollWidth,
      _ref2$scrollHeight = _ref2.scrollHeight,
      scrollHeight = _ref2$scrollHeight === void 0 ? 0 : _ref2$scrollHeight,
      _ref2$clientWidth = _ref2.clientWidth,
      clientWidth = _ref2$clientWidth === void 0 ? 0 : _ref2$clientWidth,
      _ref2$clientHeight = _ref2.clientHeight,
      clientHeight = _ref2$clientHeight === void 0 ? 0 : _ref2$clientHeight;
    return {
      left: ensurePositiveFiniteNumber(scrollLeft / (scrollWidth - clientWidth)),
      top: ensurePositiveFiniteNumber(scrollTop / (scrollHeight - clientHeight)),
      scrollLeft: scrollLeft,
      scrollTop: scrollTop,
      scrollWidth: scrollWidth,
      scrollHeight: scrollHeight,
      clientWidth: clientWidth,
      clientHeight: clientHeight
    };
  };
  var update = useCallback(function (callback) {
    if (!isHydrated) {
      return;
    }
    if (!horizontalTrackRef.current) {
      return;
    }
    if (!verticalTrackRef.current) {
      return;
    }
    var values = getValues();
    var scrollLeft = values.scrollLeft,
      clientWidth = values.clientWidth,
      scrollWidth = values.scrollWidth;
    var horizontalTrackWidth = getHorizontalTrackWidth();
    var horizontalThumbWidth = getHorizontalThumbWidth();
    var horizontalThumbX = scrollWidth - clientWidth !== 0 ? scrollLeft / (scrollWidth - clientWidth) * (horizontalTrackWidth - horizontalThumbWidth) : 0;
    var scrollTop = values.scrollTop,
      clientHeight = values.clientHeight,
      scrollHeight = values.scrollHeight;
    var verticalTrackHeight = getVerticalTrackHeight();
    var verticalThumbHeight = getVerticalThumbHeight();
    var verticalThumbY = scrollHeight - clientHeight !== 0 ? scrollTop / (scrollHeight - clientHeight) * (verticalTrackHeight - verticalThumbHeight) : 0;
    horizontalTrackRef.current.style.visibility = scrollWidth > clientWidth ? 'visible' : 'hidden';
    verticalTrackRef.current.style.visibility = scrollHeight > clientHeight ? 'visible' : 'hidden';
    horizontalThumbRef.current.style.width = "".concat(horizontalThumbWidth, "px");
    horizontalThumbRef.current.style.transform = "translateX(".concat(horizontalThumbX, "px)");
    verticalThumbRef.current.style.height = "".concat(verticalThumbHeight, "px");
    verticalThumbRef.current.style.transform = "translateY(".concat(verticalThumbY, "px)");
    if (typeof onUpdate === 'function') {
      onUpdate(_objectSpread2({
        values: values,
        // FIXME: deprecated (for backward compatibility)
        hasHorizontalScrollbar: scrollWidth > clientWidth,
        // FIXME: deprecated (for backward compatibility)
        hasVerticalScrollbar: scrollHeight > clientHeight
      }, values));
    }
    if (typeof callback === 'function') {
      callback(values);
    }
  }, [getHorizontalTrackWidth, getHorizontalThumbWidth, getVerticalTrackHeight, getVerticalThumbHeight, isHydrated, onUpdate]);
  var getHorizontalTrackWidth = useCallback(function () {
    if (!horizontalTrackRef.current) {
      return 0;
    }
    var trackWidth = getInnerWidth(horizontalTrackRef.current);
    return trackWidth;
  }, []);
  var getHorizontalThumbWidth = useCallback(function () {
    var _scrollViewRef$curren = scrollViewRef.current,
      clientWidth = _scrollViewRef$curren.clientWidth,
      scrollWidth = _scrollViewRef$curren.scrollWidth;
    if (clientWidth === scrollWidth) {
      return 0;
    }
    var trackWidth = getHorizontalTrackWidth();
    var thumbWidth = Math.max(ensurePositiveFiniteNumber(minThumbWidth), ensurePositiveFiniteNumber(Math.ceil(clientWidth / scrollWidth * trackWidth)));
    return thumbWidth;
  }, [getHorizontalTrackWidth, minThumbWidth]);
  var getVerticalTrackHeight = useCallback(function () {
    if (!verticalTrackRef.current) {
      return 0;
    }
    var trackHeight = getInnerHeight(verticalTrackRef.current);
    return trackHeight;
  }, []);
  var getVerticalThumbHeight = useCallback(function () {
    var _scrollViewRef$curren2 = scrollViewRef.current,
      clientHeight = _scrollViewRef$curren2.clientHeight,
      scrollHeight = _scrollViewRef$curren2.scrollHeight;
    if (clientHeight === scrollHeight) {
      return 0;
    }
    var trackHeight = getVerticalTrackHeight();
    var thumbHeight = Math.max(ensurePositiveFiniteNumber(minThumbHeight), ensurePositiveFiniteNumber(Math.ceil(clientHeight / scrollHeight * trackHeight)));
    return thumbHeight;
  }, [getVerticalTrackHeight, minThumbHeight]);
  var hideHorizontalTrack = useCallback(function () {
    if (overflowX === 'scroll') {
      return;
    }
    if (horizontalTrackRef.current) {
      horizontalTrackRef.current.style.opacity = 0;
    }
  }, [overflowX]);
  var hideVerticalTrack = useCallback(function () {
    if (overflowY === 'scroll') {
      return;
    }
    if (verticalTrackRef.current) {
      verticalTrackRef.current.style.opacity = 0;
    }
  }, [overflowY]);
  var hideTracks = useCallback(function () {
    var isDragging = isDraggingRef.current;
    var isScrolling = isScrollingRef.current;
    var isTrackMouseOver = isTrackMouseOverRef.current;
    var isViewMouseOver = isViewMouseOverRef.current;
    if (isDragging) {
      return;
    }
    if (isScrolling) {
      return;
    }
    if (isTrackMouseOver) {
      return;
    }
    if (isViewMouseOver) {
      return;
    }
    hideHorizontalTrack();
    hideVerticalTrack();
  }, [hideHorizontalTrack, hideVerticalTrack]);
  var showHorizontalTrack = useCallback(function () {
    if (overflowX === 'hidden') {
      return;
    }
    if (horizontalTrackRef.current) {
      horizontalTrackRef.current.style.opacity = 1;
    }
  }, [overflowX]);
  var showVerticalTrack = useCallback(function () {
    if (overflowY === 'hidden') {
      return;
    }
    if (verticalTrackRef.current) {
      verticalTrackRef.current.style.opacity = 1;
    }
  }, [overflowY]);
  var showTracks = useCallback(function () {
    showHorizontalTrack();
    showVerticalTrack();
  }, [showHorizontalTrack, showVerticalTrack]);
  var getScrollLeftByOffset = useCallback(function (offset) {
    var _scrollViewRef$curren3 = scrollViewRef.current,
      scrollWidth = _scrollViewRef$curren3.scrollWidth,
      clientWidth = _scrollViewRef$curren3.clientWidth;
    var trackWidth = getHorizontalTrackWidth();
    var thumbWidth = getHorizontalThumbWidth();
    return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
  }, [getHorizontalTrackWidth, getHorizontalThumbWidth]);
  var getScrollTopByOffset = useCallback(function (offset) {
    var _scrollViewRef$curren4 = scrollViewRef.current,
      scrollHeight = _scrollViewRef$curren4.scrollHeight,
      clientHeight = _scrollViewRef$curren4.clientHeight;
    var trackHeight = getVerticalTrackHeight();
    var thumbHeight = getVerticalThumbHeight();
    return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
  }, [getVerticalTrackHeight, getVerticalThumbHeight]);

  /* Start Scrolling Events */
  var handleScrollViewScroll = useCallback(function (event) {
    if (typeof onScroll === 'function') {
      onScroll(event);
    }
    var updateCallback = function updateCallback(values) {
      var scrollLeft = values.scrollLeft,
        scrollTop = values.scrollTop;
      viewScrollLeftRef.current = scrollLeft;
      viewScrollTopRef.current = scrollTop;
    };
    update(updateCallback);

    // Detect whether the scrolling is in progress
    if (isScrollingRef.current) {
      return;
    }

    // Start scrolling
    isScrollingRef.current = true;

    // Show tracks
    showTracks();
    var detectScrollingInterval = setInterval(function () {
      if (lastViewScrollLeftRef.current === viewScrollLeftRef.current && lastViewScrollTopRef.current === viewScrollTopRef.current) {
        clearInterval(detectScrollingInterval);

        // Stop scrolling
        isScrollingRef.current = false;

        // Hide tracks
        hideTracks();
      }
      lastViewScrollLeftRef.current = viewScrollLeftRef.current;
      lastViewScrollTopRef.current = viewScrollTopRef.current;
    }, 100);
  }, [onScroll, update, showTracks, hideTracks]);
  /* End Scrolling Events */

  /* Start Dragging Events */
  var handleDrag = useCallback(function (event) {
    var prevPageX = prevPageXRef.current;
    var prevPageY = prevPageYRef.current;
    if (prevPageX) {
      var clientX = event.clientX;
      var _horizontalTrackRef$c = horizontalTrackRef.current.getBoundingClientRect(),
        trackLeft = _horizontalTrackRef$c.left;
      var thumbWidth = getHorizontalThumbWidth();
      var clickPosition = thumbWidth - prevPageX;
      var offset = -trackLeft + clientX - clickPosition;
      scrollViewRef.current.scrollLeft = getScrollLeftByOffset(offset);
    }
    if (prevPageY) {
      var clientY = event.clientY;
      var _verticalTrackRef$cur = verticalTrackRef.current.getBoundingClientRect(),
        trackTop = _verticalTrackRef$cur.top;
      var thumbHeight = getVerticalThumbHeight();
      var _clickPosition = thumbHeight - prevPageY;
      var _offset = -trackTop + clientY - _clickPosition;
      scrollViewRef.current.scrollTop = getScrollTopByOffset(_offset);
    }
    return false;
  }, [getHorizontalThumbWidth, getScrollLeftByOffset, getVerticalThumbHeight, getScrollTopByOffset]);
  var handleDragStart = useCallback(function () {
    setStartDragging(true);
    isDraggingRef.current = true;
  }, [setStartDragging]);
  var handleDragEnd = useCallback(function () {
    setStartDragging(false);
    isDraggingRef.current = false;
    prevPageXRef.current = 0;
    prevPageYRef.current = 0;
    hideTracks();
  }, [setStartDragging, hideTracks]);

  /* Start Mouse Events */
  var handleScrollViewMouseEnter = useCallback(function () {
    isViewMouseOverRef.current = true;
    showTracks();
  }, [showTracks]);
  var handleScrollViewMouseLeave = useCallback(function () {
    isViewMouseOverRef.current = false;
    hideTracks();
  }, [hideTracks]);
  var handleTrackMouseEnter = useCallback(function () {
    isTrackMouseOverRef.current = true;
    showTracks();
  }, [showTracks]);
  var handleTrackMouseLeave = useCallback(function () {
    isTrackMouseOverRef.current = false;
    hideTracks();
  }, [hideTracks]);
  var handleHorizontalTrackMouseDown = useCallback(function (event) {
    event.preventDefault();
    var target = event.target,
      clientX = event.clientX;
    var _target$getBoundingCl = target.getBoundingClientRect(),
      targetLeft = _target$getBoundingCl.left;
    var thumbWidth = getHorizontalThumbWidth();
    var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
    scrollViewRef.current.scrollLeft = getScrollLeftByOffset(offset);
  }, [getHorizontalThumbWidth, getScrollLeftByOffset]);
  var handleVerticalTrackMouseDown = useCallback(function (event) {
    event.preventDefault();
    var target = event.target,
      clientY = event.clientY;
    var _target$getBoundingCl2 = target.getBoundingClientRect(),
      targetTop = _target$getBoundingCl2.top;
    var thumbHeight = getVerticalThumbHeight();
    var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
    scrollViewRef.current.scrollTop = getScrollTopByOffset(offset);
  }, [getVerticalThumbHeight, getScrollTopByOffset]);
  var handleHorizontalThumbMouseDown = useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();
    handleDragStart();
    var target = event.target,
      clientX = event.clientX;
    var offsetWidth = target.offsetWidth;
    var _target$getBoundingCl3 = target.getBoundingClientRect(),
      left = _target$getBoundingCl3.left;
    prevPageXRef.current = offsetWidth - (clientX - left);
  }, [handleDragStart]);
  var handleVerticalThumbMouseDown = useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();
    handleDragStart();
    var target = event.target,
      clientY = event.clientY;
    var offsetHeight = target.offsetHeight;
    var _target$getBoundingCl4 = target.getBoundingClientRect(),
      top = _target$getBoundingCl4.top;
    prevPageYRef.current = offsetHeight - (clientY - top);
  }, [handleDragStart]);
  /* End Mouse Events */

  useEffect(function () {
    /**
     * https://developer.mozilla.org/en-US/docs/Web/API/Element/wheel_event
     * Note: Don't confuse the wheel event with the scroll event. The default action of a wheel event is implementation-specific, and doesn't necessarily dispatch a scroll event. Even when it does, the delta* values in the wheel event don't necessarily reflect the content's scrolling direction. Therefore, do not rely on the wheel event's delta* properties to get the scrolling direction. Instead, detect value changes of scrollLeft and scrollTop of the target in the scroll event.
     */
    var handleVerticalTrackWheelScroll = function handleVerticalTrackWheelScroll(event) {
      event.preventDefault();
      event.stopPropagation();
      var deltaY = event.deltaY;
      var currentTop = scrollViewRef.current.scrollTop;
      scrollViewRef.current.scrollTop = currentTop + deltaY;
    };
    var handleHorizontalTrackWheelScroll = function handleHorizontalTrackWheelScroll(event) {
      event.preventDefault();
      event.stopPropagation();
      // Note: the delta* values don't reflect the scrolling direction, the event.deltaX is always zero when doing horizontal scroll
      var deltaX = event.deltaX || event.deltaY;
      var currentLeft = scrollViewRef.current.scrollLeft;
      scrollViewRef.current.scrollLeft = currentLeft + deltaX;
    };

    /**
     * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#improving_scrolling_performance_with_passive_listeners
     * Set passive to false to indicate that the function specified by listener will call `preventDefault()`
     */
    var verticalTrack = verticalTrackRef.current;
    var horizontalTrack = horizontalTrackRef.current;
    verticalTrack === null || verticalTrack === void 0 ? void 0 : verticalTrack.addEventListener('wheel', handleVerticalTrackWheelScroll, {
      passive: false
    });
    horizontalTrack === null || horizontalTrack === void 0 ? void 0 : horizontalTrack.addEventListener('wheel', handleHorizontalTrackWheelScroll, {
      passive: false
    });
    return function () {
      verticalTrack === null || verticalTrack === void 0 ? void 0 : verticalTrack.removeEventListener('wheel', handleVerticalTrackWheelScroll);
      horizontalTrack === null || horizontalTrack === void 0 ? void 0 : horizontalTrack.removeEventListener('wheel', handleHorizontalTrackWheelScroll);
    };
  }, []);
  useEffect(function () {
    var isDragging = isDraggingRef.current;
    if (isDragging) {
      document.addEventListener('mousemove', handleDrag);
      document.addEventListener('mouseup', handleDragEnd);
    }
    if (!isDragging) {
      document.removeEventListener('mousemove', handleDrag);
      document.removeEventListener('mouseup', handleDragEnd);
    }
    return function () {
      document.removeEventListener('mousemove', handleDrag);
      document.removeEventListener('mouseup', handleDragEnd);
    };
  }, [startDragging, handleDrag, handleDragEnd]);
  var el = nodeRef === null || nodeRef === void 0 ? void 0 : nodeRef.current;
  useEffect(function () {
    var _globalThis$MutationO;
    if (!el) {
      // No element to observe
      return;
    }
    update();
    var mutationObserver = null;
    var resizeObserver = null;
    var MutationObserver = (_globalThis$MutationO = globalThis.MutationObserver) !== null && _globalThis$MutationO !== void 0 ? _globalThis$MutationO : globalThis.WebKitMutationObserver;
    var ResizeObserver = globalThis.ResizeObserver;
    if (typeof MutationObserver !== 'undefined') {
      mutationObserver = new MutationObserver(function (mutations) {
        var shouldUpdate = mutations.some(function (mutation) {
          var _mutation$target;
          if ((mutation === null || mutation === void 0 ? void 0 : mutation.type) === 'attributes' && typeof (mutation === null || mutation === void 0 ? void 0 : (_mutation$target = mutation.target) === null || _mutation$target === void 0 ? void 0 : _mutation$target.getAttribute) === 'function') {
            var isScrollbarTrackOrThumb = mutation.target.getAttribute('data-scrollbar-track') || mutation.target.getAttribute('data-scrollbar-thumb');

            // Ignore mutations for the scrollbar track and scrollbar thumb to avoid triggering unnecessary updates during scrolling
            return !isScrollbarTrackOrThumb;
          }
          return true;
        });
        if (shouldUpdate) {
          update();
        }
      });
      mutationObserver.observe(el, {
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true
      });
    }
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(function (entries) {
        update();
      });
      resizeObserver.observe(el);
    }
    return function () {
      // eslint-disable-line consistent-return
      if (mutationObserver) {
        mutationObserver.disconnect();
      }
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [update, el]);
  var containerStyle = useContainerStyle({
    width: width,
    height: height,
    minWidth: minWidth,
    maxWidth: maxWidth,
    minHeight: minHeight,
    maxHeight: maxHeight
  });
  var scrollViewStyle = useScrollViewStyle({
    width: width,
    height: height,
    minWidth: minWidth,
    maxWidth: maxWidth,
    minHeight: minHeight,
    maxHeight: maxHeight,
    overflowX: overflowX,
    overflowY: overflowY
  });
  var horizontalTrackStyle = useHorizontalTrackStyle({
    overflowX: overflowX
  });
  var verticalTrackStyle = useVerticalTrackStyle({
    overflowY: overflowY
  });
  var horizontalThumbStyle = useHorizontalThumbStyle();
  var verticalThumbStyle = useVerticalThumbStyle();
  var getScrollViewProps = function getScrollViewProps() {
    return _objectSpread2(_objectSpread2({}, scrollViewStyle), {}, {
      ref: scrollViewRef,
      onScroll: handleScrollViewScroll,
      onMouseEnter: handleScrollViewMouseEnter,
      onMouseLeave: handleScrollViewMouseLeave,
      children: children
    });
  };
  var getHorizontalTrackProps = function getHorizontalTrackProps() {
    return _objectSpread2(_objectSpread2({}, horizontalTrackStyle), {}, {
      ref: horizontalTrackRef,
      onMouseDown: handleHorizontalTrackMouseDown,
      onMouseEnter: handleTrackMouseEnter,
      onMouseLeave: handleTrackMouseLeave
    });
  };
  var getHorizontalThumbProps = function getHorizontalThumbProps() {
    return _objectSpread2(_objectSpread2({}, horizontalThumbStyle), {}, {
      ref: horizontalThumbRef,
      onMouseDown: handleHorizontalThumbMouseDown
    });
  };
  var getVerticalTrackProps = function getVerticalTrackProps() {
    return _objectSpread2(_objectSpread2({}, verticalTrackStyle), {}, {
      ref: verticalTrackRef,
      onMouseDown: handleVerticalTrackMouseDown,
      onMouseEnter: handleTrackMouseEnter,
      onMouseLeave: handleTrackMouseLeave
    });
  };
  var getVerticalThumbProps = function getVerticalThumbProps() {
    return _objectSpread2(_objectSpread2({}, verticalThumbStyle), {}, {
      ref: verticalThumbRef,
      onMouseDown: handleVerticalThumbMouseDown
    });
  };
  if (typeof children === 'function') {
    return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
      ref: combinedRef
    }, containerStyle), rest), {}, {
      children: children({
        ScrollView: ScrollView,
        HorizontalTrack: HorizontalTrack,
        HorizontalThumb: HorizontalThumb,
        VerticalTrack: VerticalTrack,
        VerticalThumb: VerticalThumb,
        getScrollViewProps: getScrollViewProps,
        getHorizontalTrackProps: getHorizontalTrackProps,
        getHorizontalThumbProps: getHorizontalThumbProps,
        getVerticalTrackProps: getVerticalTrackProps,
        getVerticalThumbProps: getVerticalThumbProps
      })
    }));
  }
  return jsxs(Box, _objectSpread2(_objectSpread2(_objectSpread2({
    ref: combinedRef
  }, containerStyle), rest), {}, {
    children: [jsx(ScrollView, _objectSpread2({}, getScrollViewProps())), jsx(HorizontalTrack, _objectSpread2(_objectSpread2({}, getHorizontalTrackProps()), {}, {
      children: jsx(HorizontalThumb, _objectSpread2({}, getHorizontalThumbProps()))
    })), jsx(VerticalTrack, _objectSpread2(_objectSpread2({}, getVerticalTrackProps()), {}, {
      children: jsx(VerticalThumb, _objectSpread2({}, getVerticalThumbProps()))
    }))]
  }));
});
Scrollbar.displayName = 'Scrollbar';

var getOutlinedStyle$1 = function getOutlinedStyle(_ref) {
  var colorMode = _ref.colorMode;
  var backgroundColor = {
    dark: 'transparent',
    light: 'white'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  var borderColor = {
    dark: 'gray:60',
    light: 'gray:30'
  }[colorMode];
  var hoverBorderColor = {
    dark: 'blue:50',
    light: 'blue:50'
  }[colorMode];
  var focusBorderColor = {
    dark: 'blue:60',
    light: 'blue:60'
  }[colorMode];
  var disabledBorderColor = {
    dark: 'gray:60',
    light: 'gray:30'
  }[colorMode];
  var invalidBorderColor = {
    dark: 'red:50',
    light: 'red:50'
  }[colorMode];
  var placeholderColor = {
    dark: 'white:tertiary',
    light: 'black:tertiary'
  }[colorMode];
  return {
    backgroundColor: backgroundColor,
    border: 1,
    borderColor: borderColor,
    color: color,
    _hover: {
      borderColor: hoverBorderColor
    },
    _focus: {
      borderColor: focusBorderColor
    },
    _disabled: {
      borderColor: disabledBorderColor,
      cursor: 'not-allowed',
      opacity: '.28'
    },
    _valid: {
      // XXX - border color for valid input is not defined
    },
    _invalid: {
      borderColor: invalidBorderColor,
      '&:focus:hover': {
        borderColor: focusBorderColor
      },
      '&:hover': {
        borderColor: invalidBorderColor
      }
    },
    __placeholder: {
      color: placeholderColor,
      // Override Firefox's unusual default opacity
      opacity: 1
    }
  };
};
var getFilledStyle$1 = function getFilledStyle(_ref2) {
  var colorMode = _ref2.colorMode;
  var backgroundColor = {
    dark: 'gray:80',
    light: 'gray:10'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  return _objectSpread2(_objectSpread2({}, getOutlinedStyle$1({
    colorMode: colorMode
  })), {}, {
    backgroundColor: backgroundColor,
    color: color
  });
};
var getUnstyledStyle$1 = function getUnstyledStyle(_ref3) {
  var colorMode = _ref3.colorMode;
  var backgroundColor = {
    dark: 'transparent',
    light: 'white'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  return {
    backgroundColor: backgroundColor,
    color: color,
    border: 0,
    borderRadius: 0,
    height: undefined,
    px: undefined,
    py: undefined
  };
};
var getIconWrapperProps = function getIconWrapperProps() {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    right: 0,
    top: 0,
    height: '100%',
    pointerEvents: 'none',
    color: 'inherit',
    pr: '3x',
    pl: '1x',
    _disabled: {
      opacity: '.28'
    }
  };
};
var useSelectStyle = function useSelectStyle(_ref4) {
  var variant = _ref4.variant,
    multiple = _ref4.multiple;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var _useTheme = useTheme(),
    sizes = _useTheme.sizes;
  var sizeStyle = function () {
    var borderWidth = sizes['1q'];
    var defaultSize = 'md';
    var style = {
      'md': {
        borderRadius: 'sm',
        fontSize: 'sm',
        lineHeight: 'sm',
        pl: '3x',
        pr: '8x',
        py: "calc(".concat(sizes['3h'], " - ").concat(borderWidth, ")"),
        // 6px - 1px
        width: '100%'
      }
    }[defaultSize];
    return style;
  }();
  var variantStyle = function () {
    if (variant === 'outline') {
      return getOutlinedStyle$1({
        colorMode: colorMode
      });
    }
    if (variant === 'filled') {
      return getFilledStyle$1({
        colorMode: colorMode
      });
    }
    if (variant === 'unstyled') {
      return getUnstyledStyle$1({
        colorMode: colorMode
      });
    }
    return {};
  }();
  var baseStyle = {
    appearance: 'none',
    border: 'none',
    color: 'inherit',
    outline: 0,
    padding: 0,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    transition: 'all .2s'
  };
  if (multiple) {
    variantStyle.height = undefined;
    variantStyle.px = undefined;
  }
  return _objectSpread2(_objectSpread2(_objectSpread2({}, baseStyle), sizeStyle), variantStyle);
};
var useOptionStyle = function useOptionStyle() {
  var _useColorMode3 = useColorMode(),
    _useColorMode4 = _slicedToArray(_useColorMode3, 1),
    colorMode = _useColorMode4[0];
  var backgroundColor = {
    dark: 'gray:80',
    light: 'white'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  return {
    backgroundColor: backgroundColor,
    color: color
  };
};
var useOptionGroupStyle = function useOptionGroupStyle() {
  var _useColorMode5 = useColorMode(),
    _useColorMode6 = _slicedToArray(_useColorMode5, 1),
    colorMode = _useColorMode6[0];
  var backgroundColor = {
    dark: 'gray:80',
    light: 'white'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  return {
    backgroundColor: backgroundColor,
    color: color,
    fontWeight: 'semibold'
  };
};

var rootOptions = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'margin', 'marginTop', 'marginBottom', 'marginLeft', 'marginRight', 'marginY', 'marginX', 'flex', 'flexBasis', 'width', 'minWidth', 'maxWidth', 'zIndex', 'top', 'right', 'bottom', 'left', 'position'];
var splitProps = function splitProps(props) {
  var rootProps = {};
  var selectProps = {};
  for (var key in props) {
    if (rootOptions.includes(key)) {
      rootProps[key] = props[key];
    } else {
      selectProps[key] = props[key];
    }
  }
  return [rootProps, selectProps];
};

var _excluded$B = ["isInvalid", "children", "error", "variant"];
var defaultVariant$4 = 'outline';
var Select = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _variant;
  var isInvalid = _ref.isInvalid,
    children = _ref.children,
    error = _ref.error,
    variant = _ref.variant,
    rest = _objectWithoutProperties(_ref, _excluded$B);
  {
    // deprecation warning
    var prefix = "".concat(Select.displayName, ":");
    useOnceWhen(function () {
      warnDeprecatedProps('isInvalid', {
        prefix: prefix,
        alternative: 'error',
        willRemove: true
      });
    }, isInvalid !== undefined);
    error = error || isInvalid; // TODO: remove this line after deprecation
  }

  // Use fallback values if values are null or undefined
  variant = (_variant = variant) !== null && _variant !== void 0 ? _variant : defaultVariant$4;
  var iconWrapperProps = getIconWrapperProps();
  var ariaProps = {
    'aria-disabled': ariaAttr(rest.disabled),
    'aria-invalid': ariaAttr(error),
    'aria-required': ariaAttr(rest.required)
  };
  var multiple = rest.multiple;
  var styleProps = useSelectStyle({
    variant: variant,
    multiple: multiple
  });
  var _splitProps = splitProps(rest),
    _splitProps2 = _slicedToArray(_splitProps, 2),
    rootProps = _splitProps2[0],
    selectProps = _splitProps2[1];
  return jsxs(Box, _objectSpread2(_objectSpread2({
    position: "relative",
    width: "100%"
  }, rootProps), {}, {
    children: [jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
      as: "select",
      ref: ref
    }, ariaProps), styleProps), selectProps), {}, {
      children: children
    })), !multiple && jsx(Box, _objectSpread2(_objectSpread2({
      "aria-disabled": ariaAttr(rest.disabled),
      disabled: rest.disabled
    }, iconWrapperProps), {}, {
      children: jsx(Icon, {
        width: "4x",
        icon: "angle-down"
      })
    }))]
  }));
});
Select.displayName = 'Select';

var Option = /*#__PURE__*/forwardRef(function (props, ref) {
  var styleProps = useOptionStyle();
  return jsx(Box, _objectSpread2(_objectSpread2({
    as: "option"
  }, styleProps), props));
});
Option.displayName = 'Option';

var OptionGroup = /*#__PURE__*/forwardRef(function (props, ref) {
  var styleProps = useOptionGroupStyle();
  return jsx(Box, _objectSpread2(_objectSpread2({
    as: "optgroup"
  }, styleProps), props));
});
OptionGroup.displayName = 'OptionGroup';

Select.Option = Option;
Select.OptionGroup = OptionGroup;

var _templateObject, _templateObject2;
var pulseKeyframe = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: .4;\n  }\n  100% {\n    opacity: 1;\n  }\n"])));
var waveKeyframe = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateX(-100%);\n  }\n  50% {\n    // +0.5s of delay between each loop\n    transform: translateX(100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n"])));
var getAnimationProps = function getAnimationProps(_ref) {
  var animation = _ref.animation,
    colorMode = _ref.colorMode;
  if (animation === 'pulse') {
    return {
      animation: "".concat(pulseKeyframe, " 1.5s ease-in-out .5s infinite")
    };
  }
  if (animation === 'wave') {
    var opacity = {
      dark: 0.08,
      light: 0.32
    }[colorMode];
    var colors = ['transparent', "rgba(255, 255, 255, ".concat(opacity, ")"), 'transparent'];
    return {
      position: 'relative',
      overflow: 'hidden',
      __after: {
        animation: "".concat(waveKeyframe, " 1.6s linear .5s infinite"),
        background: "linear-gradient(90deg,".concat(colors.join(','), ")"),
        content: '""',
        position: 'absolute',
        inset: 0,
        transform: 'translateX(-100%)' // Avoid flash during server-side hydration
      }
    };
  }

  return {
    animation: animation
  };
};
var getVariantProps = function getVariantProps(_ref2) {
  var variant = _ref2.variant;
  if (variant === 'text') {
    return {
      height: '3x',
      borderRadius: 'sm',
      _empty: {
        '::before': {
          content: '"\\00a0"'
        }
      }
    };
  }
  if (variant === 'rectangle') {
    return {}; // empty
  }

  if (variant === 'circle') {
    return {
      borderRadius: '50%'
    };
  }
  return {};
};
var useSkeletonStyle = function useSkeletonStyle(_ref3) {
  var animation = _ref3.animation,
    variant = _ref3.variant;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var backgroundColor = {
    dark: 'rgba(255, 255, 255, 0.08)',
    light: 'rgba(0, 0, 0, 0.08)'
  }[colorMode];
  var animationProps = getAnimationProps({
    animation: animation,
    colorMode: colorMode
  });
  var variantProps = getVariantProps({
    variant: variant
  });
  return _objectSpread2(_objectSpread2({
    display: 'block',
    backgroundColor: backgroundColor
  }, animationProps), variantProps);
};

var _excluded$A = ["animation", "variant"];
var defaultVariant$3 = 'text';
var Skeleton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _variant;
  var animation = _ref.animation,
    variant = _ref.variant,
    rest = _objectWithoutProperties(_ref, _excluded$A);
  {
    // deprecation warning
    var prefix = "".concat(Skeleton.displayName, ":");
    useOnceWhen(function () {
      warnDeprecatedProps('variant="rect"', {
        prefix: prefix,
        alternative: 'variant="rectangle"',
        willRemove: true
      });
    }, variant === 'rect');
    if (variant === 'rect') {
      variant = 'rectangle';
    }
  }

  // Use fallback values if values are null or undefined
  variant = (_variant = variant) !== null && _variant !== void 0 ? _variant : defaultVariant$3;
  var styleProps = useSkeletonStyle({
    animation: animation,
    variant: variant
  });
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), rest));
});
Skeleton.displayName = 'Skeleton';

var Space = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(Box, _objectSpread2({
    ref: ref,
    display: "inline-flex"
  }, props));
});
Space.displayName = 'Space';

var useStackStyle = function useStackStyle(_ref) {
  var direction = _ref.direction,
    spacing = _ref.spacing;
  return _objectSpread2(_objectSpread2({
    display: 'flex',
    flexDirection: direction
  }, (direction === 'column' || direction === 'column-reverse') && {
    rowGap: spacing
  }), (direction === 'row' || direction === 'row-reverse') && {
    columnGap: spacing
  });
};
var useStackItemStyle = function useStackItemStyle() {
  return {
    display: 'inline-block'
  };
};

var StackItem = /*#__PURE__*/forwardRef(function (props, ref) {
  var styleProps = useStackItemStyle();
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), props));
});
StackItem.displayName = 'StackItem';

var _excluded$z = ["children", "direction", "flexDirection", "shouldWrapChildren", "spacing"];
var defaultDirection = 'column';
var Stack = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref2;
  var children = _ref.children,
    directionProp = _ref.direction,
    flexDirectionProp = _ref.flexDirection,
    shouldWrapChildren = _ref.shouldWrapChildren,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? 0 : _ref$spacing,
    rest = _objectWithoutProperties(_ref, _excluded$z);
  var direction = (_ref2 = flexDirectionProp !== null && flexDirectionProp !== void 0 ? flexDirectionProp : directionProp) !== null && _ref2 !== void 0 ? _ref2 : defaultDirection;
  var styleProps = useStackStyle({
    direction: direction,
    spacing: spacing
  });

  // Filter only the valid children of a component, and ignore any nullish or falsy child.
  var validChildren = React.Children.toArray(children).filter(function (c) {
    return /*#__PURE__*/React.isValidElement(c);
  });
  var clones = validChildren;
  if (shouldWrapChildren) {
    clones = validChildren.map(function (child, index) {
      // Use the provided child key, otherwise use the index as fallback
      var key = typeof child.key !== 'undefined' ? child.key : index;
      return jsx(StackItem, {
        children: child
      }, key);
    });
  }
  return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), rest), {}, {
    children: clones
  }));
});
Stack.displayName = 'Stack';

var defaultSize$1 = 'md';
var defaultVariantColor = 'blue';

var useSwitchStyle = function useSwitchStyle(_ref) {
  var disabled = _ref.disabled;
  return {
    display: 'inline-flex',
    verticalAlign: 'top',
    alignItems: 'center',
    cursor: disabled ? 'not-allowed' : 'pointer'
  };
};
var useSwitchControlBoxStyle = function useSwitchControlBoxStyle(_ref2) {
  var color = _ref2.color,
    width = _ref2.width,
    height = _ref2.height;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var trackHaloWidth = 2;
  var trackBorderWidth = 1;
  var viewBoxWidth = width + (trackHaloWidth + trackBorderWidth) * 2;
  var viewBoxHeight = height + (trackHaloWidth + trackBorderWidth) * 2;
  var focusAndCheckedColor = {
    dark: "".concat(color, ":60"),
    light: "".concat(color, ":40")
  }[colorMode];
  var checkedAndHoverColor = {
    dark: "".concat(color, ":50"),
    light: "".concat(color, ":30")
  }[colorMode];
  var trackBorderColor = {
    dark: 'black',
    light: 'white'
  }[colorMode];
  return {
    width: viewBoxWidth,
    height: viewBoxHeight,
    _child: {
      opacity: 1
    },
    _hover: {
      '[data-switch] [data-switch-track]': {
        fill: 'gray:50'
      }
    },
    _focus: {
      '[data-switch] [data-switch-track-halo]': {
        fill: focusAndCheckedColor
      },
      '[data-switch] [data-switch-track-border]': {
        fill: trackBorderColor
      }
    },
    _checked: {
      '[data-switch] [data-switch-track]': {
        fill: focusAndCheckedColor
      },
      '[data-switch] [data-switch-thumb]': {
        transform: "translateX(".concat(height, "px)")
      }
    },
    _checkedAndHover: {
      '[data-switch] [data-switch-track]': {
        fill: checkedAndHoverColor
      }
    },
    _disabled: {
      opacity: 0.28
    }
  };
};

var _excluded$y = ["size", "variantColor"];
var SwitchControlBox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaultSize$1 : _ref$size,
    _ref$variantColor = _ref.variantColor,
    variantColor = _ref$variantColor === void 0 ? defaultVariantColor : _ref$variantColor,
    rest = _objectWithoutProperties(_ref, _excluded$y);
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var width = {
    sm: 32,
    md: 48,
    lg: 64
  }[size];
  var height = {
    sm: 16,
    md: 24,
    lg: 32
  }[size];
  var radius = {
    sm: 6,
    md: 9,
    lg: 12
  }[size];
  var trackHaloWidth = 2;
  var trackBorderWidth = 1;
  var trackHaloX = 0;
  var trackHaloY = 0;
  var trackBorderX = trackHaloX + trackHaloWidth;
  var trackBorderY = trackHaloY + trackHaloWidth;
  var trackX = trackBorderX + trackBorderWidth;
  var trackY = trackBorderY + trackBorderWidth;
  var viewBoxWidth = width + (trackHaloWidth + trackBorderWidth) * 2;
  var viewBoxHeight = height + (trackHaloWidth + trackBorderWidth) * 2;
  var trackFillColor = {
    dark: 'gray:60',
    light: 'gray:30'
  }[colorMode];
  var styleProps = useSwitchControlBoxStyle({
    color: variantColor,
    width: width,
    height: height
  });
  return jsx(ControlBox, _objectSpread2(_objectSpread2(_objectSpread2({
    type: "checkbox"
  }, styleProps), rest), {}, {
    children: jsxs(Box, {
      as: "svg",
      "data-switch": true,
      width: "100%",
      height: "100%",
      viewBox: "0 0 ".concat(viewBoxWidth, " ").concat(viewBoxHeight),
      children: [jsx(Box, {
        as: "rect",
        "data-switch-track-halo": true,
        x: trackHaloX,
        y: trackHaloY,
        width: viewBoxWidth,
        height: viewBoxHeight,
        rx: "".concat(viewBoxHeight / 2),
        fill: "none",
        strokeWidth: 0
      }), jsx(Box, {
        as: "rect",
        "data-switch-track-border": true,
        x: trackBorderX,
        y: trackBorderY,
        width: viewBoxWidth - 2 * trackHaloWidth,
        height: viewBoxHeight - 2 * trackHaloWidth,
        rx: (viewBoxHeight - 2 * trackHaloWidth) / 2,
        fill: "none",
        strokeWidth: 0
      }), jsx(Box, {
        as: "rect",
        "data-switch-track": true,
        x: trackX,
        y: trackY,
        width: width,
        height: height,
        rx: height / 2,
        fill: trackFillColor,
        pointerEvents: "all"
      }), jsx(Box, {
        as: "circle",
        "data-switch-thumb": true,
        cx: viewBoxHeight / 2,
        cy: viewBoxHeight / 2,
        r: radius,
        fill: "white:emphasis",
        transform: "translateX(0)",
        transformBox: "fill-box",
        transition: createTransitionStyle(['transform'], {
          duration: 250
        })
      })]
    })
  }));
});
SwitchControlBox.displayName = 'SwitchControlBox';

var _excluded$x = ["checked", "children", "defaultChecked", "disabled", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onClick", "onFocus", "size", "value", "variantColor"];
var Switch = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var checked = _ref.checked,
    children = _ref.children,
    defaultChecked = _ref.defaultChecked,
    disabled = _ref.disabled,
    id = _ref.id,
    inputProps = _ref.inputProps,
    inputRef = _ref.inputRef,
    name = _ref.name,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaultSize$1 : _ref$size,
    value = _ref.value,
    _ref$variantColor = _ref.variantColor,
    variantColor = _ref$variantColor === void 0 ? defaultVariantColor : _ref$variantColor,
    rest = _objectWithoutProperties(_ref, _excluded$x);
  var combinedInputRef = useMergeRefs(ref, inputRef); // TODO: Move the `ref` to the outermost element in the next major version
  var styleProps = useSwitchStyle({
    disabled: disabled
  });
  return jsxs(Box, _objectSpread2(_objectSpread2(_objectSpread2({
    as: "label"
  }, styleProps), rest), {}, {
    children: [jsx(VisuallyHidden, _objectSpread2({
      as: "input",
      checked: checked,
      defaultChecked: defaultChecked,
      disabled: disabled,
      id: id,
      name: name,
      onBlur: onBlur,
      onChange: onChange,
      onClick: onClick,
      onFocus: onFocus,
      ref: combinedInputRef,
      role: "switch",
      type: "checkbox",
      value: value
    }, inputProps)), jsx(SwitchControlBox, {
      size: size,
      variantColor: variantColor
    }), !isNullish(children) && jsx(Box, {
      ml: "2x",
      userSelect: "none",
      opacity: disabled ? 0.28 : 1,
      children: children
    })]
  }));
});
Switch.displayName = 'Switch';

var LAYOUT_FLEXBOX = 'flexbox';
var LAYOUT_TABLE = 'table';
var defaultLayout = LAYOUT_FLEXBOX;
var defaultSize = 'md';
var defaultVariant$2 = 'default';

var TableContext = /*#__PURE__*/createContext();

var useTableStyle = function useTableStyle(_ref) {
  var layout = _ref.layout;
  var layoutStyle = useMemo(function () {
    if (layout === LAYOUT_TABLE) {
      return {
        as: 'table',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        display: 'table'
      };
    }
    return {
      display: 'inline-flex',
      flexDirection: 'column'
    };
  }, [layout]);
  return _objectSpread2({}, layoutStyle);
};
var useTableHeaderStyle = function useTableHeaderStyle(_ref2) {
  var layout = _ref2.layout;
  var layoutStyle = useMemo(function () {
    if (layout === LAYOUT_TABLE) {
      return {
        as: 'thead',
        display: 'table-header-group'
      };
    }
    return {
      flex: 'none'
    };
  }, [layout]);
  return _objectSpread2({}, layoutStyle);
};
var useTableHeaderRowStyle = function useTableHeaderRowStyle(_ref3) {
  var layout = _ref3.layout;
  var layoutStyle = useMemo(function () {
    if (layout === LAYOUT_TABLE) {
      return {
        as: 'tr',
        display: 'table-row'
      };
    }
    return {
      display: 'flex',
      width: 'fit-content'
    };
  }, [layout]);
  return _objectSpread2({}, layoutStyle);
};
var useTableHeaderCellStyle = function useTableHeaderCellStyle(_ref4) {
  var layout = _ref4.layout,
    size = _ref4.size,
    variant = _ref4.variant;
  var theme = useTheme();
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var layoutStyle = useMemo(function () {
    if (layout === LAYOUT_TABLE) {
      return {
        as: 'th',
        display: 'table-cell',
        textAlign: 'start' // override the default center alignment
      };
    }

    return {};
  }, [layout]);
  var visualStyle = useMemo(function () {
    var sizes = theme.sizes;
    var borderColor = {
      dark: 'gray:70',
      light: 'gray:30'
    }[colorMode];
    var color = {
      dark: 'white:secondary',
      light: 'black:secondary'
    }[colorMode];
    var px = '3x';
    var py = {
      'sm': '1x',
      'md': '2x',
      'lg': '3x'
    }[size];
    var width = 150;
    if (variant === 'outline') {
      return {
        borderTop: 1,
        borderTopColor: borderColor,
        borderBottom: 2,
        borderBottomColor: borderColor,
        borderLeft: 1,
        borderLeftColor: borderColor,
        color: color,
        fontWeight: 'semibold',
        px: px,
        pt: "calc(".concat(sizes[py], " - ").concat(sizes['1q'], ")"),
        pb: "calc(".concat(sizes[py], " - ").concat(sizes['2q'], ")"),
        width: width,
        _lastChild: {
          borderRight: 1,
          borderRightColor: borderColor
        }
      };
    }
    return {
      borderBottom: 2,
      borderBottomColor: borderColor,
      color: color,
      fontWeight: 'semibold',
      px: px,
      pt: py,
      pb: "calc(".concat(sizes[py], " - ").concat(sizes['2q'], ")"),
      width: width
    };
  }, [theme, colorMode, size, variant]);
  return _objectSpread2(_objectSpread2({}, layoutStyle), visualStyle);
};
var useTableBodyStyle = function useTableBodyStyle(_ref5) {
  var layout = _ref5.layout;
  var layoutStyle = useMemo(function () {
    if (layout === LAYOUT_TABLE) {
      return {
        as: 'tbody',
        display: 'table-row-group'
      };
    }
    return {};
  }, [layout]);
  return _objectSpread2({}, layoutStyle);
};
var useTableRowCSS = function useTableRowCSS(_ref6) {
  var role = _ref6.role,
    variant = _ref6.variant;
  if (variant === 'outline') {
    var selector = "[role=".concat(role, "] + &[role=").concat(role, "] > *");
    return sx(_defineProperty({}, selector, {
      borderTopColor: 'transparent'
    }));
  }
  return {};
};
var useTableRowStyle = function useTableRowStyle(_ref7) {
  var layout = _ref7.layout;
  var layoutStyle = useMemo(function () {
    if (layout === LAYOUT_TABLE) {
      return {
        as: 'tr',
        display: 'table-row'
      };
    }
    return {
      display: 'flex',
      width: 'fit-content'
    };
  }, [layout]);
  return _objectSpread2({}, layoutStyle);
};
var useTableCellStyle = function useTableCellStyle(_ref8) {
  var layout = _ref8.layout,
    size = _ref8.size,
    variant = _ref8.variant;
  var theme = useTheme();
  var _useColorMode3 = useColorMode(),
    _useColorMode4 = _slicedToArray(_useColorMode3, 1),
    colorMode = _useColorMode4[0];
  var layoutStyle = useMemo(function () {
    if (layout === LAYOUT_TABLE) {
      return {
        as: 'td',
        display: 'table-cell'
      };
    }
    return {};
  }, [layout]);
  var visualStyle = useMemo(function () {
    var sizes = theme.sizes;
    var borderColor = {
      dark: 'gray:70',
      light: 'gray:30'
    }[colorMode];
    var color = {
      dark: 'white:primary',
      light: 'black:primary'
    }[colorMode];
    var px = '3x';
    var py = {
      'sm': '1x',
      'md': '2x',
      'lg': '3x'
    }[size];
    var width = 150;
    if (variant === 'outline') {
      return {
        borderBottom: 1,
        borderBottomColor: borderColor,
        borderLeft: 1,
        borderLeftColor: borderColor,
        color: color,
        px: px,
        pt: py,
        pb: "calc(".concat(sizes[py], " - ").concat(sizes['1q'], ")"),
        width: width,
        _lastChild: {
          borderRight: 1,
          borderRightColor: borderColor
        }
      };
    }
    return {
      borderBottom: 1,
      borderBottomColor: borderColor,
      color: color,
      px: px,
      pt: py,
      pb: "calc(".concat(sizes[py], " - ").concat(sizes['1q'], ")"),
      width: width
    };
  }, [theme, colorMode, size, variant]);
  return _objectSpread2(_objectSpread2({}, layoutStyle), visualStyle);
};
var useTableScrollbarTrackStyle = function useTableScrollbarTrackStyle() {
  var _useColorMode5 = useColorMode(),
    _useColorMode6 = _slicedToArray(_useColorMode5, 1),
    colorMode = _useColorMode6[0];
  var backgroundColor = {
    dark: 'gray:70',
    light: 'gray:30'
  }[colorMode];
  return {
    backgroundColor: backgroundColor
  };
};

var _excluded$w = ["isHoverable", "layout", "role", "size", "variant"];
var getMemoizedState$8 = memoize(function (state) {
  return _objectSpread2({}, state);
});
var Table = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isHoverable = _ref.isHoverable,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? defaultLayout : _ref$layout,
    roleProp = _ref.role,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaultSize : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? defaultVariant$2 : _ref$variant,
    rest = _objectWithoutProperties(_ref, _excluded$w);
  {
    // deprecation warning
    var prefix = "".concat(Table.displayName, ":");
    useOnceWhen(function () {
      warnRemovedProps('isHoverable', {
        prefix: prefix,
        message: 'Use the \'_hover\' prop on the \'TableRow\' component instead.'
      });
    }, isHoverable !== undefined);
  }
  var role = roleProp !== null && roleProp !== void 0 ? roleProp : 'table';
  var styleProps = useTableStyle({
    layout: layout
  });
  var context = getMemoizedState$8({
    layout: layout,
    size: size,
    variant: variant
  });
  return jsx(TableContext.Provider, {
    value: context,
    children: jsx(Box, _objectSpread2(_objectSpread2({
      ref: ref,
      role: role
    }, styleProps), rest))
  });
});
Table.displayName = 'Table';

var useTable = function useTable() {
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(TableContext);
  return context;
};

var _excluded$v = ["role"];
var TableHeader = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var roleProp = _ref.role,
    rest = _objectWithoutProperties(_ref, _excluded$v);
  var role = roleProp || 'rowgroup';
  var _useTable = useTable(),
    layout = _useTable.layout;
  var styleProps = useTableHeaderStyle({
    layout: layout
  });
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref,
    role: role
  }, styleProps), rest));
});
TableHeader.displayName = 'TableHeader';

var _excluded$u = ["role"];
var TableHeaderRow = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var roleProp = _ref.role,
    rest = _objectWithoutProperties(_ref, _excluded$u);
  var role = roleProp !== null && roleProp !== void 0 ? roleProp : 'row';
  var _useTable = useTable(),
    layout = _useTable.layout;
  var styleProps = useTableHeaderRowStyle({
    layout: layout
  });
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref,
    role: role
  }, styleProps), rest));
});
TableHeaderRow.displayName = 'TableHeaderRow';

var _excluded$t = ["role"];
var TableHeaderCell = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var roleProp = _ref.role,
    rest = _objectWithoutProperties(_ref, _excluded$t);
  var role = roleProp !== null && roleProp !== void 0 ? roleProp : 'columnheader';
  var _useTable = useTable(),
    layout = _useTable.layout,
    size = _useTable.size,
    variant = _useTable.variant;
  var styleProps = useTableHeaderCellStyle({
    layout: layout,
    size: size,
    variant: variant
  });
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref,
    role: role
  }, styleProps), rest));
});
TableHeaderCell.displayName = 'TableHeaderCell';

var _excluded$s = ["role"];
var TableBody = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var roleProp = _ref.role,
    rest = _objectWithoutProperties(_ref, _excluded$s);
  var role = roleProp !== null && roleProp !== void 0 ? roleProp : 'rowgroup';
  var _useTable = useTable(),
    layout = _useTable.layout;
  var styleProps = useTableBodyStyle({
    layout: layout
  });
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref,
    role: role
  }, styleProps), rest));
});
TableBody.displayName = 'TableBody';

var _excluded$r = ["css", "role"];
var TableRow = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var cssProp = _ref.css,
    roleProp = _ref.role,
    rest = _objectWithoutProperties(_ref, _excluded$r);
  var role = roleProp !== null && roleProp !== void 0 ? roleProp : 'row';
  var _useTable = useTable(),
    layout = _useTable.layout,
    variant = _useTable.variant;
  var css = [useTableRowCSS({
    role: role,
    variant: variant
  }), cssProp];
  var styleProps = useTableRowStyle({
    layout: layout
  });
  return jsx(Box, _objectSpread2(_objectSpread2({
    css: css,
    ref: ref,
    role: role
  }, styleProps), rest));
});
TableRow.displayName = 'TableRow';

var _excluded$q = ["role"];
var TableCell = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var roleProp = _ref.role,
    rest = _objectWithoutProperties(_ref, _excluded$q);
  var role = roleProp !== null && roleProp !== void 0 ? roleProp : 'cell';
  var _useTable = useTable(),
    layout = _useTable.layout,
    size = _useTable.size,
    variant = _useTable.variant;
  var styleProps = useTableCellStyle({
    layout: layout,
    size: size,
    variant: variant
  });
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref,
    role: role
  }, styleProps), rest));
});
TableCell.displayName = 'TableCell';

var _excluded$p = ["children"];
var TableScrollbar = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$p);
  var trackStyleProps = useTableScrollbarTrackStyle();
  return jsx(Scrollbar, _objectSpread2(_objectSpread2({
    ref: ref
  }, rest), {}, {
    children: function children(_ref2) {
      var ScrollView = _ref2.ScrollView,
        HorizontalTrack = _ref2.HorizontalTrack,
        VerticalTrack = _ref2.VerticalTrack,
        HorizontalThumb = _ref2.HorizontalThumb,
        VerticalThumb = _ref2.VerticalThumb,
        getScrollViewProps = _ref2.getScrollViewProps,
        getHorizontalTrackProps = _ref2.getHorizontalTrackProps,
        getVerticalTrackProps = _ref2.getVerticalTrackProps,
        getHorizontalThumbProps = _ref2.getHorizontalThumbProps,
        getVerticalThumbProps = _ref2.getVerticalThumbProps;
      return jsxs(Fragment, {
        children: [jsx(ScrollView, _objectSpread2(_objectSpread2({}, getScrollViewProps()), {}, {
          children: _children
        })), jsx(HorizontalTrack, _objectSpread2(_objectSpread2(_objectSpread2({}, getHorizontalTrackProps()), trackStyleProps), {}, {
          children: jsx(HorizontalThumb, _objectSpread2({}, getHorizontalThumbProps()))
        })), jsx(VerticalTrack, _objectSpread2(_objectSpread2(_objectSpread2({}, getVerticalTrackProps()), trackStyleProps), {}, {
          children: jsx(VerticalThumb, _objectSpread2({}, getVerticalThumbProps()))
        }))]
      });
    }
  }));
});
TableScrollbar.displayName = 'TableScrollbar';

Table.Header = TableHeader;
Table.HeaderRow = TableHeaderRow;
Table.HeaderCell = TableHeaderCell;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Cell = TableCell;

var useTabStyle = function useTabStyle(_ref) {
  var disabled = _ref.disabled,
    isSelected = _ref.isSelected,
    orientation = _ref.orientation,
    tabIndex = _ref.tabIndex,
    variant = _ref.variant;
  var theme = useTheme();
  var sizes = theme.sizes;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var getCursorStyle = function getCursorStyle() {
    if (disabled) {
      return 'not-allowed';
    }
    if (isSelected) {
      return 'default';
    }
    return 'pointer';
  };
  if (variant === 'default') {
    var _hover, _selected;
    // border color
    var disabledBorderColor = 'transparent';
    var focusBorderColor = {
      dark: 'blue:60',
      light: 'blue:60'
    }[colorMode];
    var hoverBorderColor = {
      dark: 'gray:60',
      light: 'gray:60'
    }[colorMode];
    var selectedBorderColor = {
      dark: 'red:60',
      light: 'red:60'
    }[colorMode];

    // color
    var color = {
      dark: 'white:secondary',
      light: 'black:secondary'
    }[colorMode];
    var disabledColor = {
      dark: 'white:disabled',
      light: 'black:disabled'
    }[colorMode];
    var focusColor = {
      dark: 'white:primary',
      light: 'black:primary'
    }[colorMode];
    var hoverColor = {
      dark: 'white:primary',
      light: 'black:primary'
    }[colorMode];
    var selectedColor = {
      dark: 'white:primary',
      light: 'black:primary'
    }[colorMode];
    var getBorderColorStyleWithFallback = function getBorderColorStyleWithFallback(fallbackBorderColor) {
      if (disabled && isSelected) {
        // Returns the selected border color if the tab is both disabled and selected
        return selectedBorderColor;
      }
      if (disabled) {
        // Returns the disabled border color if the tab is disabled
        return disabledBorderColor;
      }
      if (isSelected) {
        // Returns the selected border color if the tab is selected
        return selectedBorderColor;
      }
      // Returns the fallback border color
      return fallbackBorderColor;
    };
    var getColorStyleWithFallback = function getColorStyleWithFallback(fallbackColor) {
      if (disabled) {
        // Returns the disabled color if the tab is disabled
        return disabledColor;
      }
      if (isSelected) {
        // Returns the selected color if the tab is selected
        return selectedColor;
      }
      // Returns the fallback color
      return fallbackColor;
    };
    var selectedPaddingXKey = {
      'horizontal': 'px',
      'vertical': 'pr'
    }[orientation];
    var selectedPaddingYKey = {
      'horizontal': 'pt',
      'vertical': 'py'
    }[orientation];
    var selectedBorderColorKey = {
      'horizontal': 'borderBottomColor',
      'vertical': 'borderLeftColor'
    }[orientation];
    var selectedBorderStyleKey = {
      'horizontal': 'borderBottomStyle',
      'vertical': 'borderLeftStyle'
    }[orientation];
    var selectedBorderWidthKey = {
      'horizontal': 'borderBottomWidth',
      'vertical': 'borderLeftWidth'
    }[orientation];
    return {
      fontSize: 'sm',
      lineHeight: 'sm',
      borderColor: 'transparent',
      borderStyle: 'solid',
      borderWidth: '1h',
      color: getColorStyleWithFallback(color),
      cursor: getCursorStyle(),
      display: 'flex',
      alignItems: 'center',
      px: '3x',
      py: '2x',
      outline: tabIndex < 0 ? 0 : undefined,
      // Remove the default outline for tabindex="-1"
      _hover: (_hover = {
        border: 'none'
      }, _defineProperty(_hover, selectedBorderColorKey, getBorderColorStyleWithFallback(hoverBorderColor)), _defineProperty(_hover, selectedBorderStyleKey, 'solid'), _defineProperty(_hover, selectedBorderWidthKey, '1h'), _defineProperty(_hover, "color", getColorStyleWithFallback(hoverColor)), _defineProperty(_hover, selectedPaddingXKey, "calc(".concat(sizes === null || sizes === void 0 ? void 0 : sizes['3x'], " + ").concat(sizes === null || sizes === void 0 ? void 0 : sizes['1h'], ")")), _defineProperty(_hover, selectedPaddingYKey, "calc(".concat(sizes === null || sizes === void 0 ? void 0 : sizes['2x'], " + ").concat(sizes === null || sizes === void 0 ? void 0 : sizes['1h'], ")")), _hover),
      _focus: {
        borderColor: getBorderColorStyleWithFallback(focusBorderColor),
        color: getColorStyleWithFallback(focusColor)
      },
      _selected: (_selected = {
        border: 'none'
      }, _defineProperty(_selected, selectedBorderColorKey, getBorderColorStyleWithFallback(selectedBorderColor)), _defineProperty(_selected, selectedBorderStyleKey, 'solid'), _defineProperty(_selected, selectedBorderWidthKey, '1h'), _defineProperty(_selected, "color", getColorStyleWithFallback(selectedColor)), _defineProperty(_selected, selectedPaddingXKey, "calc(".concat(sizes === null || sizes === void 0 ? void 0 : sizes['3x'], " + ").concat(sizes === null || sizes === void 0 ? void 0 : sizes['1h'], ")")), _defineProperty(_selected, selectedPaddingYKey, "calc(".concat(sizes === null || sizes === void 0 ? void 0 : sizes['2x'], " + ").concat(sizes === null || sizes === void 0 ? void 0 : sizes['1h'], ")")), _selected)
    };
  }
  if (variant === 'filled') {
    var _ref2;
    // background color
    var backgroundColor = {
      dark: 'gray:90',
      light: 'gray:30'
    }[colorMode];
    var disabledBackgroundColor = {
      dark: 'gray:90',
      light: 'gray:30'
    }[colorMode];
    var focusBackgroundColor = {
      dark: 'gray:90',
      light: 'gray:20'
    }[colorMode];
    var hoverBackgroundColor = {
      dark: 'gray:70',
      light: 'gray:10'
    }[colorMode];
    var selectedBackgroundColor = {
      dark: 'gray:80',
      light: 'gray:20'
    }[colorMode];

    // border color
    var borderColor = {
      dark: 'gray:80',
      light: 'gray:20'
    }[colorMode];
    var _disabledBorderColor = {
      dark: 'gray:80',
      light: 'gray:20'
    }[colorMode];
    var _focusBorderColor = {
      dark: 'blue:60',
      light: 'blue:60'
    }[colorMode];
    var _hoverBorderColor = {
      dark: 'gray:70',
      light: 'gray:20'
    }[colorMode];
    var _selectedBorderColor = {
      dark: 'gray:80',
      light: 'gray:20'
    }[colorMode];

    // color
    var _color = {
      dark: 'white:primary',
      light: 'black:primary'
    }[colorMode];
    var _disabledColor = {
      dark: 'white:disabled',
      light: 'black:disabled'
    }[colorMode];
    var _focusColor = {
      dark: 'white:primary',
      light: 'black:primary'
    }[colorMode];
    var _hoverColor = {
      dark: 'white:primary',
      light: 'black:primary'
    }[colorMode];
    var _selectedColor = {
      dark: 'white:primary',
      light: 'black:primary'
    }[colorMode];
    var getBackgroundColorStyleWithFallback = function getBackgroundColorStyleWithFallback(fallbackBackgroundColor) {
      if (disabled) {
        // Returns the disabled background color if the tab is disabled
        return disabledBackgroundColor;
      }
      if (isSelected) {
        // Returns the selected background color if the tab is selected
        return selectedBackgroundColor;
      }
      // Returns the fallback color
      return fallbackBackgroundColor;
    };
    var _getBorderColorStyleWithFallback = function _getBorderColorStyleWithFallback(fallbackBorderColor) {
      if (disabled && isSelected) {
        // Returns the selected border color if the tab is both disabled and selected
        return _selectedBorderColor;
      }
      if (disabled) {
        // Returns the disabled border color if the tab is disabled
        return _disabledBorderColor;
      }
      if (isSelected) {
        // Returns the selected border color if the tab is selected
        return _selectedBorderColor;
      }
      // Returns the fallback border color
      return fallbackBorderColor;
    };
    var _getColorStyleWithFallback = function _getColorStyleWithFallback(fallbackColor) {
      if (disabled) {
        // Returns the disabled color if the tab is disabled
        return _disabledColor;
      }
      if (isSelected) {
        // Returns the selected color if the tab is selected
        return _selectedColor;
      }
      // Returns the fallback color
      return fallbackColor;
    };
    var siblingMarginKey = {
      'horizontal': 'mr',
      'vertical': 'mb'
    }[orientation];
    return _ref2 = {
      fontSize: 'sm',
      lineHeight: 'sm',
      backgroundColor: getBackgroundColorStyleWithFallback(backgroundColor),
      borderColor: _getBorderColorStyleWithFallback(borderColor),
      borderStyle: 'solid',
      borderWidth: '1q',
      color: _getColorStyleWithFallback(_color),
      cursor: getCursorStyle(),
      display: 'flex',
      alignItems: 'center',
      px: "calc(".concat(sizes === null || sizes === void 0 ? void 0 : sizes['3x'], " + ").concat(sizes === null || sizes === void 0 ? void 0 : sizes['1q'], ")"),
      py: "calc(".concat(sizes === null || sizes === void 0 ? void 0 : sizes['2x'], " + ").concat(sizes === null || sizes === void 0 ? void 0 : sizes['1q'], ")")
    }, _defineProperty(_ref2, siblingMarginKey, '-1q'), _defineProperty(_ref2, "_hover", {
      backgroundColor: getBackgroundColorStyleWithFallback(hoverBackgroundColor),
      borderColor: _getBorderColorStyleWithFallback(_hoverBorderColor),
      color: _getColorStyleWithFallback(_hoverColor)
    }), _defineProperty(_ref2, "_focus", {
      backgroundColor: getBackgroundColorStyleWithFallback(focusBackgroundColor),
      borderColor: _getBorderColorStyleWithFallback(_focusBorderColor),
      borderStyle: 'solid',
      borderWidth: '1h',
      color: _getColorStyleWithFallback(_focusColor),
      px: '3x',
      py: '2x',
      zIndex: 1
    }), _defineProperty(_ref2, "_selected", {
      backgroundColor: getBackgroundColorStyleWithFallback(selectedBackgroundColor),
      borderColor: _getBorderColorStyleWithFallback(_selectedBorderColor),
      color: _getColorStyleWithFallback(_selectedColor)
    }), _defineProperty(_ref2, "_lastOfType", _defineProperty({}, siblingMarginKey, 0)), _ref2;
  }
  return {
    cursor: getCursorStyle(),
    display: 'flex',
    alignItems: 'center'
  };
};
var useTabsStyle = function useTabsStyle(_ref3) {
  var orientation = _ref3.orientation;
  var flexDirection = {
    'horizontal': 'column',
    'vertical': 'row'
  }[orientation];
  return {
    display: 'flex',
    flexDirection: flexDirection
  };
};
var useTabListStyle = function useTabListStyle(_ref4) {
  var orientation = _ref4.orientation;
  var flexDirection = {
    'horizontal': 'row',
    'vertical': 'column'
  }[orientation];
  return {
    display: 'flex',
    flexDirection: flexDirection
  };
};
var useTabPanelStyle = function useTabPanelStyle(_ref5) {
  _ref5.tabIndex;
  return {
    // Remove the default outline for accessibility reasons, even when the TabPanel is focused using the keyboard (regardless of the tabIndex value specified on the TabPanel).
    outline: 0
  };
};

var TabsContext = /*#__PURE__*/createContext();

var useTabs = function useTabs() {
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(TabsContext);
  return context;
};

var _excluded$o = ["children", "disabled", "index", "onClick"];
var isIndexEqual$1 = function isIndexEqual(index1, index2) {
  return !isNullOrUndefined(index1) && !isNullOrUndefined(index2) && index1 === index2;
};
var Tab = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    disabledProp = _ref.disabled,
    indexProp = _ref.index,
    onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded$o);
  var _useState = useState(indexProp),
    _useState2 = _slicedToArray(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var context = useTabs();
  var registerTab = ensureFunction(context === null || context === void 0 ? void 0 : context.registerTab);
  var unregisterTab = ensureFunction(context === null || context === void 0 ? void 0 : context.unregisterTab);
  var tabId = "".concat(config.name, ":Tab-").concat(index);
  var tabPanelId = "".concat(config.name, ":TabPanel-").concat(index);
  var disabled = disabledProp !== null && disabledProp !== void 0 ? disabledProp : context === null || context === void 0 ? void 0 : context.disabled;
  var isSelected = isIndexEqual$1(index, context === null || context === void 0 ? void 0 : context.index);
  var orientation = context === null || context === void 0 ? void 0 : context.orientation;
  var variant = context === null || context === void 0 ? void 0 : context.variant;
  var tabIndex = disabled || isSelected ? -1 : 0;
  var styleProps = useTabStyle({
    disabled: disabled,
    isSelected: isSelected,
    orientation: orientation,
    variant: variant,
    tabIndex: tabIndex
  });
  var handleClick = callEventHandlers(onClick, function (event) {
    if (isSelected) {
      // Do not trigger onChange if the tab is already selected
      return;
    }
    ensureFunction(context === null || context === void 0 ? void 0 : context.onChange)(index);
  });

  // Ensure the tab is registered only once at the first render
  useEffectOnce(function () {
    if (isNullOrUndefined(index)) {
      var newIndex = registerTab();
      setIndex(newIndex);
      return function () {
        unregisterTab(newIndex);
      };
    }
    registerTab(index);
    return function () {
      unregisterTab(index);
    };
  });
  var getTabProps = function getTabProps() {
    return _objectSpread2(_objectSpread2({
      'aria-controls': tabPanelId,
      'aria-selected': ariaAttr(isSelected),
      'data-index': index,
      disabled: disabled,
      id: tabId,
      onClick: handleClick,
      ref: ref,
      role: 'tab',
      tabIndex: tabIndex
    }, styleProps), rest);
  };
  var tabContext = {
    getTabProps: getTabProps,
    disabled: disabled,
    index: index,
    isSelected: isSelected
  };
  {
    // deprecation warning
    var prefix = "".concat(Tab.displayName, ":");
    Object.defineProperties(tabContext, {
      isActive: {
        get: function get() {
          warnDeprecatedProps('isActive', {
            prefix: prefix,
            alternative: 'isSelected',
            willRemove: true
          });
          return isSelected;
        }
      }
    });
  }
  if (typeof children === 'function') {
    return children(tabContext);
  }
  return jsx(ButtonBase, _objectSpread2(_objectSpread2({}, getTabProps()), {}, {
    children: children
  }));
});
Tab.displayName = 'Tab';

var defaultOrientation = 'horizontal';
var defaultVariant$1 = 'default';

var _excluded$n = ["activateOnKeyPress", "isFitted", "isManual", "children", "defaultIndex", "disabled", "index", "onChange", "orientation", "variant"];
var getMemoizedState$7 = memoize(function (state) {
  return _objectSpread2({}, state);
});
var stateReducer = function stateReducer(prevState, nextState) {
  return _objectSpread2(_objectSpread2({}, prevState), typeof nextState === 'function' ? nextState(prevState) : nextState);
};
var Tabs = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var activateOnKeyPress = _ref.activateOnKeyPress,
    isFitted = _ref.isFitted,
    isManual = _ref.isManual,
    children = _ref.children,
    _ref$defaultIndex = _ref.defaultIndex,
    defaultIndex = _ref$defaultIndex === void 0 ? 0 : _ref$defaultIndex,
    disabled = _ref.disabled,
    indexProp = _ref.index,
    onChange = _ref.onChange,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? defaultOrientation : _ref$orientation,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? defaultVariant$1 : _ref$variant,
    rest = _objectWithoutProperties(_ref, _excluded$n);
  {
    // deprecation warning
    var prefix = "".concat(Tabs.displayName, ":");
    useOnceWhen(function () {
      warnRemovedProps('activateOnKeyPress', {
        prefix: prefix
      });
    }, activateOnKeyPress !== undefined);
    useOnceWhen(function () {
      warnRemovedProps('isFitted', {
        prefix: prefix
      });
    }, isFitted !== undefined);
    useOnceWhen(function () {
      warnRemovedProps('isManual', {
        prefix: prefix
      });
    }, isManual !== undefined);
    useOnceWhen(function () {
      warnDeprecatedProps('variant="line"', {
        prefix: prefix,
        alternative: 'variant="default"',
        willRemove: true
      });
    }, variant === 'line');
    useOnceWhen(function () {
      warnDeprecatedProps('variant="enclosed"', {
        prefix: prefix,
        alternative: 'variant="filled"',
        willRemove: true
      });
    }, variant === 'enclosed');
    if (variant === 'line') {
      variant = 'default';
    }
    if (variant === 'enclosed') {
      variant = 'filled';
    }
  }
  var tabMap = useConst(function () {
    return new Map();
  });
  var tabPanelMap = useConst(function () {
    return new Map();
  });
  var _useReducer = useReducer(stateReducer, {
      index: indexProp !== null && indexProp !== void 0 ? indexProp : defaultIndex
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    setState = _useReducer2[1];
  useEffect(function () {
    if (indexProp !== undefined) {
      setState({
        index: indexProp
      });
    }
  }, [indexProp]);
  var handleChange = function handleChange(index) {
    if (indexProp !== undefined) {
      setState({
        index: indexProp
      });
    } else {
      setState({
        index: index
      });
    }
    if (typeof onChange === 'function') {
      onChange(index);
    }
  };
  var registerTab = function registerTab(index) {
    var nextIndex = isNullOrUndefined(index) ? tabMap.size : index;
    tabMap.set(nextIndex, true);
    return nextIndex;
  };
  var unregisterTab = function unregisterTab(index) {
    return tabMap["delete"](index);
  };
  var registerTabPanel = function registerTabPanel(index) {
    var nextIndex = isNullOrUndefined(index) ? tabPanelMap.size : index;
    tabPanelMap.set(nextIndex, true);
    return nextIndex;
  };
  var unregisterTabPanel = function unregisterTabPanel(index) {
    return tabPanelMap["delete"](index);
  };
  var context = getMemoizedState$7({
    disabled: disabled,
    index: state.index,
    onChange: handleChange,
    orientation: orientation,
    variant: variant,
    registerTab: registerTab,
    registerTabPanel: registerTabPanel,
    unregisterTab: unregisterTab,
    unregisterTabPanel: unregisterTabPanel
  });
  var styleProps = useTabsStyle({
    orientation: orientation
  });
  return jsx(TabsContext.Provider, {
    value: context,
    children: jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
      ref: ref
    }, styleProps), rest), {}, {
      children: runIfFn(children, context)
    }))
  });
});
Tabs.displayName = 'Tabs';

var _excluded$m = ["aria-label"];
var TabList = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var ariaLabel = _ref['aria-label'],
    rest = _objectWithoutProperties(_ref, _excluded$m);
  var context = useTabs();
  var orientation = context === null || context === void 0 ? void 0 : context.orientation;
  var styleProps = useTabListStyle({
    orientation: orientation
  });
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref,
    "aria-label": ariaLabel,
    "aria-orientation": orientation,
    role: "tablist"
  }, styleProps), rest));
});
TabList.displayName = 'TabList';

var _excluded$l = ["children", "index"];
var isIndexEqual = function isIndexEqual(index1, index2) {
  return !isNullOrUndefined(index1) && !isNullOrUndefined(index2) && index1 === index2;
};
var TabPanel = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    indexProp = _ref.index,
    rest = _objectWithoutProperties(_ref, _excluded$l);
  var _useState = useState(indexProp),
    _useState2 = _slicedToArray(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var context = useTabs();
  var registerTabPanel = ensureFunction(context === null || context === void 0 ? void 0 : context.registerTabPanel);
  var unregisterTabPanel = ensureFunction(context === null || context === void 0 ? void 0 : context.unregisterTabPanel);
  var tabId = "".concat(config.name, ":Tab-").concat(index);
  var tabPanelId = "".concat(config.name, ":TabPanel-").concat(index);
  var isSelected = isIndexEqual(index, context === null || context === void 0 ? void 0 : context.index);
  var tabIndex = 0;
  var styleProps = useTabPanelStyle({
    tabIndex: tabIndex
  });

  // Ensure the tab panel is registered only once at the first render
  useEffectOnce(function () {
    if (isNullOrUndefined(index)) {
      var newIndex = registerTabPanel();
      setIndex(newIndex);
      return function () {
        unregisterTabPanel(newIndex);
      };
    }
    registerTabPanel(index);
    return function () {
      unregisterTabPanel(index);
    };
  });
  var getTabPanelProps = function getTabPanelProps() {
    return _objectSpread2(_objectSpread2({
      'aria-hidden': ariaAttr(!isSelected),
      'aria-labelledby': tabId,
      hidden: !isSelected,
      id: tabPanelId,
      ref: ref,
      role: 'tabpanel',
      tabIndex: tabIndex
    }, styleProps), rest);
  };
  var tabPanelContext = {
    getTabPanelProps: getTabPanelProps,
    index: index,
    isSelected: isSelected
  };
  {
    // deprecation warning
    var prefix = "".concat(TabPanel.displayName, ":");
    Object.defineProperties(tabPanelContext, {
      isActive: {
        get: function get() {
          warnDeprecatedProps('isActive', {
            prefix: prefix,
            alternative: 'isSelected',
            willRemove: true
          });
          return isSelected;
        }
      }
    });
  }
  if (typeof children === 'function') {
    return children(tabPanelContext);
  }
  return jsx(Box, _objectSpread2(_objectSpread2({}, getTabPanelProps()), {}, {
    children: children
  }));
});
TabPanel.displayName = 'TabPanel';

var TabPanels = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(Box, _objectSpread2({
    ref: ref
  }, props));
});
TabPanels.displayName = 'TabPanels';

var getSolidTagStyle = function getSolidTagStyle(_ref) {
  var _theme$colors, _theme$colors2, _theme$sizes, _theme$colors3, _theme$colors4, _theme$sizes2;
  var colorProp = _ref.color,
    colorMode = _ref.colorMode,
    theme = _ref.theme;
  var undefinedColor = {
    dark: {
      backgroundColor: "".concat(colorProp, ":80"),
      color: "".concat(colorProp, ":20")
    },
    light: {
      backgroundColor: "".concat(colorProp, ":80"),
      color: "".concat(colorProp, ":20")
    }
  }[colorMode];
  var solidColors = {
    dark: {
      gray: {
        backgroundColor: 'gray:70',
        color: 'gray:20'
      },
      red: {
        backgroundColor: 'red:80',
        color: 'red:20'
      },
      magenta: {
        backgroundColor: 'magenta:80',
        color: 'magenta:20'
      },
      purple: {
        backgroundColor: 'purple:80',
        color: 'purple:20'
      },
      blue: {
        backgroundColor: 'blue:80',
        color: 'blue:20'
      },
      green: {
        backgroundColor: 'green:70',
        color: 'green:20'
      },
      teal: {
        backgroundColor: 'teal:70',
        color: 'teal:20'
      },
      cyan: {
        backgroundColor: 'cyan:70',
        color: 'cyan:20'
      }
    },
    light: {
      gray: {
        backgroundColor: 'gray:70',
        color: 'gray:20'
      },
      red: {
        backgroundColor: 'red:80',
        color: 'red:20'
      },
      magenta: {
        backgroundColor: 'magenta:80',
        color: 'magenta:20'
      },
      purple: {
        backgroundColor: 'purple:80',
        color: 'purple:20'
      },
      blue: {
        backgroundColor: 'blue:80',
        color: 'blue:20'
      },
      green: {
        backgroundColor: 'green:70',
        color: 'green:20'
      },
      teal: {
        backgroundColor: 'teal:70',
        color: 'teal:20'
      },
      cyan: {
        backgroundColor: 'cyan:70',
        color: 'cyan:20'
      }
    }
  }[colorMode];
  var baseColors = solidColors[colorProp] || undefinedColor;

  // Normal
  var backgroundColor = {
    dark: 'gray:70',
    light: 'gray:20'
  }[colorMode];
  var color = {
    dark: 'gray:20',
    light: 'black:emphasis'
  }[colorMode];
  // Focus
  var focusColor = {
    dark: theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors['blue:60'],
    light: theme === null || theme === void 0 ? void 0 : (_theme$colors2 = theme.colors) === null || _theme$colors2 === void 0 ? void 0 : _theme$colors2['blue:60']
  }[colorMode];
  var focusBoxShadowSpreadRadius = theme === null || theme === void 0 ? void 0 : (_theme$sizes = theme.sizes) === null || _theme$sizes === void 0 ? void 0 : _theme$sizes['1q'];
  var boxShadowColor = {
    dark: theme === null || theme === void 0 ? void 0 : (_theme$colors3 = theme.colors) === null || _theme$colors3 === void 0 ? void 0 : _theme$colors3['black:emphasis'],
    light: theme === null || theme === void 0 ? void 0 : (_theme$colors4 = theme.colors) === null || _theme$colors4 === void 0 ? void 0 : _theme$colors4['white:emphasis']
  }[colorMode];
  var boxShadowSpreadRadius = theme === null || theme === void 0 ? void 0 : (_theme$sizes2 = theme.sizes) === null || _theme$sizes2 === void 0 ? void 0 : _theme$sizes2['2q'];
  // Disable
  var disabledOpacity = {
    dark: 0.28,
    light: 0.3
  }[colorMode];
  // Invalid
  var invalidBackgroundColor = {
    dark: 'red:60',
    light: 'red:20'
  }[colorMode];
  var invalidColor = {
    dark: 'white:emphasis',
    light: 'red:100'
  }[colorMode];
  return _objectSpread2(_objectSpread2({
    backgroundColor: backgroundColor,
    color: color
  }, colorProp && baseColors), {}, {
    _focus: {
      '&:not([disabled])': {
        borderColor: focusColor,
        boxShadow: "inset 0 0 0 ".concat(focusBoxShadowSpreadRadius, " ").concat(focusColor, ", inset 0 0 0 ").concat(boxShadowSpreadRadius, " ").concat(boxShadowColor)
      }
    },
    _invalid: {
      backgroundColor: invalidBackgroundColor,
      color: invalidColor
    },
    _disabled: {
      cursor: 'not-allowed',
      opacity: disabledOpacity
    }
  });
};
var getOutlineTagStyle = function getOutlineTagStyle(_ref2) {
  var _theme$colors5, _theme$colors6, _theme$sizes3, _theme$colors7, _theme$colors8, _theme$sizes4;
  var colorProp = _ref2.color,
    colorMode = _ref2.colorMode,
    theme = _ref2.theme;
  var undefinedColor = {
    dark: {
      borderColor: "".concat(colorProp, ":50"),
      color: "".concat(colorProp, ":50")
    },
    light: {
      borderColor: "".concat(colorProp, ":50"),
      color: "".concat(colorProp, ":50")
    }
  }[colorMode];
  var outlineColors = {
    dark: {
      gray: {
        borderColor: 'gray:50',
        color: 'gray:40'
      }
    },
    light: {
      gray: {
        borderColor: 'gray:50',
        color: 'gray:40'
      }
    }
  }[colorMode];
  var baseColors = outlineColors[colorProp] || undefinedColor;

  // Normal
  var borderColor = {
    dark: 'gray:40',
    light: 'gray:60'
  }[colorMode];
  var color = {
    dark: 'gray:40',
    light: 'gray:60'
  }[colorMode];
  // Focus
  var focusColor = {
    dark: theme === null || theme === void 0 ? void 0 : (_theme$colors5 = theme.colors) === null || _theme$colors5 === void 0 ? void 0 : _theme$colors5['blue:60'],
    light: theme === null || theme === void 0 ? void 0 : (_theme$colors6 = theme.colors) === null || _theme$colors6 === void 0 ? void 0 : _theme$colors6['blue:60']
  }[colorMode];
  var focusBoxShadowSpreadRadius = theme === null || theme === void 0 ? void 0 : (_theme$sizes3 = theme.sizes) === null || _theme$sizes3 === void 0 ? void 0 : _theme$sizes3['1q'];
  var boxShadowColor = {
    dark: theme === null || theme === void 0 ? void 0 : (_theme$colors7 = theme.colors) === null || _theme$colors7 === void 0 ? void 0 : _theme$colors7['black:emphasis'],
    light: theme === null || theme === void 0 ? void 0 : (_theme$colors8 = theme.colors) === null || _theme$colors8 === void 0 ? void 0 : _theme$colors8['white:emphasis']
  }[colorMode];
  var boxShadowSpreadRadius = theme === null || theme === void 0 ? void 0 : (_theme$sizes4 = theme.sizes) === null || _theme$sizes4 === void 0 ? void 0 : _theme$sizes4['2q'];
  // Disable
  var disabledOpacity = {
    dark: 0.28,
    light: 0.3
  }[colorMode];
  // Invalid
  var invalidBackgroundColor = {
    dark: 'red:60',
    light: 'red:20'
  }[colorMode];
  var invalidColor = {
    dark: 'white:emphasis',
    light: 'red:100'
  }[colorMode];
  return _objectSpread2(_objectSpread2({
    borderColor: borderColor,
    color: color
  }, colorProp && baseColors), {}, {
    _focus: {
      '&:not([disabled])': {
        borderColor: focusColor,
        boxShadow: "inset 0 0 0 ".concat(focusBoxShadowSpreadRadius, " ").concat(focusColor, ", inset 0 0 0 ").concat(boxShadowSpreadRadius, " ").concat(boxShadowColor)
      }
    },
    _invalid: {
      borderColor: invalidBackgroundColor,
      backgroundColor: invalidBackgroundColor,
      color: invalidColor
    },
    _disabled: {
      cursor: 'not-allowed',
      opacity: disabledOpacity
    }
  });
};
var useTagStyle = function useTagStyle(_ref3) {
  var color = _ref3.color,
    size = _ref3.size,
    variant = _ref3.variant;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var theme = useTheme();
  var sizes = theme.sizes;
  var borderWidth = sizes['1q'];
  var px = "calc(".concat(sizes['2x'], " - ").concat(borderWidth, ")");
  var baseStyle = {
    alignItems: 'center',
    borderColor: 'transparent',
    borderRadius: 'sm',
    borderStyle: 'solid',
    borderWidth: borderWidth,
    display: 'inline-flex',
    position: 'relative',
    px: px
  };
  var sizeStyle = {
    sm: {
      fontSize: 'xs',
      lineHeight: 1,
      minHeight: '4x'
    },
    md: {
      fontSize: 'xs',
      lineHeight: 'xs',
      minHeight: '6x',
      py: "calc(".concat(sizes['1h'], " - ").concat(borderWidth, ")")
    },
    lg: {
      fontSize: 'md',
      lineHeight: 'md',
      minHeight: '8x',
      py: "calc(".concat(sizes['1x'], " - ").concat(borderWidth, ")")
    }
  }[size];
  var variantStyle = {
    'solid': getSolidTagStyle({
      color: color,
      colorMode: colorMode,
      theme: theme
    }),
    'outline': getOutlineTagStyle({
      color: color,
      colorMode: colorMode,
      theme: theme
    })
  }[variant];
  return _objectSpread2(_objectSpread2(_objectSpread2({}, baseStyle), sizeStyle), variantStyle);
};
var useTagCloseButtonStyle = function useTagCloseButtonStyle(_ref4) {
  var isClosable = _ref4.isClosable;
  var _useColorMode3 = useColorMode(),
    _useColorMode4 = _slicedToArray(_useColorMode3, 1),
    colorMode = _useColorMode4[0];
  var color = {
    dark: 'white:tertiary',
    light: 'black:tertiary'
  }[colorMode];
  var hoverColor = {
    dark: 'white:emphasis',
    light: 'black:emphasis'
  }[colorMode];
  var activeColor = color;
  var focusColor = hoverColor;
  var disabledColor = color;
  var focusOutlineColor = {
    dark: 'blue:60',
    light: 'blue:60'
  }[colorMode];
  var size = '4x';
  var baseStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: color,
    height: size,
    width: size,
    transition: createTransitionStyle(['color'], {
      duration: 200
    }),
    _hover: {
      color: hoverColor
    },
    _focus: {
      color: focusColor,
      outline: 1,
      outlineColor: focusOutlineColor
    },
    _active: {
      color: activeColor
    },
    _disabled: {
      color: disabledColor,
      cursor: 'not-allowed'
    }
  };
  if (isClosable) {
    return _objectSpread2(_objectSpread2({}, baseStyle), {}, {
      ml: '2x'
    });
  }
  return baseStyle;
};

var TagContext = /*#__PURE__*/createContext();

var useTag = function useTag() {
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(TagContext);
  return context;
};

var _excluded$k = ["children", "onClick"];
var TagCloseButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    onClickProp = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded$k);
  var tagContext = useTag(); // context might be an undefined value
  var _tagContext = _objectSpread2({}, tagContext),
    disabled = _tagContext.disabled,
    isClosable = _tagContext.isClosable,
    onClose = _tagContext.onClose;
  var styleProps = useTagCloseButtonStyle({
    isClosable: isClosable
  });
  return jsx(ButtonBase, _objectSpread2(_objectSpread2(_objectSpread2({
    "aria-label": "Close",
    ref: ref,
    disabled: disabled,
    onClick: callEventHandlers(onClickProp, onClose)
  }, styleProps), rest), {}, {
    children: children !== null && children !== void 0 ? children : jsx(Icon, {
      icon: "close-s"
    })
  }));
});

var _excluded$j = ["isCloseButtonVisible", "isInvalid", "variantColor", "children", "disabled", "error", "isClosable", "onClose", "size", "variant"];
var getMemoizedState$6 = memoize(function (state) {
  return _objectSpread2({}, state);
});
var Tag = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isCloseButtonVisible = _ref.isCloseButtonVisible,
    isInvalid = _ref.isInvalid,
    variantColor = _ref.variantColor,
    children = _ref.children,
    disabled = _ref.disabled,
    error = _ref.error,
    isClosable = _ref.isClosable,
    onClose = _ref.onClose,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'solid' : _ref$variant,
    rest = _objectWithoutProperties(_ref, _excluded$j);
  {
    // deprecation warning
    var prefix = "".concat(Tag.displayName, ":");
    useOnceWhen(function () {
      warnDeprecatedProps('variantColor', {
        prefix: prefix,
        alternative: 'backgroundColor',
        willRemove: true
      });
    }, variantColor !== undefined);
    useOnceWhen(function () {
      warnDeprecatedProps('isCloseButtonVisible', {
        prefix: prefix,
        alternative: 'isClosable',
        willRemove: true
      });
    }, isCloseButtonVisible !== undefined);
    useOnceWhen(function () {
      warnDeprecatedProps('isInvalid', {
        prefix: prefix,
        alternative: 'error',
        willRemove: true
      });
    }, isInvalid !== undefined);
    isClosable = isClosable || isCloseButtonVisible; // TODO: remove this line after deprecation
    error = error || isInvalid; // TODO: remove this line after deprecation
  }

  var ariaProps = {
    'aria-disabled': ariaAttr(disabled),
    'aria-invalid': ariaAttr(error)
  };
  var context = getMemoizedState$6({
    disabled: disabled,
    error: error,
    isClosable: isClosable,
    onClose: onClose,
    size: size,
    variant: variant
  });
  var styleProps = useTagStyle({
    color: variantColor,
    // TODO: remove this line after deprecation
    isClosable: isClosable,
    size: size,
    variant: variant
  });
  return jsx(TagContext.Provider, {
    value: context,
    children: jsxs(Box, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
      ref: ref
    }, ariaProps), styleProps), rest), {}, {
      children: [runIfFn(children, context), !!isClosable && jsx(TagCloseButton, {})]
    }))
  });
});
Tag.displayName = 'Tag';

var useTextStyle = function useTextStyle(_ref) {
  var size = _ref.size;
  var _useTheme = useTheme(),
    fontSizes = _useTheme.fontSizes,
    lineHeights = _useTheme.lineHeights;
  return {
    fontSize: fontSizes === null || fontSizes === void 0 ? void 0 : fontSizes[size],
    lineHeight: lineHeights === null || lineHeights === void 0 ? void 0 : lineHeights[size]
  };
};
var useTextLabelStyle = function useTextLabelStyle(_ref2) {
  var size = _ref2.size;
  var textStyle = useTextStyle({
    size: size
  });
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var color = {
    dark: 'white:secondary',
    light: 'black:secondary'
  }[colorMode];
  return _objectSpread2(_objectSpread2({}, textStyle), {}, {
    color: color
  });
};

var _excluded$i = ["size"];
var Text = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var size = _ref.size,
    rest = _objectWithoutProperties(_ref, _excluded$i);
  var styleProps = useTextStyle({
    size: size
  });
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), rest));
});
Text.displayName = 'Text';

var _excluded$h = ["size"];
var TextLabel = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var size = _ref.size,
    rest = _objectWithoutProperties(_ref, _excluded$h);
  var styleProps = useTextLabelStyle({
    size: size
  });
  return jsx(Text, _objectSpread2(_objectSpread2({
    as: "label",
    ref: ref
  }, styleProps), rest));
});
TextLabel.displayName = 'TextLabel';

var getOutlinedStyle = function getOutlinedStyle(_ref) {
  var colorMode = _ref.colorMode;
  var backgroundColor = {
    dark: 'transparent',
    light: 'white'
  }[colorMode];
  var borderColor = {
    dark: 'gray:60',
    light: 'gray:30'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  var hoverBorderColor = {
    dark: 'blue:50',
    light: 'blue:50'
  }[colorMode];
  var focusBorderColor = {
    dark: 'blue:60',
    light: 'blue:60'
  }[colorMode];
  var disabledBorderColor = {
    dark: 'gray:60',
    light: 'gray:30'
  }[colorMode];
  var invalidBorderColor = {
    dark: 'red:50',
    light: 'red:50'
  }[colorMode];
  var placeholderColor = {
    dark: 'white:tertiary',
    light: 'black:tertiary'
  }[colorMode];
  return {
    backgroundColor: backgroundColor,
    border: 1,
    borderColor: borderColor,
    color: color,
    _hover: {
      borderColor: hoverBorderColor
    },
    _focus: {
      borderColor: focusBorderColor
    },
    _disabled: {
      borderColor: disabledBorderColor,
      cursor: 'not-allowed',
      opacity: '.28'
    },
    _valid: {
      // XXX - border color for valid input is not defined
    },
    _invalid: {
      borderColor: invalidBorderColor,
      '&:focus:hover': {
        borderColor: focusBorderColor
      },
      '&:hover': {
        borderColor: invalidBorderColor
      }
    },
    __placeholder: {
      color: placeholderColor,
      // Override Firefox's unusual default opacity
      opacity: 1
    }
  };
};
var getFilledStyle = function getFilledStyle(_ref2) {
  var colorMode = _ref2.colorMode;
  var backgroundColor = {
    dark: 'gray:80',
    light: 'gray:10'
  }[colorMode];
  return _objectSpread2(_objectSpread2({}, getOutlinedStyle({
    colorMode: colorMode
  })), {}, {
    backgroundColor: backgroundColor
  });
};
var getUnstyledStyle = function getUnstyledStyle(_ref3) {
  var colorMode = _ref3.colorMode;
  var backgroundColor = {
    dark: 'transparent',
    light: 'white'
  }[colorMode];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  return {
    backgroundColor: backgroundColor,
    border: 0,
    borderRadius: 0,
    color: color,
    px: undefined,
    py: undefined
  };
};
var useTextareaStyle = function useTextareaStyle(_ref4) {
  var variant = _ref4.variant;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var _useTheme = useTheme(),
    sizes = _useTheme.sizes;
  var sizeStyle = function () {
    var borderWidth = sizes['1q'];
    var defaultSize = 'md';
    var style = {
      'md': {
        borderRadius: 'sm',
        fontSize: 'sm',
        lineHeight: 'sm',
        minHeight: '9x',
        // 6px (top) + 20px + 10px (bottom) = 36px
        px: '3x',
        pt: "calc(".concat(sizes['3h'], " - ").concat(borderWidth, ")"),
        // 6px - 1px
        pb: "calc(".concat(sizes['5h'], " - ").concat(borderWidth, ")"),
        // 10px - 1px
        width: '100%'
      }
    }[defaultSize];
    return style;
  }();
  var variantStyle = function () {
    if (variant === 'outline') {
      return getOutlinedStyle({
        colorMode: colorMode
      });
    }
    if (variant === 'filled') {
      return getFilledStyle({
        colorMode: colorMode
      });
    }
    if (variant === 'unstyled') {
      return getUnstyledStyle({
        colorMode: colorMode
      });
    }
    return {};
  }();
  var baseStyle = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    transition: 'all .2s'
  };
  return _objectSpread2(_objectSpread2(_objectSpread2({}, baseStyle), sizeStyle), variantStyle);
};

var _excluded$g = ["variant"];
var defaultVariant = 'outline';
var Textarea = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _variant;
  var variant = _ref.variant,
    rest = _objectWithoutProperties(_ref, _excluded$g);
  // Use the default variant if variant is null or undefined
  variant = (_variant = variant) !== null && _variant !== void 0 ? _variant : defaultVariant;
  var styleProps = useTextareaStyle({
    variant: variant
  });
  return jsx(InputBase, _objectSpread2(_objectSpread2({
    ref: ref,
    as: "textarea"
  }, styleProps), rest));
});
Textarea.displayName = 'Textarea';

var getAppearanceStyle = function getAppearanceStyle(_ref) {
  var appearance = _ref.appearance,
    colorMode = _ref.colorMode;
  var backgroundColor = {
    dark: 'gray:10',
    light: 'white'
  }[colorMode];
  var color = 'black:primary';
  var appearanceStyle = {
    success: {
      borderLeftColor: 'green:50',
      borderLeftStyle: 'solid',
      borderLeftWidth: '1x',
      pl: '3x'
    },
    info: {
      borderLeftColor: 'blue:60',
      borderLeftStyle: 'solid',
      borderLeftWidth: '1x',
      pl: '3x'
    },
    warning: {
      borderLeftColor: 'yellow:50',
      borderLeftStyle: 'solid',
      borderLeftWidth: '1x',
      pl: '3x'
    },
    error: {
      borderLeftColor: 'red:60',
      borderLeftStyle: 'solid',
      borderLeftWidth: '1x',
      pl: '3x'
    }
  }[appearance];
  return _objectSpread2({
    backgroundColor: backgroundColor,
    color: color
  }, appearanceStyle);
};
var useToastStyle = function useToastStyle(_ref2) {
  var appearance = _ref2.appearance;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var appearanceStyle = getAppearanceStyle({
    appearance: appearance,
    colorMode: colorMode
  });
  return _objectSpread2({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    position: 'relative',
    px: '4x',
    py: '4x'
  }, appearanceStyle);
};
var useToastIconStyle = function useToastIconStyle(_ref3) {
  var appearance = _ref3.appearance;
  var color = {
    'success': 'green:50',
    'info': 'blue:60',
    'warning': 'yellow:50',
    'error': 'red:60'
  }[appearance];
  return {
    color: color,
    display: 'inline-flex',
    mr: '2x',
    mt: '1h'
  };
};
var useToastMessageStyle = function useToastMessageStyle(_ref4) {
  var isClosable = _ref4.isClosable;
  return {
    pr: isClosable ? '10x' : 0,
    width: '100%'
  };
};

/**
 * Returns a style object for the close button in a toast component.
 *
 * If `isClosable` is true, the button will be positioned absolutely in the top-right corner of the toast.
 *
 * You can also control the position of the close button declaratively by using the `ToastCloseButton` component within an `Toast` component:
 *
 * ```jsx
 * <Toast appearance="success">
 *   <Text pr="10x">This is a success toast.</Text>
 *   <ToastCloseButton top={9} right={7} position="absolute" />
 * </Toast>
 * ```
 *
 * In this case, the `isClosable` prop is not needed and can be omitted.
 */
var useToastCloseButtonStyle = function useToastCloseButtonStyle(_ref5) {
  var isClosable = _ref5.isClosable;
    _ref5.variant;
  var _useColorMode3 = useColorMode(),
    _useColorMode4 = _slicedToArray(_useColorMode3, 1),
    colorMode = _useColorMode4[0];
  var color = {
    dark: 'black:tertiary',
    light: 'black:tertiary'
  }[colorMode];
  var size = '8x';
  var _focusBorderColor = 'blue:60';
  var _focusBoxShadowBorderColor = 'blue:60';
  var _hoverColor = {
    dark: 'black:primary',
    light: 'black:primary'
  }[colorMode];
  var baseStyle = useIconButtonStyle({
    color: color,
    size: size,
    _focusBorderColor: _focusBorderColor,
    _focusBoxShadowBorderColor: _focusBoxShadowBorderColor,
    _hoverColor: _hoverColor
  });
  if (isClosable) {
    var top = '10q'; // (52px - 32px) / 2 = 10px
    var right = '2x';
    return _objectSpread2(_objectSpread2({}, baseStyle), {}, {
      position: 'absolute',
      top: top,
      right: right
    });
  }
  return baseStyle;
};

var ToastContext = /*#__PURE__*/createContext();
var ToastManagerContext = /*#__PURE__*/createContext();

var useToast$1 = function useToast() {
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(ToastContext);
  return context;
};

var _excluded$f = ["children", "onClick"];
var ToastCloseButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    onClickProp = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded$f);
  var alertContext = useToast$1(); // context might be an undefined value
  var _alertContext = _objectSpread2({}, alertContext),
    isClosable = _alertContext.isClosable,
    onClose = _alertContext.onClose,
    variant = _alertContext.variant;
  var styleProps = useToastCloseButtonStyle({
    isClosable: isClosable,
    variant: variant
  });
  return jsx(ButtonBase, _objectSpread2(_objectSpread2(_objectSpread2({
    "aria-label": "Close",
    ref: ref,
    onClick: callEventHandlers(onClickProp, onClose)
  }, styleProps), rest), {}, {
    children: children !== null && children !== void 0 ? children : jsx(Icon, {
      icon: "close-s"
    })
  }));
});
ToastCloseButton.displayName = 'ToastCloseButton';

var getIconByAppearance = function getIconByAppearance(appearance) {
  var iconName = {
    success: 'success',
    info: 'info',
    warning: 'warning-minor',
    error: 'error'
  }[appearance];
  if (!iconName) {
    return null;
  }
  return jsx(Icon, {
    icon: "".concat(iconName)
  });
};
var ToastIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var toastContext = useToast$1(); // context might be an undefined value
  var _toastContext = _objectSpread2({}, toastContext),
    appearance = _toastContext.appearance,
    iconProp = _toastContext.icon;
  var styleProps = useToastIconStyle({
    appearance: appearance
  });
  var icon = useMemo(function () {
    if (typeof iconProp === 'string') {
      return jsx(Icon, {
        icon: iconProp
      });
    }
    if (iconProp === undefined) {
      return getIconByAppearance(appearance);
    }
    return iconProp;
  }, [appearance, iconProp]);
  if (!icon) {
    return null;
  }
  return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), props), {}, {
    children: icon
  }));
});
ToastIcon.displayName = 'ToastIcon';

var ToastMessage = /*#__PURE__*/forwardRef(function (props, ref) {
  var alertContext = useToast$1(); // context might be an undefined value
  var _alertContext = _objectSpread2({}, alertContext),
    isClosable = _alertContext.isClosable;
  var styleProps = useToastMessageStyle({
    isClosable: isClosable
  });
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), props));
});
ToastMessage.displayName = 'ToastMessage';

var defaultAppearance = 'none';

var _excluded$e = ["isCloseButtonVisible", "appearance", "icon", "isClosable", "onClose", "children"];
var getMemoizedState$5 = memoize(function (state) {
  return _objectSpread2({}, state);
});
var Toast = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isCloseButtonVisible = _ref.isCloseButtonVisible,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? defaultAppearance : _ref$appearance,
    icon = _ref.icon,
    _ref$isClosable = _ref.isClosable,
    isClosable = _ref$isClosable === void 0 ? false : _ref$isClosable,
    onClose = _ref.onClose,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$e);
  {
    // deprecation warning
    var prefix = "".concat(Toast.displayName, ":");
    useOnceWhen(function () {
      warnDeprecatedProps('isCloseButtonVisible', {
        prefix: prefix,
        alternative: 'isClosable',
        willRemove: true
      });
    }, isCloseButtonVisible !== undefined);
    isClosable = isClosable || isCloseButtonVisible; // TODO: remove this line after deprecation
  }

  var context = getMemoizedState$5({
    appearance: appearance,
    icon: icon,
    isClosable: isClosable,
    onClose: onClose
  });
  var styleProps = useToastStyle({
    appearance: appearance
  });
  return jsx(ToastContext.Provider, {
    value: context,
    children: jsxs(Box, _objectSpread2(_objectSpread2(_objectSpread2({
      ref: ref
    }, styleProps), rest), {}, {
      children: [jsx(ToastIcon, {}), jsx(ToastMessage, {
        children: runIfFn(children, context)
      }), !!isClosable && jsx(ToastCloseButton, {})]
    }))
  });
});
Toast.displayName = 'Toast';

var _excluded$d = ["placement"];
var ToastContainer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var placement = _ref.placement,
    rest = _objectWithoutProperties(_ref, _excluded$d);
  var styleProps = {
    boxSizing: 'border-box',
    maxHeight: '100%',
    maxWidth: '100%',
    overflow: 'hidden',
    position: 'fixed',
    zIndex: 'toast'
  };
  placement = ensureString(placement);
  if (placement.includes('top')) {
    styleProps.top = 0;
  }
  if (placement.includes('bottom')) {
    styleProps.bottom = 0;
  }
  if (placement.includes('left')) {
    styleProps.left = 0;
  }
  if (placement.includes('right')) {
    styleProps.right = 0;
  }
  if (placement.includes('center') || placement === 'top' || placement === 'bottom') {
    styleProps.left = '50%';
    styleProps.transform = 'translateX(-50%)';
  }
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: ref,
    "data-toast-placement": placement
  }, styleProps), rest));
});

var useTimeout = function useTimeout(callback) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var savedCallback = useRef(null);

  // Remember the latest callback
  useEffect(function () {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval
  useEffect(function () {
    function tick() {
      if (typeof savedCallback.current === 'function') {
        savedCallback.current();
      }
    }
    if (delay === null || delay === undefined) {
      return function () {};
    }
    var id = setTimeout(tick, delay);
    return function () {
      return clearTimeout(id);
    };
  }, [delay]);
};

var _excluded$c = ["children", "duration", "onClose", "onMouseEnter", "onMouseLeave"];
var ToastController = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? null : _ref$duration,
    onClose = _ref.onClose,
    onMouseEnterProp = _ref.onMouseEnter,
    onMouseLeaveProp = _ref.onMouseLeave,
    rest = _objectWithoutProperties(_ref, _excluded$c);
  var nodeRef = useRef();
  var combinedRef = useMergeRefs(nodeRef, ref);
  var _useState = useState(duration),
    _useState2 = _slicedToArray(_useState, 2),
    delay = _useState2[0],
    setDelay = _useState2[1];
  var onMouseEnter = useCallback(function (event) {
    setDelay(null);
  }, []);
  var onMouseLeave = useCallback(function (event) {
    setDelay(duration);
  }, [duration]);
  useTimeout(onClose, delay);
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: combinedRef,
    onMouseEnter: callEventHandlers(onMouseEnterProp, onMouseEnter),
    onMouseLeave: callEventHandlers(onMouseLeaveProp, onMouseLeave)
  }, rest), {}, {
    children: children
  }));
});

var _excluded$b = ["appear", "children", "easing", "in", "style", "timeout"];
var getScale = function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
};
var mapStateToVariantStyle$1 = function mapStateToVariantStyle(state, props) {
  var variantStyle = {
    entering: {
      height: 'auto',
      opacity: 1,
      transform: getScale(1)
    },
    entered: {
      height: 'auto',
      opacity: 1,
      transform: 'none'
    },
    exiting: {
      height: 0,
      opacity: 0,
      overflow: 'hidden',
      transform: getScale(0.75)
    },
    exited: {
      height: 0,
      opacity: 0,
      transform: getScale(0.75)
    }
  }[state];
  return typeof variantStyle === 'function' ? variantStyle(props) : variantStyle;
};
var defaultEasing$1 = {
  enter: transitionEasing.easeInOut,
  exit: transitionEasing.easeInOut
};
var defaultTimeout$1 = {
  enter: transitionDuration.standard,
  exit: transitionDuration.standard
};
var Wrapper = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(Box, _objectSpread2({
    ref: ref
  }, props));
});
var ToastTransition = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$appear = _ref.appear,
    appear = _ref$appear === void 0 ? false : _ref$appear,
    _children = _ref.children,
    _ref$easing = _ref.easing,
    easing = _ref$easing === void 0 ? defaultEasing$1 : _ref$easing,
    inProp = _ref["in"],
    style = _ref.style,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? defaultTimeout$1 : _ref$timeout,
    rest = _objectWithoutProperties(_ref, _excluded$b);
  var nodeRef = useRef(null);
  var combinedRef = useMergeRefs(nodeRef, ref);
  var wrapperRef = useRef(null);
  useEffect(function () {
    var node = nodeRef.current;
    reflow(node); // force reflow to make the transition work when animating appearance
  }, [inProp]);
  return jsx(Transition, _objectSpread2(_objectSpread2({
    appear: appear,
    "in": inProp,
    nodeRef: nodeRef,
    timeout: timeout
  }, rest), {}, {
    children: function children(state, childProps) {
      var transitionProps = inProp ? getEnterTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      }) : getExitTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      });
      var transition = [createTransitionStyle('height', transitionProps), createTransitionStyle('opacity', transitionProps), createTransitionStyle('transform', {
        duration: transitionProps.duration * 0.666,
        easing: transitionProps.easing,
        delay: inProp ? transitionProps.delay : transitionProps.delay || transitionProps.duration * 0.333
      })].join(',');
      var variantStyle = mapStateToVariantStyle$1(state, {});
      var styleProps = _objectSpread2(_objectSpread2({}, variantStyle), {}, {
        transition: transition,
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      });
      if (typeof _children === 'function') {
        return _children(state, _objectSpread2(_objectSpread2({}, childProps), {}, {
          ref: combinedRef,
          style: _objectSpread2(_objectSpread2({}, styleProps), style)
        }));
      }
      var isAnimationStart = inProp && state === 'entering' || !inProp && (state === 'entering' || state === 'entered');
      //const isAnimationEnd = (inProp && (state === 'entered')) ||
      //  (!inProp && (state === 'exited'));

      if (isAnimationStart) {
        var wrapper = wrapperRef.current;
        var contentHeight = wrapper === null || wrapper === void 0 ? void 0 : wrapper.offsetHeight;
        styleProps.height = contentHeight;
      }
      return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
        ref: combinedRef
      }, childProps), styleProps), {}, {
        style: style,
        children: jsx(Wrapper, {
          ref: wrapperRef,
          children: _children
        })
      }));
    }
  }));
});
ToastTransition.displayName = 'ToastTransition';

var uniqueId = function () {
  var id = 0;
  return function () {
    id += 1;
    return String(id);
  };
}();
var getMemoizedState$4 = memoize(function (state) {
  return _objectSpread2({}, state);
});
var defaultPlacement$1 = 'bottom-right';
var placements = ['bottom', 'bottom-right', 'bottom-left', 'top', 'top-left', 'top-right'];
var getToastPlacementByState = function getToastPlacementByState(state, id) {
  var toast = Object.values(state).reduce(function (acc, val) {
    return acc.concat(val);
  }, []).find(function (toast) {
    return toast.id === id;
  });
  return toast === null || toast === void 0 ? void 0 : toast.placement;
};
var ToastManager = function ToastManager(_ref) {
  var DEPRECATED_container = _ref.container,
    children = _ref.children,
    containerRef = _ref.containerRef,
    _ref$placement = _ref.placement,
    placementProp = _ref$placement === void 0 ? defaultPlacement$1 : _ref$placement;
  {
    // deprecation warning
    var prefix = "".concat(ToastManager.displayName, ":");
    useOnceWhen(function () {
      warnDeprecatedProps('container', {
        prefix: prefix,
        alternative: 'containerRef',
        willRemove: true
      });
    }, DEPRECATED_container !== undefined);
  }
  var isHydrated = useHydrated();
  var _useState = useState(function () {
      return placements.reduce(function (acc, placement) {
        acc[placement] = [];
        return acc;
      }, {});
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];

  /**
   * Create properties for a new toast
   */
  var createToast = useCallback(function (message, options) {
    var _options$id, _options$placement;
    var id = (_options$id = options === null || options === void 0 ? void 0 : options.id) !== null && _options$id !== void 0 ? _options$id : uniqueId();
    var duration = options === null || options === void 0 ? void 0 : options.duration;
    var placement = ensureString((_options$placement = options === null || options === void 0 ? void 0 : options.placement) !== null && _options$placement !== void 0 ? _options$placement : placementProp);
    var onClose = function onClose() {
      return close(id, placement);
    };
    return {
      // A unique identifier that represents the toast message
      id: id,
      // The toast message to render
      message: message,
      // The placement of the toast
      placement: placement,
      // The duration (in milliseconds) that the toast should remain on the screen. If set to null, toast will never dismiss.
      duration: duration,
      // The function to close the toast
      onClose: onClose
    };
  }, [close, placementProp]);

  /**
   * Close a toast record at its placement
   */
  var close = useCallback(function (id, placement) {
    setState(function (prevState) {
      var _placement;
      placement = (_placement = placement) !== null && _placement !== void 0 ? _placement : getToastPlacementByState(prevState, id);
      return _objectSpread2(_objectSpread2({}, prevState), {}, _defineProperty({}, placement, ensureArray(prevState[placement]).filter(function (toast) {
        return toast.id !== id;
      })));
    });
  }, []);

  /**
   * Close all toasts at once with the given placements, including the following:
   * • top
   * • top-left
   * • top-right
   * • bottom
   * • bottom-left
   * • bottom-right
   */
  var closeAll = useCallback(function (options) {
    setState(function (prevState) {
      var placements = options !== null && options !== void 0 && options.placements ? ensureArray(options === null || options === void 0 ? void 0 : options.placements) : Object.keys(prevState);
      var nextState = placements.reduce(function (acc, placement) {
        acc[placement] = [];
        return acc;
      }, {});
      return _objectSpread2(_objectSpread2({}, prevState), nextState);
    });
  }, []);

  /**
   * Find the first toast in the array that matches the provided id. Otherwise, `undefined` is returned if not found.
   * If no values satisfy the testing function, undefined is returned.
   */
  var find = useCallback(function (id) {
    var placement = getToastPlacementByState(state, id);
    return ensureArray(state[placement]).find(function (toast) {
      return toast.id === id;
    });
  }, [state]);

  /**
   * Find the first toast in the array that matches the provided id. Otherwise, -1 is returned if not found.
   */
  var findIndex = useCallback(function (id) {
    var placement = getToastPlacementByState(state, id);
    return ensureArray(state[placement]).findIndex(function (toast) {
      return toast.id === id;
    });
  }, [state]);

  /**
   * Create a toast at the specified placement and return the id
   */
  var notify = useCallback(function (message, options) {
    var id = options.id,
      duration = options.duration,
      placement = options.placement;
    var toast = createToast(message, {
      id: id,
      duration: duration,
      placement: placement
    });
    if (!placements.includes(toast.placement)) {
      console.error("[ToastManager] Error: Invalid toast placement \"".concat(toast.placement, "\". Please provide a valid placement from the following options: ").concat(placements.join(', '), "."));
      return false;
    }
    setState(function (prevState) {
      var isTop = toast.placement.includes('top');

      /**
       * For the toast is placemented at the top edges:
       *   toast #3 ← the most recent
       *   toast #2
       *   toast #1
       *
       * For the toast is placemented at the bottom edges:
       *   toast #1
       *   toast #2
       *   toast #3 ← the most recent
       */
      var prevToasts = _toConsumableArray(ensureArray(prevState[toast.placement]));
      var toasts = [];
      if (isTop) {
        var begin = 0;
        var end = undefined;
        toasts = [toast].concat(_toConsumableArray(prevToasts)).slice(begin, end);
      } else {
        // Negative index counts back from the end of the array — if start < 0, start + array.length is used.
        var _begin = undefined;
        toasts = [].concat(_toConsumableArray(prevToasts), [toast]).slice(_begin);
      }
      return _objectSpread2(_objectSpread2({}, prevState), {}, _defineProperty({}, toast.placement, toasts));
    });
    return toast.id;
  }, [createToast]);

  /**
   * Update a specific toast with new options based on the given id. Returns `true` if the toast exists, else `false`.
   */
  var update = useCallback(function (id, options) {
    var _find;
    var placement = (_find = find(id)) === null || _find === void 0 ? void 0 : _find.placement;
    var index = findIndex(id);
    if (!placement || index === -1) {
      return false;
    }
    setState(function (prevState) {
      var nextState = _objectSpread2({}, prevState);
      nextState[placement][index] = _objectSpread2(_objectSpread2({}, nextState[placement][index]), options);
      return nextState;
    });
    return true;
  }, [find, findIndex]);
  var context = getMemoizedState$4({
    // Methods
    close: close,
    closeAll: closeAll,
    find: find,
    findIndex: findIndex,
    notify: notify,
    update: update,
    // Properties
    placement: placementProp,
    // State
    state: state,
    setState: setState
  });
  return jsxs(ToastManagerContext.Provider, {
    value: context,
    children: [runIfFn(children, context), !!isHydrated && jsx(Portal, {
      container: DEPRECATED_container // FIXME: deprecated (remove in next major version)
      ,
      containerRef: containerRef,
      children: Object.keys(state).map(function (placement) {
        var toasts = ensureArray(state[placement]);
        return jsx(ToastContainer, {
          placement: placement,
          children: jsx(TransitionGroup, {
            component: null,
            children: toasts.map(function (toast) {
              return jsx(ToastTransition, {
                "in": true,
                collapsedHeight: 0,
                unmountOnExit: true,
                children: jsx(ToastController, {
                  duration: toast.duration,
                  onClose: toast.onClose,
                  children: function () {
                    if (isElement(toast.message)) {
                      return toast.message;
                    }
                    if (isValidElementType(toast.message)) {
                      return jsx(toast.message, {
                        id: toast.id,
                        onClose: toast.onClose,
                        placement: toast.placement
                      });
                    }
                    return null;
                  }()
                })
              }, toast.id);
            })
          })
        }, placement);
      })
    })]
  });
};
ToastManager.displayName = 'ToastManager';

var useToastManager = function useToastManager() {
  var createToastRef = useRef(null);
  var toastManagerRef = useRef(null);
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(ToastManagerContext);
  if (!context) {
    throw new Error('The `useToastManager` hook must be called from a descendent of the `ToastManager`.');
  }
  createToastRef.current = context.notify;
  if (!toastManagerRef.current) {
    toastManagerRef.current = function () {
      var _createToastRef$curre;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return (_createToastRef$curre = createToastRef.current) === null || _createToastRef$curre === void 0 ? void 0 : _createToastRef$curre.call.apply(_createToastRef$curre, [createToastRef].concat(args));
    };
  }
  Object.assign(toastManagerRef.current, context);
  return toastManagerRef.current;
};

var ToastProvider = ToastManager; // alias of ToastManager
var useToast = useToastManager; // alias of useToastManager

var pixelize = function pixelize(value) {
  if (typeof value === 'string') {
    return value;
  }
  value = ensureNumber(value);
  return "".concat(value, "px");
};
var useTooltipArrowStyle = function useTooltipArrowStyle(_ref) {
  var _sizes$arrowHeightPro, _sizes$arrowWidthProp;
  var arrowHeightProp = _ref.arrowHeight,
    arrowWidthProp = _ref.arrowWidth;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var _useTheme = useTheme(),
    sizes = _useTheme.sizes;
  var arrowHeight = (_sizes$arrowHeightPro = sizes[arrowHeightProp]) !== null && _sizes$arrowHeightPro !== void 0 ? _sizes$arrowHeightPro : pixelize(arrowHeightProp);
  var arrowWidth = (_sizes$arrowWidthProp = sizes[arrowWidthProp]) !== null && _sizes$arrowWidthProp !== void 0 ? _sizes$arrowWidthProp : pixelize(arrowWidthProp);
  var dropShadowColor = {
    dark: 'rgba(0, 0, 0, 0.16)',
    light: 'rgba(0, 0, 0, 0.08)'
  }[colorMode];
  return {
    // https://popper.js.org/docs/v2/tutorial/#arrow
    '&[data-popper-placement^="top"]': {
      position: 'absolute',
      bottom: 0,
      '::before': {
        content: '""',
        borderTop: "".concat(arrowHeight, " solid"),
        borderLeft: "calc(".concat(arrowWidth, "/2) solid transparent"),
        borderRight: "calc(".concat(arrowWidth, "/2) solid transparent"),
        filter: "drop-shadow(0 1px 1px ".concat(dropShadowColor, ")"),
        position: 'absolute',
        bottom: "-".concat(arrowHeight),
        transform: 'translateX(-50%)'
      }
    },
    '&[data-popper-placement^="bottom"]': {
      position: 'absolute',
      top: 0,
      '::before': {
        content: '""',
        borderBottom: "".concat(arrowHeight, " solid"),
        borderLeft: "calc(".concat(arrowWidth, "/2) solid transparent"),
        borderRight: "calc(".concat(arrowWidth, "/2) solid transparent"),
        filter: "drop-shadow(0 -1px 1px ".concat(dropShadowColor, ")"),
        position: 'absolute',
        top: "-".concat(arrowHeight),
        transform: 'translateX(-50%)'
      }
    },
    '&[data-popper-placement^="left"]': {
      position: 'absolute',
      right: 0,
      '::before': {
        content: '""',
        borderLeft: "".concat(arrowHeight, " solid"),
        borderTop: "calc(".concat(arrowWidth, "/2) solid transparent"),
        borderBottom: "calc(".concat(arrowWidth, "/2) solid transparent"),
        filter: "drop-shadow(1px 0px 1px ".concat(dropShadowColor, ")"),
        position: 'absolute',
        right: "-".concat(arrowHeight),
        transform: 'translateY(-50%)'
      }
    },
    '&[data-popper-placement^="right"]': {
      position: 'absolute',
      left: 0,
      '::before': {
        content: '""',
        borderRight: "".concat(arrowHeight, " solid"),
        borderTop: "calc(".concat(arrowWidth, "/2) solid transparent"),
        borderBottom: "calc(".concat(arrowWidth, "/2) solid transparent"),
        filter: "drop-shadow(-1px 0px 1px ".concat(dropShadowColor, ")"),
        position: 'absolute',
        left: "-".concat(arrowHeight),
        transform: 'translateY(-50%)'
      }
    }
  };
};
var useTooltipTriggerStyle = function useTooltipTriggerStyle() {
  return {
    // The tooltip trigger style will be passed to the wrapper element when the "shouldWrapChildren" prop is set to true
  };
};
var useTooltipContentStyle = function useTooltipContentStyle() {
  var _colorStyle$shadow;
  var _useColorMode3 = useColorMode(),
    _useColorMode4 = _slicedToArray(_useColorMode3, 1),
    colorMode = _useColorMode4[0];
  var _useColorStyle = useColorStyle({
      colorMode: colorMode
    }),
    _useColorStyle2 = _slicedToArray(_useColorStyle, 1),
    colorStyle = _useColorStyle2[0];
  var backgroundColor = {
    dark: 'gray:10',
    light: 'gray:70'
  }[colorMode];
  var color = {
    dark: 'black:primary',
    light: 'white:primary'
  }[colorMode];
  return {
    backgroundColor: backgroundColor,
    borderRadius: 'sm',
    boxShadow: colorStyle === null || colorStyle === void 0 ? void 0 : (_colorStyle$shadow = colorStyle.shadow) === null || _colorStyle$shadow === void 0 ? void 0 : _colorStyle$shadow.thin,
    color: color,
    fontWeight: 'normal',
    fontSize: 'sm',
    lineHeight: 'sm',
    px: '3x',
    py: '1x'
  };
};

var TooltipContext = /*#__PURE__*/createContext();

var useTooltip = function useTooltip() {
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(TooltipContext);
  return context;
};

var _excluded$a = ["arrowHeight", "arrowWidth", "sx"];
var TooltipArrow = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$arrowHeight = _ref.arrowHeight,
    arrowHeight = _ref$arrowHeight === void 0 ? 4 : _ref$arrowHeight,
    _ref$arrowWidth = _ref.arrowWidth,
    arrowWidth = _ref$arrowWidth === void 0 ? 8 : _ref$arrowWidth,
    sx = _ref.sx,
    rest = _objectWithoutProperties(_ref, _excluded$a);
  var _useTooltip = useTooltip(),
    placement = _useTooltip.placement,
    tooltipContentRef = _useTooltip.tooltipContentRef;
  var tooltipContentEl = tooltipContentRef === null || tooltipContentRef === void 0 ? void 0 : tooltipContentRef.current;
  var styleProps = useTooltipArrowStyle({
    arrowHeight: arrowHeight,
    arrowWidth: arrowWidth
  });
  if (isHTMLElement(tooltipContentEl)) {
    // Compute the background color of the first direct child of the tooltip content and apply it to the tooltip arrow
    var computedStyle = getComputedStyle(tooltipContentEl.firstChild);
    styleProps.color = computedStyle === null || computedStyle === void 0 ? void 0 : computedStyle.backgroundColor;
  }
  return jsx(Box, _objectSpread2({
    ref: ref,
    role: "presentation"
    // The `data-popper-arrow` attribute is utilized by `popper/Popper.js` to designate the element used as the arrow
    ,
    "data-popper-arrow": true
    // The `data-popper-placement` attribute is automatically updated by `popper/Popper.js` to reflect the popper's actual placement
    ,
    "data-popper-placement": placement,
    sx: [styleProps].concat(_toConsumableArray(Array.isArray(sx) ? sx : [sx]))
  }, rest));
});
TooltipArrow.displayName = 'TooltipArrow';

var _excluded$9 = ["PopperArrowComponent", "PopperArrowProps", "PopperComponent", "PopperProps", "TooltipArrowComponent", "TooltipArrowProps", "TransitionComponent", "TransitionProps", "children"];
var mapPlacementToTransformOrigin = function mapPlacementToTransformOrigin(placement) {
  return {
    'top': 'bottom center',
    'top-start': 'bottom left',
    'top-end': 'bottom right',
    'bottom': 'top center',
    'bottom-start': 'top left',
    'bottom-end': 'top right',
    'left': 'right center',
    'left-start': 'right top',
    'left-end': 'right bottom',
    'right': 'left center',
    'right-start': 'left top',
    'right-end': 'left bottom'
  }[placement];
};
var TooltipContent = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var PopperArrowComponent = _ref.PopperArrowComponent,
    PopperArrowProps = _ref.PopperArrowProps,
    _ref$PopperComponent = _ref.PopperComponent,
    PopperComponent = _ref$PopperComponent === void 0 ? Popper : _ref$PopperComponent,
    PopperProps = _ref.PopperProps,
    _ref$TooltipArrowComp = _ref.TooltipArrowComponent,
    TooltipArrowComponent = _ref$TooltipArrowComp === void 0 ? TooltipArrow : _ref$TooltipArrowComp,
    TooltipArrowProps = _ref.TooltipArrowProps,
    _ref$TransitionCompon = _ref.TransitionComponent,
    TransitionComponent = _ref$TransitionCompon === void 0 ? Grow : _ref$TransitionCompon,
    TransitionProps = _ref.TransitionProps,
    _children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$9);
  {
    // deprecation warning
    var prefix = "".concat(TooltipContent.displayName, ":");
    useOnceWhen(function () {
      warnRemovedProps('PopperArrowComponent', {
        prefix: prefix,
        alternative: 'TooltipArrowComponent'
      });
    }, PopperArrowComponent !== undefined);
    useOnceWhen(function () {
      warnDeprecatedProps('PopperArrowProps', {
        prefix: prefix,
        alternative: 'TooltipArrowProps',
        willRemove: true
      });
    }, PopperArrowProps !== undefined);
    TooltipArrowProps = _objectSpread2(_objectSpread2({}, PopperArrowProps), TooltipArrowProps);
  }
  var isHydrated = useHydrated();
  var nodeRef = useRef(null);
  var combinedRef = useMergeRefs(nodeRef, ref);
  var _useTooltip = useTooltip(),
    arrow = _useTooltip.arrow,
    disabled = _useTooltip.disabled,
    followCursor = _useTooltip.followCursor,
    isOpen = _useTooltip.isOpen,
    mousePageX = _useTooltip.mousePageX,
    mousePageY = _useTooltip.mousePageY,
    nextToCursor = _useTooltip.nextToCursor,
    offset = _useTooltip.offset,
    placement = _useTooltip.placement,
    tooltipId = _useTooltip.tooltipId,
    tooltipContentRef = _useTooltip.tooltipContentRef,
    tooltipTriggerId = _useTooltip.tooltipTriggerId,
    tooltipTriggerRef = _useTooltip.tooltipTriggerRef;
  var styleProps = useTooltipContentStyle();
  var tooltipTriggerElement = tooltipTriggerRef.current;
  var _ensureArray = ensureArray(offset),
    _ensureArray2 = _slicedToArray(_ensureArray, 2),
    _ensureArray2$ = _ensureArray2[0],
    skidding = _ensureArray2$ === void 0 ? 0 : _ensureArray2$,
    _ensureArray2$2 = _ensureArray2[1],
    distance = _ensureArray2$2 === void 0 ? 8 : _ensureArray2$2;
  var _useMemo = useMemo(function () {
      var _skidding = skidding;
      var _distance = distance;
      if (isHTMLElement(tooltipTriggerElement) && (followCursor || nextToCursor)) {
        var offsetHeight = tooltipTriggerElement.offsetHeight;
        var leftmostOffset = getLeftmostOffset(tooltipTriggerElement);
        var topmostOffset = getTopmostOffset(tooltipTriggerElement);
        _skidding = mousePageX - leftmostOffset + 10;
        _distance = mousePageY - topmostOffset - offsetHeight + 15;
      }
      return [_skidding, _distance];
    }, [skidding, distance, tooltipTriggerElement, followCursor, nextToCursor, mousePageX, mousePageY]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    computedSkidding = _useMemo2[0],
    computedDistance = _useMemo2[1];
  var popperModifiers = useMemo(function () {
    var modifiers = [{
      // https://popper.js.org/docs/v2/modifiers/offset/
      name: 'offset',
      options: {
        offset: [computedSkidding, computedDistance]
      }
    }];
    return modifiers;
  }, [computedSkidding, computedDistance]);
  if (!isHydrated) {
    return null;
  }
  if (disabled) {
    return null;
  }
  if (!_children || isBlankString(_children) || isEmptyArray(_children)) {
    // TOOD: Objects are not valid as a React child
    return null;
  }
  return jsx(PopperComponent, _objectSpread2(_objectSpread2({
    "aria-hidden": ariaAttr(!isOpen),
    "aria-labelledby": tooltipTriggerId,
    "data-popper-placement": placement,
    anchorEl: tooltipTriggerRef.current // TODO: rename to `referenceRef` in a future release
    ,
    id: tooltipId,
    isOpen: isOpen,
    placement: placement,
    pointerEvents: "none",
    ref: tooltipContentRef,
    role: "tooltip",
    unmountOnExit: true,
    usePortal: false // Pass `true` in `PopperProps` to render tooltip in a portal
    ,
    willUseTransition: true,
    zIndex: "tooltip"
  }, PopperProps), {}, {
    modifiers: [].concat(_toConsumableArray(popperModifiers), _toConsumableArray(ensureArray(PopperProps === null || PopperProps === void 0 ? void 0 : PopperProps.modifiers))),
    children: function children(_ref2) {
      var placement = _ref2.placement,
        transition = _ref2.transition;
      var _transition = _objectSpread2({}, transition),
        inProp = _transition["in"],
        onEnter = _transition.onEnter,
        onExited = _transition.onExited;
      return jsx(TransitionComponent, _objectSpread2(_objectSpread2({
        appear: true
      }, TransitionProps), {}, {
        ref: combinedRef,
        "in": inProp,
        onEnter: callAll(onEnter, TransitionProps === null || TransitionProps === void 0 ? void 0 : TransitionProps.onEnter),
        onExited: callAll(onExited, TransitionProps === null || TransitionProps === void 0 ? void 0 : TransitionProps.onExited),
        children: function children(state, _ref3) {
          var ref = _ref3.ref,
            transitionStyle = _ref3.style;
          return jsxs(Box, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
            ref: ref
          }, styleProps), transitionStyle), {}, {
            transformOrigin: mapPlacementToTransformOrigin(placement)
          }, rest), {}, {
            children: [_children, !!arrow && jsx(TooltipArrowComponent, _objectSpread2({}, TooltipArrowProps))]
          }));
        }
      }));
    }
  }));
});
TooltipContent.displayName = 'TooltipContent';

var _excluded$8 = ["children", "shouldWrapChildren", "onBlur", "onClick", "onFocus", "onMouseEnter", "onMouseLeave", "onMouseMove", "onPointerDown"];
var TooltipTrigger = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$shouldWrapChildr = _ref.shouldWrapChildren,
    shouldWrapChildren = _ref$shouldWrapChildr === void 0 ? false : _ref$shouldWrapChildr,
    onBlurProp = _ref.onBlur,
    onClickProp = _ref.onClick,
    onFocusProp = _ref.onFocus,
    onMouseEnterProp = _ref.onMouseEnter,
    onMouseLeaveProp = _ref.onMouseLeave,
    onMouseMoveProp = _ref.onMouseMove,
    onPointerDownProp = _ref.onPointerDown,
    rest = _objectWithoutProperties(_ref, _excluded$8);
  var _useTooltip = useTooltip(),
    closeOnClick = _useTooltip.closeOnClick,
    closeOnEsc = _useTooltip.closeOnEsc,
    closeOnPointerDown = _useTooltip.closeOnPointerDown,
    followCursor = _useTooltip.followCursor,
    isOpen = _useTooltip.isOpen,
    onClose = _useTooltip.onClose,
    onOpen = _useTooltip.onOpen,
    openOnFocus = _useTooltip.openOnFocus,
    setMousePageX = _useTooltip.setMousePageX,
    setMousePageY = _useTooltip.setMousePageY,
    tooltipId = _useTooltip.tooltipId,
    tooltipTriggerId = _useTooltip.tooltipTriggerId,
    tooltipTriggerRef = _useTooltip.tooltipTriggerRef;
  var combinedRef = useMergeRefs(tooltipTriggerRef, ref);
  var styleProps = useTooltipTriggerStyle();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    enableMouseMove = _useState2[0],
    setEnableMouseMove = _useState2[1];
  var eventHandler = {};
  eventHandler.onBlur = function (event) {
    if (isOpen) {
      onClose();
    }
  };
  eventHandler.onClick = function (event) {
    if (isOpen && closeOnClick) {
      onClose();
    }
  };
  eventHandler.onFocus = function (event) {
    if (!isOpen && openOnFocus) {
      onOpen();
    }
  };
  eventHandler.onKeyDown = function (event) {
    if (isOpen && closeOnEsc && event.key === 'Escape') {
      onClose();
    }
  };
  eventHandler.onMouseEnter = function (event) {
    setEnableMouseMove(true); // track mouse movement
    onOpen(function () {
      // callback
      setEnableMouseMove(followCursor); // after the enter delay, track mouse movement only if "followCursor" is true
    });
  };

  eventHandler.onMouseLeave = function (event) {
    onClose(function () {
      // callback
      setEnableMouseMove(true);
    });
  };
  eventHandler.onMouseMove = function (event) {
    if (enableMouseMove || followCursor) {
      setMousePageX(event.pageX);
      setMousePageY(event.pageY);
    }
  };
  eventHandler.onPointerDown = function (event) {
    if (isOpen && closeOnPointerDown) {
      onClose();
    }
  };
  useEventListener(function () {
    return getOwnerDocument(tooltipTriggerRef.current);
  },
  // owner document
  'keydown', closeOnEsc ? eventHandler.onKeyDown : undefined);

  /**
   * This allows for catching the "mouseleave" event when the tooltip trigger is disabled.
   * There is currently a known issue in React regarding the onMouseLeave polyfill.
   * @see https://github.com/facebook/react/issues/11972
   */
  useEventListener(function () {
    return tooltipTriggerRef.current;
  }, 'mouseleave', eventHandler.onMouseLeave);
  var getTooltipTriggerProps = function getTooltipTriggerProps() {
    var ownProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ownRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2(_objectSpread2(_objectSpread2({}, ownProps), {}, {
      'aria-describedby': isOpen ? tooltipId : undefined,
      id: tooltipTriggerId,
      ref: mergeRefs(combinedRef, ownRef),
      onBlur: callEventHandlers(ownProps === null || ownProps === void 0 ? void 0 : ownProps.onBlur, onBlurProp, eventHandler.onBlur),
      onClick: callEventHandlers(ownProps === null || ownProps === void 0 ? void 0 : ownProps.onClick, onClickProp, eventHandler.onClick),
      onFocus: callEventHandlers(ownProps === null || ownProps === void 0 ? void 0 : ownProps.onFocus, onFocusProp, eventHandler.onFocus),
      onMouseEnter: callEventHandlers(ownProps === null || ownProps === void 0 ? void 0 : ownProps.onMouseEnter, onMouseEnterProp, eventHandler.onMouseEnter),
      onMouseLeave: callEventHandlers(ownProps === null || ownProps === void 0 ? void 0 : ownProps.onMouseLeave, onMouseLeaveProp, eventHandler.onMouseLeave),
      onMouseMove: callEventHandlers(ownProps === null || ownProps === void 0 ? void 0 : ownProps.onMouseMove, onMouseMoveProp, eventHandler.onMouseMove),
      onPointerDown: callEventHandlers(ownProps === null || ownProps === void 0 ? void 0 : ownProps.onPointerDown, onPointerDownProp, eventHandler.onPointerDown)
    }, styleProps), rest);
  };
  if (typeof children === 'function') {
    return children({
      getTooltipTriggerProps: getTooltipTriggerProps
    });
  }
  if (shouldWrapChildren) {
    return jsx(Box, _objectSpread2(_objectSpread2({}, getTooltipTriggerProps()), {}, {
      children: children
    }));
  }

  // Ensure tooltip has only one child node
  var child = React.Children.only(children);
  var tooltipTriggerProps = getTooltipTriggerProps(child === null || child === void 0 ? void 0 : child.props, child === null || child === void 0 ? void 0 : child.ref);
  return /*#__PURE__*/cloneElement(child, tooltipTriggerProps);
});
TooltipTrigger.displayName = 'TooltipTrigger';

var _excluded$7 = ["PopperArrowComponent", "PopperArrowProps", "PopperComponent", "PopperProps", "TooltipArrowComponent", "TooltipArrowProps", "TransitionComponent", "TransitionProps", "shouldWrapChildren", "arrowAt", "hideArrow", "hideDelay", "showDelay", "closeOnMouseDown", "arrow", "children", "closeOnClick", "closeOnEsc", "closeOnPointerDown", "defaultIsOpen", "disabled", "enterDelay", "followCursor", "isOpen", "label", "leaveDelay", "nextToCursor", "offset", "onClose", "onOpen", "openOnFocus", "placement"];
var getMemoizedState$3 = memoize(function (state) {
  return _objectSpread2({}, state);
});
var defaultPlacement = 'bottom';
var Tooltip = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var PopperArrowComponent = _ref.PopperArrowComponent,
    PopperArrowProps = _ref.PopperArrowProps,
    _ref$PopperComponent = _ref.PopperComponent,
    PopperComponent = _ref$PopperComponent === void 0 ? Popper : _ref$PopperComponent,
    PopperProps = _ref.PopperProps,
    _ref$TooltipArrowComp = _ref.TooltipArrowComponent,
    TooltipArrowComponent = _ref$TooltipArrowComp === void 0 ? TooltipArrow : _ref$TooltipArrowComp,
    TooltipArrowProps = _ref.TooltipArrowProps,
    _ref$TransitionCompon = _ref.TransitionComponent,
    TransitionComponent = _ref$TransitionCompon === void 0 ? Grow : _ref$TransitionCompon,
    TransitionProps = _ref.TransitionProps,
    _ref$shouldWrapChildr = _ref.shouldWrapChildren,
    shouldWrapChildren = _ref$shouldWrapChildr === void 0 ? false : _ref$shouldWrapChildr,
    arrowAt = _ref.arrowAt,
    hideArrow = _ref.hideArrow,
    hideDelay = _ref.hideDelay,
    showDelay = _ref.showDelay,
    closeOnMouseDown = _ref.closeOnMouseDown,
    _ref$arrow = _ref.arrow,
    arrow = _ref$arrow === void 0 ? true : _ref$arrow,
    children = _ref.children,
    _ref$closeOnClick = _ref.closeOnClick,
    closeOnClick = _ref$closeOnClick === void 0 ? true : _ref$closeOnClick,
    _ref$closeOnEsc = _ref.closeOnEsc,
    closeOnEsc = _ref$closeOnEsc === void 0 ? true : _ref$closeOnEsc,
    _ref$closeOnPointerDo = _ref.closeOnPointerDown,
    closeOnPointerDown = _ref$closeOnPointerDo === void 0 ? true : _ref$closeOnPointerDo,
    _ref$defaultIsOpen = _ref.defaultIsOpen,
    defaultIsOpen = _ref$defaultIsOpen === void 0 ? false : _ref$defaultIsOpen,
    disabled = _ref.disabled,
    _ref$enterDelay = _ref.enterDelay,
    enterDelay = _ref$enterDelay === void 0 ? 100 : _ref$enterDelay,
    followCursor = _ref.followCursor,
    isOpenProp = _ref.isOpen,
    label = _ref.label,
    _ref$leaveDelay = _ref.leaveDelay,
    leaveDelay = _ref$leaveDelay === void 0 ? 0 : _ref$leaveDelay,
    nextToCursor = _ref.nextToCursor,
    offset = _ref.offset,
    onCloseProp = _ref.onClose,
    onOpenProp = _ref.onOpen,
    _ref$openOnFocus = _ref.openOnFocus,
    openOnFocus = _ref$openOnFocus === void 0 ? true : _ref$openOnFocus,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? defaultPlacement : _ref$placement,
    rest = _objectWithoutProperties(_ref, _excluded$7);
  {
    // deprecation warning
    var prefix = "".concat(Tooltip.displayName, ":");
    useOnceWhen(function () {
      warnRemovedProps('arrowAt', {
        prefix: prefix,
        alternative: 'TooltipArrowProps'
      });
    }, arrowAt !== undefined);
    useOnceWhen(function () {
      warnDeprecatedProps('hideArrow', {
        prefix: prefix,
        alternative: 'arrow',
        willRemove: true
      });
    }, process.env.NODE_ENV !== 'production' && hideArrow !== undefined);
    useOnceWhen(function () {
      warnDeprecatedProps('hideDelay', {
        prefix: prefix,
        alternative: 'leaveDelay',
        willRemove: true
      });
    }, hideDelay !== undefined);
    useOnceWhen(function () {
      warnDeprecatedProps('showDelay', {
        prefix: prefix,
        alternative: 'enterDelay',
        willRemove: true
      });
    }, showDelay !== undefined);
    useOnceWhen(function () {
      warnDeprecatedProps('closeOnMouseDown', {
        prefix: prefix,
        alternative: 'closeOnPointerDown',
        willRemove: true
      });
    }, closeOnMouseDown !== undefined);
    if (hideArrow !== undefined) {
      arrow = !hideArrow;
    }
  }
  var tooltipContentRef = useRef(null);
  var tooltipTriggerRef = useRef(null);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    mousePageX = _useState2[0],
    setMousePageX = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    mousePageY = _useState4[0],
    setMousePageY = _useState4[1];
  var _useState5 = useState(isOpenProp !== null && isOpenProp !== void 0 ? isOpenProp : defaultIsOpen),
    _useState6 = _slicedToArray(_useState5, 2),
    isOpen = _useState6[0],
    setIsOpen = _useState6[1];
  useEffect(function () {
    var isControlled = isOpenProp !== undefined;
    if (isControlled) {
      setIsOpen(isOpenProp);
    }
  }, [isOpenProp]);
  var enterTimeoutRef = useRef();
  var leaveTimeoutRef = useRef();
  var openWithDelay = useCallback(function (callback, delay) {
    if (leaveTimeoutRef.current) {
      clearTimeout(leaveTimeoutRef.current);
      leaveTimeoutRef.current = undefined;
    }
    if (delay > 0) {
      enterTimeoutRef.current = setTimeout(function () {
        enterTimeoutRef.current = undefined;
        setIsOpen(true);
        typeof callback === 'function' && callback();
      }, delay);
    } else {
      setIsOpen(true);
      typeof callback === 'function' && callback();
    }
  }, []);
  var closeWithDelay = useCallback(function (callback, delay) {
    if (enterTimeoutRef.current) {
      clearTimeout(enterTimeoutRef.current);
      enterTimeoutRef.current = undefined;
    }
    if (delay > 0) {
      leaveTimeoutRef.current = setTimeout(function () {
        leaveTimeoutRef.current = undefined;
        setIsOpen(false);
        typeof callback === 'function' && callback();
      }, delay);
    } else {
      setIsOpen(false);
      typeof callback === 'function' && callback();
    }
  }, []);
  var onOpen = useCallback(function (callback) {
    var isControlled = isOpenProp !== undefined;
    if (!isControlled) {
      var delay = enterDelay;
      openWithDelay(callback, delay);
    }
    if (typeof onOpenProp === 'function') {
      onOpenProp();
    }
  }, [isOpenProp, onOpenProp, openWithDelay, enterDelay]);
  var onClose = useCallback(function (callback) {
    var isControlled = isOpenProp !== undefined;
    if (!isControlled) {
      var delay = leaveDelay;
      closeWithDelay(callback, delay);
    }
    if (typeof onCloseProp === 'function') {
      onCloseProp();
    }
  }, [isOpenProp, onCloseProp, closeWithDelay, leaveDelay]);
  useEffect(function () {
    return function () {
      if (enterTimeoutRef.current) {
        clearTimeout(enterTimeoutRef.current);
        enterTimeoutRef.current = undefined;
      }
      if (leaveTimeoutRef.current) {
        clearTimeout(leaveTimeoutRef.current);
        leaveTimeoutRef.current = undefined;
      }
    };
  }, []);
  var defaultId = useAutoId();
  var tooltipId = "".concat(config.name, ":Tooltip-").concat(defaultId);
  var tooltipTriggerId = "".concat(config.name, ":TooltipTrigger-").concat(defaultId);
  var context = getMemoizedState$3({
    arrow: followCursor || nextToCursor ? false : arrow,
    closeOnClick: closeOnClick,
    closeOnEsc: closeOnEsc,
    closeOnPointerDown: closeOnPointerDown,
    disabled: disabled,
    followCursor: followCursor,
    isOpen: isOpen,
    mousePageX: mousePageX,
    mousePageY: mousePageY,
    nextToCursor: nextToCursor,
    offset: offset,
    onClose: onClose,
    onOpen: onOpen,
    openOnFocus: openOnFocus,
    placement: followCursor || nextToCursor ? 'bottom-start' : placement,
    setMousePageX: setMousePageX,
    setMousePageY: setMousePageY,
    tooltipId: tooltipId,
    tooltipContentRef: tooltipContentRef,
    tooltipTriggerId: tooltipTriggerId,
    tooltipTriggerRef: tooltipTriggerRef
  });
  if (typeof children === 'function') {
    return jsx(TooltipContext.Provider, {
      value: context,
      children: children(context)
    });
  }
  return jsxs(TooltipContext.Provider, {
    value: context,
    children: [jsx(TooltipTrigger, {
      shouldWrapChildren: shouldWrapChildren,
      children: children
    }), jsx(TooltipContent, _objectSpread2(_objectSpread2({
      PopperArrowComponent: PopperArrowComponent // removed
      ,
      PopperArrowProps: PopperArrowProps // deprecated
      ,
      PopperComponent: PopperComponent,
      PopperProps: PopperProps,
      TooltipArrowComponent: TooltipArrowComponent,
      TooltipArrowProps: TooltipArrowProps,
      TransitionComponent: TransitionComponent,
      TransitionProps: TransitionProps
    }, rest), {}, {
      children: label
    }))]
  });
});
Tooltip.displayName = 'Tooltip';

var useTruncateStyle = function useTruncateStyle() {
  return {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };
};

var Truncate = /*#__PURE__*/forwardRef(function (props, ref) {
  var styleProps = useTruncateStyle();
  return jsx(Text, _objectSpread2(_objectSpread2({
    ref: ref
  }, styleProps), props));
});
Truncate.displayName = 'Truncate';

var _excluded$6 = ["children"];
var OverflowTooltip = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$6);
  var contentRef = useRef();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    isOverflown = _useState2[0],
    setIsOverflown = _useState2[1];
  var truncateStyle = useTruncateStyle();
  var onMouseEnter = useCallback(function (event) {
    var el = event.currentTarget;
    setIsOverflown(el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth);
  }, []);
  var onMouseLeave = useCallback(function (event) {
    setIsOverflown(false);
  }, []);
  useEventListener(function () {
    return contentRef.current;
  }, 'mouseenter', onMouseEnter);
  useEventListener(function () {
    return contentRef.current;
  }, 'mouseleave', onMouseLeave);
  return jsx(Tooltip, _objectSpread2(_objectSpread2({
    ref: ref,
    disabled: !isOverflown
  }, rest), {}, {
    children: typeof children === 'function' ? children({
      ref: contentRef,
      style: truncateStyle
    }) : jsx(Truncate, {
      ref: contentRef,
      children: children
    })
  }));
});
OverflowTooltip.displayName = 'OverflowTooltip';

var DescendantContext = /*#__PURE__*/createContext();

var getMemoizedState$2 = memoize(function (state) {
  return _objectSpread2({}, state);
});
var binaryFindElement = function binaryFindElement(array, element) {
  var start = 0;
  var end = array.length - 1;
  while (start <= end) {
    var middle = Math.floor((start + end) / 2);
    if (array[middle].element === element) {
      return middle;
    }

    // eslint-disable-next-line no-bitwise
    if (array[middle].element.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_PRECEDING) {
      end = middle - 1;
    } else {
      start = middle + 1;
    }
  }
  return start;
};
var Descendant = function Descendant(_ref) {
  var children = _ref.children,
    depth = _ref.depth,
    id = _ref.id;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    descendants = _useState2[0],
    setDescendants = _useState2[1];
  var registerDescendant = useCallback(function (element) {
    setDescendants(function (prevDescendants) {
      var nextDescendants;
      if (prevDescendants.length === 0) {
        // If there are no descendants, register at index 0 and bail.
        return [{
          element: element,
          index: 0
        }];
      }
      var index = binaryFindElement(prevDescendants, element);
      if (prevDescendants[index] && prevDescendants[index].element === element) {
        // If the element is already registered, just use the same array
        nextDescendants = prevDescendants;
      } else {
        // When registering a descendant, we need to make sure we insert in
        // into the array in the same order that it appears in the DOM. So as
        // new descendants are added or maybe some are removed, we always know
        // that the array is up-to-date and correct.
        //
        // So here we look at our registered descendants and see if the new
        // element we are adding appears earlier than an existing descendant's
        // DOM node via `node.compareDocumentPosition`. If it does, we insert
        // the new element at this index. Because `registerDescendant` will be
        // called in an effect every time the descendants state value changes,
        // we should be sure that this index is accurate when descendent
        // elements come or go from our component.

        var nextDescendant = {
          element: element,
          index: index
        };

        // If an index is not found we will push the element to the end.
        nextDescendants = prevDescendants.slice();
        nextDescendants.splice(index, 0, nextDescendant);
      }
      nextDescendants.forEach(function (descendant, position) {
        descendant.index = position;
      });
      return nextDescendants;
    });
    return element;
  }, []);
  var unregisterDescendant = useCallback(function (element) {
    setDescendants(function (prevDescendants) {
      return prevDescendants.filter(function (descendant) {
        return element !== descendant.element;
      });
    });
  }, []);
  var context = getMemoizedState$2({
    descendants: descendants,
    depth: depth,
    id: id,
    registerDescendant: registerDescendant,
    unregisterDescendant: unregisterDescendant
  });
  return jsx(DescendantContext.Provider, {
    value: context,
    children: children
  });
};
Descendant.displayName = 'Descendant';

/**
 * This hook registers our descendant by passing it into an array. We can then
 * search that array by to find its index when registering it in the component.
 * We use this for focus management, keyboard navigation, and typeahead
 * functionality for some components.
 *
 * The hook accepts the element node
 *
 * Our main goals with this are:
 *   1) maximum composability,
 *   2) minimal API friction
 *   3) SSR compatibility*
 *   4) concurrent safe
 *   5) index always up-to-date with the tree despite changes
 *   6) works with memoization of any component in the tree (hopefully)
 *
 * As for SSR, the good news is that we don't actually need the index on the
 * server for most use-cases, as we are only using it to determine the order of
 * composed descendants for keyboard navigation.
 */
var useDescendant = function useDescendant(element) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    forceUpdate = _useState2[1];
  var _useContext = useContext(DescendantContext),
    _useContext$descendan = _useContext.descendants,
    descendants = _useContext$descendan === void 0 ? [] : _useContext$descendan,
    _useContext$depth = _useContext.depth,
    parentDepth = _useContext$depth === void 0 ? 0 : _useContext$depth,
    _useContext$id = _useContext.id,
    parentId = _useContext$id === void 0 ? null : _useContext$id,
    _useContext$registerD = _useContext.registerDescendant,
    registerDescendant = _useContext$registerD === void 0 ? noop : _useContext$registerD,
    _useContext$unregiste = _useContext.unregisterDescendant,
    unregisterDescendant = _useContext$unregiste === void 0 ? noop : _useContext$unregiste;

  // This will initially return -1 because we haven't registered the descendant
  // on the first render. After we register, this will then return the correct
  // index on the following render and we will re-register descendants
  // so that everything is up-to-date before the user interacts with a
  // collection.
  var index = descendants.findIndex(function (item) {
    return item.element === element;
  });
  var previousDescendants = usePrevious(descendants);

  // We also need to re-register descendants any time ANY of the other
  // descendants have changed. My brain was melting when I wrote this and it
  // feels a little off, but checking in render and using the result in the
  // effect's dependency array works well enough.
  var someDescendantsHaveChanged = descendants.some(function (newDescendant, position) {
    return previousDescendants && previousDescendants[position] && previousDescendants[position].element !== newDescendant.element;
  });

  // Prevent flashing
  useIsomorphicEffect(function () {
    if (element) {
      registerDescendant(element);
      return function () {
        unregisterDescendant(element);
      };
    }
    forceUpdate({});
    return undefined;
  }, [element, registerDescendant, unregisterDescendant, index, someDescendantsHaveChanged]);
  return {
    index: index,
    parentDepth: parentDepth,
    parentId: parentId
  };
};

var TreeContext = /*#__PURE__*/createContext();
var TreeItemContext = /*#__PURE__*/createContext();

var useTreeItemStyle = function useTreeItemStyle() {
  return {};
};
var useTreeItemContentStyle = function useTreeItemContentStyle(_ref) {
  var isDisabled = _ref.isDisabled,
    isSelected = _ref.isSelected,
    tabIndex = _ref.tabIndex;
  var _useColorMode = useColorMode(),
    _useColorMode2 = _slicedToArray(_useColorMode, 1),
    colorMode = _useColorMode2[0];
  var color = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  var hoverBackgroundColor = {
    dark: 'rgba(255, 255, 255, 0.12)',
    light: 'rgba(0, 0, 0, 0.12)'
  }[colorMode];
  var focusBorderColor = {
    dark: 'blue:60',
    light: 'blue:60'
  }[colorMode];
  var disabledColor = {
    dark: 'white:disabled',
    light: 'black:disabled'
  }[colorMode];
  var defaultBackgroundColor = undefined;
  var selectedBackgroundColor = {
    dark: 'rgba(255, 255, 255, 0.08)',
    light: 'rgba(0, 0, 0, 0.08)'
  }[colorMode];
  return {
    backgroundColor: isSelected ? selectedBackgroundColor : defaultBackgroundColor,
    color: isDisabled ? disabledColor : color,
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    display: 'flex',
    textDecoration: 'none',
    alignItems: 'center',
    outline: tabIndex < 0 ? 0 : undefined,
    // Remove the default outline for tabindex="-1"
    px: '3x',
    py: '2x',
    userSelect: 'none',
    width: '100%',
    _hover: {
      backgroundColor: !isDisabled ? hoverBackgroundColor : undefined
    },
    _focus: {
      borderColor: focusBorderColor

      // Note: The border will be added in TreeItemContent
    }
  };
};

var useTreeItemToggleStyle = function useTreeItemToggleStyle() {
  return {
    display: 'inline-flex',
    backgroundColor: 'transparent'
  };
};
var useTreeItemToggleIconStyle = function useTreeItemToggleIconStyle(_ref2) {
  var disabled = _ref2.disabled;
  var _useColorMode3 = useColorMode(),
    _useColorMode4 = _slicedToArray(_useColorMode3, 1),
    colorMode = _useColorMode4[0];
  var color = {
    dark: 'white:secondary',
    light: 'black:secondary'
  }[colorMode];
  var disabledColor = {
    dark: 'white:disabled',
    light: 'black:disabled'
  }[colorMode];
  var hoverColor = {
    dark: 'white:primary',
    light: 'black:primary'
  }[colorMode];
  return {
    display: 'inline-flex',
    color: disabled ? disabledColor : color,
    _hover: {
      color: disabled ? disabledColor : hoverColor
    }
  };
};
var useTreeStyle = function useTreeStyle() {
  return {
    outline: 0
  };
};

var _excluded$5 = ["defaultExpanded", "defaultSelected", "expanded", "id", "isSelectable", "isUnselectable", "multiSelect", "onBlur", "onFocus", "onKeyDown", "onNodeFocus", "onNodeSelect", "onNodeToggle", "selected"];
var getMemoizedState$1 = memoize(function (state) {
  return _objectSpread2({}, state);
});
var Tree = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$defaultExpanded = _ref.defaultExpanded,
    defaultExpanded = _ref$defaultExpanded === void 0 ? [] : _ref$defaultExpanded,
    _ref$defaultSelected = _ref.defaultSelected,
    defaultSelected = _ref$defaultSelected === void 0 ? [] : _ref$defaultSelected,
    expandedProp = _ref.expanded,
    idProp = _ref.id,
    _ref$isSelectable = _ref.isSelectable,
    isSelectable = _ref$isSelectable === void 0 ? false : _ref$isSelectable,
    _ref$isUnselectable = _ref.isUnselectable,
    isUnselectable = _ref$isUnselectable === void 0 ? false : _ref$isUnselectable,
    _ref$multiSelect = _ref.multiSelect,
    multiSelect = _ref$multiSelect === void 0 ? false : _ref$multiSelect,
    onBlurProp = _ref.onBlur,
    onFocusProp = _ref.onFocus,
    onKeyDownProp = _ref.onKeyDown,
    onNodeFocusProp = _ref.onNodeFocus,
    onNodeSelectProp = _ref.onNodeSelect,
    onNodeToggleProp = _ref.onNodeToggle,
    selectedProp = _ref.selected,
    rest = _objectWithoutProperties(_ref, _excluded$5);
  var treeId = useAutoId(idProp);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    focusedNodeId = _useState2[0],
    setFocusedNodeId = _useState2[1];
  var _useState3 = useState(ensureArray(expandedProp !== null && expandedProp !== void 0 ? expandedProp : defaultExpanded)),
    _useState4 = _slicedToArray(_useState3, 2),
    expandedNodeIds = _useState4[0],
    setExpandedNodeIds = _useState4[1];
  var _useState5 = useState(ensureArray(selectedProp !== null && selectedProp !== void 0 ? selectedProp : defaultSelected)),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedNodeIds = _useState6[0],
    setSelectedNodeIds = _useState6[1];
  var nodeMap = useConst(function () {
    return new Map();
  }); // Used to store node data
  var activeDescendant = nodeMap.get(focusedNodeId) ? nodeMap.get(focusedNodeId).idAttr : null;
  var lastSelectedNode = useRef(null);
  var lastSelectionWasRange = useRef(false);
  var currentRangeSelection = useRef([]);
  useEffect(function () {
    var isControlled = expandedProp !== undefined;
    if (isControlled) {
      setExpandedNodeIds(ensureArray(expandedProp));
    }
  }, [expandedProp]);
  useEffect(function () {
    var isControlled = selectedProp !== undefined;
    if (isControlled) {
      setSelectedNodeIds(ensureArray(selectedProp));
    }
  }, [selectedProp]);

  /**
   * Node helpers
   */

  var getIsNodeDisabled = useCallback(function (id) {
    var node = nodeMap.get(id);
    if (!node) {
      return false;
    }
    if (node.isDisabled) {
      return true;
    }
    while (!isNullish(node.parentId)) {
      node = nodeMap.get(node.parentId);
      if (node.isDisabled) {
        return true;
      }
    }
    return false;
  }, [nodeMap]);
  var getIsNodeExpandable = useCallback(function (id) {
    var _nodeMap$get;
    return !!((_nodeMap$get = nodeMap.get(id)) !== null && _nodeMap$get !== void 0 && _nodeMap$get.isExpandable);
  }, [nodeMap]);
  var getIsNodeExpanded = useCallback(function (id) {
    return expandedNodeIds.indexOf(id) !== -1;
  }, [expandedNodeIds]);
  var getIsNodeFocused = useCallback(function (id) {
    return focusedNodeId === id;
  }, [focusedNodeId]);
  var getIsNodeSelectable = useCallback(function (id) {
    return isSelectable && !getIsNodeDisabled(id);
  }, [getIsNodeDisabled, isSelectable]);
  var getIsNodeSelected = useCallback(function (id) {
    return selectedNodeIds.indexOf(id) !== -1;
  }, [selectedNodeIds]);
  var getChildNodes = useCallback(function (id) {
    return Array.from(nodeMap.values()).filter(function (node) {
      return node.parentId === id;
    }).sort(function (a, b) {
      return a.index - b.index;
    }).map(function (child) {
      return child.id;
    });
  }, [nodeMap]);
  var getNavigableChildNodes = useCallback(function (id) {
    var focusableNodes = getChildNodes(id).filter(function (id) {
      return !getIsNodeDisabled(id);
    });
    return focusableNodes;
  }, [getChildNodes, getIsNodeDisabled]);
  var getNextNode = useCallback(function (id) {
    // If expanded get first child
    if (getIsNodeExpanded(id) && getNavigableChildNodes(id).length > 0) {
      return getNavigableChildNodes(id)[0];
    }
    var node = nodeMap.get(id);
    while (!isNullish(node)) {
      // Try to get next sibling
      var siblingIds = getNavigableChildNodes(node.parentId);
      var nextSiblingId = siblingIds[siblingIds.indexOf(node.id) + 1];
      if (nextSiblingId) {
        return nextSiblingId;
      }

      // If the sibling does not exist, go up a level to the parent and try again.
      node = nodeMap.get(node.parentId);
    }
    return null;
  }, [getIsNodeExpanded, getNavigableChildNodes, nodeMap]);
  var getPreviousNode = useCallback(function (id) {
    var node = nodeMap.get(id);
    var siblingIds = getNavigableChildNodes(node.parentId);
    var nodeIndex = siblingIds.indexOf(id);
    if (nodeIndex === 0) {
      return node.parentId;
    }
    var currentNodeId = siblingIds[nodeIndex - 1];
    while (getIsNodeExpanded(currentNodeId) && getNavigableChildNodes(currentNodeId).length > 0) {
      currentNodeId = getNavigableChildNodes(currentNodeId).pop();
    }
    return currentNodeId;
  }, [getIsNodeExpanded, getNavigableChildNodes, nodeMap]);
  var getFirstNode = useCallback(function () {
    return getNavigableChildNodes(null)[0];
  }, [getNavigableChildNodes]);
  var getLastNode = useCallback(function () {
    var lastNodeId = getNavigableChildNodes(null).pop();
    while (getIsNodeExpanded(lastNodeId)) {
      var lastChildNodes = getNavigableChildNodes(lastNodeId);
      if (lastChildNodes.length === 0) {
        break;
      }
      lastNodeId = lastChildNodes.pop();
    }
    return lastNodeId;
  }, [getIsNodeExpanded, getNavigableChildNodes]);
  var getParentNode = useCallback(function (id) {
    return nodeMap.get(id).parentId;
  }, [nodeMap]);

  /**
   * This is used to determine the start and end of a selection range so we can get the nodes between the two border nodes.
   *
   * It finds the nodes' common ancestor using a naive implementation of a lowest common ancestor algorithm.
   * (https://en.wikipedia.org/wiki/Lowest_common_ancestor)
   *
   * Then compares the ancestor's 2 children that are ancestors of nodeA and NodeB, so we can compare their indexes
   * to work out which node comes first in a depth first search.
   * (https://en.wikipedia.org/wiki/Depth-first_search)
   *
   * Another way to put it is which node is shallower in a trémaux tree
   * https://en.wikipedia.org/wiki/Tr%C3%A9maux_tree
   */
  var findOrderInTremauxTree = useCallback(function (nodeAId, nodeBId) {
    if (nodeAId === nodeBId) {
      return [nodeAId, nodeBId];
    }
    var nodeA = nodeMap.get(nodeAId);
    var nodeB = nodeMap.get(nodeBId);
    if (nodeA.parentId === nodeB.id || nodeB.parentId === nodeA.id) {
      return nodeB.parentId === nodeA.id ? [nodeA.id, nodeB.id] : [nodeB.id, nodeA.id];
    }
    var aFamily = [nodeA.id];
    var bFamily = [nodeB.id];
    var aAncestor = nodeA.parentId;
    var bAncestor = nodeB.parentId;
    var aAncestorIsCommon = bFamily.indexOf(aAncestor) !== -1;
    var bAncestorIsCommon = aFamily.indexOf(bAncestor) !== -1;
    var continueA = true;
    var continueB = true;
    while (!bAncestorIsCommon && !aAncestorIsCommon) {
      if (continueA) {
        aFamily.push(aAncestor);
        aAncestorIsCommon = bFamily.indexOf(aAncestor) !== -1;
        continueA = aAncestor !== null;
        if (!aAncestorIsCommon && continueA) {
          aAncestor = nodeMap.get(aAncestor).parentId;
        }
      }
      if (continueB && !aAncestorIsCommon) {
        bFamily.push(bAncestor);
        bAncestorIsCommon = aFamily.indexOf(bAncestor) !== -1;
        continueB = bAncestor !== null;
        if (!bAncestorIsCommon && continueB) {
          bAncestor = nodeMap.get(bAncestor).parentId;
        }
      }
    }
    var commonAncestor = aAncestorIsCommon ? aAncestor : bAncestor;
    var ancestorFamily = getChildNodes(commonAncestor);
    var aSide = aFamily[aFamily.indexOf(commonAncestor) - 1];
    var bSide = bFamily[bFamily.indexOf(commonAncestor) - 1];
    return ancestorFamily.indexOf(aSide) < ancestorFamily.indexOf(bSide) ? [nodeAId, nodeBId] : [nodeBId, nodeAId];
  }, [getChildNodes, nodeMap]);
  var getNodesInRange = useCallback(function (nodeA, nodeB) {
    var _findOrderInTremauxTr = findOrderInTremauxTree(nodeA, nodeB),
      _findOrderInTremauxTr2 = _slicedToArray(_findOrderInTremauxTr, 2),
      first = _findOrderInTremauxTr2[0],
      last = _findOrderInTremauxTr2[1];
    var nodes = [first];
    var current = first;
    while (current !== last) {
      current = getNextNode(current);
      nodes.push(current);
    }
    return nodes;
  }, [findOrderInTremauxTree, getNextNode]);
  var focusNode = useCallback(function (id) {
    if (!id) {
      return;
    }
    setFocusedNodeId(id);
    var node = nodeMap.get(id);
    node.focus();
    if (typeof onNodeFocusProp === 'function') {
      onNodeFocusProp(id);
    }
  }, [nodeMap, onNodeFocusProp]);
  var focusNextNode = useCallback(function (id) {
    focusNode(getNextNode(id));
  }, [focusNode, getNextNode]);
  var focusPreviousNode = useCallback(function (id) {
    focusNode(getPreviousNode(id));
  }, [focusNode, getPreviousNode]);
  var focusFirstNode = useCallback(function (id) {
    focusNode(getFirstNode());
  }, [focusNode, getFirstNode]);
  var focusLastNode = useCallback(function (id) {
    focusNode(getLastNode());
  }, [focusNode, getLastNode]);

  /**
   * Toggle the expansion state of a node
   *
   * @param {number|string] id - The id of the node to toggle
   * @param {boolean} [nextValue] - The next value of the node's expansion state
   * @returns {boolean} - Whether the node's expansion state was toggled
   */
  var toggleExpansion = useCallback(function () {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : focusedNodeId;
    var nextValue = arguments.length > 1 ? arguments[1] : undefined;
    if (!id) {
      return false;
    }
    var isNodeExpandable = getIsNodeExpandable(id);
    if (!isNodeExpandable) {
      return false;
    }
    var willExpand = typeof nextValue === 'boolean' ? nextValue : !getIsNodeExpanded(id);
    var newExpandedNodes = willExpand ? expandedNodeIds.concat(id) : expandedNodeIds.filter(function (expandedNodeId) {
      return expandedNodeId !== id;
    });
    if (typeof onNodeToggleProp === 'function') {
      onNodeToggleProp(newExpandedNodes);
    }
    setExpandedNodeIds(newExpandedNodes);
    return true;
  }, [expandedNodeIds, focusedNodeId, getIsNodeExpandable, getIsNodeExpanded, onNodeToggleProp]);

  /**
   * Toggle the selection state of a node
   *
   * @param {number|string] id - The id of the node to toggle
   * @param {boolean} [nextValue] - The next value of the node's selection state
   * @returns {boolean} - Whether the node's selection state was toggled
   */
  var toggleSelection = useCallback(function (id, nextValue) {
    if (!id) {
      return false;
    }
    var isNodeSelectable = getIsNodeSelectable(id);
    if (!isNodeSelectable) {
      return false;
    }
    var willSelect = typeof nextValue === 'boolean' ? nextValue : !getIsNodeSelected(id);
    var newSelectedNodes = willSelect ? selectedNodeIds.concat(id) : selectedNodeIds.filter(function (selectedNodeId) {
      return selectedNodeId !== id;
    });
    if (typeof onNodeSelectProp === 'function') {
      onNodeSelectProp(newSelectedNodes);
    }
    setSelectedNodeIds(newSelectedNodes);
    lastSelectedNode.current = id;
    lastSelectionWasRange.current = false;
    currentRangeSelection.current = [];
    return true;
  }, [getIsNodeSelectable, getIsNodeSelected, onNodeSelectProp, selectedNodeIds]);

  /**
   * Select a node
   *
   * @param {number|string] id - The id of the node to select
   * @returns {boolean} - Whether the node was selected
   */
  var selectNode = useCallback(function (id) {
    if (!id) {
      return false;
    }
    var isNodeSelectable = getIsNodeSelectable(id);
    if (!isNodeSelectable) {
      return false;
    }
    var willUnselect = isUnselectable && getIsNodeSelected(id) && selectedNodeIds.length === 1;
    var newSelectedNodes = willUnselect ? [] : [id];
    if (typeof onNodeSelectProp === 'function') {
      onNodeSelectProp(newSelectedNodes);
    }
    setSelectedNodeIds(newSelectedNodes);
    lastSelectedNode.current = id;
    lastSelectionWasRange.current = false;
    currentRangeSelection.current = [];
    return true;
  }, [getIsNodeSelectable, getIsNodeSelected, isUnselectable, onNodeSelectProp, selectedNodeIds]);

  /**
   * Select a range of nodes
   *
   * @param {number|string} start - The id of the node to start the range from
   * @param {number|string} [current] - The id of the node to continue the range from
   * @param {number|string} end - The id of the node to end the range at
   * @returns {boolean} - Whether the range was selected successfully
   */
  var selectRange = useCallback(function (_ref2) {
    var _ref2$start = _ref2.start,
      start = _ref2$start === void 0 ? lastSelectedNode.current : _ref2$start,
      current = _ref2.current,
      end = _ref2.end;
    if (!isSelectable) {
      return false;
    }
    if (isNullish(start) || isNullish(end)) {
      return false;
    }
    if (!isNullish(current)) {
      var newSelectedNodes = selectedNodeIds.slice();
      if (currentRangeSelection.current.indexOf(current) === -1) {
        currentRangeSelection.current = [];
      }
      if (lastSelectionWasRange.current) {
        if (currentRangeSelection.current.indexOf(end) !== -1) {
          newSelectedNodes = newSelectedNodes.filter(function (id) {
            return id === start || id !== current;
          });
          currentRangeSelection.current = currentRangeSelection.current.filter(function (id) {
            return id === start || id !== current;
          });
        } else {
          newSelectedNodes.push(end);
          currentRangeSelection.current.push(end);
        }
      } else {
        newSelectedNodes.push(end);
        currentRangeSelection.current.push(current, end);
      }
      if (typeof onNodeSelectProp === 'function') {
        onNodeSelectProp(newSelectedNodes);
      }
      setSelectedNodeIds(newSelectedNodes);
    } else {
      // If last selection was a range selection, ignore nodes that were selected
      var nodes = lastSelectionWasRange.current ? selectedNodeIds.filter(function (id) {
        return currentRangeSelection.current.indexOf(id) === -1;
      }) : selectedNodeIds.slice();
      var nodesInRange = getNodesInRange(start, end).filter(function (node) {
        return !getIsNodeDisabled(node);
      });
      currentRangeSelection.current = nodesInRange;
      var _newSelectedNodes = nodes.concat(nodesInRange);
      _newSelectedNodes = _newSelectedNodes.filter(function (id, index) {
        return _newSelectedNodes.indexOf(id) === index;
      });
      if (typeof onNodeSelectProp === 'function') {
        onNodeSelectProp(_newSelectedNodes);
      }
      setSelectedNodeIds(_newSelectedNodes);
    }
    lastSelectionWasRange.current = true;
    return true;
  }, [getIsNodeDisabled, getNodesInRange, isSelectable, onNodeSelectProp, selectedNodeIds]);
  var rangeSelectToFirst = useCallback(function (id) {
    if (!lastSelectedNode.current) {
      lastSelectedNode.current = id;
    }
    var start = lastSelectionWasRange.current ? lastSelectedNode.current : id;
    var end = getFirstNode();
    selectRange({
      start: start,
      end: end
    });
  }, [getFirstNode, selectRange]);
  var rangeSelectToLast = useCallback(function (id) {
    if (!lastSelectedNode.current) {
      lastSelectedNode.current = id;
    }
    var start = lastSelectionWasRange.current ? lastSelectedNode.current : id;
    var end = getLastNode();
    selectRange({
      start: start,
      end: end
    });
  }, [getLastNode, selectRange]);
  var selectNextNode = useCallback(function (id) {
    var nextNode = getNextNode(id);
    if (getIsNodeDisabled(nextNode)) {
      return;
    }
    var start = lastSelectedNode.current;
    var current = id;
    var end = nextNode;
    selectRange({
      start: start,
      current: current,
      end: end
    });
  }, [getIsNodeDisabled, getNextNode, selectRange]);
  var selectPreviousNode = useCallback(function (id) {
    var previousNode = getPreviousNode(id);
    if (getIsNodeDisabled(previousNode)) {
      return;
    }
    var start = lastSelectedNode.current;
    var current = id;
    var end = previousNode;
    selectRange({
      start: start,
      current: current,
      end: end
    });
  }, [getIsNodeDisabled, getPreviousNode, selectRange]);
  var selectAllNodes = useCallback(function () {
    var start = getFirstNode();
    var end = getLastNode();
    selectRange({
      start: start,
      end: end
    });
  }, [getFirstNode, getLastNode, selectRange]);

  /**
   * Mapping helpers
   */

  var registerNode = useCallback(function (nodeProps) {
    var id = nodeProps.id;

    // Ensure that nodeProps include the required fields
    var requiredFields = ['focus', 'id', 'idAttr', 'isDisabled', 'isExpandable', 'parentId'];
    var pass = requiredFields.every(function (field) {
      return Object.prototype.hasOwnProperty.call(nodeProps, field);
    });
    if (!pass) {
      console.error('Error: `nodeProps` is missing some required fields.', nodeProps);
      // bypass
    }

    nodeMap.set(id, nodeProps);
    return id;
  }, [nodeMap]);
  var unregisterNode = useCallback(function (id) {
    nodeMap["delete"](id);
  }, [nodeMap]);

  /**
   * Event handlers
   */

  var onBlur = function onBlur(event) {
    var receivingFocusTarget = event.relatedTarget; // The element that will receive focus (if any)
    var isFocusWithin = event.currentTarget && event.currentTarget.contains(receivingFocusTarget);
    if (!isFocusWithin) {
      // Clear the `focusedNodeId` since focus is moving outside the current target
      setFocusedNodeId(null);
    }
  };
  var onFocus = function onFocus(event) {
    var receivingFocusTarget = event.target; // The element that will receive focus (if any)
    var losingFocusTarget = event.relatedTarget; // The element that is losing focus (if any)

    if (event.currentTarget !== receivingFocusTarget) {
      // If the event bubbled (which is React specific) we don't want to steal focus
      return;
    }
    if (event.currentTarget.contains(losingFocusTarget)) {
      // If the focus is within the tree, don't steal focus
      return;
    }
    var firstSelectedNode = selectedNodeIds[0];
    if (firstSelectedNode) {
      focusNode(firstSelectedNode);
    } else {
      focusFirstNode();
    }
  };
  var onKeyDown = function onKeyDown(event) {
    var flag = false;
    var key = event.key;

    // If the tree is empty there will be no focused node
    if (event.altKey || !focusedNodeId) {
      return;
    }
    var isCtrlPressed = event.ctrlKey || event.metaKey;
    var isShiftPressed = event.shiftKey;
    switch (key) {
      case ' ':
        if (!getIsNodeDisabled(focusedNodeId)) {
          if (multiSelect && isShiftPressed) {
            var start = lastSelectedNode.current;
            var end = focusedNodeId;
            selectRange({
              start: start,
              end: end
            });
            flag = true;
          } else if (multiSelect) {
            flag = toggleSelection(focusedNodeId);
          } else {
            flag = selectNode(focusedNodeId);
          }
        }
        event.stopPropagation();
        break;
      case 'Enter':
        if (!getIsNodeDisabled(focusedNodeId)) {
          if (getIsNodeExpandable(focusedNodeId)) {
            toggleExpansion(focusedNodeId);
            flag = true;
          } else if (multiSelect) {
            flag = toggleSelection(focusedNodeId);
          } else {
            flag = selectNode(focusedNodeId);
          }
        }
        event.stopPropagation();
        break;
      case 'ArrowDown':
        if (multiSelect && isShiftPressed) {
          selectNextNode(focusedNodeId);
        }
        focusNextNode(focusedNodeId);
        flag = true;
        break;
      case 'ArrowUp':
        if (multiSelect && isShiftPressed) {
          selectPreviousNode(focusedNodeId);
        }
        focusPreviousNode(focusedNodeId);
        flag = true;
        break;
      case 'ArrowRight':
        if (getIsNodeExpandable(focusedNodeId)) {
          if (getIsNodeExpanded(focusedNodeId)) {
            focusNextNode(focusedNodeId);
            flag = true;
          } else if (!getIsNodeDisabled(focusedNodeId)) {
            toggleExpansion(focusedNodeId);
            flag = true;
          }
        }
        break;
      case 'ArrowLeft':
        if (getIsNodeExpanded(focusedNodeId) && !getIsNodeDisabled(focusedNodeId)) {
          toggleExpansion(focusedNodeId);
          flag = true;
        } else {
          var parentNode = getParentNode(focusedNodeId);
          if (parentNode) {
            focusNode(parentNode);
            flag = true;
          }
        }
        break;
      case 'Home':
        if (multiSelect && isCtrlPressed && isShiftPressed && !getIsNodeDisabled(focusedNodeId)) {
          rangeSelectToFirst(focusedNodeId);
        }
        focusFirstNode();
        flag = true;
        break;
      case 'End':
        if (multiSelect && isCtrlPressed && isShiftPressed && !getIsNodeDisabled(focusedNodeId)) {
          rangeSelectToLast(focusedNodeId);
        }
        focusLastNode();
        flag = true;
        break;
      default:
        if (multiSelect && isCtrlPressed && key.toLowerCase() === 'a') {
          selectAllNodes();
          flag = true;
        }
        break;
    }
    if (flag) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  /**
   * Context
   */

  var context = getMemoizedState$1({
    focusNode: focusNode,
    getIsNodeDisabled: getIsNodeDisabled,
    getIsNodeExpandable: getIsNodeExpandable,
    getIsNodeExpanded: getIsNodeExpanded,
    getIsNodeFocused: getIsNodeFocused,
    getIsNodeSelectable: getIsNodeSelectable,
    getIsNodeSelected: getIsNodeSelected,
    isSelectable: isSelectable,
    multiSelect: multiSelect,
    nodeMap: nodeMap,
    registerNode: registerNode,
    selectNode: selectNode,
    selectRange: selectRange,
    toggleExpansion: toggleExpansion,
    toggleSelection: toggleSelection,
    treeId: treeId,
    unregisterNode: unregisterNode
  });
  var tabIndex = 0;
  var styleProps = useTreeStyle();
  return jsx(TreeContext.Provider, {
    value: context,
    children: jsx(Descendant, {
      depth: -1,
      children: jsx(Box, _objectSpread2(_objectSpread2({
        ref: ref,
        "aria-activedescendant": activeDescendant,
        "aria-multiselectable": ariaAttr(multiSelect),
        id: treeId,
        role: "tree",
        onBlur: callEventHandlers(onBlurProp, onBlur),
        onFocus: callEventHandlers(onFocusProp, onFocus),
        onKeyDown: callEventHandlers(onKeyDownProp, onKeyDown),
        tabIndex: tabIndex
      }, styleProps), rest))
    })
  });
});
Tree.displayName = 'Tree';

var useTree = function useTree() {
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(TreeContext);
  return context;
};

var _excluded$4 = ["TransitionComponent", "TransitionProps", "children", "disabled", "id", "nodeId", "render"];
var getMemoizedState = memoize(function (state) {
  return _objectSpread2({}, state);
});
var TreeItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$TransitionCompon = _ref.TransitionComponent,
    TransitionComponent = _ref$TransitionCompon === void 0 ? Collapse : _ref$TransitionCompon,
    TransitionProps = _ref.TransitionProps,
    children = _ref.children,
    disabledProp = _ref.disabled,
    idAttrProp = _ref.id,
    nodeId = _ref.nodeId,
    render = _ref.render,
    rest = _objectWithoutProperties(_ref, _excluded$4);
  var _useTree = useTree(),
    focusNode = _useTree.focusNode,
    getIsNodeDisabled = _useTree.getIsNodeDisabled,
    getIsNodeExpanded = _useTree.getIsNodeExpanded,
    getIsNodeFocused = _useTree.getIsNodeFocused,
    getIsNodeSelected = _useTree.getIsNodeSelected,
    registerNode = _useTree.registerNode,
    selectNode = _useTree.selectNode,
    selectRange = _useTree.selectRange,
    toggleSelection = _useTree.toggleSelection,
    toggleExpansion = _useTree.toggleExpansion,
    treeId = _useTree.treeId,
    unregisterNode = _useTree.unregisterNode;
  var contentRef = useRef();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    element = _useState2[0],
    setElement = _useState2[1];
  var combinedRef = useMergeRefs(setElement, ref);
  var idAttr = useMemo(function () {
    if (!isNullish(idAttrProp)) {
      return idAttrProp;
    }
    if (treeId && nodeId) {
      return "".concat(treeId, "-").concat(nodeId);
    }
    return null;
  }, [idAttrProp, treeId, nodeId]);
  var _useDescendant = useDescendant(element),
    index = _useDescendant.index,
    parentDepth = _useDescendant.parentDepth,
    parentId = _useDescendant.parentId;
  var nodeDepth = ensureNumber(parentDepth) + 1;
  var validChildren = React.Children.toArray(children).filter(function (child) {
    return /*#__PURE__*/isValidElement(child) || typeof child === 'string' || typeof child === 'number';
  });
  var isExpandable = validChildren.length > 0;
  var isDisabled = getIsNodeDisabled ? getIsNodeDisabled(nodeId) : false;
  var isExpanded = getIsNodeExpanded ? getIsNodeExpanded(nodeId) : false;
  var isFocused = getIsNodeFocused ? getIsNodeFocused(nodeId) : false;
  var isSelected = getIsNodeSelected ? getIsNodeSelected(nodeId) : false;
  useEffect(function () {
    if (typeof registerNode === 'function' && typeof unregisterNode === 'function' && index !== -1) {
      registerNode({
        depth: nodeDepth,
        focus: function focus() {
          requestAnimationFrame(function () {
            var el = contentRef.current;
            el && el.focus();
          });
        },
        id: nodeId,
        idAttr: idAttr,
        isDisabled: Boolean(disabledProp),
        isExpandable: isExpandable,
        parentId: parentId
      });
      return function () {
        unregisterNode(nodeId);
      };
    }
    return undefined;
  }, [registerNode, unregisterNode, index, nodeDepth, nodeId, idAttr, disabledProp, isExpandable, parentId]);
  var selectHandler = useCallback(function () {
    var isDisabled = getIsNodeDisabled(nodeId);
    var isFocused = getIsNodeFocused(nodeId);
    if (isDisabled) {
      return;
    }
    if (!isFocused) {
      focusNode(nodeId);
    }
    selectNode(nodeId);
  }, [nodeId, getIsNodeDisabled, getIsNodeFocused, focusNode, selectNode]);
  var selectRangeHandler = useCallback(function () {
    var isDisabled = getIsNodeDisabled(nodeId);
    var isFocused = getIsNodeFocused(nodeId);
    if (isDisabled) {
      return;
    }
    if (!isFocused) {
      focusNode(nodeId);
    }

    // When performing a range selection, the `start` parameter is assigned the value of `lastSelectedNode.current`
    var end = nodeId;
    selectRange({
      end: end
    });
  }, [nodeId, getIsNodeDisabled, getIsNodeFocused, focusNode, selectRange]);
  var toggleExpansionHandler = useCallback(function () {
    var isDisabled = getIsNodeDisabled(nodeId);
    if (isDisabled) {
      return;
    }

    // Note: We do not focus the node when toggling expansion state

    toggleExpansion(nodeId);
  }, [nodeId, getIsNodeDisabled, toggleExpansion]);
  var toggleSelectionHandler = useCallback(function () {
    var isDisabled = getIsNodeDisabled(nodeId);
    var isFocused = getIsNodeFocused(nodeId);
    if (isDisabled) {
      return;
    }
    if (!isFocused) {
      focusNode(nodeId);
    }
    toggleSelection(nodeId);
  }, [nodeId, getIsNodeDisabled, getIsNodeFocused, focusNode, toggleSelection]);
  var styleProps = useTreeItemStyle();
  var context = getMemoizedState({
    contentRef: contentRef,
    // internal use only
    isDisabled: isDisabled,
    isExpandable: isExpandable,
    isExpanded: isExpanded,
    isFocused: isFocused,
    isSelected: isSelected,
    nodeId: nodeId,
    nodeDepth: nodeDepth,
    select: selectHandler,
    selectRange: selectRangeHandler,
    toggleExpansion: toggleExpansionHandler,
    toggleSelection: toggleSelectionHandler
  });
  return jsx(TreeItemContext.Provider, {
    value: context,
    children: jsxs(Box, _objectSpread2(_objectSpread2(_objectSpread2({
      ref: combinedRef,
      "aria-disabled": ariaAttr(isDisabled),
      "aria-expanded": ariaAttr(isExpanded),
      "aria-selected": ariaAttr(isSelected),
      id: idAttr,
      role: "treeitem"
    }, styleProps), rest), {}, {
      children: [runIfFn(render, context), !!isExpandable && jsx(Descendant, {
        depth: nodeDepth,
        id: nodeId,
        children: jsx(TransitionComponent, _objectSpread2(_objectSpread2({
          appear: false // do not perform the enter transition when it first mounts
          ,
          "in": isExpanded,
          role: "group",
          unmountOnExit: true
        }, TransitionProps), {}, {
          children: children
        }))
      })]
    }))
  });
});
TreeItem.displayName = 'TreeItem';

var useTreeItem = function useTreeItem() {
  if (!useContext) {
    throw new Error('The `useContext` hook is not available with your React version.');
  }
  var context = useContext(TreeItemContext);
  return context;
};

var _excluded$3 = ["onClick", "onMouseDown", "sx"];
var TreeItemContent = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var onClickProp = _ref.onClick,
    onMouseDownProp = _ref.onMouseDown,
    sxProp = _ref.sx,
    rest = _objectWithoutProperties(_ref, _excluded$3);
  var _useTheme = useTheme(),
    sizes = _useTheme.sizes;
  var _useTree = useTree(),
    multiSelect = _useTree.multiSelect;
  var context = useTreeItem();
  var _context = _objectSpread2({}, context),
    contentRef = _context.contentRef,
    isDisabled = _context.isDisabled,
    isSelected = _context.isSelected,
    nodeDepth = _context.nodeDepth,
    select = _context.select,
    selectRange = _context.selectRange,
    toggleSelection = _context.toggleSelection;
  var combinedRef = useMergeRefs(contentRef, ref);
  var onClick = useCallback(function (event) {
    var isCtrlPressed = event.ctrlKey;
    var isMetaPressed = event.metaKey;
    var isShiftPressed = event.shiftKey;
    if (multiSelect && isShiftPressed) {
      selectRange();
      return;
    }
    if (multiSelect && (isCtrlPressed || isMetaPressed)) {
      toggleSelection();
      return;
    }
    select();
  }, [multiSelect, select, selectRange, toggleSelection]);
  var onMouseDown = useCallback(function (event) {
    var isCtrlPressed = event.ctrlKey;
    var isMetaPressed = event.metaKey;
    var isShiftPressed = event.shiftKey;
    if (isCtrlPressed || isMetaPressed || isShiftPressed || isDisabled) {
      // Prevent text selection
      event.preventDefault();
    }
  }, [isDisabled]);
  var tabIndex = -1;
  var styleProps = useTreeItemContentStyle({
    isDisabled: isDisabled,
    isSelected: isSelected,
    tabIndex: tabIndex
  });
  var sxProps = useMemo(function () {
    return [{
      pl: "calc(".concat(nodeDepth, " * ").concat(sizes['6x'], " + ").concat(sizes['3x'], ")"),
      pr: "calc(".concat(sizes['3x'], ")"),
      ':focus-visible': {
        borderStyle: 'solid',
        borderWidth: '1h',
        pl: "calc(".concat(nodeDepth, " * ").concat(sizes['6x'], " + ").concat(sizes['3x'], " - ").concat(sizes['1h'], ")"),
        pr: "calc(".concat(sizes['3x'], " - ").concat(sizes['1h'], ")"),
        py: "calc(".concat(sizes['2x'], " - ").concat(sizes['1h'], ")")
      }
    }].concat(_toConsumableArray(ensureArray(sxProp)));
  }, [nodeDepth, sizes, sxProp]);
  return jsx(Box, _objectSpread2(_objectSpread2({
    ref: combinedRef,
    onClick: callEventHandlers(onClickProp, onClick),
    onMouseDown: callEventHandlers(onMouseDownProp, onMouseDown),
    tabIndex: tabIndex,
    sx: sxProps
  }, styleProps), rest));
});
TreeItemContent.displayName = 'TreeItemContent';

var _excluded$2 = ["children", "disabled", "onClick"];
var TreeItemToggle = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    onClickProp = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded$2);
  var _useTreeItem = useTreeItem(),
    isExpanded = _useTreeItem.isExpanded,
    toggleExpansion = _useTreeItem.toggleExpansion;
  var styleProps = useTreeItemToggleStyle();
  var onClick = useCallback(function (event) {
    // Stop event bubbling to prevent the node from being selected
    event.stopPropagation();
    toggleExpansion();
  }, [toggleExpansion]);
  var getTreeItemToggleProps = function getTreeItemToggleProps() {
    return _objectSpread2(_objectSpread2({
      'aria-disabled': ariaAttr(disabled),
      'aria-expanded': ariaAttr(isExpanded),
      disabled: disabled,
      onClick: callEventHandlers(onClickProp, onClick),
      ref: ref,
      role: 'button',
      tabIndex: 0
    }, styleProps), rest);
  };
  if (typeof children === 'function') {
    return children({
      getTreeItemToggleProps: getTreeItemToggleProps
    });
  }
  return jsx(ButtonBase, _objectSpread2(_objectSpread2({}, getTreeItemToggleProps()), {}, {
    children: children
  }));
});
TreeItemToggle.displayName = 'TreeItemToggle';

var _excluded$1 = ["appear", "children", "disabled", "easing", "nodeId", "style", "timeout"];
var mapStateToVariantStyle = function mapStateToVariantStyle(state, props) {
  var variantStyle = {
    entering: function entering(props) {
      return {
        transform: 'rotate(90deg)'
      };
    },
    entered: function entered(props) {
      return {
        transform: 'rotate(90deg)'
      };
    },
    exiting: function exiting(props) {
      return {
        transform: 'rotate(0deg)'
      };
    },
    exited: function exited(props) {
      return {
        transform: 'rotate(0deg)'
      };
    }
  }[state];
  return typeof variantStyle === 'function' ? variantStyle(props) : variantStyle;
};
var defaultEasing = {
  enter: transitionEasing.easeOut,
  exit: transitionEasing.easeOut
};
var defaultTimeout = {
  enter: 133,
  exit: Math.floor(133 * 0.7)
};
var TreeItemToggleIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$appear = _ref.appear,
    appear = _ref$appear === void 0 ? false : _ref$appear,
    _children = _ref.children,
    disabled = _ref.disabled,
    _ref$easing = _ref.easing,
    easing = _ref$easing === void 0 ? defaultEasing : _ref$easing;
    _ref.nodeId;
    var style = _ref.style,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? defaultTimeout : _ref$timeout,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  var context = useTreeItem();
  var nodeRef = useRef(null);
  var combinedRef = useMergeRefs(nodeRef, ref);
  var isExpanded = ensureBoolean(context === null || context === void 0 ? void 0 : context.isExpanded);
  var toggleIconStyleProps = useTreeItemToggleIconStyle({
    disabled: disabled
  });
  useEffect(function () {
    if (isExpanded) {
      var node = nodeRef.current;
      reflow(node); // force reflow to make the transition work when animating appearance
    }
  }, [isExpanded]);
  return jsx(Transition, _objectSpread2(_objectSpread2({
    appear: appear,
    "in": isExpanded,
    nodeRef: nodeRef,
    timeout: timeout
  }, rest), {}, {
    children: function children(state, childProps) {
      var transitionProps = isExpanded ? getEnterTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      }) : getExitTransitionProps({
        style: style,
        timeout: timeout,
        easing: easing
      });
      var transition = createTransitionStyle('transform', transitionProps);
      var variantStyle = mapStateToVariantStyle(state, {});
      var styleProps = _objectSpread2(_objectSpread2(_objectSpread2({}, toggleIconStyleProps), variantStyle), {}, {
        'aria-disabled': ariaAttr(disabled),
        transition: transition
      });
      if (typeof _children === 'function') {
        return _children(state, _objectSpread2(_objectSpread2({}, childProps), {}, {
          ref: combinedRef,
          style: _objectSpread2(_objectSpread2({}, styleProps), style)
        }));
      }
      var iconName = 'angle-right';
      return jsx(Box, _objectSpread2(_objectSpread2(_objectSpread2({
        ref: combinedRef
      }, styleProps), childProps), {}, {
        style: style,
        children: _children !== null && _children !== void 0 ? _children : jsx(Icon, {
          width: "4x",
          icon: iconName
        })
      }));
    }
  }));
});
TreeItemToggleIcon.displayName = 'TreeItemToggleIcon';

var _excluded = ["variant"];
var FlatButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$variant = _ref.variant,
    variantProp = _ref$variant === void 0 ? 'solid' : _ref$variant,
    rest = _objectWithoutProperties(_ref, _excluded);
  useOnce(function () {
    console.error('Warning: `FlatButton` is deprecated and will be removed in the next major release. Please use `Button` or `ButtonBase` instead.\n\nSee https://trendmicro-frontend.github.io/tonic-ui/react/latest/getting-started/migration-v0x for more information.');
  });
  var variant = {
    'solid': 'default',
    'outline': 'secondary'
  }[variantProp];
  return jsx(Button, _objectSpread2({
    ref: ref,
    variant: variant
  }, rest));
});
FlatButton.displayName = 'FlatButton';

var PseudoBox = /*#__PURE__*/forwardRef(function (props, ref) {
  useOnce(function () {
    console.error('Warning: The `PseudoBox` component is deprecated and will be removed in the next major release. Use the `Box` component instead.');
  });
  return jsx(Box, _objectSpread2({
    ref: ref
  }, props));
});
PseudoBox.displayName = 'PseudoBox';

var ToggleSwitch = /*#__PURE__*/forwardRef(function (props, ref) {
  useOnce(function () {
    console.error('Warning: The `ToggleSwitch` component is deprecated and will be removed in the next major release. Use the `Switch` component instead.');
  });
  return jsx(Switch, _objectSpread2({
    ref: ref
  }, props));
});
ToggleSwitch.displayName = 'ToggleSwitch';

var useDisclosure = function useDisclosure(defaultIsOpen) {
  useOnce(function () {
    console.error('Warning: The `useDisclosure` Hook is deprecated and will be removed in the next major release. Use the `useToggle` Hook instead.\n\nSee https://trendmicro-frontend.github.io/tonic-ui/react/latest/hooks for more information.');
  });
  var _useState = useState(Boolean(defaultIsOpen)),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var onClose = useCallback(function () {
    return setIsOpen(false);
  }, []);
  var onOpen = useCallback(function () {
    return setIsOpen(true);
  }, []);
  var onToggle = useCallback(function () {
    return setIsOpen(function (prevIsOpen) {
      return !prevIsOpen;
    });
  }, []);
  return {
    isOpen: isOpen,
    onOpen: onOpen,
    onClose: onClose,
    onToggle: onToggle
  };
};

var withTheme = (function () {
  useOnce(function () {
    console.error('Warning: `withTheme` is deprecated and will be removed in the next major release. Use the `useTheme` Hook instead.');
  });
  return withTheme$1.apply(void 0, arguments);
});

var PopperArrow = function PopperArrow() {
  useOnce(function () {
    console.error('Error: The `PopperArrow` component has been removed from Tonic UI. Please use the `PopoverArrow` component for popovers or `TooltipArrow` component for tooltips instead.');
  });
  return null;
};
PopperArrow.displayName = 'PopperArrow';

export { Accordion, AccordionBody, AccordionCollapse, AccordionContent, AccordionHeader, AccordionItem, AccordionToggle, AccordionToggleIcon, Alert, AlertCloseButton, AlertIcon, AlertMessage, Badge, Box, Button, ButtonBase, ButtonGroup, ButtonLink, CSSBaseline, Checkbox, CheckboxGroup, Code, Collapse, ColorModeProvider, ColorStyleProvider, ControlBox, DarkMode, Divider, Drawer, DrawerBody, DrawerCloseButton, DrawerContainer, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, Fade, FlatButton, Flex, Grid, Grow, Icon, Image, Input, InputAdornment, InputBase, InputControl, InputGroup, InputGroupAddon, InputGroupAppend, InputGroupPrepend, InvertedMode, LightMode, LinearProgress, Link, LinkButton, Menu, MenuButton, MenuContent, MenuDivider, MenuGroup, MenuItem, MenuList, MenuToggle, MenuToggleIcon, Modal, ModalBody, ModalCloseButton, ModalContainer, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Option, OptionGroup, OverflowTooltip, Pagination, PaginationItem, Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverFooter, PopoverHeader, PopoverTrigger, Popper, PopperArrow, Portal, PortalManager, PseudoBox, Radio, RadioGroup, ResizeHandle, SVGIcon, Scale, Scrollbar, SearchInput, Select, Skeleton, Slide, Space, Spinner, Stack, Submenu, SubmenuContent, SubmenuList, SubmenuToggle, Switch, Tab, TabList, TabPanel, TabPanels, Table, TableBody, TableCell, ResizeHandle as TableColumnResizeHandle, TableHeader, TableHeaderCell, TableHeaderRow, TableRow, TableScrollbar, Tabs, Tag, TagCloseButton, Text, TextLabel, Textarea, ThemeProvider, Toast, ToastCloseButton, ToastContainer, ToastController, ToastIcon, ToastManager, ToastMessage, ToastProvider, ToastTransition, ToggleSwitch, TonicProvider, Tooltip, TooltipArrow, TooltipContent, TooltipTrigger, Tree, TreeItem, TreeItemContent, TreeItemToggle, TreeItemToggleIcon, Truncate, VisuallyHidden, Zoom, colorStyle, theme, useAccordion, useAccordionItem, useButtonGroup, useCheckboxGroup, useColorMode, useColorStyle, useDisclosure, useDrawer, useInputGroup, useMenu, useModal, usePagination, usePopover, usePortalManager, useRadioGroup, useSubmenu, useTabs, useToast, useToastManager, useTree, useTreeItem, withTheme };
